import ye, { useState as ve, useEffect as Qe, useId as Ir, useRef as nn, createElement as xb, forwardRef as ne, Children as Wf, isValidElement as Ff, cloneElement as Ab, useCallback as kl, createContext as _b, useMemo as Zp, useLayoutEffect as Kp } from "react";
import Ob from "react-dom";
function If(l) {
  return l && l.__esModule && Object.prototype.hasOwnProperty.call(l, "default") ? l.default : l;
}
var cf = { exports: {} }, qr = {};
var $p;
function Nb() {
  if ($p) return qr;
  $p = 1;
  var l = Symbol.for("react.transitional.element"), i = Symbol.for("react.fragment");
  function u(s, o, f) {
    var m = null;
    if (f !== void 0 && (m = "" + f), o.key !== void 0 && (m = "" + o.key), "key" in o) {
      f = {};
      for (var g in o)
        g !== "key" && (f[g] = o[g]);
    } else f = o;
    return o = f.ref, {
      $$typeof: l,
      type: s,
      key: m,
      ref: o !== void 0 ? o : null,
      props: f
    };
  }
  return qr.Fragment = i, qr.jsx = u, qr.jsxs = u, qr;
}
var Jp;
function Eb() {
  return Jp || (Jp = 1, cf.exports = Nb()), cf.exports;
}
var h = Eb(), sf = { exports: {} }, of, Wp;
function jb() {
  if (Wp) return of;
  Wp = 1;
  var l = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return of = l, of;
}
var ff, Fp;
function Rb() {
  if (Fp) return ff;
  Fp = 1;
  var l = /* @__PURE__ */ jb();
  function i() {
  }
  function u() {
  }
  return u.resetWarningCache = i, ff = function() {
    function s(m, g, y, b, T, A) {
      if (A !== l) {
        var x = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw x.name = "Invariant Violation", x;
      }
    }
    s.isRequired = s;
    function o() {
      return s;
    }
    var f = {
      array: s,
      bigint: s,
      bool: s,
      func: s,
      number: s,
      object: s,
      string: s,
      symbol: s,
      any: s,
      arrayOf: o,
      element: s,
      elementType: s,
      instanceOf: o,
      node: s,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: u,
      resetWarningCache: i
    };
    return f.PropTypes = f, f;
  }, ff;
}
var Ip;
function Cb() {
  return Ip || (Ip = 1, sf.exports = /* @__PURE__ */ Rb()()), sf.exports;
}
var Db = /* @__PURE__ */ Cb();
const p = /* @__PURE__ */ If(Db), zb = () => {
  const [l, i] = ve(null), [u, s] = ve(!1), [o, f] = ve(null), [m, g] = ve("");
  return Qe(() => {
    if (!m) return;
    (() => {
      f(null), s(!0);
      try {
        fetch(m).then((b) => b.json()).then((b) => {
          i(b), s(!1);
        }).catch((b) => {
          f(b), s(!1);
        });
      } catch (b) {
        f(b);
      }
    })();
  }, [m]), [{ data: l, loading: u, error: o }, g];
};
function Mb(l) {
  const [i, u] = ve(!1);
  return Qe(() => {
    const s = window.matchMedia(l);
    s.matches !== i && u(s.matches);
    const o = () => {
      u(s.matches);
    };
    return s.addEventListener("change", o), () => s.removeEventListener("change", o);
  }, [i, l]), i;
}
const Pp = (l, i, u) => l ? i : u, _c = (l) => (l || []).join(" ");
function tg(l, i) {
  (i == null || i > l.length) && (i = l.length);
  for (var u = 0, s = Array(i); u < i; u++) s[u] = l[u];
  return s;
}
function kb(l) {
  if (Array.isArray(l)) return l;
}
function Lb(l, i) {
  var u = l == null ? null : typeof Symbol < "u" && l[Symbol.iterator] || l["@@iterator"];
  if (u != null) {
    var s, o, f, m, g = [], y = !0, b = !1;
    try {
      if (f = (u = u.call(l)).next, i !== 0) for (; !(y = (s = f.call(u)).done) && (g.push(s.value), g.length !== i); y = !0) ;
    } catch (T) {
      b = !0, o = T;
    } finally {
      try {
        if (!y && u.return != null && (m = u.return(), Object(m) !== m)) return;
      } finally {
        if (b) throw o;
      }
    }
    return g;
  }
}
function Bb() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Hb(l, i) {
  return kb(l) || Lb(l, i) || Ub(l, i) || Bb();
}
function Ub(l, i) {
  if (l) {
    if (typeof l == "string") return tg(l, i);
    var u = {}.toString.call(l).slice(8, -1);
    return u === "Object" && l.constructor && (u = l.constructor.name), u === "Map" || u === "Set" ? Array.from(l) : u === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(u) ? tg(l, i) : void 0;
  }
}
const iy = Object.entries, eg = Object.setPrototypeOf, qb = Object.isFrozen, Vb = Object.getPrototypeOf, Yb = Object.getOwnPropertyDescriptor;
let He = Object.freeze, Ue = Object.seal, Mi = Object.create, ry = typeof Reflect < "u" && Reflect, zf = ry.apply, Mf = ry.construct;
He || (He = function(i) {
  return i;
});
Ue || (Ue = function(i) {
  return i;
});
zf || (zf = function(i, u) {
  for (var s = arguments.length, o = new Array(s > 2 ? s - 2 : 0), f = 2; f < s; f++)
    o[f - 2] = arguments[f];
  return i.apply(u, o);
});
Mf || (Mf = function(i) {
  for (var u = arguments.length, s = new Array(u > 1 ? u - 1 : 0), o = 1; o < u; o++)
    s[o - 1] = arguments[o];
  return new i(...s);
});
const Vr = Oe(Array.prototype.forEach), Gb = Oe(Array.prototype.lastIndexOf), ng = Oe(Array.prototype.pop), Di = Oe(Array.prototype.push), Xb = Oe(Array.prototype.splice), el = Array.isArray, Zr = Oe(String.prototype.toLowerCase), df = Oe(String.prototype.toString), ag = Oe(String.prototype.match), Yr = Oe(String.prototype.replace), lg = Oe(String.prototype.indexOf), Qb = Oe(String.prototype.trim), Zb = Oe(Number.prototype.toString), Kb = Oe(Boolean.prototype.toString), ig = typeof BigInt > "u" ? null : Oe(BigInt.prototype.toString), rg = typeof Symbol > "u" ? null : Oe(Symbol.prototype.toString), Re = Oe(Object.prototype.hasOwnProperty), Gr = Oe(Object.prototype.toString), Le = Oe(RegExp.prototype.test), Rl = $b(TypeError);
function Oe(l) {
  return function(i) {
    i instanceof RegExp && (i.lastIndex = 0);
    for (var u = arguments.length, s = new Array(u > 1 ? u - 1 : 0), o = 1; o < u; o++)
      s[o - 1] = arguments[o];
    return zf(l, i, s);
  };
}
function $b(l) {
  return function() {
    for (var i = arguments.length, u = new Array(i), s = 0; s < i; s++)
      u[s] = arguments[s];
    return Mf(l, u);
  };
}
function Ot(l, i) {
  let u = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Zr;
  if (eg && eg(l, null), !el(i))
    return l;
  let s = i.length;
  for (; s--; ) {
    let o = i[s];
    if (typeof o == "string") {
      const f = u(o);
      f !== o && (qb(i) || (i[s] = f), o = f);
    }
    l[o] = !0;
  }
  return l;
}
function Jb(l) {
  for (let i = 0; i < l.length; i++)
    Re(l, i) || (l[i] = null);
  return l;
}
function Ge(l) {
  const i = Mi(null);
  for (const s of iy(l)) {
    var u = Hb(s, 2);
    const o = u[0], f = u[1];
    Re(l, o) && (el(f) ? i[o] = Jb(f) : f && typeof f == "object" && f.constructor === Object ? i[o] = Ge(f) : i[o] = f);
  }
  return i;
}
function Wb(l) {
  switch (typeof l) {
    case "string":
      return l;
    case "number":
      return Zb(l);
    case "boolean":
      return Kb(l);
    case "bigint":
      return ig ? ig(l) : "0";
    case "symbol":
      return rg ? rg(l) : "Symbol()";
    case "undefined":
      return Gr(l);
    case "function":
    case "object": {
      if (l === null)
        return Gr(l);
      const i = l, u = Gn(i, "toString");
      if (typeof u == "function") {
        const s = u(i);
        return typeof s == "string" ? s : Gr(s);
      }
      return Gr(l);
    }
    default:
      return Gr(l);
  }
}
function Gn(l, i) {
  for (; l !== null; ) {
    const s = Yb(l, i);
    if (s) {
      if (s.get)
        return Oe(s.get);
      if (typeof s.value == "function")
        return Oe(s.value);
    }
    l = Vb(l);
  }
  function u() {
    return null;
  }
  return u;
}
function Fb(l) {
  try {
    return Le(l, ""), !0;
  } catch {
    return !1;
  }
}
const ug = He(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "search", "section", "select", "shadow", "slot", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), hf = He(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "enterkeyhint", "exportparts", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "inputmode", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "part", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), mf = He(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), Ib = He(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), pf = He(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), Pb = He(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), cg = He(["#text"]), sg = He(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "command", "commandfor", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "exportparts", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inert", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "part", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "slot", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns"]), gf = He(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "mask-type", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), og = He(["accent", "accentunder", "align", "bevelled", "close", "columnalign", "columnlines", "columnspacing", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lquote", "lspace", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), gc = He(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), t1 = Ue(/{{[\w\W]*|^[\w\W]*}}/g), e1 = Ue(/<%[\w\W]*|^[\w\W]*%>/g), n1 = Ue(/\${[\w\W]*/g), a1 = Ue(/^data-[\-\w.\u00B7-\uFFFF]+$/), l1 = Ue(/^aria-[\-\w]+$/), fg = Ue(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), i1 = Ue(/^(?:\w+script|data):/i), r1 = Ue(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), u1 = Ue(/^html$/i), c1 = Ue(/^[a-z][.\w]*(-[.\w]+)+$/i), dg = Ue(/<[/\w!]/g), s1 = Ue(/<[/\w]/g), o1 = Ue(/<\/no(script|embed|frames)/i), f1 = Ue(/\/>/i), Yn = {
  element: 1,
  attribute: 2,
  text: 3,
  cdataSection: 4,
  entityReference: 5,
  // Deprecated
  entityNode: 6,
  // Deprecated
  processingInstruction: 7,
  comment: 8,
  document: 9,
  documentType: 10,
  documentFragment: 11,
  notation: 12
  // Deprecated
}, d1 = function() {
  return typeof window > "u" ? null : window;
}, h1 = function(i, u) {
  if (typeof i != "object" || typeof i.createPolicy != "function")
    return null;
  let s = null;
  const o = "data-tt-policy-suffix";
  u && u.hasAttribute(o) && (s = u.getAttribute(o));
  const f = "dompurify" + (s ? "#" + s : "");
  try {
    return i.createPolicy(f, {
      createHTML(m) {
        return m;
      },
      createScriptURL(m) {
        return m;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + f + " could not be created."), null;
  }
}, hg = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
}, Pa = function(i, u, s, o) {
  return Re(i, u) && el(i[u]) ? Ot(o.base ? Ge(o.base) : {}, i[u], o.transform) : s;
};
function uy() {
  let l = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : d1();
  const i = (Z) => uy(Z);
  if (i.version = "3.4.11", i.removed = [], !l || !l.document || l.document.nodeType !== Yn.document || !l.Element)
    return i.isSupported = !1, i;
  let u = l.document;
  const s = u, o = s.currentScript;
  l.DocumentFragment;
  const f = l.HTMLTemplateElement, m = l.Node, g = l.Element, y = l.NodeFilter, b = l.NamedNodeMap;
  b === void 0 && (l.NamedNodeMap || l.MozNamedAttrMap), l.HTMLFormElement;
  const T = l.DOMParser, A = l.trustedTypes, x = g.prototype, U = Gn(x, "cloneNode"), D = Gn(x, "remove"), R = Gn(x, "nextSibling"), q = Gn(x, "childNodes"), Y = Gn(x, "parentNode"), L = Gn(x, "shadowRoot"), et = Gn(x, "attributes"), W = m && m.prototype ? Gn(m.prototype, "nodeType") : null, X = m && m.prototype ? Gn(m.prototype, "nodeName") : null;
  if (typeof f == "function") {
    const Z = u.createElement("template");
    Z.content && Z.content.ownerDocument && (u = Z.content.ownerDocument);
  }
  let B, G = "", F, ut = !1, yt = 0;
  const Dt = function() {
    if (yt > 0)
      throw Rl('A configured TRUSTED_TYPES_POLICY callback (createHTML or createScriptURL) must not call DOMPurify.sanitize, as that causes infinite recursion. Do not pass a policy whose callbacks wrap DOMPurify as TRUSTED_TYPES_POLICY; see the "DOMPurify and Trusted Types" section of the README.');
  }, Nt = function(S) {
    Dt(), yt++;
    try {
      return B.createHTML(S);
    } finally {
      yt--;
    }
  }, pt = function(S) {
    Dt(), yt++;
    try {
      return B.createScriptURL(S);
    } finally {
      yt--;
    }
  }, Se = function() {
    return ut || (F = h1(A, o), ut = !0), F;
  }, Zt = u, Q = Zt.implementation, V = Zt.createNodeIterator, $ = Zt.createDocumentFragment, J = Zt.getElementsByTagName, tt = s.importNode;
  let lt = hg();
  i.isSupported = typeof iy == "function" && typeof Y == "function" && Q && Q.createHTMLDocument !== void 0;
  const vt = t1, ct = e1, at = n1, ot = a1, ue = l1, fe = i1, bt = r1, Ut = c1;
  let Kt = fg, zt = null;
  const Zn = Ot({}, [...ug, ...hf, ...mf, ...pf, ...cg]);
  let Jt = null;
  const qi = Ot({}, [...sg, ...gf, ...og, ...gc]);
  let Lt = Object.seal(Mi(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), Kn = null, Gl = null;
  const Cn = Object.seal(Mi(null, {
    tagCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    }
  }));
  let Vi = !0, il = !0, Xl = !1, Ql = !0, Dn = !1, rl = !0, de = !1, Yi = !1, Zl = null, Kl = null, va = !1, ba = !1, ul = !1, $l = !1, nu = !0, Sa = !1;
  const qe = "user-content-";
  let dn = !0, Ce = !1, Ta = {}, hn = null;
  const Gi = Ot({}, [
    "annotation-xml",
    "audio",
    "colgroup",
    "desc",
    "foreignobject",
    "head",
    "iframe",
    "math",
    "mi",
    "mn",
    "mo",
    "ms",
    "mtext",
    "noembed",
    "noframes",
    "noscript",
    "plaintext",
    "script",
    // <selectedcontent> mirrors the selected <option>'s subtree, cloned by
    // the UA (customizable <select>) — including any on* handlers — and the
    // engine re-mirrors synchronously whenever a removal changes which
    // option/selectedcontent is current, even inside DOMPurify's inert
    // DOMParser document. Hoisting its children on removal re-inserts a fresh
    // mirror target ahead of the walk, which the engine refills, looping
    // forever (DoS) and amplifying output. Dropping its content on removal
    // (rather than hoisting) breaks that cascade; the content is a duplicate
    // of the option, which is sanitized on its own. See campaign-3 F1/F6.
    "selectedcontent",
    "style",
    "svg",
    "template",
    "thead",
    "title",
    "video",
    "xmp"
  ]);
  let cl = null;
  const sl = Ot({}, ["audio", "video", "img", "source", "image", "track"]);
  let wa = null;
  const zn = Ot({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), $n = "http://www.w3.org/1998/Math/MathML", Mn = "http://www.w3.org/2000/svg", mn = "http://www.w3.org/1999/xhtml";
  let Jn = mn, ol = !1, Wn = null;
  const es = Ot({}, [$n, Mn, mn], df), Xi = He(["mi", "mo", "mn", "ms", "mtext"]);
  let Jl = Ot({}, Xi);
  const Qi = He(["annotation-xml"]);
  let fl = Ot({}, Qi);
  const Zi = Ot({}, ["title", "style", "font", "a", "script"]);
  let xa = null;
  const au = ["application/xhtml+xml", "text/html"], kn = "text/html";
  let ht = null, he = null;
  const Aa = u.createElement("form"), Wl = function(S) {
    return S instanceof RegExp || S instanceof Function;
  }, Ki = function() {
    let S = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (he && he === S)
      return;
    (!S || typeof S != "object") && (S = {}), S = Ge(S), xa = // eslint-disable-next-line unicorn/prefer-includes
    au.indexOf(S.PARSER_MEDIA_TYPE) === -1 ? kn : S.PARSER_MEDIA_TYPE, ht = xa === "application/xhtml+xml" ? df : Zr, zt = Pa(S, "ALLOWED_TAGS", Zn, {
      transform: ht
    }), Jt = Pa(S, "ALLOWED_ATTR", qi, {
      transform: ht
    }), Wn = Pa(S, "ALLOWED_NAMESPACES", es, {
      transform: df
    }), wa = Pa(S, "ADD_URI_SAFE_ATTR", zn, {
      transform: ht,
      base: zn
    }), cl = Pa(S, "ADD_DATA_URI_TAGS", sl, {
      transform: ht,
      base: sl
    }), hn = Pa(S, "FORBID_CONTENTS", Gi, {
      transform: ht
    }), Kn = Pa(S, "FORBID_TAGS", Ge({}), {
      transform: ht
    }), Gl = Pa(S, "FORBID_ATTR", Ge({}), {
      transform: ht
    }), Ta = Re(S, "USE_PROFILES") ? S.USE_PROFILES && typeof S.USE_PROFILES == "object" ? Ge(S.USE_PROFILES) : S.USE_PROFILES : !1, Vi = S.ALLOW_ARIA_ATTR !== !1, il = S.ALLOW_DATA_ATTR !== !1, Xl = S.ALLOW_UNKNOWN_PROTOCOLS || !1, Ql = S.ALLOW_SELF_CLOSE_IN_ATTR !== !1, Dn = S.SAFE_FOR_TEMPLATES || !1, rl = S.SAFE_FOR_XML !== !1, de = S.WHOLE_DOCUMENT || !1, ba = S.RETURN_DOM || !1, ul = S.RETURN_DOM_FRAGMENT || !1, $l = S.RETURN_TRUSTED_TYPE || !1, va = S.FORCE_BODY || !1, nu = S.SANITIZE_DOM !== !1, Sa = S.SANITIZE_NAMED_PROPS || !1, dn = S.KEEP_CONTENT !== !1, Ce = S.IN_PLACE || !1, Kt = Fb(S.ALLOWED_URI_REGEXP) ? S.ALLOWED_URI_REGEXP : fg, Jn = typeof S.NAMESPACE == "string" ? S.NAMESPACE : mn, Jl = Re(S, "MATHML_TEXT_INTEGRATION_POINTS") && S.MATHML_TEXT_INTEGRATION_POINTS && typeof S.MATHML_TEXT_INTEGRATION_POINTS == "object" ? Ge(S.MATHML_TEXT_INTEGRATION_POINTS) : Ot({}, Xi), fl = Re(S, "HTML_INTEGRATION_POINTS") && S.HTML_INTEGRATION_POINTS && typeof S.HTML_INTEGRATION_POINTS == "object" ? Ge(S.HTML_INTEGRATION_POINTS) : Ot({}, Qi);
    const j = Re(S, "CUSTOM_ELEMENT_HANDLING") && S.CUSTOM_ELEMENT_HANDLING && typeof S.CUSTOM_ELEMENT_HANDLING == "object" ? Ge(S.CUSTOM_ELEMENT_HANDLING) : Mi(null);
    if (Lt = Mi(null), Re(j, "tagNameCheck") && Wl(j.tagNameCheck) && (Lt.tagNameCheck = j.tagNameCheck), Re(j, "attributeNameCheck") && Wl(j.attributeNameCheck) && (Lt.attributeNameCheck = j.attributeNameCheck), Re(j, "allowCustomizedBuiltInElements") && typeof j.allowCustomizedBuiltInElements == "boolean" && (Lt.allowCustomizedBuiltInElements = j.allowCustomizedBuiltInElements), Ue(Lt), Dn && (il = !1), ul && (ba = !0), Ta && (zt = Ot({}, cg), Jt = Mi(null), Ta.html === !0 && (Ot(zt, ug), Ot(Jt, sg)), Ta.svg === !0 && (Ot(zt, hf), Ot(Jt, gf), Ot(Jt, gc)), Ta.svgFilters === !0 && (Ot(zt, mf), Ot(Jt, gf), Ot(Jt, gc)), Ta.mathMl === !0 && (Ot(zt, pf), Ot(Jt, og), Ot(Jt, gc))), Cn.tagCheck = null, Cn.attributeCheck = null, Re(S, "ADD_TAGS") && (typeof S.ADD_TAGS == "function" ? Cn.tagCheck = S.ADD_TAGS : el(S.ADD_TAGS) && (zt === Zn && (zt = Ge(zt)), Ot(zt, S.ADD_TAGS, ht))), Re(S, "ADD_ATTR") && (typeof S.ADD_ATTR == "function" ? Cn.attributeCheck = S.ADD_ATTR : el(S.ADD_ATTR) && (Jt === qi && (Jt = Ge(Jt)), Ot(Jt, S.ADD_ATTR, ht))), Re(S, "ADD_URI_SAFE_ATTR") && el(S.ADD_URI_SAFE_ATTR) && Ot(wa, S.ADD_URI_SAFE_ATTR, ht), Re(S, "FORBID_CONTENTS") && el(S.FORBID_CONTENTS) && (hn === Gi && (hn = Ge(hn)), Ot(hn, S.FORBID_CONTENTS, ht)), Re(S, "ADD_FORBID_CONTENTS") && el(S.ADD_FORBID_CONTENTS) && (hn === Gi && (hn = Ge(hn)), Ot(hn, S.ADD_FORBID_CONTENTS, ht)), dn && (zt["#text"] = !0), de && Ot(zt, ["html", "head", "body"]), zt.table && (Ot(zt, ["tbody"]), delete Kn.tbody), S.TRUSTED_TYPES_POLICY) {
      if (typeof S.TRUSTED_TYPES_POLICY.createHTML != "function")
        throw Rl('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
      if (typeof S.TRUSTED_TYPES_POLICY.createScriptURL != "function")
        throw Rl('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
      const K = B;
      B = S.TRUSTED_TYPES_POLICY;
      try {
        G = Nt("");
      } catch (I) {
        throw B = K, I;
      }
    } else S.TRUSTED_TYPES_POLICY === null ? (B = void 0, G = "") : (B === void 0 && (B = Se()), B && typeof G == "string" && (G = Nt("")));
    He && He(S), he = S;
  }, lu = Ot({}, [...hf, ...mf, ...Ib]), $i = Ot({}, [...pf, ...Pb]), dl = function(S, j, K) {
    return j.namespaceURI === mn ? S === "svg" : j.namespaceURI === $n ? S === "svg" && (K === "annotation-xml" || Jl[K]) : !!lu[S];
  }, Ji = function(S, j, K) {
    return j.namespaceURI === mn ? S === "math" : j.namespaceURI === Mn ? S === "math" && fl[K] : !!$i[S];
  }, _a = function(S, j, K) {
    return j.namespaceURI === Mn && !fl[K] || j.namespaceURI === $n && !Jl[K] ? !1 : !$i[S] && (Zi[S] || !lu[S]);
  }, Oa = function(S) {
    let j = Y(S);
    (!j || !j.tagName) && (j = {
      namespaceURI: Jn,
      tagName: "template"
    });
    const K = Zr(S.tagName), I = Zr(j.tagName);
    return Wn[S.namespaceURI] ? S.namespaceURI === Mn ? dl(K, j, I) : S.namespaceURI === $n ? Ji(K, j, I) : S.namespaceURI === mn ? _a(K, j, I) : !!(xa === "application/xhtml+xml" && Wn[S.namespaceURI]) : !1;
  }, Ze = function(S) {
    Di(i.removed, {
      element: S
    });
    try {
      Y(S).removeChild(S);
    } catch {
      if (D(S), !Y(S))
        throw Rl("a node selected for removal could not be detached from its tree and cannot be safely returned; refusing to sanitize in place");
    }
  }, Fn = function(S) {
    const j = q(S);
    if (j) {
      const I = [];
      Vr(j, (ft) => {
        Di(I, ft);
      }), Vr(I, (ft) => {
        try {
          D(ft);
        } catch {
        }
      });
    }
    const K = et(S);
    if (K)
      for (let I = K.length - 1; I >= 0; --I) {
        const ft = K[I], wt = ft && ft.name;
        if (typeof wt == "string")
          try {
            S.removeAttribute(wt);
          } catch {
          }
      }
  }, Wt = function(S, j) {
    try {
      Di(i.removed, {
        attribute: j.getAttributeNode(S),
        from: j
      });
    } catch {
      Di(i.removed, {
        attribute: null,
        from: j
      });
    }
    if (j.removeAttribute(S), S === "is")
      if (ba || ul)
        try {
          Ze(j);
        } catch {
        }
      else
        try {
          j.setAttribute(S, "");
        } catch {
        }
  }, iu = function(S) {
    const j = et(S);
    if (j)
      for (let K = j.length - 1; K >= 0; --K) {
        const I = j[K], ft = I && I.name;
        if (!(typeof ft != "string" || Jt[ht(ft)]))
          try {
            S.removeAttribute(ft);
          } catch {
          }
      }
  }, ru = function(S) {
    const j = [S];
    for (; j.length > 0; ) {
      const K = j.pop();
      (W ? W(K) : K.nodeType) === Yn.element && iu(K);
      const ft = q(K);
      if (ft)
        for (let wt = ft.length - 1; wt >= 0; --wt)
          j.push(ft[wt]);
    }
  }, Ln = function(S) {
    let j = null, K = null;
    if (va)
      S = "<remove></remove>" + S;
    else {
      const wt = ag(S, /^[\r\n\t ]+/);
      K = wt && wt[0];
    }
    xa === "application/xhtml+xml" && Jn === mn && (S = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + S + "</body></html>");
    const I = B ? Nt(S) : S;
    if (Jn === mn)
      try {
        j = new T().parseFromString(I, xa);
      } catch {
      }
    if (!j || !j.documentElement) {
      j = Q.createDocument(Jn, "template", null);
      try {
        j.documentElement.innerHTML = ol ? G : I;
      } catch {
      }
    }
    const ft = j.body || j.documentElement;
    return S && K && ft.insertBefore(u.createTextNode(K), ft.childNodes[0] || null), Jn === mn ? J.call(j, de ? "html" : "body")[0] : de ? j.documentElement : ft;
  }, In = function(S) {
    return V.call(
      S.ownerDocument || S,
      S,
      // eslint-disable-next-line no-bitwise
      y.SHOW_ELEMENT | y.SHOW_COMMENT | y.SHOW_TEXT | y.SHOW_PROCESSING_INSTRUCTION | y.SHOW_CDATA_SECTION,
      null
    );
  }, Fl = function(S) {
    return S = Yr(S, vt, " "), S = Yr(S, ct, " "), S = Yr(S, at, " "), S;
  }, Il = function(S) {
    var j;
    S.normalize();
    const K = V.call(
      S.ownerDocument || S,
      S,
      // eslint-disable-next-line no-bitwise
      y.SHOW_TEXT | y.SHOW_COMMENT | y.SHOW_CDATA_SECTION | y.SHOW_PROCESSING_INSTRUCTION,
      null
    );
    let I = K.nextNode();
    for (; I; )
      I.data = Fl(I.data), I = K.nextNode();
    const ft = (j = S.querySelectorAll) === null || j === void 0 ? void 0 : j.call(S, "template");
    ft && Vr(ft, (wt) => {
      Na(wt.content) && Il(wt.content);
    });
  }, hl = function(S) {
    const j = X ? X(S) : null;
    return typeof j != "string" || ht(j) !== "form" ? !1 : typeof S.nodeName != "string" || typeof S.textContent != "string" || typeof S.removeChild != "function" || // Realm-safe NamedNodeMap detection: equality against the cached
    // prototype getter. Clobbered .attributes (e.g. <input name="attributes">)
    // makes the direct read diverge from the cached read; a clean form
    // (same-realm OR foreign-realm) has both reads pointing at the same
    // canonical NamedNodeMap.
    S.attributes !== et(S) || typeof S.removeAttribute != "function" || typeof S.setAttribute != "function" || typeof S.namespaceURI != "string" || typeof S.insertBefore != "function" || typeof S.hasChildNodes != "function" || // NodeType clobbering probe. Cached Node.prototype.nodeType getter
    // returns the integer 1 for any Element regardless of realm; direct
    // read on a clobbered form (e.g. <input name="nodeType">) returns
    // the named child element. Cheap addition — nodeType is read from
    // an internal slot, no serialization cost — and removes a residual
    // clobbering surface used by several mXSS / PI / comment branches
    // in _sanitizeElements that compare currentNode.nodeType directly.
    S.nodeType !== W(S) || // HTMLFormElement has [LegacyOverrideBuiltIns]: a descendant named
    // "childNodes" shadows the prototype getter. Direct reads of
    // form.childNodes from a clobbered form return the named child
    // instead of the real NodeList, so any walk that reads it directly
    // skips the form's real children. Compare the direct read to the
    // cached Node.prototype getter — when the form's named-property
    // getter intercepts the read, the two values differ and we flag
    // the form. This catches every clobbering child type (input,
    // select, etc.) regardless of whether the named child happens to
    // carry a numeric .length, which a typeof-based probe would miss
    // (e.g. HTMLSelectElement.length is a defined unsigned-long).
    S.childNodes !== q(S);
  }, Na = function(S) {
    if (!W || typeof S != "object" || S === null)
      return !1;
    try {
      return W(S) === Yn.documentFragment;
    } catch {
      return !1;
    }
  }, Bn = function(S) {
    if (!W || typeof S != "object" || S === null)
      return !1;
    try {
      return typeof W(S) == "number";
    } catch {
      return !1;
    }
  };
  function Ke(Z, S, j) {
    Z.length !== 0 && Vr(Z, (K) => {
      K.call(i, S, j, he);
    });
  }
  const An = function(S, j) {
    return !!(rl && S.hasChildNodes() && !Bn(S.firstElementChild) && Le(dg, S.textContent) && Le(dg, S.innerHTML) || rl && S.namespaceURI === mn && j === "style" && Bn(S.firstElementChild) || S.nodeType === Yn.processingInstruction || rl && S.nodeType === Yn.comment && Le(s1, S.data));
  }, $e = function(S, j) {
    if (!Kn[j] && Ii(j) && (Lt.tagNameCheck instanceof RegExp && Le(Lt.tagNameCheck, j) || Lt.tagNameCheck instanceof Function && Lt.tagNameCheck(j)))
      return !1;
    if (dn && !hn[j]) {
      const K = Y(S), I = q(S);
      if (I && K) {
        const ft = I.length;
        for (let wt = ft - 1; wt >= 0; --wt) {
          const me = Ce ? I[wt] : U(I[wt], !0);
          K.insertBefore(me, R(S));
        }
      }
    }
    return Ze(S), !0;
  }, Wi = function(S) {
    if (Ke(lt.beforeSanitizeElements, S, null), hl(S))
      return Ze(S), !0;
    const j = ht(X ? X(S) : S.nodeName);
    if (Ke(lt.uponSanitizeElement, S, {
      tagName: j,
      allowedTags: zt
    }), An(S, j))
      return Ze(S), !0;
    if (Kn[j] || !(Cn.tagCheck instanceof Function && Cn.tagCheck(j)) && !zt[j])
      return $e(S, j);
    if ((W ? W(S) : S.nodeType) === Yn.element && !Oa(S) || (j === "noscript" || j === "noembed" || j === "noframes") && Le(o1, S.innerHTML))
      return Ze(S), !0;
    if (Dn && S.nodeType === Yn.text) {
      const I = Fl(S.textContent);
      S.textContent !== I && (Di(i.removed, {
        element: S.cloneNode()
      }), S.textContent = I);
    }
    return Ke(lt.afterSanitizeElements, S, null), !1;
  }, uu = function(S, j, K) {
    if (Gl[j] || nu && (j === "id" || j === "name") && (K in u || K in Aa))
      return !1;
    const I = Jt[j] || Cn.attributeCheck instanceof Function && Cn.attributeCheck(j, S);
    if (!(il && Le(ot, j))) {
      if (!(Vi && Le(ue, j))) {
        if (I) {
          if (!wa[j]) {
            if (!Le(Kt, Yr(K, bt, ""))) {
              if (!((j === "src" || j === "xlink:href" || j === "href") && S !== "script" && lg(K, "data:") === 0 && cl[S])) {
                if (!(Xl && !Le(fe, Yr(K, bt, "")))) {
                  if (K)
                    return !1;
                }
              }
            }
          }
        } else if (
          // First condition does a very basic check if a) it's basically a valid custom element tagname AND
          // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
          // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
          !(Ii(S) && (Lt.tagNameCheck instanceof RegExp && Le(Lt.tagNameCheck, S) || Lt.tagNameCheck instanceof Function && Lt.tagNameCheck(S)) && (Lt.attributeNameCheck instanceof RegExp && Le(Lt.attributeNameCheck, j) || Lt.attributeNameCheck instanceof Function && Lt.attributeNameCheck(j, S)) || // Alternative, second condition checks if it's an `is`-attribute, AND
          // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
          j === "is" && Lt.allowCustomizedBuiltInElements && (Lt.tagNameCheck instanceof RegExp && Le(Lt.tagNameCheck, K) || Lt.tagNameCheck instanceof Function && Lt.tagNameCheck(K)))
        ) return !1;
      }
    }
    return !0;
  }, Fi = Ot({}, ["annotation-xml", "color-profile", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "missing-glyph"]), Ii = function(S) {
    return !Fi[Zr(S)] && Le(Ut, S);
  }, Pl = function(S, j, K, I) {
    if (B && typeof A == "object" && typeof A.getAttributeType == "function" && !K)
      switch (A.getAttributeType(S, j)) {
        case "TrustedHTML":
          return Nt(I);
        case "TrustedScriptURL":
          return pt(I);
      }
    return I;
  }, ns = function(S, j, K, I) {
    try {
      K ? S.setAttributeNS(K, j, I) : S.setAttribute(j, I), hl(S) ? Ze(S) : ng(i.removed);
    } catch {
      Wt(j, S);
    }
  }, Ve = function(S) {
    Ke(lt.beforeSanitizeAttributes, S, null);
    const j = S.attributes;
    if (!j || hl(S))
      return;
    const K = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: Jt,
      forceKeepAttr: void 0
    };
    let I = j.length;
    const ft = ht(S.nodeName);
    for (; I--; ) {
      const wt = j[I], me = wt.name, ae = wt.namespaceURI, Je = wt.value, an = ht(me), ja = Je;
      let Ft = me === "value" ? ja : Qb(ja);
      if (K.attrName = an, K.attrValue = Ft, K.keepAttr = !0, K.forceKeepAttr = void 0, Ke(lt.uponSanitizeAttribute, S, K), Ft = K.attrValue, Sa && (an === "id" || an === "name") && lg(Ft, qe) !== 0 && (Wt(me, S), Ft = qe + Ft), rl && Le(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, Ft)) {
        Wt(me, S);
        continue;
      }
      if (an === "attributename" && ag(Ft, "href")) {
        Wt(me, S);
        continue;
      }
      if (!K.forceKeepAttr) {
        if (!K.keepAttr) {
          Wt(me, S);
          continue;
        }
        if (!Ql && Le(f1, Ft)) {
          Wt(me, S);
          continue;
        }
        if (Dn && (Ft = Fl(Ft)), !uu(ft, an, Ft)) {
          Wt(me, S);
          continue;
        }
        Ft = Pl(ft, an, ae, Ft), Ft !== ja && ns(S, me, ae, Ft);
      }
    }
    Ke(lt.afterSanitizeAttributes, S, null);
  }, Ea = function(S) {
    let j = null;
    const K = In(S);
    for (Ke(lt.beforeSanitizeShadowDOM, S, null); j = K.nextNode(); )
      if (Ke(lt.uponSanitizeShadowNode, j, null), Wi(j), Ve(j), Na(j.content) && Ea(j.content), (W ? W(j) : j.nodeType) === Yn.element) {
        const ft = L(j);
        Na(ft) && (ti(ft), Ea(ft));
      }
    Ke(lt.afterSanitizeShadowDOM, S, null);
  }, ti = function(S) {
    const j = [{
      node: S,
      shadow: null
    }];
    for (; j.length > 0; ) {
      const K = j.pop();
      if (K.shadow) {
        Ea(K.shadow);
        continue;
      }
      const I = K.node, wt = (W ? W(I) : I.nodeType) === Yn.element, me = q(I);
      if (me)
        for (let ae = me.length - 1; ae >= 0; --ae)
          j.push({
            node: me[ae],
            shadow: null
          });
      if (wt) {
        const ae = X ? X(I) : null;
        if (typeof ae == "string" && ht(ae) === "template") {
          const Je = I.content;
          Na(Je) && j.push({
            node: Je,
            shadow: null
          });
        }
      }
      if (wt) {
        const ae = L(I);
        Na(ae) && j.push({
          node: null,
          shadow: ae
        }, {
          node: ae,
          shadow: null
        });
      }
    }
  };
  return i.sanitize = function(Z) {
    let S = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, j = null, K = null, I = null, ft = null;
    if (ol = !Z, ol && (Z = "<!-->"), typeof Z != "string" && !Bn(Z) && (Z = Wb(Z), typeof Z != "string"))
      throw Rl("dirty is not a string, aborting");
    if (!i.isSupported)
      return Z;
    Yi ? (zt = Zl, Jt = Kl) : Ki(S), (lt.uponSanitizeElement.length > 0 || lt.uponSanitizeAttribute.length > 0) && (zt = Ge(zt)), lt.uponSanitizeAttribute.length > 0 && (Jt = Ge(Jt)), i.removed = [];
    const wt = Ce && typeof Z != "string" && Bn(Z);
    if (wt) {
      const Je = X ? X(Z) : Z.nodeName;
      if (typeof Je == "string") {
        const an = ht(Je);
        if (!zt[an] || Kn[an])
          throw Rl("root node is forbidden and cannot be sanitized in-place");
      }
      if (hl(Z))
        throw Rl("root node is clobbered and cannot be sanitized in-place");
      try {
        ti(Z);
      } catch (an) {
        throw Fn(Z), an;
      }
    } else if (Bn(Z))
      j = Ln("<!---->"), K = j.ownerDocument.importNode(Z, !0), K.nodeType === Yn.element && K.nodeName === "BODY" || K.nodeName === "HTML" ? j = K : j.appendChild(K), ti(K);
    else {
      if (!ba && !Dn && !de && // eslint-disable-next-line unicorn/prefer-includes
      Z.indexOf("<") === -1)
        return B && $l ? Nt(Z) : Z;
      if (j = Ln(Z), !j)
        return ba ? null : $l ? G : "";
    }
    j && va && Ze(j.firstChild);
    const me = In(wt ? Z : j);
    try {
      for (; I = me.nextNode(); )
        Wi(I), Ve(I), Na(I.content) && Ea(I.content);
    } catch (Je) {
      throw wt && Fn(Z), Je;
    }
    if (wt)
      return Vr(i.removed, (Je) => {
        Je.element && ru(Je.element);
      }), Dn && Il(Z), Z;
    if (ba) {
      if (Dn && Il(j), ul)
        for (ft = $.call(j.ownerDocument); j.firstChild; )
          ft.appendChild(j.firstChild);
      else
        ft = j;
      return (Jt.shadowroot || Jt.shadowrootmode) && (ft = tt.call(s, ft, !0)), ft;
    }
    let ae = de ? j.outerHTML : j.innerHTML;
    return de && zt["!doctype"] && j.ownerDocument && j.ownerDocument.doctype && j.ownerDocument.doctype.name && Le(u1, j.ownerDocument.doctype.name) && (ae = "<!DOCTYPE " + j.ownerDocument.doctype.name + `>
` + ae), Dn && (ae = Fl(ae)), B && $l ? Nt(ae) : ae;
  }, i.setConfig = function() {
    let Z = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Ki(Z), Yi = !0, Zl = zt, Kl = Jt;
  }, i.clearConfig = function() {
    he = null, Yi = !1, Zl = null, Kl = null, B = F, G = "";
  }, i.isValidAttribute = function(Z, S, j) {
    he || Ki({});
    const K = ht(Z), I = ht(S);
    return uu(K, I, j);
  }, i.addHook = function(Z, S) {
    typeof S == "function" && Re(lt, Z) && Di(lt[Z], S);
  }, i.removeHook = function(Z, S) {
    if (Re(lt, Z)) {
      if (S !== void 0) {
        const j = Gb(lt[Z], S);
        return j === -1 ? void 0 : Xb(lt[Z], j, 1)[0];
      }
      return ng(lt[Z]);
    }
  }, i.removeHooks = function(Z) {
    Re(lt, Z) && (lt[Z] = []);
  }, i.removeAllHooks = function() {
    lt = hg();
  }, i;
}
var mg = uy();
let yc = null;
function m1() {
  return yc || (typeof window < "u" ? yc = mg(window) : yc = mg), yc;
}
function p1(l) {
  const i = l ? document.querySelector(l) : document;
  return i ? i.querySelector(
    'button, [href], input, select, textarea, [tabIndex]:not([tabIndex="-1"])'
  ) : null;
}
const Xe = (l) => ({ __html: m1().sanitize(l) }), pg = (l, i, u) => {
  let s = l;
  const o = [];
  for (; s < i; )
    s > 0 && s <= u && o.push(s), s += 1;
  return o;
};
let yf = !1;
const g1 = (l, i) => {
  yf || (yf = !0, setTimeout(() => {
    l(), yf = !1;
  }, i));
};
let gg;
const y1 = (l, i) => {
  window.clearTimeout(gg), gg = window.setTimeout(l, i);
};
function v1(l) {
  if (l && typeof l.getBoundingClientRect == "function") {
    const { bottom: i, top: u } = l.getBoundingClientRect(), { offsetTop: s } = l;
    if (u < 0 && i > 0) {
      const o = l.style;
      l.style = `${o};transition: height 0s !important; overflow:hidden; height:${i}px!important;max-height:${i}px!important`, window.scrollTo({ behavior: "instant", top: s }), setTimeout(() => {
        l.style = o, window.scrollTo({
          behavior: "smooth",
          top: l.offsetTop - i / 2
        });
      }, 50);
    }
  }
}
p.shape({
  event: p.string,
  action: p.string,
  name: p.string,
  region: p.string,
  section: p.string,
  component: p.string,
  type: p.string,
  text: p.string
});
const cy = ({
  event: l = "",
  action: i = "",
  name: u = "",
  type: s = "",
  section: o = "",
  text: f = "",
  region: m = "",
  component: g = "",
  eventCallback: y,
  eventTimeout: b
}) => {
  const { dataLayer: T } = window, A = {
    event: l.toLowerCase(),
    action: i.toLowerCase(),
    name: u.toLowerCase(),
    type: s.toLowerCase(),
    region: m.toLowerCase(),
    section: o.toLowerCase(),
    text: f.toLowerCase(),
    component: g.toLowerCase()
  };
  y && (A.eventCallback = y), b && (A.eventTimeout = b), T ? T.push(A) : y && y();
}, Pr = ({ children: l }) => /* @__PURE__ */ h.jsx(h.Fragment, { children: l });
Pr.propTypes = {
  children: p.oneOfType([
    p.arrayOf(p.node),
    p.node,
    p.string
  ])
};
var vf = { exports: {} };
var yg;
function b1() {
  return yg || (yg = 1, (function(l) {
    (function() {
      var i = {}.hasOwnProperty;
      function u() {
        for (var f = "", m = 0; m < arguments.length; m++) {
          var g = arguments[m];
          g && (f = o(f, s(g)));
        }
        return f;
      }
      function s(f) {
        if (typeof f == "string" || typeof f == "number")
          return f;
        if (typeof f != "object")
          return "";
        if (Array.isArray(f))
          return u.apply(null, f);
        if (f.toString !== Object.prototype.toString && !f.toString.toString().includes("[native code]"))
          return f.toString();
        var m = "";
        for (var g in f)
          i.call(f, g) && f[g] && (m = o(m, g));
        return m;
      }
      function o(f, m) {
        return m ? f ? f + " " + m : f + m : f;
      }
      l.exports ? (u.default = u, l.exports = u) : window.classNames = u;
    })();
  })(vf)), vf.exports;
}
var S1 = b1();
const Rt = /* @__PURE__ */ If(S1);
({
  ...Pr.propTypes
});
const sy = ({ children: l, className: i = "container", ...u }) => /* @__PURE__ */ h.jsx("div", { className: i, ...u, children: /* @__PURE__ */ h.jsx("div", { className: "row", children: l }) });
sy.propTypes = {
  children: Pr.propTypes.children
};
({
  ...sy.propTypes
});
Pr.propTypes.children, p.oneOf(["0", "3", "4", "6", "8", "9", "12"]);
Pr.propTypes.children;
const T1 = p.shape({
  url: p.string,
  altText: p.string,
  cssClass: p.arrayOf(p.string),
  size: p.oneOf(["small", "medium", "large"])
}), bf = p.shape({
  text: p.string,
  maxWidth: p.string,
  cssClass: p.arrayOf(p.string),
  highlightColor: p.oneOf(["gold", "black"])
}), oy = p.shape({
  color: p.oneOf(["gold", "maroon", "gray", "dark"]),
  content: p.shape({
    icon: p.arrayOf(p.string),
    header: p.string,
    body: p.string
  })
}), Pf = p.shape({
  text: p.string,
  name: p.string,
  event: p.string,
  action: p.string,
  type: p.string,
  region: p.string,
  section: p.string,
  component: p.string
}), w1 = "staticMarkup";
function ql() {
  const i = Ir().indexOf(w1) > -1 ? !0 : void 0;
  return {
    isBootstrap: i,
    isReact: i ? void 0 : !0
  };
}
const be = ({ gaData: l, prefix: i = "", children: u }) => {
  const { isReact: s } = ql(), { onClick: o, ...f } = u.props;
  if (s)
    return ye.cloneElement(u, {
      ...f,
      onClick: (y) => (l && l.event && l.action && cy(l), o ? o(y) : !0)
    });
  let m = "";
  ["input", "header", "header-input"].includes(i) && (m = `-${i}`);
  const g = {
    [`data-ga${m}`]: l.text,
    [`data-ga${m}-name`]: l.name,
    [`data-ga${m}-event`]: l.event,
    [`data-ga${m}-action`]: l.action,
    [`data-ga${m}-type`]: l.type,
    [`data-ga${m}-region`]: l.region,
    [`data-ga${m}-section`]: l.section,
    [`data-ga${m}-component`]: l.component
  };
  return ye.cloneElement(u, {
    ...f,
    onClick: o,
    ...g
  });
}, fy = ({
  id: l,
  parentId: i,
  /** @type {AccordionCard} */
  item: u,
  openCard: s,
  onClick: o,
  gaData: f,
  ref: m
}) => {
  var b, T, A, x, U, D;
  const g = l === s, y = g ? "open" : "close";
  return /* @__PURE__ */ h.jsxs(
    "div",
    {
      ref: m,
      className: Rt("accordion-item", "mt-3", {
        [`accordion-item-${u.color}`]: u.color,
        "accordion-header-icon": (b = u.content) == null ? void 0 : b.icon
      }),
      children: [
        /* @__PURE__ */ h.jsx("div", { className: "accordion-header", children: /* @__PURE__ */ h.jsx("h4", { children: /* @__PURE__ */ h.jsx(
          be,
          {
            gaData: {
              ...f,
              action: y,
              text: u.content.header
            },
            children: /* @__PURE__ */ h.jsxs(
              "button",
              {
                "data-testid": "accordion-opener",
                className: Rt({ collapsed: !g }),
                "data-bs-toggle": "collapse",
                href: `#card-body-${l}`,
                type: "button",
                "aria-expanded": g,
                "aria-controls": `card-body-${l}`,
                onClick: (R) => o(R, l),
                children: [
                  (T = u.content) != null && T.icon ? /* @__PURE__ */ h.jsxs("span", { className: "accordion-icon", children: [
                    /* @__PURE__ */ h.jsx(
                      "i",
                      {
                        className: `${(A = u.content.icon) == null ? void 0 : A[0]} fa-${(x = u.content.icon) == null ? void 0 : x[1]} me-2`
                      }
                    ),
                    u.content.header
                  ] }) : (U = u.content) == null ? void 0 : U.header,
                  /* @__PURE__ */ h.jsx("i", { className: "fas fa-chevron-up" })
                ]
              }
            )
          }
        ) }) }),
        ((D = u.content) == null ? void 0 : D.body) && /* @__PURE__ */ h.jsx(
          "div",
          {
            "data-bs-parent": `#${i}`,
            id: `card-body-${l}`,
            className: Rt("collapse", { show: g }),
            children: /* @__PURE__ */ h.jsx(
              "div",
              {
                className: "accordion-body",
                dangerouslySetInnerHTML: Xe(u.content.body)
              }
            )
          }
        )
      ]
    }
  );
};
fy.propTypes = {
  id: p.number,
  // @ts-ignore a technical type mismatch between PropTypes definition and your TypeScript
  item: oy,
  parentId: p.string,
  openCard: p.number,
  onClick: p.func,
  gaData: p.object
};
const x1 = {
  event: "collapse",
  name: "onclick",
  type: "click",
  region: "main content"
}, dy = ({ cards: l, openedCard: i }) => {
  const [u, s] = ve(i), o = `accordion-${Ir()}`, f = nn(
    /** @type { HTMLDivElement[]} */
    []
  ), m = (g, y) => {
    if (g.preventDefault(), u !== y) {
      const b = f.current[u - 1], T = b == null ? void 0 : b.lastElementChild;
      v1(T), s(y);
    } else
      s(null);
  };
  return /* @__PURE__ */ h.jsx("div", { className: "accordion", id: o, children: l == null ? void 0 : l.map(
    (g, y) => g.content.body && g.content.header && /* @__PURE__ */ h.jsx(
      fy,
      {
        ref: (b) => {
          f.current[y] = b;
        },
        id: y + 1,
        parentId: o,
        item: g,
        openCard: u,
        onClick: m,
        gaData: x1
      },
      y + 1
    )
  ) });
};
dy.propTypes = {
  /**
   * Cards to show in the accordion component
   */
  cards: p.arrayOf(oy).isRequired,
  /**
   * Opened card based on rendered card position
   */
  openedCard: p.number
};
const vg = {
  name: "onclick",
  event: "link",
  action: "click",
  type: "internal link",
  region: "main content"
}, al = ({
  label: l = "",
  cardTitle: i = "",
  gaData: u,
  ariaLabel: s,
  block: o,
  color: f = "gray",
  disabled: m,
  element: g = "button",
  href: y,
  icon: b,
  innerRef: T,
  onClick: A,
  size: x = "default",
  variant: U,
  classes: D,
  target: R = "_self",
  ...q
}) => {
  if (U) {
    const et = {
      borderless: "borderless",
      outline: "outline",
      filled: "filled"
    }, W = Rt("btn", et[U], {
      [`btn-${et[U]}-${f}`]: !0,
      "btn-medium": x === "medium",
      "btn-small": x === "small",
      "btn-large": x === "large" || x === "default",
      disabled: m
    });
    let X = g;
    return y && g === "button" && (X = "a"), /* @__PURE__ */ h.jsx(
      be,
      {
        gaData: {
          ...vg,
          section: i,
          ...u,
          text: l
        },
        children: /* @__PURE__ */ h.jsxs(
          X,
          {
            type: X === "button" && A ? "button" : void 0,
            ...q,
            className: Rt(D) || W,
            href: y,
            ref: T,
            onClick: A,
            "aria-label": s,
            target: X === "a" ? R : null,
            disabled: m,
            children: [
              b && /* @__PURE__ */ h.jsx("i", { className: `${b == null ? void 0 : b[0]} fa-${b == null ? void 0 : b[1]} me-1` }),
              l
            ]
          }
        )
      }
    );
  }
  const Y = Rt("btn", {
    [`btn-${f}`]: !0,
    "btn-md": x === "small",
    "btn-sm": x === "xsmall",
    "btn-block": o,
    disabled: m
  });
  let L = g;
  return y && g === "button" && (L = "a"), /* @__PURE__ */ h.jsx(
    be,
    {
      gaData: {
        ...vg,
        section: i,
        // @deprecated - remove at some point
        ...u,
        text: l
      },
      children: /* @__PURE__ */ h.jsxs(
        L,
        {
          type: L === "button" && A ? "button" : void 0,
          ...q,
          className: Rt(D) || Y,
          href: y,
          ref: T,
          onClick: A,
          "aria-label": s,
          target: L === "a" ? R : null,
          children: [
            b && /* @__PURE__ */ h.jsx("i", { className: `${b == null ? void 0 : b[0]} fa-${b == null ? void 0 : b[1]} me-1` }),
            l
          ]
        }
      )
    }
  );
};
al.propTypes = {
  /**
   * Button label
   */
  label: p.string,
  /**
   * @deprecated
   * Card title, use `gaData.section` instead
   */
  cardTitle: p.string,
  /**
   * Google Analytics event data
   */
  gaData: Pf,
  /**
    ARIA label for accessibility
  */
  ariaLabel: p.string,
  /**
    Render button as a block-button?
  */
  block: p.bool,
  /**
    Button background color
  */
  color: p.oneOf(["gold", "maroon", "gray", "dark"]),
  /**
    Disable the button?
  */
  disabled: p.bool,
  /**
    Pass in a Component to override default button element.
    For example: react-router Link
  */
  element: p.oneOfType([
    p.func,
    p.string,
    p.shape({ $$typeof: p.symbol, render: p.func }),
    p.arrayOf(
      p.oneOfType([
        p.func,
        p.string,
        p.shape({ $$typeof: p.symbol, render: p.func })
      ])
    )
  ]),
  /**
    Link target url; will cause button to be rendered as `<a>` link
  */
  href: p.string,
  /**
    React Font Awesome icon prefix and name string to be rendered in button label. Ex: ['fab', 'drupal']
  */
  icon: p.arrayOf(p.string),
  /**
   * ref will only get you a reference to the Button component, use innerRef to
   * get a reference to the DOM element (for things like focus management).
   */
  innerRef: p.oneOfType([
    p.object,
    p.func,
    p.string
  ]),
  /**
    Event handler function for `<button>`
  */
  onClick: p.func,
  /**
    Button size. Legacy sizes (default, small, xsmall) or new sizes (large, medium, small) when used with variant prop.
  */
  size: p.oneOf(["default", "small", "xsmall", "large", "medium"]),
  /**
    Button style variant (borderless, outline, filled). When provided, uses new UDS button styles.
  */
  variant: p.oneOf(["borderless", "outline", "filled"]),
  /**
    Classes to add to button
  */
  classes: p.arrayOf(p.string),
  /**
   Link target type
   */
  target: p.oneOf(["_blank", "_self", "_top", "_parent"])
};
function A1(l) {
  var i = /* @__PURE__ */ Object.create(null);
  return function(u) {
    return i[u] === void 0 && (i[u] = l(u)), i[u];
  };
}
var _1 = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, O1 = /* @__PURE__ */ A1(
  function(l) {
    return _1.test(l) || l.charCodeAt(0) === 111 && l.charCodeAt(1) === 110 && l.charCodeAt(2) < 91;
  }
  /* Z+1 */
), te = "-ms-", Jr = "-moz-", kt = "-webkit-", hy = "comm", Gc = "rule", td = "decl", N1 = "@import", E1 = "@namespace", my = "@keyframes", j1 = "@layer", py = Math.abs, ed = String.fromCharCode, kf = Object.assign;
function R1(l, i) {
  return Ee(l, 0) ^ 45 ? (((i << 2 ^ Ee(l, 0)) << 2 ^ Ee(l, 1)) << 2 ^ Ee(l, 2)) << 2 ^ Ee(l, 3) : 0;
}
function gy(l) {
  return l.trim();
}
function pa(l, i) {
  return (l = i.exec(l)) ? l[0] : l;
}
function mt(l, i, u) {
  return l.replace(i, u);
}
function Oc(l, i, u) {
  return l.indexOf(i, u);
}
function Ee(l, i) {
  return l.charCodeAt(i) | 0;
}
function Ll(l, i, u) {
  return l.slice(i, u);
}
function jn(l) {
  return l.length;
}
function yy(l) {
  return l.length;
}
function Kr(l, i) {
  return i.push(l), l;
}
function C1(l, i) {
  return l.map(i).join("");
}
function bg(l, i) {
  return l.filter(function(u) {
    return !pa(u, i);
  });
}
var Xc = 1, ki = 1, vy = 0, xn = 0, _e = 0, Ui = "";
function Qc(l, i, u, s, o, f, m, g) {
  return { value: l, root: i, parent: u, type: s, props: o, children: f, line: Xc, column: ki, length: m, return: "", siblings: g };
}
function tl(l, i) {
  return kf(Qc("", null, null, "", null, null, 0, l.siblings), l, { length: -l.length }, i);
}
function zi(l) {
  for (; l.root; )
    l = tl(l.root, { children: [l] });
  Kr(l, l.siblings);
}
function D1() {
  return _e;
}
function z1() {
  return _e = xn > 0 ? Ee(Ui, --xn) : 0, ki--, _e === 10 && (ki = 1, Xc--), _e;
}
function Rn() {
  return _e = xn < vy ? Ee(Ui, xn++) : 0, ki++, _e === 10 && (ki = 1, Xc++), _e;
}
function nl() {
  return Ee(Ui, xn);
}
function Nc() {
  return xn;
}
function Zc(l, i) {
  return Ll(Ui, l, i);
}
function Fr(l) {
  switch (l) {
    // \0 \t \n \r \s whitespace token
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    // ! + , / > @ ~ isolate token
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    // ; { } breakpoint token
    case 59:
    case 123:
    case 125:
      return 4;
    // : accompanied token
    case 58:
      return 3;
    // " ' ( [ opening delimit token
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    // ) ] closing delimit token
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function M1(l) {
  return Xc = ki = 1, vy = jn(Ui = l), xn = 0, [];
}
function k1(l) {
  return Ui = "", l;
}
function Sf(l) {
  return gy(Zc(xn - 1, Lf(l === 91 ? l + 2 : l === 40 ? l + 1 : l)));
}
function L1(l) {
  for (; (_e = nl()) && _e < 33; )
    Rn();
  return Fr(l) > 2 || Fr(_e) > 3 ? "" : " ";
}
function B1(l, i) {
  for (; --i && Rn() && !(_e < 48 || _e > 102 || _e > 57 && _e < 65 || _e > 70 && _e < 97); )
    ;
  return Zc(l, Nc() + (i < 6 && nl() == 32 && Rn() == 32));
}
function Lf(l) {
  for (; Rn(); )
    switch (_e) {
      // ] ) " '
      case l:
        return xn;
      // " '
      case 34:
      case 39:
        l !== 34 && l !== 39 && Lf(_e);
        break;
      // (
      case 40:
        l === 41 && Lf(l);
        break;
      // \
      case 92:
        Rn();
        break;
    }
  return xn;
}
function H1(l, i) {
  for (; Rn() && l + _e !== 57; )
    if (l + _e === 84 && nl() === 47)
      break;
  return "/*" + Zc(i, xn - 1) + "*" + ed(l === 47 ? l : Rn());
}
function U1(l) {
  for (; !Fr(nl()); )
    Rn();
  return Zc(l, xn);
}
function q1(l) {
  return k1(Ec("", null, null, null, [""], l = M1(l), 0, [0], l));
}
function Ec(l, i, u, s, o, f, m, g, y) {
  for (var b = 0, T = 0, A = m, x = 0, U = 0, D = 0, R = 1, q = 1, Y = 1, L = 0, et = "", W = o, X = f, B = s, G = et; q; )
    switch (D = L, L = Rn()) {
      // (
      case 40:
        if (D != 108 && Ee(G, A - 1) == 58) {
          Oc(G += mt(Sf(L), "&", "&\f"), "&\f", py(b ? g[b - 1] : 0)) != -1 && (Y = -1);
          break;
        }
      // " ' [
      case 34:
      case 39:
      case 91:
        G += Sf(L);
        break;
      // \t \n \r \s
      case 9:
      case 10:
      case 13:
      case 32:
        G += L1(D);
        break;
      // \
      case 92:
        G += B1(Nc() - 1, 7);
        continue;
      // /
      case 47:
        switch (nl()) {
          case 42:
          case 47:
            Kr(V1(H1(Rn(), Nc()), i, u, y), y), (Fr(D || 1) == 5 || Fr(nl() || 1) == 5) && jn(G) && Ll(G, -1, void 0) !== " " && (G += " ");
            break;
          default:
            G += "/";
        }
        break;
      // {
      case 123 * R:
        g[b++] = jn(G) * Y;
      // } ; \0
      case 125 * R:
      case 59:
      case 0:
        switch (L) {
          // \0 }
          case 0:
          case 125:
            q = 0;
          // ;
          case 59 + T:
            Y == -1 && (G = mt(G, /\f/g, "")), U > 0 && (jn(G) - A || R === 0 && D === 47) && Kr(U > 32 ? Tg(G + ";", s, u, A - 1, y) : Tg(mt(G, " ", "") + ";", s, u, A - 2, y), y);
            break;
          // @ ;
          case 59:
            G += ";";
          // { rule/at-rule
          default:
            if (Kr(B = Sg(G, i, u, b, T, o, g, et, W = [], X = [], A, f), f), L === 123)
              if (T === 0)
                Ec(G, i, B, B, W, f, A, g, X);
              else {
                switch (x) {
                  // c(ontainer)
                  case 99:
                    if (Ee(G, 3) === 110) break;
                  // l(ayer)
                  case 108:
                    if (Ee(G, 2) === 97) break;
                  default:
                    T = 0;
                  // d(ocument) m(edia) s(upports)
                  case 100:
                  case 109:
                  case 115:
                }
                T ? Ec(l, B, B, s && Kr(Sg(l, B, B, 0, 0, o, g, et, o, W = [], A, X), X), o, X, A, g, s ? W : X) : Ec(G, B, B, B, [""], X, 0, g, X);
              }
        }
        b = T = U = 0, R = Y = 1, et = G = "", A = m;
        break;
      // :
      case 58:
        A = 1 + jn(G), U = D;
      default:
        if (R < 1) {
          if (L == 123)
            --R;
          else if (L == 125 && R++ == 0 && z1() == 125)
            continue;
        }
        switch (G += ed(L), L * R) {
          // &
          case 38:
            Y = T > 0 ? 1 : (G += "\f", -1);
            break;
          // ,
          case 44:
            g[b++] = (jn(G) - 1) * Y, Y = 1;
            break;
          // @
          case 64:
            nl() === 45 && (G += Sf(Rn())), x = nl(), T = A = jn(et = G += U1(Nc())), L++;
            break;
          // -
          case 45:
            D === 45 && jn(G) == 2 && (R = 0);
        }
    }
  return f;
}
function Sg(l, i, u, s, o, f, m, g, y, b, T, A) {
  for (var x = o - 1, U = o === 0 ? f : [""], D = yy(U), R = 0, q = 0, Y = 0; R < s; ++R)
    for (var L = 0, et = Ll(l, x + 1, x = py(q = m[R])), W = l; L < D; ++L)
      (W = gy(q > 0 ? U[L] + " " + et : mt(et, /&\f/g, U[L]))) && (y[Y++] = W);
  return Qc(l, i, u, o === 0 ? Gc : g, y, b, T, A);
}
function V1(l, i, u, s) {
  return Qc(l, i, u, hy, ed(D1()), Ll(l, 2, -2), 0, s);
}
function Tg(l, i, u, s, o) {
  return Qc(l, i, u, td, Ll(l, 0, s), Ll(l, s + 1, -1), s, o);
}
function by(l, i, u) {
  switch (R1(l, i)) {
    // color-adjust
    case 5103:
      return kt + "print-" + l + l;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
    // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
      return kt + l + l;
    // mask-composite
    case 4855:
      return kt + l.replace("add", "source-over").replace("substract", "source-out").replace("intersect", "source-in").replace("exclude", "xor") + l;
    // tab-size
    case 4789:
      return Jr + l + l;
    // appearance, user-select, transform, hyphens, text-size-adjust
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return kt + l + Jr + l + te + l + l;
    // writing-mode
    case 5936:
      switch (Ee(l, i + 11)) {
        // vertical-l(r)
        case 114:
          return kt + l + te + mt(l, /[svh]\w+-[tblr]{2}/, "tb") + l;
        // vertical-r(l)
        case 108:
          return kt + l + te + mt(l, /[svh]\w+-[tblr]{2}/, "tb-rl") + l;
        // horizontal(-)tb
        case 45:
          return kt + l + te + mt(l, /[svh]\w+-[tblr]{2}/, "lr") + l;
      }
    // flex, flex-direction, scroll-snap-type, writing-mode
    case 6828:
    case 4268:
    case 2903:
      return kt + l + te + l + l;
    // order
    case 6165:
      return kt + l + te + "flex-" + l + l;
    // align-items
    case 5187:
      return kt + l + mt(l, /(\w+).+(:[^]+)/, kt + "box-$1$2" + te + "flex-$1$2") + l;
    // align-self
    case 5443:
      return kt + l + te + "flex-item-" + mt(l, /flex-|-self/g, "") + (pa(l, /flex-|baseline/) ? "" : te + "grid-row-" + mt(l, /flex-|-self/g, "")) + l;
    // align-content
    case 4675:
      return kt + l + te + "flex-line-pack" + mt(l, /align-content|flex-|-self/g, "") + l;
    // flex-shrink
    case 5548:
      return kt + l + te + mt(l, "shrink", "negative") + l;
    // flex-basis
    case 5292:
      return kt + l + te + mt(l, "basis", "preferred-size") + l;
    // flex-grow
    case 6060:
      return kt + "box-" + mt(l, "-grow", "") + kt + l + te + mt(l, "grow", "positive") + l;
    // transition
    case 4554:
      return kt + mt(l, /([^-])(transform)/g, "$1" + kt + "$2") + l;
    // cursor
    case 6187:
      return mt(mt(mt(l, /(zoom-|grab)/, kt + "$1"), /(image-set)/, kt + "$1"), l, "") + l;
    // background, background-image
    case 5495:
    case 3959:
      return mt(l, /(image-set\([^]*)/, kt + "$1$`$1");
    // justify-content
    case 4968:
      return mt(mt(l, /(.+:)(flex-)?(.*)/, kt + "box-pack:$3" + te + "flex-pack:$3"), /space-between/, "justify") + kt + l + l;
    // justify-self
    case 4200:
      if (!pa(l, /flex-|baseline/)) return te + "grid-column-align" + Ll(l, i) + l;
      break;
    // grid-template-(columns|rows)
    case 2592:
    case 3360:
      return te + mt(l, "template-", "") + l;
    // grid-(row|column)-start
    case 4384:
    case 3616:
      return u && u.some(function(s, o) {
        return i = o, pa(s.props, /grid-\w+-end/);
      }) ? ~Oc(l + (u = u[i].value), "span", 0) ? l : te + mt(l, "-start", "") + l + te + "grid-row-span:" + (~Oc(u, "span", 0) ? pa(u, /\d+/) : +pa(u, /\d+/) - +pa(l, /\d+/)) + ";" : te + mt(l, "-start", "") + l;
    // grid-(row|column)-end
    case 4896:
    case 4128:
      return u && u.some(function(s) {
        return pa(s.props, /grid-\w+-start/);
      }) ? l : te + mt(mt(l, "-end", "-span"), "span ", "") + l;
    // (margin|padding)-inline-(start|end)
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return mt(l, /(.+)-inline(.+)/, kt + "$1$2") + l;
    // (min|max)?(width|height|inline-size|block-size)
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (jn(l) - 1 - i > 6)
        switch (Ee(l, i + 1)) {
          // (m)ax-content, (m)in-content
          case 109:
            if (Ee(l, i + 4) !== 45)
              break;
          // (f)ill-available, (f)it-content
          case 102:
            return mt(l, /(.+:)(.+)-([^]+)/, "$1" + kt + "$2-$3$1" + Jr + (Ee(l, i + 3) == 108 ? "$3" : "$2-$3")) + l;
          // (s)tretch
          case 115:
            return ~Oc(l, "stretch", 0) ? by(mt(l, "stretch", "fill-available"), i, u) + l : l;
        }
      break;
    // grid-(column|row)
    case 5152:
    case 5920:
      return mt(l, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(s, o, f, m, g, y, b) {
        return te + o + ":" + f + b + (m ? te + o + "-span:" + (g ? y : +y - +f) + b : "") + l;
      });
    // position: sticky
    case 4949:
      if (Ee(l, i + 6) === 121)
        return mt(l, ":", ":" + kt) + l;
      break;
    // display: (flex|inline-flex|grid|inline-grid)
    case 6444:
      switch (Ee(l, Ee(l, 14) === 45 ? 18 : 11)) {
        // (inline-)?fle(x)
        case 120:
          return mt(l, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + kt + (Ee(l, 14) === 45 ? "inline-" : "") + "box$3$1" + kt + "$2$3$1" + te + "$2box$3") + l;
        // (inline-)?gri(d)
        case 100:
          return mt(l, ":", ":" + te) + l;
      }
      break;
    // scroll-margin, scroll-margin-(top|right|bottom|left)
    case 5719:
    case 2647:
    case 2135:
    case 3927:
    case 2391:
      return mt(l, "scroll-", "scroll-snap-") + l;
  }
  return l;
}
function Bc(l, i) {
  for (var u = "", s = 0; s < l.length; s++)
    u += i(l[s], s, l, i) || "";
  return u;
}
function Y1(l, i, u, s) {
  switch (l.type) {
    case j1:
      if (l.children.length) break;
    case N1:
    case E1:
    case td:
      return l.return = l.return || l.value;
    case hy:
      return "";
    case my:
      return l.return = l.value + "{" + Bc(l.children, s) + "}";
    case Gc:
      if (!jn(l.value = l.props.join(","))) return "";
  }
  return jn(u = Bc(l.children, s)) ? l.return = l.value + "{" + u + "}" : "";
}
function G1(l) {
  var i = yy(l);
  return function(u, s, o, f) {
    for (var m = "", g = 0; g < i; g++)
      m += l[g](u, s, o, f) || "";
    return m;
  };
}
function X1(l) {
  return function(i) {
    i.root || (i = i.return) && l(i);
  };
}
function Q1(l, i, u, s) {
  if (l.length > -1 && !l.return)
    switch (l.type) {
      case td:
        l.return = by(l.value, l.length, u);
        return;
      case my:
        return Bc([tl(l, { value: mt(l.value, "@", "@" + kt) })], s);
      case Gc:
        if (l.length)
          return C1(u = l.props, function(o) {
            switch (pa(o, s = /(::plac\w+|:read-\w+)/)) {
              // :read-(only|write)
              case ":read-only":
              case ":read-write":
                zi(tl(l, { props: [mt(o, /:(read-\w+)/, ":" + Jr + "$1")] })), zi(tl(l, { props: [o] })), kf(l, { props: bg(u, s) });
                break;
              // :placeholder
              case "::placeholder":
                zi(tl(l, { props: [mt(o, /:(plac\w+)/, ":" + kt + "input-$1")] })), zi(tl(l, { props: [mt(o, /:(plac\w+)/, ":" + Jr + "$1")] })), zi(tl(l, { props: [mt(o, /:(plac\w+)/, te + "input-$1")] })), zi(tl(l, { props: [o] })), kf(l, { props: bg(u, s) });
                break;
            }
            return "";
          });
    }
}
var Gt = { env: { NODE_ENV: "production" } }, Tf, wf;
const Bl = typeof Gt < "u" && Gt.env !== void 0 && (Gt.env.REACT_APP_SC_ATTR || Gt.env.SC_ATTR) || "data-styled", Sy = "active", Ty = "data-styled-version", Kc = "6.4.2", nd = `/*!sc*/
`, Wr = typeof window < "u" && typeof document < "u";
function wg(l) {
  if (typeof Gt < "u" && Gt.env !== void 0) {
    const i = Gt.env[l];
    if (i !== void 0 && i !== "") return i !== "false";
  }
}
const Z1 = !!(typeof SC_DISABLE_SPEEDY == "boolean" ? SC_DISABLE_SPEEDY : (wf = (Tf = wg("REACT_APP_SC_DISABLE_SPEEDY")) !== null && Tf !== void 0 ? Tf : wg("SC_DISABLE_SPEEDY")) !== null && wf !== void 0 ? wf : typeof Gt < "u" && Gt.env !== void 0 && Gt.env.NODE_ENV !== "production"), K1 = "sc-keyframes-", $1 = Gt.env.NODE_ENV !== "production" ? { 1: `Cannot create styled-component for component: %s.

`, 2: `Can't collect styles once you've consumed a \`ServerStyleSheet\`'s styles! \`ServerStyleSheet\` is a one off instance for each server-side render cycle.

- Are you trying to reuse it across renders?
- Are you accidentally calling collectStyles twice?

`, 3: `Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.

`, 4: `The \`StyleSheetManager\` expects a valid target or sheet prop!

- Does this error occur on the client and is your target falsy?
- Does this error occur on the server and is the sheet falsy?

`, 5: `The clone method cannot be used on the client!

- Are you running in a client-like environment on the server?
- Are you trying to run SSR on the client?

`, 6: `Trying to insert a new style tag, but the given Node is unmounted!

- Are you using a custom target that isn't mounted?
- Does your document not have a valid head element?
- Have you accidentally removed a style tag manually?

`, 7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n', 8: `ThemeProvider: Please make your "theme" prop an object.

`, 9: "Missing document `<head>`\n\n", 10: `Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021

`, 11: `_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.

`, 12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://styled-components.com/docs/api#css\n\n", 13: `%s is not a styled component and cannot be referred to via component selector. See https://styled-components.com/docs/advanced#referring-to-other-components for more details.

`, 14: `ThemeProvider: "theme" prop is required.

`, 15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n", 16: `Reached the limit of how many styled components may be created at group %s.
You may only create up to 1,073,741,824 components. If you're creating components dynamically,
as for instance in your render method then you may be running into this limitation.

`, 17: `CSSStyleSheet could not be found on HTMLStyleElement.
Has styled-components' style tag been unmounted or altered by another script?

`, 18: `Accessing \`useTheme\` hook outside of a \`<ThemeProvider>\` element.

\`\`\`jsx
import { useTheme } from 'styled-components';
export function StyledCompoent({ children }) {
  const theme = useTheme();
  return <div style={{ width: theme.sizes.full }}>{children}</div>;
}

import { StyledComponent } from './StyledComponent';
import { theme } from './theme';
export function App() {
  return (
    <ThemeProvider theme={theme}>
      <StyledComponent />
    </ThemeProvider>
  );
}
\`\`\`

If you need access to the theme in an uncertain composition scenario, \`React.useContext(ThemeContext)\` will not emit an error if there is no \`ThemeProvider\` ancestor.
` } : {};
function tu(l, ...i) {
  return Gt.env.NODE_ENV === "production" ? new Error(`An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#${l} for more information.${i.length > 0 ? ` Args: ${i.join(", ")}` : ""}`) : new Error((function(...u) {
    let s = u[0];
    const o = [];
    for (let f = 1, m = u.length; f < m; f += 1) o.push(u[f]);
    return o.forEach((f) => {
      s = s.replace(/%[a-z]/, f);
    }), s;
  })($1[l], ...i).trim());
}
const J1 = 1 << 30;
let jc = /* @__PURE__ */ new Map(), Hc = /* @__PURE__ */ new Map(), Rc = 1;
const vc = (l) => {
  if (jc.has(l)) return jc.get(l);
  for (; Hc.has(Rc); ) Rc++;
  const i = Rc++;
  if (Gt.env.NODE_ENV !== "production" && ((0 | i) < 0 || i > J1)) throw tu(16, `${i}`);
  return jc.set(l, i), Hc.set(i, l), i;
}, W1 = (l) => Hc.get(l), F1 = (l, i) => {
  Rc = i + 1, jc.set(l, i), Hc.set(i, l);
}, xg = /invalid hook call/i, bc = /* @__PURE__ */ new Set(), I1 = (l, i) => {
  if (Gt.env.NODE_ENV !== "production") {
    const u = `The component ${l}${i ? ` with the id of "${i}"` : ""} has been created dynamically.
You may see this warning because you've called styled inside another component.
To resolve this only create new StyledComponents outside of any render method and function component.
See https://styled-components.com/docs/basics#define-styled-components-outside-of-the-render-method for more info.
`, s = console.error;
    try {
      let o = !0;
      console.error = (f, ...m) => {
        xg.test(f) ? (o = !1, bc.delete(u)) : s(f, ...m);
      }, typeof ye.useState == "function" && ye.useState(null), o && !bc.has(u) && (console.warn(u), bc.add(u));
    } catch (o) {
      xg.test(o.message) && bc.delete(u);
    } finally {
      console.error = s;
    }
  }
}, ad = Object.freeze([]), Li = Object.freeze({});
function P1(l, i, u = Li) {
  return l.theme !== u.theme && l.theme || i || u.theme;
}
const tS = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, eS = /(^-|-$)/g;
function wy(l) {
  return l.replace(tS, "-").replace(eS, "");
}
const nS = /(a)(d)/gi, Ag = (l) => String.fromCharCode(l + (l > 25 ? 39 : 97));
function xy(l) {
  let i, u = "";
  for (i = Math.abs(l); i > 52; i = i / 52 | 0) u = Ag(i % 52) + u;
  return (Ag(i % 52) + u).replace(nS, "$1-$2");
}
const Bf = 5381, zl = (l, i) => {
  let u = i.length;
  for (; u; ) l = 33 * l ^ i.charCodeAt(--u);
  return l;
}, Ay = (l) => zl(Bf, l);
function aS(l) {
  return xy(Ay(l) >>> 0);
}
function ld(l) {
  return Gt.env.NODE_ENV !== "production" && typeof l == "string" && l || l.displayName || l.name || "Component";
}
function Cc(l) {
  return typeof l == "string" && (Gt.env.NODE_ENV === "production" || l.charAt(0) === l.charAt(0).toLowerCase());
}
function lS(l) {
  return Cc(l) ? `styled.${l}` : `Styled(${ld(l)})`;
}
const _y = Symbol.for("react.memo"), iS = Symbol.for("react.forward_ref"), rS = { contextType: !0, defaultProps: !0, displayName: !0, getDerivedStateFromError: !0, getDerivedStateFromProps: !0, propTypes: !0, type: !0 }, uS = { name: !0, length: !0, prototype: !0, caller: !0, callee: !0, arguments: !0, arity: !0 }, Oy = { $$typeof: !0, compare: !0, defaultProps: !0, displayName: !0, propTypes: !0, type: !0 }, cS = { [iS]: { $$typeof: !0, render: !0, defaultProps: !0, displayName: !0, propTypes: !0 }, [_y]: Oy };
function _g(l) {
  return ("type" in (i = l) && i.type.$$typeof) === _y ? Oy : "$$typeof" in l ? cS[l.$$typeof] : rS;
  var i;
}
const sS = Object.defineProperty, oS = Object.getOwnPropertyNames, fS = Object.getOwnPropertySymbols, dS = Object.getOwnPropertyDescriptor, hS = Object.getPrototypeOf, mS = Object.prototype;
function Ny(l, i, u) {
  if (typeof i != "string") {
    const s = hS(i);
    s && s !== mS && Ny(l, s, u);
    const o = oS(i).concat(fS(i)), f = _g(l), m = _g(i);
    for (let g = 0; g < o.length; ++g) {
      const y = o[g];
      if (!(y in uS || u && u[y] || m && y in m || f && y in f)) {
        const b = dS(i, y);
        try {
          sS(l, y, b);
        } catch {
        }
      }
    }
  }
  return l;
}
function $c(l) {
  return typeof l == "function";
}
const pS = Symbol.for("react.forward_ref");
function Ey(l) {
  return l != null && (typeof l == "object" || typeof l == "function") && l.$$typeof === pS && "styledComponentId" in l;
}
function $r(l, i) {
  return l && i ? l + " " + i : l || i || "";
}
function Og(l, i) {
  return l.join("");
}
function Hl(l) {
  return l !== null && typeof l == "object" && l.constructor.name === Object.name && !("props" in l && l.$$typeof);
}
function Hf(l, i, u = !1) {
  if (!u && !Hl(l) && !Array.isArray(l)) return i;
  if (Array.isArray(i)) for (let s = 0; s < i.length; s++) l[s] = Hf(l[s], i[s]);
  else if (Hl(i)) for (const s in i) l[s] = Hf(l[s], i[s]);
  return l;
}
function jy(l, i) {
  Object.defineProperty(l, "toString", { value: i });
}
const gS = class {
  constructor(l) {
    this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = l, this._cGroup = 0, this._cIndex = 0;
  }
  indexOfGroup(l) {
    if (l === this._cGroup) return this._cIndex;
    let i = this._cIndex;
    if (l > this._cGroup) for (let u = this._cGroup; u < l; u++) i += this.groupSizes[u];
    else for (let u = this._cGroup - 1; u >= l; u--) i -= this.groupSizes[u];
    return this._cGroup = l, this._cIndex = i, i;
  }
  insertRules(l, i) {
    if (l >= this.groupSizes.length) {
      const o = this.groupSizes, f = o.length;
      let m = f;
      for (; l >= m; ) if (m <<= 1, m < 0) throw tu(16, `${l}`);
      this.groupSizes = new Uint32Array(m), this.groupSizes.set(o), this.length = m;
      for (let g = f; g < m; g++) this.groupSizes[g] = 0;
    }
    let u = this.indexOfGroup(l + 1), s = 0;
    for (let o = 0, f = i.length; o < f; o++) this.tag.insertRule(u, i[o]) && (this.groupSizes[l]++, u++, s++);
    s > 0 && this._cGroup > l && (this._cIndex += s);
  }
  clearGroup(l) {
    if (l < this.length) {
      const i = this.groupSizes[l], u = this.indexOfGroup(l), s = u + i;
      this.groupSizes[l] = 0;
      for (let o = u; o < s; o++) this.tag.deleteRule(u);
      i > 0 && this._cGroup > l && (this._cIndex -= i);
    }
  }
  getGroup(l) {
    let i = "";
    if (l >= this.length || this.groupSizes[l] === 0) return i;
    const u = this.groupSizes[l], s = this.indexOfGroup(l), o = s + u;
    for (let f = s; f < o; f++) i += this.tag.getRule(f) + nd;
    return i;
  }
}, yS = `style[${Bl}][${Ty}="${Kc}"]`, vS = new RegExp(`^${Bl}\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)`), Ng = (l) => typeof ShadowRoot < "u" && l instanceof ShadowRoot || "host" in l && l.nodeType === 11, Uf = (l) => {
  if (!l) return document;
  if (Ng(l)) return l;
  if ("getRootNode" in l) {
    const i = l.getRootNode();
    if (Ng(i)) return i;
  }
  return document;
}, bS = (l, i, u) => {
  const s = u.split(",");
  let o;
  for (let f = 0, m = s.length; f < m; f++) (o = s[f]) && l.registerName(i, o);
}, SS = (l, i) => {
  var u;
  const s = ((u = i.textContent) !== null && u !== void 0 ? u : "").split(nd), o = [];
  for (let f = 0, m = s.length; f < m; f++) {
    const g = s[f].trim();
    if (!g) continue;
    const y = g.match(vS);
    if (y) {
      const b = 0 | parseInt(y[1], 10), T = y[2];
      b !== 0 && (F1(T, b), bS(l, T, y[3]), l.getTag().insertRules(b, o)), o.length = 0;
    } else o.push(g);
  }
}, xf = (l) => {
  const i = Uf(l.options.target).querySelectorAll(yS);
  for (let u = 0, s = i.length; u < s; u++) {
    const o = i[u];
    o && o.getAttribute(Bl) !== Sy && (SS(l, o), o.parentNode && o.parentNode.removeChild(o));
  }
};
let Xr = !1;
function TS() {
  if (Xr !== !1) return Xr;
  if (typeof document < "u") {
    const l = document.head.querySelector('meta[property="csp-nonce"]');
    if (l) return Xr = l.nonce || l.getAttribute("content") || void 0;
    const i = document.head.querySelector('meta[name="sc-nonce"]');
    if (i) return Xr = i.getAttribute("content") || void 0;
  }
  return Xr = typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : void 0;
}
const Ry = (l, i) => {
  const u = document.head, s = l || u, o = document.createElement("style"), f = ((y) => {
    const b = Array.from(y.querySelectorAll(`style[${Bl}]`));
    return b[b.length - 1];
  })(s), m = f !== void 0 ? f.nextSibling : null;
  o.setAttribute(Bl, Sy), o.setAttribute(Ty, Kc);
  const g = i || TS();
  return g && o.setAttribute("nonce", g), s.insertBefore(o, m), o;
}, wS = class {
  constructor(l, i) {
    this.element = Ry(l, i), this.element.appendChild(document.createTextNode("")), this.sheet = ((u) => {
      var s;
      if (u.sheet) return u.sheet;
      const o = (s = u.getRootNode().styleSheets) !== null && s !== void 0 ? s : document.styleSheets;
      for (let f = 0, m = o.length; f < m; f++) {
        const g = o[f];
        if (g.ownerNode === u) return g;
      }
      throw tu(17);
    })(this.element), this.length = 0;
  }
  insertRule(l, i) {
    try {
      return this.sheet.insertRule(i, l), this.length++, !0;
    } catch {
      return !1;
    }
  }
  deleteRule(l) {
    this.sheet.deleteRule(l), this.length--;
  }
  getRule(l) {
    const i = this.sheet.cssRules[l];
    return i && i.cssText ? i.cssText : "";
  }
}, xS = class {
  constructor(l, i) {
    this.element = Ry(l, i), this.nodes = this.element.childNodes, this.length = 0;
  }
  insertRule(l, i) {
    if (l <= this.length && l >= 0) {
      const u = document.createTextNode(i);
      return this.element.insertBefore(u, this.nodes[l] || null), this.length++, !0;
    }
    return !1;
  }
  deleteRule(l) {
    this.element.removeChild(this.nodes[l]), this.length--;
  }
  getRule(l) {
    return l < this.length ? this.nodes[l].textContent : "";
  }
};
let Eg = Wr;
const AS = { isServer: !Wr, useCSSOMInjection: !Z1 };
class Jc {
  static registerId(i) {
    return vc(i);
  }
  constructor(i = Li, u = {}, s) {
    this.options = Object.assign(Object.assign({}, AS), i), this.gs = u, this.keyframeIds = /* @__PURE__ */ new Set(), this.names = new Map(s), this.server = !!i.isServer, !this.server && Wr && Eg && (Eg = !1, xf(this)), jy(this, () => ((o) => {
      const f = o.getTag(), { length: m } = f;
      let g = "";
      for (let y = 0; y < m; y++) {
        const b = W1(y);
        if (b === void 0) continue;
        const T = o.names.get(b);
        if (T === void 0 || !T.size) continue;
        const A = f.getGroup(y);
        if (A.length === 0) continue;
        const x = Bl + ".g" + y + '[id="' + b + '"]';
        let U = "";
        for (const D of T) D.length > 0 && (U += D + ",");
        g += A + x + '{content:"' + U + '"}' + nd;
      }
      return g;
    })(this));
  }
  rehydrate() {
    !this.server && Wr && xf(this);
  }
  reconstructWithOptions(i, u = !0) {
    const s = new Jc(Object.assign(Object.assign({}, this.options), i), this.gs, u && this.names || void 0);
    return s.keyframeIds = new Set(this.keyframeIds), !this.server && Wr && i.target !== this.options.target && Uf(this.options.target) !== Uf(i.target) && xf(s), s;
  }
  allocateGSInstance(i) {
    return this.gs[i] = (this.gs[i] || 0) + 1;
  }
  getTag() {
    return this.tag || (this.tag = (i = (({ useCSSOMInjection: u, target: s, nonce: o }) => u ? new wS(s, o) : new xS(s, o))(this.options), new gS(i)));
    var i;
  }
  hasNameForId(i, u) {
    var s, o;
    return (o = (s = this.names.get(i)) === null || s === void 0 ? void 0 : s.has(u)) !== null && o !== void 0 && o;
  }
  registerName(i, u) {
    vc(i), i.startsWith(K1) && this.keyframeIds.add(i);
    const s = this.names.get(i);
    s ? s.add(u) : this.names.set(i, /* @__PURE__ */ new Set([u]));
  }
  insertRules(i, u, s) {
    this.registerName(i, u), this.getTag().insertRules(vc(i), s);
  }
  clearNames(i) {
    this.names.has(i) && this.names.get(i).clear();
  }
  clearRules(i) {
    this.getTag().clearGroup(vc(i)), this.clearNames(i);
  }
  clearTag() {
    this.tag = void 0;
  }
}
const Cy = /* @__PURE__ */ new WeakSet(), _S = { animationIterationCount: 1, aspectRatio: 1, borderImageOutset: 1, borderImageSlice: 1, borderImageWidth: 1, columnCount: 1, columns: 1, flex: 1, flexGrow: 1, flexShrink: 1, gridRow: 1, gridRowEnd: 1, gridRowSpan: 1, gridRowStart: 1, gridColumn: 1, gridColumnEnd: 1, gridColumnSpan: 1, gridColumnStart: 1, fontWeight: 1, lineHeight: 1, opacity: 1, order: 1, orphans: 1, scale: 1, tabSize: 1, widows: 1, zIndex: 1, zoom: 1, WebkitLineClamp: 1, fillOpacity: 1, floodOpacity: 1, stopOpacity: 1, strokeDasharray: 1, strokeDashoffset: 1, strokeMiterlimit: 1, strokeOpacity: 1, strokeWidth: 1 };
function OS(l, i) {
  return i == null || typeof i == "boolean" || i === "" ? "" : typeof i != "number" || i === 0 || l in _S || l.startsWith("--") ? String(i).trim() : i + "px";
}
const Dl = 47;
function jg(l) {
  if (l.charCodeAt(0) === 45 && l.charCodeAt(1) === 45) return l;
  let i = "";
  for (let u = 0; u < l.length; u++) {
    const s = l.charCodeAt(u);
    i += s >= 65 && s <= 90 ? "-" + String.fromCharCode(s + 32) : l[u];
  }
  return i.startsWith("ms-") ? "-" + i : i;
}
const NS = Symbol.for("sc-keyframes");
function qf(l) {
  return typeof l == "object" && l !== null && NS in l;
}
function Dy(l) {
  return $c(l) && !(l.prototype && l.prototype.isReactComponent);
}
const zy = (l) => l == null || l === !1 || l === "", ES = Symbol.for("react.client.reference");
function Rg(l) {
  return l.$$typeof === ES;
}
function Cg(l) {
  const i = l.$$id, u = (i && i.includes("#") ? i.split("#").pop() : i) || l.name || "unknown";
  console.warn(`Interpolating a client component (${u}) as a selector is not supported in server components. The component selector pattern requires access to the component's internal class name, which is not available across the server/client boundary. Use a plain CSS class selector instead.`);
}
function My(l, i) {
  for (const u in l) {
    const s = l[u];
    l.hasOwnProperty(u) && !zy(s) && (Array.isArray(s) && Cy.has(s) || $c(s) ? i.push(jg(u) + ":", s, ";") : Hl(s) ? (i.push(u + " {"), My(s, i), i.push("}")) : i.push(jg(u) + ": " + OS(u, s) + ";"));
  }
}
function Ml(l, i, u, s, o = []) {
  if (zy(l)) return o;
  const f = typeof l;
  if (f === "string") return o.push(l), o;
  if (f === "function") {
    if (Rg(l)) return Gt.env.NODE_ENV !== "production" && Cg(l), o;
    if (Dy(l) && i) {
      const m = l(i);
      return Gt.env.NODE_ENV === "production" || typeof m != "object" || Array.isArray(m) || qf(m) || Hl(m) || m === null || console.error(`${ld(l)} is not a styled component and cannot be referred to via component selector. See https://styled-components.com/docs/advanced#referring-to-other-components for more details.`), Ml(m, i, u, s, o);
    }
    return o.push(l), o;
  }
  if (Array.isArray(l)) {
    for (let m = 0; m < l.length; m++) Ml(l[m], i, u, s, o);
    return o;
  }
  return Ey(l) ? (o.push(`.${l.styledComponentId}`), o) : qf(l) ? (u ? (l.inject(u, s), o.push(l.getName(s))) : o.push(l), o) : Rg(l) ? (Gt.env.NODE_ENV !== "production" && Cg(l), o) : Hl(l) ? l.toString !== Object.prototype.toString ? (o.push(l.toString()), o) : (My(l, o), o) : (o.push(l.toString()), o);
}
const jS = Ay(Kc);
class RS {
  constructor(i, u, s) {
    this.rules = i, this.componentId = u, this.baseHash = zl(jS, u), this.baseStyle = s, Jc.registerId(u);
  }
  generateAndInjectStyles(i, u, s) {
    let o = this.baseStyle ? this.baseStyle.generateAndInjectStyles(i, u, s) : "";
    {
      let f = "";
      for (let m = 0; m < this.rules.length; m++) {
        const g = this.rules[m];
        if (typeof g == "string") f += g;
        else if (g) if (Dy(g)) {
          const y = g(i);
          typeof y == "string" ? f += y : y != null && y !== !1 && (Gt.env.NODE_ENV === "production" || typeof y != "object" || Array.isArray(y) || qf(y) || Hl(y) || console.error(`${ld(g)} is not a styled component and cannot be referred to via component selector. See https://styled-components.com/docs/advanced#referring-to-other-components for more details.`), f += Og(Ml(y, i, u, s)));
        } else f += Og(Ml(g, i, u, s));
      }
      if (f) {
        this.dynamicNameCache || (this.dynamicNameCache = /* @__PURE__ */ new Map());
        const m = s.hash ? s.hash + f : f;
        let g = this.dynamicNameCache.get(m);
        if (!g) {
          if (g = xy(zl(zl(this.baseHash, s.hash), f) >>> 0), this.dynamicNameCache.size >= 200) {
            const y = this.dynamicNameCache.keys().next().value;
            y !== void 0 && this.dynamicNameCache.delete(y);
          }
          this.dynamicNameCache.set(m, g);
        }
        if (!u.hasNameForId(this.componentId, g)) {
          const y = s(f, "." + g, void 0, this.componentId);
          u.insertRules(this.componentId, g, y);
        }
        o = $r(o, g);
      }
    }
    return o;
  }
}
const CS = /&/g;
function ky(l, i) {
  let u = 0;
  for (; --i >= 0 && l.charCodeAt(i) === 92; ) u++;
  return !(1 & ~u);
}
function Af(l) {
  const i = l.length;
  let u = "", s = 0, o = 0, f = 0, m = !1, g = !1;
  for (let y = 0; y < i; y++) {
    const b = l.charCodeAt(y);
    if (f !== 0 || m || b !== Dl || l.charCodeAt(y + 1) !== 42) if (m) b === 42 && l.charCodeAt(y + 1) === Dl && (m = !1, y++);
    else if (b !== 34 && b !== 39 || ky(l, y)) {
      if (f === 0) if (b === 123) o++;
      else if (b === 125) {
        if (o--, o < 0) {
          g = !0;
          let T = y + 1;
          for (; T < i; ) {
            const A = l.charCodeAt(T);
            if (A === 59 || A === 10) break;
            T++;
          }
          T < i && l.charCodeAt(T) === 59 && T++, o = 0, y = T - 1, s = T;
          continue;
        }
        o === 0 && (u += l.substring(s, y + 1), s = y + 1);
      } else b === 59 && o === 0 && (u += l.substring(s, y + 1), s = y + 1);
    } else f === 0 ? f = b : f === b && (f = 0);
    else m = !0, y++;
  }
  return g || o !== 0 || f !== 0 ? (s < i && o === 0 && f === 0 && (u += l.substring(s)), u) : l;
}
function Ly(l, i) {
  const u = i + " ", s = "," + u;
  for (let o = 0; o < l.length; o++) {
    const f = l[o];
    if (f.type === "rule") {
      f.value = (u + f.value).replaceAll(",", s);
      const m = f.props, g = [];
      for (let y = 0; y < m.length; y++) g[y] = u + m[y];
      f.props = g;
    }
    Array.isArray(f.children) && f.type !== "@keyframes" && Ly(f.children, i);
  }
  return l;
}
function DS({ options: l = Li, plugins: i = ad } = Li) {
  let u, s, o;
  const f = (x, U, D) => D.startsWith(s) && D.endsWith(s) && D.replaceAll(s, "").length > 0 ? `.${u}` : x, m = i.slice();
  m.push((x) => {
    x.type === Gc && x.value.includes("&") && (o || (o = new RegExp(`\\${s}\\b`, "g")), x.props[0] = x.props[0].replace(CS, s).replace(o, f));
  }), l.prefix && m.push(Q1), m.push(Y1);
  let g = [];
  const y = G1(m.concat(X1((x) => g.push(x)))), b = (x, U = "", D = "", R = "&") => {
    u = R, s = U, o = void 0;
    const q = (function(L) {
      const et = L.indexOf("//") !== -1, W = L.indexOf("}") !== -1;
      if (!et && !W) return L;
      if (!et) return Af(L);
      const X = L.length;
      let B = "", G = 0, F = 0, ut = 0, yt = 0, Dt = 0, Nt = !1;
      for (; F < X; ) {
        const pt = L.charCodeAt(F);
        if (pt !== 34 && pt !== 39 || ky(L, F)) if (ut === 0) if (pt === Dl && F + 1 < X && L.charCodeAt(F + 1) === 42) {
          for (F += 2; F + 1 < X && (L.charCodeAt(F) !== 42 || L.charCodeAt(F + 1) !== Dl); ) F++;
          F += 2;
        } else if (pt !== 40) if (pt !== 41) if (yt > 0) F++;
        else if (pt === 42 && F + 1 < X && L.charCodeAt(F + 1) === Dl) B += L.substring(G, F), F += 2, G = F, Nt = !0;
        else if (pt === Dl && F + 1 < X && L.charCodeAt(F + 1) === Dl) {
          for (B += L.substring(G, F); F < X && L.charCodeAt(F) !== 10; ) F++;
          G = F, Nt = !0;
        } else pt === 123 ? Dt++ : pt === 125 && Dt--, F++;
        else yt > 0 && yt--, F++;
        else yt++, F++;
        else F++;
        else ut === 0 ? ut = pt : ut === pt && (ut = 0), F++;
      }
      return Nt ? (G < X && (B += L.substring(G)), Dt === 0 ? B : Af(B)) : Dt === 0 ? L : Af(L);
    })(x);
    let Y = q1(D || U ? D + " " + U + " { " + q + " }" : q);
    return l.namespace && (Y = Ly(Y, l.namespace)), g = [], Bc(Y, y), g;
  }, T = l;
  let A = Bf;
  for (let x = 0; x < i.length; x++) i[x].name || tu(15), A = zl(A, i[x].name);
  return T != null && T.namespace && (A = zl(A, T.namespace)), T != null && T.prefix && (A = zl(A, "p")), b.hash = A !== Bf ? A.toString() : "", b;
}
const zS = new Jc(), MS = DS(), By = ye.createContext({ shouldForwardProp: void 0, styleSheet: zS, stylis: MS, stylisPlugins: void 0 });
By.Consumer;
function kS() {
  return ye.useContext(By);
}
const Hy = ye.createContext(void 0);
Hy.Consumer;
const Dg = Object.prototype.hasOwnProperty, _f = {};
function LS(l, i) {
  const u = typeof l != "string" ? "sc" : wy(l);
  _f[u] = (_f[u] || 0) + 1;
  const s = u + "-" + aS(Kc + u + _f[u]);
  return i ? i + "-" + s : s;
}
let Of;
function BS(l, i, u) {
  const s = Ey(l), o = l, f = !Cc(l), { attrs: m = ad, componentId: g = LS(i.displayName, i.parentComponentId), displayName: y = lS(l) } = i, b = i.displayName && i.componentId ? wy(i.displayName) + "-" + i.componentId : i.componentId || g, T = s && o.attrs ? o.attrs.concat(m).filter(Boolean) : m;
  let { shouldForwardProp: A } = i;
  if (s && o.shouldForwardProp) {
    const R = o.shouldForwardProp;
    if (i.shouldForwardProp) {
      const q = i.shouldForwardProp;
      A = (Y, L) => R(Y, L) && q(Y, L);
    } else A = R;
  }
  const x = new RS(u, b, s ? o.componentStyle : void 0);
  function U(R, q) {
    return (function(Y, L, et) {
      const { attrs: W, componentStyle: X, defaultProps: B, foldedComponentIds: G, styledComponentId: F, target: ut } = Y, yt = ye.useContext(Hy), Dt = kS(), Nt = Y.shouldForwardProp || Dt.shouldForwardProp;
      Gt.env.NODE_ENV !== "production" && ye.useDebugValue && ye.useDebugValue(F);
      const pt = P1(L, yt, B) || Li;
      let Se, Zt;
      {
        const J = ye.useRef(null), tt = J.current;
        if (tt !== null && tt[1] === pt && tt[2] === Dt.styleSheet && tt[3] === Dt.stylis && tt[7] === X && (function(lt, vt, ct) {
          const at = lt, ot = vt;
          let ue = 0;
          for (const fe in ot) if (Dg.call(ot, fe) && (ue++, at[fe] !== ot[fe])) return !1;
          return ue === ct;
        })(tt[0], L, tt[4])) Se = tt[5], Zt = tt[6];
        else {
          Se = (function(vt, ct, at) {
            const ot = Object.assign(Object.assign({}, ct), { className: void 0, theme: at }), ue = vt.length > 1;
            for (let fe = 0; fe < vt.length; fe++) {
              const bt = vt[fe], Ut = $c(bt) ? bt(ue ? Object.assign({}, ot) : ot) : bt;
              for (const Kt in Ut) Kt === "className" ? ot.className = $r(ot.className, Ut[Kt]) : Kt === "style" ? ot.style = Object.assign(Object.assign({}, ot.style), Ut[Kt]) : Kt in ct && ct[Kt] === void 0 || (ot[Kt] = Ut[Kt]);
            }
            return "className" in ct && typeof ct.className == "string" && (ot.className = $r(ot.className, ct.className)), ot;
          })(W, L, pt), Zt = (function(vt, ct, at, ot) {
            const ue = vt.generateAndInjectStyles(ct, at, ot);
            return Gt.env.NODE_ENV !== "production" && ye.useDebugValue && ye.useDebugValue(ue), ue;
          })(X, Se, Dt.styleSheet, Dt.stylis);
          let lt = 0;
          for (const vt in L) Dg.call(L, vt) && lt++;
          J.current = [L, pt, Dt.styleSheet, Dt.stylis, lt, Se, Zt, X];
        }
      }
      Gt.env.NODE_ENV !== "production" && Y.warnTooManyClasses && Y.warnTooManyClasses(Zt);
      const Q = Se.as || ut, V = (function(J, tt, lt, vt) {
        const ct = {};
        for (const at in J) J[at] === void 0 || at[0] === "$" || at === "as" || at === "theme" && J.theme === lt || (at === "forwardedAs" ? ct.as = J.forwardedAs : vt && !vt(at, tt) || (ct[at] = J[at], vt || Gt.env.NODE_ENV !== "development" || O1(at) || (Of || (Of = /* @__PURE__ */ new Set())).has(at) || !Cc(tt) || tt.includes("-") || (Of.add(at), console.warn(`styled-components: it looks like an unknown prop "${at}" is being sent through to the DOM, which will likely trigger a React console error. If you would like automatic filtering of unknown props, you can opt-into that behavior via \`<StyleSheetManager shouldForwardProp={...}>\` (connect an API like \`@emotion/is-prop-valid\`) or consider using transient props (\`$\` prefix for automatic filtering.)`))));
        return ct;
      })(Se, Q, pt, Nt);
      let $ = $r(G, F);
      return Zt && ($ += " " + Zt), Se.className && ($ += " " + Se.className), V[Cc(Q) && Q.includes("-") ? "class" : "className"] = $, et && (V.ref = et), xb(Q, V);
    })(D, R, q);
  }
  U.displayName = y;
  let D = ye.forwardRef(U);
  return D.attrs = T, D.componentStyle = x, D.displayName = y, D.shouldForwardProp = A, D.foldedComponentIds = s ? $r(o.foldedComponentIds, o.styledComponentId) : "", D.styledComponentId = b, D.target = s ? o.target : l, Object.defineProperty(D, "defaultProps", { get() {
    return this._foldedDefaultProps;
  }, set(R) {
    this._foldedDefaultProps = s ? (function(q, ...Y) {
      for (const L of Y) Hf(q, L, !0);
      return q;
    })({}, o.defaultProps, R) : R;
  } }), Gt.env.NODE_ENV !== "production" && (I1(y, b), D.warnTooManyClasses = /* @__PURE__ */ ((R, q) => {
    let Y = {}, L = !1;
    return (et) => {
      !L && (Y[et] = !0, Object.keys(Y).length >= 200) && (console.warn(`Over 200 classes were generated for component ${R}${q ? ` with the id of "${q}"` : ""}.
Consider using the attrs method, together with a style object for frequently changed styles.
Example:
  const Component = styled.div.attrs(props => ({
    style: {
      background: props.background,
    },
  }))\`width: 100%;\`

  <Component />`), L = !0, Y = {});
    };
  })(y, b)), jy(D, () => `.${D.styledComponentId}`), f && Ny(D, l, { attrs: !0, componentStyle: !0, displayName: !0, foldedComponentIds: !0, shouldForwardProp: !0, styledComponentId: !0, target: !0 }), D;
}
var HS = /* @__PURE__ */ new Set(["a", "abbr", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "blockquote", "body", "button", "br", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "menu", "meter", "nav", "object", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "search", "section", "select", "slot", "small", "span", "strong", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "filter", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "switch", "symbol", "text", "textPath", "tspan", "use"]);
function zg(l, i) {
  const u = [l[0]];
  for (let s = 0, o = i.length; s < o; s += 1) u.push(i[s], l[s + 1]);
  return u;
}
const Mg = (l) => (Cy.add(l), l);
function US(l, ...i) {
  if ($c(l) || Hl(l)) return Mg(Ml(zg(ad, [l, ...i])));
  const u = l;
  return i.length === 0 && u.length === 1 && typeof u[0] == "string" ? Ml(u) : Mg(Ml(zg(u, i)));
}
function Vf(l, i, u = Li) {
  if (!i) throw tu(1, i);
  const s = (o, ...f) => l(i, u, US(o, ...f));
  return s.attrs = (o) => Vf(l, i, Object.assign(Object.assign({}, u), { attrs: Array.prototype.concat(u.attrs, o).filter(Boolean) })), s.withConfig = (o) => Vf(l, i, Object.assign(Object.assign({}, u), o)), s;
}
const Uy = (l) => Vf(BS, l), Qn = Uy;
HS.forEach((l) => {
  Qn[l] = Uy(l);
});
Gt.env.NODE_ENV !== "production" && typeof navigator < "u" && navigator.product === "ReactNative" && console.warn(`It looks like you've imported 'styled-components' on React Native.
Perhaps you're looking to import 'styled-components/native'?
Read more about this at https://styled-components.com/docs/basics#react-native`);
const Sc = `__sc-${Bl}__`;
Gt.env.NODE_ENV !== "production" && Gt.env.NODE_ENV !== "test" && typeof window < "u" && (window[Sc] || (window[Sc] = 0), window[Sc] === 1 && console.warn(`It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.

See https://styled-components.com/docs/faqs#why-am-i-getting-a-warning-about-several-instances-of-module-on-the-page for more info.`), window[Sc] += 1);
const qS = Qn.div`
  &.sticky {
    position: fixed;
    top: var(--uds-anchor-menu-top, 0px);
    left: 0;
    width: 100%;
  }
  .mobile-menu-toggler {
    background-color: transparent;
    border: none;
    padding: 0;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    text-align: inherit;
    i {
      transition: all 0.3s;
    }
  }
  .show-menu i {
    transform: rotate(-180deg);
  }
  .nav-link {
    border: none;
    background-color: #ffffff;
    i {
      width: 2rem !important;
      text-align: center !important;
    }
  }
`, Dc = "On This Page", VS = {
  event: "collapse",
  name: "onclick",
  type: "click",
  text: Dc
}, qy = ({
  items: l,
  firstElementId: i,
  focusFirstFocusableElement: u = !1
}) => {
  const { isReact: s, isBootstrap: o } = ql(), f = nn(null), m = Mb("(max-width: 991px)"), [g, y] = ve({
    hasHeader: !1,
    hasAltMenuSpacing: !1,
    containerClass: "container-xl",
    activeContainer: "",
    showMenu: !1,
    sticky: !1
  }), b = () => document.getElementById("asu-header") || document.getElementById("headerContainer") || document.getElementById("asuHeader"), T = () => {
    const X = b();
    return Math.max((X == null ? void 0 : X.getBoundingClientRect().bottom) || 0, 0);
  }, A = () => {
    var Dt;
    const X = {}, B = window.scrollY, G = T(), F = (Dt = document.getElementById(i)) == null ? void 0 : Dt.getBoundingClientRect().top, ut = 103;
    F >= 0 && (X.sticky = !1, X.activeContainer = ""), B > f.current.getBoundingClientRect().top && (X.sticky = !0);
    const yt = g.hasHeader ? G + ut : ut;
    l == null || l.forEach(({ targetIdName: Nt }) => {
      const pt = document.getElementById(Nt), Se = (pt == null ? void 0 : pt.getBoundingClientRect().top) - yt, Zt = (pt == null ? void 0 : pt.getBoundingClientRect().bottom) - yt;
      Se < 0 && Zt > 0 && (X.activeContainer = Nt);
    }), y((Nt) => ({
      ...Nt,
      ...X
    }));
  }, x = () => {
    g1(A, 150), y1(A, 150);
  }, U = () => !!b(), D = () => !!document.getElementById(
    "degreeDetailPageContainer"
  );
  function R(X = null) {
    if (X === null) return g.containerClass;
    const B = Object.values(X.classList).filter(
      (G) => [
        "container-sm",
        "container-md",
        "container",
        "container-lg",
        "container-xl",
        "container-fluid"
      ].includes(G)
    );
    return B.length > 0 ? B.join(" ") : R(X.parentElement);
  }
  Qe(() => {
    const X = document.getElementById(i) || null, B = {
      hasHeader: U(),
      hasAltMenuSpacing: D(),
      containerClass: R(X)
    };
    y((G) => ({
      ...G,
      ...B
    }));
  }, []), Qe(() => (window == null || window.addEventListener("scroll", x), () => window.removeEventListener("scroll", x)), [g.hasHeader]);
  const q = (X) => {
    var yt, Dt;
    const B = T(), G = window.scrollY - (g.hasHeader ? B + 100 : 100), F = m ? 410 : 90;
    let ut = ((yt = document.getElementById(X)) == null ? void 0 : yt.getBoundingClientRect().top) + G;
    f.current.classList.contains("sticky") || (ut -= F), u && ((Dt = p1(`#${X}`)) == null || Dt.focus()), window.scrollTo({ top: ut, behavior: "smooth" });
  }, Y = () => {
    y((X) => ({
      ...X,
      showMenu: !X.showMenu
    }));
  }, L = g.hasHeader ? T() : 0, et = o ? "div" : qS, W = o ? {} : {
    // @ts-ignore
    requiresAltMenuSpacing: g.hasAltMenuSpacing
  };
  return (l == null ? void 0 : l.length) > 0 && /* @__PURE__ */ h.jsx(
    et,
    {
      ...W,
      ref: f,
      id: "uds-anchor-menu",
      className: Rt(
        "uds-anchor-menu",
        "uds-anchor-menu-expanded-lg",
        "mb-4",
        {
          sticky: g.sticky,
          "with-header": g.hasHeader
        }
      ),
      style: (
        /** @type {React.CSSProperties} */
        {
          ...g.showMenu ? { borderBottom: 0 } : {},
          "--uds-anchor-menu-top": `${L}px`
        }
      ),
      children: /* @__PURE__ */ h.jsxs("div", { className: `${g.containerClass} uds-anchor-menu-wrapper`, children: [
        /* @__PURE__ */ h.jsx("h2", { children: m ? /* @__PURE__ */ h.jsx(
          be,
          {
            gaData: {
              ...VS,
              action: g.showMenu ? "close" : "open"
            },
            children: /* @__PURE__ */ h.jsxs(
              "button",
              {
                className: Rt("mobile-menu-toggler", {
                  "show-menu": g.showMenu
                }),
                type: "button",
                onClick: Y,
                "data-bs-toggle": "collapse",
                "data-bs-target": "#collapseAnchorMenu",
                "aria-controls": "collapseAnchorMenu",
                "aria-expanded": g.showMenu,
                children: [
                  Dc,
                  ":",
                  /* @__PURE__ */ h.jsx("i", { className: "fas fa-chevron-down" })
                ]
              }
            )
          }
        ) : /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
          Dc,
          ":"
        ] }) }),
        /* @__PURE__ */ h.jsx(
          "div",
          {
            "data-testid": "anchor-menu-container",
            id: "collapseAnchorMenu",
            className: Rt("card", "card-body", "collapse", {
              show: g.showMenu
            }),
            children: /* @__PURE__ */ h.jsx(
              "nav",
              {
                "data-testid": "anchor-menu",
                className: "nav",
                "aria-label": Dc,
                children: l == null ? void 0 : l.map((X) => (
                  // Use this package button
                  // @ts-ignore
                  /* @__PURE__ */ h.jsx(
                    al,
                    {
                      "data-testid": `anchor-item-${X.targetIdName}`,
                      classes: Rt("nav-link", {
                        active: g.activeContainer === X.targetIdName
                      }).split(" "),
                      ariaLabel: X.text,
                      label: X.text,
                      icon: X.icon,
                      onClick: s && (() => q(X.targetIdName)),
                      href: o && `#${X.targetIdName}`
                    },
                    X.targetIdName
                  )
                ))
              }
            )
          }
        )
      ] })
    }
  );
};
qy.propTypes = {
  /**
   * Anchor menu items
   */
  items: p.arrayOf(
    p.shape({
      text: p.string.isRequired,
      targetIdName: p.string.isRequired,
      icon: p.arrayOf(p.string)
    })
  ).isRequired,
  /**
   * First next sibling element of the anchor menu
   */
  firstElementId: p.string.isRequired,
  /**
   * If true it focus the first focusable element into the section
   * If false it focus the next menu item into the nav bar
   */
  focusFirstFocusableElement: p.bool
};
var Tc = { exports: {} }, wc = { exports: {} }, Nf, kg;
function YS() {
  if (kg) return Nf;
  kg = 1;
  var l = 1e3, i = l * 60, u = i * 60, s = u * 24, o = s * 365.25;
  Nf = function(b, T) {
    T = T || {};
    var A = typeof b;
    if (A === "string" && b.length > 0)
      return f(b);
    if (A === "number" && isNaN(b) === !1)
      return T.long ? g(b) : m(b);
    throw new Error(
      "val is not a non-empty string or a valid number. val=" + JSON.stringify(b)
    );
  };
  function f(b) {
    if (b = String(b), !(b.length > 100)) {
      var T = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
        b
      );
      if (T) {
        var A = parseFloat(T[1]), x = (T[2] || "ms").toLowerCase();
        switch (x) {
          case "years":
          case "year":
          case "yrs":
          case "yr":
          case "y":
            return A * o;
          case "days":
          case "day":
          case "d":
            return A * s;
          case "hours":
          case "hour":
          case "hrs":
          case "hr":
          case "h":
            return A * u;
          case "minutes":
          case "minute":
          case "mins":
          case "min":
          case "m":
            return A * i;
          case "seconds":
          case "second":
          case "secs":
          case "sec":
          case "s":
            return A * l;
          case "milliseconds":
          case "millisecond":
          case "msecs":
          case "msec":
          case "ms":
            return A;
          default:
            return;
        }
      }
    }
  }
  function m(b) {
    return b >= s ? Math.round(b / s) + "d" : b >= u ? Math.round(b / u) + "h" : b >= i ? Math.round(b / i) + "m" : b >= l ? Math.round(b / l) + "s" : b + "ms";
  }
  function g(b) {
    return y(b, s, "day") || y(b, u, "hour") || y(b, i, "minute") || y(b, l, "second") || b + " ms";
  }
  function y(b, T, A) {
    if (!(b < T))
      return b < T * 1.5 ? Math.floor(b / T) + " " + A : Math.ceil(b / T) + " " + A + "s";
  }
  return Nf;
}
var Lg;
function GS() {
  return Lg || (Lg = 1, (function(l, i) {
    i = l.exports = o.debug = o.default = o, i.coerce = y, i.disable = m, i.enable = f, i.enabled = g, i.humanize = YS(), i.names = [], i.skips = [], i.formatters = {};
    var u;
    function s(b) {
      var T = 0, A;
      for (A in b)
        T = (T << 5) - T + b.charCodeAt(A), T |= 0;
      return i.colors[Math.abs(T) % i.colors.length];
    }
    function o(b) {
      function T() {
        if (T.enabled) {
          var A = T, x = +/* @__PURE__ */ new Date(), U = x - (u || x);
          A.diff = U, A.prev = u, A.curr = x, u = x;
          for (var D = new Array(arguments.length), R = 0; R < D.length; R++)
            D[R] = arguments[R];
          D[0] = i.coerce(D[0]), typeof D[0] != "string" && D.unshift("%O");
          var q = 0;
          D[0] = D[0].replace(/%([a-zA-Z%])/g, function(L, et) {
            if (L === "%%") return L;
            q++;
            var W = i.formatters[et];
            if (typeof W == "function") {
              var X = D[q];
              L = W.call(A, X), D.splice(q, 1), q--;
            }
            return L;
          }), i.formatArgs.call(A, D);
          var Y = T.log || i.log || console.log.bind(console);
          Y.apply(A, D);
        }
      }
      return T.namespace = b, T.enabled = i.enabled(b), T.useColors = i.useColors(), T.color = s(b), typeof i.init == "function" && i.init(T), T;
    }
    function f(b) {
      i.save(b), i.names = [], i.skips = [];
      for (var T = (typeof b == "string" ? b : "").split(/[\s,]+/), A = T.length, x = 0; x < A; x++)
        T[x] && (b = T[x].replace(/\*/g, ".*?"), b[0] === "-" ? i.skips.push(new RegExp("^" + b.substr(1) + "$")) : i.names.push(new RegExp("^" + b + "$")));
    }
    function m() {
      i.enable("");
    }
    function g(b) {
      var T, A;
      for (T = 0, A = i.skips.length; T < A; T++)
        if (i.skips[T].test(b))
          return !1;
      for (T = 0, A = i.names.length; T < A; T++)
        if (i.names[T].test(b))
          return !0;
      return !1;
    }
    function y(b) {
      return b instanceof Error ? b.stack || b.message : b;
    }
  })(wc, wc.exports)), wc.exports;
}
var Bg;
function XS() {
  return Bg || (Bg = 1, (function(l, i) {
    var u = { env: { NODE_ENV: "production" } };
    i = l.exports = GS(), i.log = f, i.formatArgs = o, i.save = m, i.load = g, i.useColors = s, i.storage = typeof chrome < "u" && typeof chrome.storage < "u" ? chrome.storage.local : y(), i.colors = [
      "lightseagreen",
      "forestgreen",
      "goldenrod",
      "dodgerblue",
      "darkorchid",
      "crimson"
    ];
    function s() {
      return typeof window < "u" && window.process && window.process.type === "renderer" ? !0 : typeof document < "u" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // is firebug? http://stackoverflow.com/a/398120/376773
      typeof window < "u" && window.console && (window.console.firebug || window.console.exception && window.console.table) || // is firefox >= v31?
      // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
      typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // double check webkit in userAgent just in case we are in a worker
      typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
    }
    i.formatters.j = function(b) {
      try {
        return JSON.stringify(b);
      } catch (T) {
        return "[UnexpectedJSONParseError]: " + T.message;
      }
    };
    function o(b) {
      var T = this.useColors;
      if (b[0] = (T ? "%c" : "") + this.namespace + (T ? " %c" : " ") + b[0] + (T ? "%c " : " ") + "+" + i.humanize(this.diff), !!T) {
        var A = "color: " + this.color;
        b.splice(1, 0, A, "color: inherit");
        var x = 0, U = 0;
        b[0].replace(/%[a-zA-Z%]/g, function(D) {
          D !== "%%" && (x++, D === "%c" && (U = x));
        }), b.splice(U, 0, A);
      }
    }
    function f() {
      return typeof console == "object" && console.log && Function.prototype.apply.call(console.log, console, arguments);
    }
    function m(b) {
      try {
        b == null ? i.storage.removeItem("debug") : i.storage.debug = b;
      } catch {
      }
    }
    function g() {
      var b;
      try {
        b = i.storage.debug;
      } catch {
      }
      return !b && typeof u < "u" && "env" in u && (b = u.env.DEBUG), b;
    }
    i.enable(g());
    function y() {
      try {
        return window.localStorage;
      } catch {
      }
    }
  })(Tc, Tc.exports)), Tc.exports;
}
var Ef, Hg;
function QS() {
  if (Hg) return Ef;
  Hg = 1;
  var l = XS()("jsonp");
  Ef = s;
  var i = 0;
  function u() {
  }
  function s(o, f, m) {
    typeof f == "function" && (m = f, f = {}), f || (f = {});
    var g = f.prefix || "__jp", y = f.name || g + i++, b = f.param || "callback", T = f.timeout != null ? f.timeout : 6e4, A = encodeURIComponent, x = document.getElementsByTagName("script")[0] || document.head, U, D;
    T && (D = setTimeout(function() {
      R(), m && m(new Error("Timeout"));
    }, T));
    function R() {
      U.parentNode && U.parentNode.removeChild(U), window[y] = u, D && clearTimeout(D);
    }
    function q() {
      window[y] && R();
    }
    return window[y] = function(Y) {
      l("jsonp got", Y), R(), m && m(null, Y);
    }, o += (~o.indexOf("?") ? "&" : "?") + b + "=" + A(y), o = o.replace("?&", "?"), l('jsonp req "%s"', o), U = document.createElement("script"), U.src = o, x.parentNode.insertBefore(U, x), q;
  }
  return Ef;
}
var ZS = QS();
const Vl = /* @__PURE__ */ If(ZS);
var KS = Object.defineProperty, $S = Object.defineProperties, JS = Object.getOwnPropertyDescriptors, Uc = Object.getOwnPropertySymbols, Vy = Object.prototype.hasOwnProperty, Yy = Object.prototype.propertyIsEnumerable, Ug = (l, i, u) => i in l ? KS(l, i, { enumerable: !0, configurable: !0, writable: !0, value: u }) : l[i] = u, gt = (l, i) => {
  for (var u in i || (i = {}))
    Vy.call(i, u) && Ug(l, u, i[u]);
  if (Uc)
    for (var u of Uc(i))
      Yy.call(i, u) && Ug(l, u, i[u]);
  return l;
}, Ct = (l, i) => $S(l, JS(i)), Xt = (l, i) => {
  var u = {};
  for (var s in l)
    Vy.call(l, s) && i.indexOf(s) < 0 && (u[s] = l[s]);
  if (l != null && Uc)
    for (var s of Uc(l))
      i.indexOf(s) < 0 && Yy.call(l, s) && (u[s] = l[s]);
  return u;
};
function WS(l, i) {
  return Wf.map(l, (u) => !Ff(u) || u.props.fill !== void 0 ? u : Ab(u, { fill: i }));
}
function Wc(l) {
  var i = l, {
    bgStyle: u = {},
    borderRadius: s = 0,
    children: o,
    color: f,
    iconFillColor: m = "white",
    round: g = !1,
    size: y = 64
  } = i, b = Xt(i, [
    "bgStyle",
    "borderRadius",
    "children",
    "color",
    "iconFillColor",
    "round",
    "size"
  ]);
  const T = WS(o, m);
  return /* @__PURE__ */ h.jsxs("svg", Ct(gt({ viewBox: "0 0 64 64", width: y, height: y }, b), { children: [
    g ? /* @__PURE__ */ h.jsx("circle", { cx: "32", cy: "32", r: "32", fill: f, style: u }) : /* @__PURE__ */ h.jsx(
      "rect",
      {
        width: "64",
        height: "64",
        rx: s,
        ry: s,
        fill: f,
        style: u
      }
    ),
    T
  ] }));
}
class FS extends Error {
  constructor(i) {
    super(i), this.name = "AssertionError";
  }
}
function ee(l, i) {
  if (!l)
    throw new FS(i);
}
function Qt(l) {
  const i = Object.entries(l).filter(([, u]) => u != null).map(([u, s]) => `${encodeURIComponent(u)}=${encodeURIComponent(String(s))}`);
  return i.length > 0 ? `?${i.join("&")}` : "";
}
const IS = {
  bluesky: "Share on Bluesky",
  email: "Share by email",
  facebook: "Share on Facebook",
  facebookmessenger: "Share in Messenger",
  gab: "Share on Gab",
  hatena: "Share on Hatena",
  instapaper: "Save to Instapaper",
  line: "Share on Line",
  linkedin: "Share on LinkedIn",
  livejournal: "Share on LiveJournal",
  mailru: "Share on Mail.ru",
  ok: "Share on OK",
  pinterest: "Pin on Pinterest",
  pocket: "Save to Pocket",
  reddit: "Share on Reddit",
  telegram: "Share on Telegram",
  threads: "Share on Threads",
  tumblr: "Share on Tumblr",
  twitter: "Share on X",
  viber: "Share on Viber",
  vk: "Share on VK",
  weibo: "Share on Weibo",
  whatsapp: "Share on WhatsApp",
  workplace: "Share on Workplace"
}, PS = (l) => !!l && (typeof l == "object" || typeof l == "function") && "then" in l && typeof l.then == "function", tT = (l, i) => ({
  left: window.outerWidth / 2 + (window.screenX || window.screenLeft || 0) - l / 2,
  top: window.outerHeight / 2 + (window.screenY || window.screenTop || 0) - i / 2
}), eT = (l, i) => ({
  top: (window.screen.height - i) / 2,
  left: (window.screen.width - l) / 2
});
function nT(l) {
  var i;
  const u = Wf.toArray(l);
  if (u.length !== 1)
    return;
  const [s] = u;
  if (Ff(s))
    return s.props.round ? "50%" : (i = s.props.borderRadius) != null ? i : 0;
}
function Gy(l) {
  return Wf.toArray(l).some((i) => typeof i == "string" ? i.trim().length > 0 : typeof i == "number" ? !0 : Ff(i) ? Gy(i.props.children) : !1);
}
function aT(l, i, u) {
  var s = i, { height: o, width: f } = s, m = Xt(s, ["height", "width"]);
  const g = gt({
    height: o,
    width: f,
    location: "no",
    toolbar: "no",
    status: "no",
    directories: "no",
    menubar: "no",
    scrollbars: "yes",
    resizable: "no",
    centerscreen: "yes",
    chrome: "yes"
  }, m), y = window.open(
    l,
    "",
    Object.keys(g).map((b) => `${b}=${g[b]}`).join(", ")
  );
  if (u) {
    const b = window.setInterval(() => {
      try {
        (y === null || y.closed) && (window.clearInterval(b), u(y));
      } catch (T) {
        console.error(T);
      }
    }, 1e3);
  }
  return y;
}
function re(l) {
  var i = l, {
    "aria-label": u,
    "aria-labelledby": s,
    beforeOnClick: o,
    children: f,
    className: m,
    disabled: g,
    disabledStyle: y = { opacity: 0.6 },
    forwardedRef: b,
    htmlTitle: T,
    networkLink: A,
    networkName: x,
    onClick: U,
    onShareWindowClose: D,
    openShareDialogOnClick: R = !0,
    opts: q,
    resetButtonStyle: Y = !0,
    style: L,
    title: et,
    type: W = "button",
    url: X,
    windowHeight: B = 400,
    windowPosition: G = "windowCenter",
    windowWidth: F = 550
  } = i, ut = Xt(i, [
    "aria-label",
    "aria-labelledby",
    "beforeOnClick",
    "children",
    "className",
    "disabled",
    "disabledStyle",
    "forwardedRef",
    "htmlTitle",
    "networkLink",
    "networkName",
    // deconstructed from ...rest to prevent passing it to the button element
    "onClick",
    "onShareWindowClose",
    "openShareDialogOnClick",
    "opts",
    "resetButtonStyle",
    "style",
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    "title",
    // deconstructed from ...rest to prevent passing it to the button element
    "type",
    "url",
    "windowHeight",
    "windowPosition",
    "windowWidth"
  ]);
  const yt = nT(f), Dt = !u && !s && !Gy(f) ? IS[x] : void 0, Nt = async (Zt) => {
    if (g)
      return;
    const Q = A(X, q);
    if (Zt.preventDefault(), o) {
      const V = o();
      PS(V) && await V;
    }
    if (R) {
      const V = gt({
        height: B,
        width: F
      }, G === "windowCenter" ? tT(F, B) : eT(F, B));
      aT(Q, V, D);
    }
    U && U(Zt, Q);
  }, pt = Rt(
    "react-share__ShareButton",
    {
      "react-share__ShareButton--disabled": !!g,
      disabled: !!g
    },
    m
  ), Se = gt(gt(Y ? {
    backgroundColor: "transparent",
    border: "none",
    padding: 0,
    display: "inline-flex",
    borderRadius: yt,
    outlineOffset: 2,
    font: "inherit",
    color: "inherit",
    cursor: "pointer"
  } : {}, L), g && y);
  return /* @__PURE__ */ h.jsx(
    "button",
    Ct(gt({}, ut), {
      "aria-label": u || Dt,
      "aria-labelledby": s,
      className: pt,
      disabled: g,
      onClick: Nt,
      ref: b,
      style: Se,
      title: T,
      type: W,
      children: f
    })
  );
}
function lT(l, { title: i, separator: u }) {
  return ee(l, "bluesky.url"), "https://bsky.app/intent/compose" + Qt({
    text: i ? i + u + l : l
  });
}
const iT = ne(
  (l, i) => {
    var u = l, { separator: s, title: o } = u, f = Xt(u, ["separator", "title"]);
    return /* @__PURE__ */ h.jsx(
      re,
      Ct(gt({}, f), {
        forwardedRef: i,
        networkName: "bluesky",
        networkLink: lT,
        opts: {
          title: o,
          separator: s || " "
        },
        windowHeight: 460,
        windowPosition: "windowCenter",
        windowWidth: 660
      })
    );
  }
);
iT.displayName = "BlueskyShareButton";
function rT(l) {
  return /* @__PURE__ */ h.jsx(Wc, Ct(gt({ color: "#7f7f7f" }, l), { children: /* @__PURE__ */ h.jsx("path", { d: "M17,22v20h30V22H17z M41.1,25L32,32.1L22.9,25H41.1z M20,39V26.6l12,9.3l12-9.3V39H20z" }) }));
}
function uT(l, { subject: i, body: u, separator: s }) {
  return "mailto:" + Qt({ subject: i, body: u ? u + s + l : l });
}
const Xy = ne(
  (l, i) => {
    var u = l, { body: s, separator: o, subject: f } = u, m = Xt(u, ["body", "separator", "subject"]);
    return /* @__PURE__ */ h.jsx(
      re,
      Ct(gt({}, m), {
        forwardedRef: i,
        networkName: "email",
        networkLink: uT,
        onClick: (g, y) => {
          window.location.href = y;
        },
        openShareDialogOnClick: !1,
        opts: {
          subject: f,
          body: s,
          separator: o || " "
        }
      })
    );
  }
);
Xy.displayName = "EmailShareButton";
function qg(l) {
  return /* @__PURE__ */ h.jsx(Wc, Ct(gt({ color: "#0866FF" }, l), { children: /* @__PURE__ */ h.jsx("path", { d: "M34.1,47V33.3h4.6l0.7-5.3h-5.3v-3.4c0-1.5,0.4-2.6,2.6-2.6l2.8,0v-4.8c-0.5-0.1-2.2-0.2-4.1-0.2 c-4.1,0-6.9,2.5-6.9,7V28H24v5.3h4.6V47H34.1z" }) }));
}
function cT(l, { appId: i, redirectUri: u, to: s }) {
  return "https://www.facebook.com/dialog/send" + Qt({
    link: l,
    redirect_uri: u || l,
    app_id: i,
    to: s
  });
}
const sT = ne((l, i) => {
  var u = l, { appId: s, redirectUri: o, to: f } = u, m = Xt(u, ["appId", "redirectUri", "to"]);
  return /* @__PURE__ */ h.jsx(
    re,
    Ct(gt({}, m), {
      forwardedRef: i,
      networkName: "facebookmessenger",
      networkLink: cT,
      opts: {
        appId: s,
        redirectUri: o,
        to: f
      },
      windowHeight: 820,
      windowWidth: 1e3
    })
  );
});
sT.displayName = "FacebookMessengerShareButton";
function oT(l, { hashtag: i }) {
  return ee(l, "facebook.url"), "https://www.facebook.com/sharer/sharer.php" + Qt({ u: l, hashtag: i });
}
const Yf = ne(
  (l, i) => {
    var u = l, { hashtag: s } = u, o = Xt(u, ["hashtag"]);
    return /* @__PURE__ */ h.jsx(
      re,
      Ct(gt({}, o), {
        forwardedRef: i,
        networkName: "facebook",
        networkLink: oT,
        opts: { hashtag: s },
        windowHeight: 400,
        windowWidth: 550
      })
    );
  }
);
Yf.displayName = "FacebookShareButton";
function fT() {
  const l = nn(!1);
  return Qe(() => (l.current = !0, () => {
    l.current = !1;
  }), []), kl(() => l.current, []);
}
function dT(l) {
  var i = l, {
    children: u = (x) => x,
    className: s,
    getCount: o,
    url: f
  } = i, m = Xt(i, [
    "children",
    "className",
    "getCount",
    "url"
  ]);
  const g = fT(), [y, b] = ve(void 0), [T, A] = ve(!1);
  return Qe(() => {
    A(!0), o(f, (x) => {
      g() && (b(x), A(!1));
    });
  }, [f]), /* @__PURE__ */ h.jsx("span", Ct(gt({ className: Rt("react-share__ShareCount", s) }, m), { children: !T && y !== void 0 && u(y) }));
}
function Yl(l) {
  const i = (u) => /* @__PURE__ */ h.jsx(dT, gt({ getCount: l }, u));
  return i.displayName = `ShareCount(${l.name})`, i;
}
function hT(l, i) {
  const u = `https://graph.facebook.com/?id=${l}&fields=og_object{engagement}`;
  Vl(u, (s, o) => {
    i(
      !s && o && o.og_object && o.og_object.engagement ? o.og_object.engagement.count : void 0
    );
  });
}
Yl(hT);
function mT(l, { title: i }) {
  return ee(l, "hatena.url"), `http://b.hatena.ne.jp/add?mode=confirm&url=${l}&title=${i}`;
}
const pT = ne(
  (l, i) => {
    var u = l, { title: s } = u, o = Xt(u, ["title"]);
    return /* @__PURE__ */ h.jsx(
      re,
      Ct(gt({}, o), {
        forwardedRef: i,
        networkName: "hatena",
        networkLink: mT,
        opts: { title: s },
        windowHeight: 460,
        windowPosition: "windowCenter",
        windowWidth: 660
      })
    );
  }
);
pT.displayName = "HatenaShareButton";
function gT(l, i) {
  Vl(
    "https://bookmark.hatenaapis.com/count/entry" + Qt({
      url: l
    }),
    (s, o) => {
      i(o ?? void 0);
    }
  );
}
Yl(gT);
function yT(l, { title: i, description: u }) {
  return ee(l, "instapaper.url"), "http://www.instapaper.com/hello2" + Qt({
    url: l,
    title: i,
    description: u
  });
}
const vT = ne(
  (l, i) => {
    var u = l, { description: s, title: o } = u, f = Xt(u, ["description", "title"]);
    return /* @__PURE__ */ h.jsx(
      re,
      Ct(gt({}, f), {
        forwardedRef: i,
        networkName: "instapaper",
        networkLink: yT,
        opts: {
          title: o,
          description: s
        },
        windowHeight: 500,
        windowPosition: "windowCenter",
        windowWidth: 500
      })
    );
  }
);
vT.displayName = "InstapaperShareButton";
function bT(l, { title: i }) {
  return ee(l, "line.url"), "https://social-plugins.line.me/lineit/share" + Qt({
    url: l,
    text: i
  });
}
const ST = ne(
  (l, i) => {
    var u = l, { title: s } = u, o = Xt(u, ["title"]);
    return /* @__PURE__ */ h.jsx(
      re,
      Ct(gt({}, o), {
        forwardedRef: i,
        networkName: "line",
        networkLink: bT,
        opts: { title: s },
        windowHeight: 500,
        windowWidth: 500
      })
    );
  }
);
ST.displayName = "LineShareButton";
function Vg(l) {
  return /* @__PURE__ */ h.jsx(Wc, Ct(gt({ color: "#0077B5" }, l), { children: /* @__PURE__ */ h.jsx("path", { d: "M20.4,44h5.4V26.6h-5.4V44z M23.1,18c-1.7,0-3.1,1.4-3.1,3.1c0,1.7,1.4,3.1,3.1,3.1 c1.7,0,3.1-1.4,3.1-3.1C26.2,19.4,24.8,18,23.1,18z M39.5,26.2c-2.6,0-4.4,1.4-5.1,2.8h-0.1v-2.4h-5.2V44h5.4v-8.6 c0-2.3,0.4-4.5,3.2-4.5c2.8,0,2.8,2.6,2.8,4.6V44H46v-9.5C46,29.8,45,26.2,39.5,26.2z" }) }));
}
function TT(l, { title: i, summary: u, source: s }) {
  return ee(l, "linkedin.url"), "https://linkedin.com/shareArticle" + Qt({ url: l, mini: "true", title: i, summary: u, source: s });
}
const Gf = ne(
  (l, i) => {
    var u = l, { source: s, summary: o, title: f } = u, m = Xt(u, ["source", "summary", "title"]);
    return /* @__PURE__ */ h.jsx(
      re,
      Ct(gt({}, m), {
        forwardedRef: i,
        networkName: "linkedin",
        networkLink: TT,
        opts: { title: f, summary: o, source: s },
        windowHeight: 600,
        windowWidth: 750
      })
    );
  }
);
Gf.displayName = "LinkedinShareButton";
function wT(l, { title: i, description: u }) {
  return ee(l, "livejournal.url"), "https://www.livejournal.com/update.bml" + Qt({
    subject: i,
    event: u
  });
}
const xT = ne(
  (l, i) => {
    var u = l, { description: s, title: o } = u, f = Xt(u, ["description", "title"]);
    return /* @__PURE__ */ h.jsx(
      re,
      Ct(gt({}, f), {
        forwardedRef: i,
        networkName: "livejournal",
        networkLink: wT,
        opts: {
          title: o,
          description: s
        },
        windowHeight: 460,
        windowWidth: 660
      })
    );
  }
);
xT.displayName = "LivejournalShareButton";
function AT(l, { title: i, description: u, imageUrl: s }) {
  return ee(l, "mailru.url"), "https://connect.mail.ru/share" + Qt({
    url: l,
    title: i,
    description: u,
    image_url: s
  });
}
const _T = ne(
  (l, i) => {
    var u = l, { description: s, imageUrl: o, title: f } = u, m = Xt(u, ["description", "imageUrl", "title"]);
    return /* @__PURE__ */ h.jsx(
      re,
      Ct(gt({}, m), {
        forwardedRef: i,
        networkName: "mailru",
        networkLink: AT,
        opts: {
          title: f,
          description: s,
          imageUrl: o
        },
        windowHeight: 460,
        windowWidth: 660
      })
    );
  }
);
_T.displayName = "MailruShareButton";
function OT(l, { title: i, description: u, image: s }) {
  return ee(l, "ok.url"), "https://connect.ok.ru/offer" + Qt({
    url: l,
    title: i,
    description: u,
    imageUrl: s
  });
}
const NT = ne(
  (l, i) => {
    var u = l, { description: s, image: o, title: f } = u, m = Xt(u, ["description", "image", "title"]);
    return /* @__PURE__ */ h.jsx(
      re,
      Ct(gt({}, m), {
        forwardedRef: i,
        networkName: "ok",
        networkLink: OT,
        opts: {
          title: f,
          description: s,
          image: o
        },
        windowHeight: 480,
        windowPosition: "screenCenter",
        windowWidth: 588
      })
    );
  }
);
NT.displayName = "OKShareButton";
function ET(l, i) {
  window.OK || (window.OK = {
    Share: {
      count: function(f, m) {
        var g, y;
        (y = (g = window.OK.callbacks)[f]) == null || y.call(g, m);
      }
    },
    callbacks: []
  });
  const u = "https://connect.ok.ru/dk", s = window.OK.callbacks.length;
  return window.ODKL = {
    updateCount(o, f) {
      var m, g;
      const y = o === "" ? 0 : parseInt(o.replace("react-share-", ""), 10);
      (g = (m = window.OK.callbacks)[y]) == null || g.call(m, f === "" ? void 0 : parseInt(f, 10));
    }
  }, window.OK.callbacks.push(i), Vl(
    u + Qt({
      "st.cmd": "extLike",
      uid: `react-share-${s}`,
      ref: l
    })
  );
}
Yl(ET);
function jT(l, { media: i, description: u, pinId: s }) {
  return s ? `https://pinterest.com/pin/${s}/repin/x/` : (ee(l, "pinterest.url"), ee(i, "pinterest.media"), "https://pinterest.com/pin/create/button/" + Qt({
    url: l,
    media: i,
    description: u
  }));
}
const RT = ne(
  (l, i) => {
    var u = l, { description: s, media: o, pinId: f } = u, m = Xt(u, ["description", "media", "pinId"]);
    return /* @__PURE__ */ h.jsx(
      re,
      Ct(gt({}, m), {
        forwardedRef: i,
        networkName: "pinterest",
        networkLink: jT,
        opts: {
          media: o,
          description: s,
          pinId: f
        },
        windowHeight: 730,
        windowWidth: 1e3
      })
    );
  }
);
RT.displayName = "PinterestShareButton";
function CT(l, i) {
  Vl(
    "https://api.pinterest.com/v1/urls/count.json" + Qt({
      url: l
    }),
    (s, o) => {
      i(o ? o.count : void 0);
    }
  );
}
Yl(CT);
function DT(l, { title: i }) {
  return ee(l, "pocket.url"), "https://getpocket.com/save" + Qt({
    url: l,
    title: i
  });
}
const zT = ne(
  (l, i) => {
    var u = l, { title: s } = u, o = Xt(u, ["title"]);
    return /* @__PURE__ */ h.jsx(
      re,
      Ct(gt({}, o), {
        forwardedRef: i,
        networkName: "pocket",
        networkLink: DT,
        opts: { title: s },
        windowHeight: 500,
        windowWidth: 500
      })
    );
  }
);
zT.displayName = "PocketShareButton";
function MT(l, { title: i }) {
  return ee(l, "reddit.url"), "https://www.reddit.com/submit" + Qt({
    url: l,
    title: i
  });
}
const kT = ne(
  (l, i) => {
    var u = l, { title: s } = u, o = Xt(u, ["title"]);
    return /* @__PURE__ */ h.jsx(
      re,
      Ct(gt({}, o), {
        forwardedRef: i,
        networkName: "reddit",
        networkLink: MT,
        opts: { title: s },
        windowHeight: 460,
        windowPosition: "windowCenter",
        windowWidth: 660
      })
    );
  }
);
kT.displayName = "RedditShareButton";
function LT(l, { title: i }) {
  return ee(l, "gab.url"), "https://gab.com/compose" + Qt({
    url: l,
    text: i
  });
}
const BT = ne(
  (l, i) => {
    var u = l, { title: s } = u, o = Xt(u, ["title"]);
    return /* @__PURE__ */ h.jsx(
      re,
      Ct(gt({}, o), {
        forwardedRef: i,
        networkName: "gab",
        networkLink: LT,
        opts: { title: s },
        windowHeight: 640,
        windowPosition: "windowCenter",
        windowWidth: 660
      })
    );
  }
);
BT.displayName = "GabShareButton";
function HT(l, i) {
  const u = `https://www.reddit.com/api/info.json?limit=1&url=${l}`;
  Vl(u, { param: "jsonp" }, (s, o) => {
    i(
      !s && o && o.data && o.data.children.length > 0 && o.data.children[0].data.score ? o.data.children[0].data.score : void 0
    );
  });
}
Yl(HT);
function UT(l, { title: i }) {
  return ee(l, "telegram.url"), "https://telegram.me/share/url" + Qt({
    url: l,
    text: i
  });
}
const qT = ne(
  (l, i) => {
    var u = l, { title: s } = u, o = Xt(u, ["title"]);
    return /* @__PURE__ */ h.jsx(
      re,
      Ct(gt({}, o), {
        forwardedRef: i,
        networkName: "telegram",
        networkLink: UT,
        opts: { title: s },
        windowHeight: 400,
        windowWidth: 550
      })
    );
  }
);
qT.displayName = "TelegramShareButton";
function VT(l, { title: i }) {
  return ee(l, "threads.url"), "https://threads.net/intent/post" + Qt({
    url: l,
    text: i
  });
}
const YT = ne(
  (l, i) => {
    var u = l, { hashtags: s, related: o, title: f, via: m } = u, g = Xt(u, ["hashtags", "related", "title", "via"]);
    return /* @__PURE__ */ h.jsx(
      re,
      Ct(gt({}, g), {
        forwardedRef: i,
        networkName: "threads",
        networkLink: VT,
        opts: { title: f },
        windowHeight: 600,
        windowWidth: 550
      })
    );
  }
);
YT.displayName = "ThreadsShareButton";
function GT(l, {
  title: i,
  caption: u,
  tags: s,
  posttype: o
}) {
  return ee(l, "tumblr.url"), "https://www.tumblr.com/widgets/share/tool" + Qt({
    canonicalUrl: l,
    title: i,
    caption: u,
    tags: s,
    posttype: o
  });
}
const XT = ne(
  (l, i) => {
    var u = l, { caption: s, posttype: o, tags: f, title: m } = u, g = Xt(u, ["caption", "posttype", "tags", "title"]);
    return /* @__PURE__ */ h.jsx(
      re,
      Ct(gt({}, g), {
        forwardedRef: i,
        networkName: "tumblr",
        networkLink: GT,
        opts: {
          title: m,
          tags: (f || []).join(","),
          caption: s,
          posttype: o || "link"
        },
        windowHeight: 460,
        windowWidth: 660
      })
    );
  }
);
XT.displayName = "TumblrShareButton";
function QT(l, i) {
  return Vl(
    "https://api.tumblr.com/v2/share/stats" + Qt({
      url: l
    }),
    (s, o) => {
      i(!s && o && o.response ? o.response.note_count : void 0);
    }
  );
}
Yl(QT);
function ZT(l, {
  title: i,
  via: u,
  hashtags: s = [],
  related: o = []
}) {
  return ee(l, "x.url"), ee(Array.isArray(s), "x.hashtags is not an array"), ee(Array.isArray(o), "x.related is not an array"), "https://twitter.com/intent/tweet" + Qt({
    url: l,
    text: i,
    via: u,
    hashtags: s.length > 0 ? s.join(",") : void 0,
    related: o.length > 0 ? o.join(",") : void 0
  });
}
const qc = ne(
  (l, i) => {
    var u = l, { hashtags: s, related: o, title: f, via: m } = u, g = Xt(u, ["hashtags", "related", "title", "via"]);
    return /* @__PURE__ */ h.jsx(
      re,
      Ct(gt({}, g), {
        forwardedRef: i,
        networkName: "twitter",
        networkLink: ZT,
        opts: {
          hashtags: s,
          title: f,
          via: m,
          related: o
        },
        windowHeight: 400,
        windowWidth: 550
      })
    );
  }
);
qc.displayName = "XShareButton";
const KT = ne((l, i) => /* @__PURE__ */ h.jsx(qc, Ct(gt({}, l), { ref: i })));
KT.displayName = "TwitterShareButton";
function $T(l, { title: i, separator: u }) {
  return ee(l, "viber.url"), "viber://forward" + Qt({
    text: i ? i + u + l : l
  });
}
const JT = ne(
  (l, i) => {
    var u = l, { separator: s, title: o } = u, f = Xt(u, ["separator", "title"]);
    return /* @__PURE__ */ h.jsx(
      re,
      Ct(gt({}, f), {
        forwardedRef: i,
        networkName: "viber",
        networkLink: $T,
        opts: {
          title: o,
          separator: s || " "
        },
        windowHeight: 460,
        windowWidth: 660
      })
    );
  }
);
JT.displayName = "ViberShareButton";
function WT(l, { title: i, image: u, noParse: s, noVkLinks: o }) {
  return ee(l, "vk.url"), "https://vk.com/share.php" + Qt({
    url: l,
    title: i,
    image: u,
    noparse: s ? 1 : 0,
    no_vk_links: o ? 1 : 0
  });
}
const FT = ne(
  (l, i) => {
    var u = l, { image: s, noParse: o, noVkLinks: f, title: m } = u, g = Xt(u, ["image", "noParse", "noVkLinks", "title"]);
    return /* @__PURE__ */ h.jsx(
      re,
      Ct(gt({}, g), {
        forwardedRef: i,
        networkName: "vk",
        networkLink: WT,
        opts: {
          title: m,
          image: s,
          noParse: o,
          noVkLinks: f
        },
        windowHeight: 460,
        windowWidth: 660
      })
    );
  }
);
FT.displayName = "VKShareButton";
function IT(l, i) {
  window.VK || (window.VK = {}), window.VK.Share = {
    count: (o, f) => {
      var m, g;
      return (g = (m = window.VK.callbacks) == null ? void 0 : m[o]) == null ? void 0 : g.call(m, f);
    }
  }, window.VK.callbacks = [];
  const u = "https://vk.com/share.php", s = window.VK.callbacks.length;
  return window.VK.callbacks.push(i), Vl(
    u + Qt({
      act: "count",
      index: s,
      url: l
    })
  );
}
Yl(IT);
function PT(l, { title: i, image: u }) {
  return ee(l, "weibo.url"), "http://service.weibo.com/share/share.php" + Qt({
    url: l,
    title: i,
    pic: u
  });
}
const tw = ne(
  (l, i) => {
    var u = l, { image: s, title: o } = u, f = Xt(u, ["image", "title"]);
    return /* @__PURE__ */ h.jsx(
      re,
      Ct(gt({}, f), {
        forwardedRef: i,
        networkName: "weibo",
        networkLink: PT,
        opts: {
          title: o,
          image: s
        },
        windowHeight: 550,
        windowPosition: "screenCenter",
        windowWidth: 660
      })
    );
  }
);
tw.displayName = "WeiboShareButton";
function ew(l, { title: i, separator: u }) {
  return ee(l, "whatsapp.url"), "https://api.whatsapp.com/send" + Qt({
    text: i ? i + u + l : l
  });
}
const nw = ne(
  (l, i) => {
    var u = l, { separator: s, title: o } = u, f = Xt(u, ["separator", "title"]);
    return /* @__PURE__ */ h.jsx(
      re,
      Ct(gt({}, f), {
        forwardedRef: i,
        networkName: "whatsapp",
        networkLink: ew,
        opts: {
          title: o,
          separator: s || " "
        },
        windowHeight: 400,
        windowWidth: 550
      })
    );
  }
);
nw.displayName = "WhatsappShareButton";
function aw(l, { quote: i, hashtag: u }) {
  return ee(l, "workplace.url"), "https://work.facebook.com/sharer.php" + Qt({
    u: l,
    quote: i,
    hashtag: u
  });
}
const lw = ne(
  (l, i) => {
    var u = l, { hashtag: s, quote: o } = u, f = Xt(u, ["hashtag", "quote"]);
    return /* @__PURE__ */ h.jsx(
      re,
      Ct(gt({}, f), {
        forwardedRef: i,
        networkName: "workplace",
        networkLink: aw,
        opts: {
          quote: o,
          hashtag: s
        },
        windowHeight: 400,
        windowWidth: 550
      })
    );
  }
);
lw.displayName = "WorkplaceShareButton";
function Yg(l) {
  return /* @__PURE__ */ h.jsx(Wc, Ct(gt({ color: "#000000" }, l), { children: /* @__PURE__ */ h.jsx("path", { d: "M 41.116 18.375 h 4.962 l -10.8405 12.39 l 12.753 16.86 H 38.005 l -7.821 -10.2255 L 21.235 47.625 H 16.27 l 11.595 -13.2525 L 15.631 18.375 H 25.87 l 7.0695 9.3465 z m -1.7415 26.28 h 2.7495 L 24.376 21.189 H 21.4255 z" }) }));
}
const iw = Qn.div`
  &.news-container h2 {
    font-size: 48px;
  }

  &.event-container h2 {
    font-size: 40px;
  }

  &.news-container img,
  &.event-container img {
    width: 100%;
    max-width: fit-content;
  }

  &.wrapper-container h4 {
    margin-top: 0;
  }

  &.wrapper-container {
    max-width: 1300px;
    margin: 0 auto;
    padding: 0 10%;
  }

  &.event-container.wrapper-container {
    max-width: 1500px;
  }

  &.news-container {
    background: #fff;
  }

  ol.breadcrumb {
    padding: 0;
    margin: 0;
  }

  ol.breadcrumb > li {
    margin-bottom: 0;
  }

  .article-social-media {
    margin-bottom: 24px;
  }

  .react-share__ShareButton {
    margin-right: 12px;
  }

  i.news-date {
    display: inline-block;
    margin-bottom: 24px;
  }

  .highlight-gold {
    box-shadow:
      -0.15em 0 0 #ffc627,
      0.15em 0 0 #ffc627;
    background: #ffc627;
  }

  .author {
    display: inline-block;
    margin-top: 30px;
    margin-left: -7px;
    padding: 0 6px;
    font-size: 16px;
    font-weight: 600;
    line-height: 16px;
  }

  .icon-bg {
    display: inline-block;
    position: relative;
    padding: 1px 3.5px;
    background-color: maroon;
    margin-right: 4px;
    border-radius: 4px;
    color: white;
    font-size: 0.65rem;
  }

  .uds-button {
    margin-top: 17px;
    padding: 0;
  }

  .author-title {
    max-width: 250px;
    margin-top: 10px;
    margin-bottom: 11px;
    font-size: 16px;
  }

  .author-contact {
    margin-top: 4px;
    font-size: 14px;
    font-weight: 500;
  }

  ol.breadcrumb a {
    text-decoration: none;
  }

  i.fa-calendar,
  i.fa-map-marker-alt {
    font-size: 1.17rem;
    margin-right: 8px;
  }

  .event-author {
    font-size: 16px;
    font-weight: 600;
    line-height: 16px;
  }

  .event-author-title {
    margin-top: 4px;
  }

  .event-author-info {
    margin-top: 24px;
  }
`, rw = Qn.div`
  border-top: 1px solid black;
  h4 {
    margin-top: 0;
  }
  .react-share__ShareButton {
    margin-right: 24px;
  }
`, Qy = ({
  type: l = "news",
  articleUrl: i = "",
  publicationDate: u,
  title: s,
  body: o,
  authorEmail: f,
  authorName: m,
  authorPhone: g,
  authorTitle: y,
  breadcrumbs: b,
  calendarUrl: T,
  eventLocation: A,
  eventTime: x,
  headerImageUrl: U,
  registrationUrl: D,
  zoomUrl: R
}) => {
  const q = Rt("col", "col-12", {
    "col-lg-8": l === "event" && (D || R || T)
  }), Y = () => D ? /* @__PURE__ */ h.jsx("div", { className: "card-button uds-button", children: /* @__PURE__ */ h.jsx(al, { color: "maroon", href: D, label: "Register" }) }) : /* @__PURE__ */ h.jsx("div", { className: "card-button uds-button", children: /* @__PURE__ */ h.jsx(al, { color: "maroon", href: R, label: "Attend on Zoom" }) }), L = () => /* @__PURE__ */ h.jsx("div", { className: "row pb-2", "data-testid": "author-info", children: /* @__PURE__ */ h.jsxs("div", { className: "col col-12", children: [
    /* @__PURE__ */ h.jsx("div", { className: "author highlight-gold", children: m }),
    y && /* @__PURE__ */ h.jsx("div", { className: "author-title", children: y }),
    f && /* @__PURE__ */ h.jsxs("div", { className: "author-contact", children: [
      /* @__PURE__ */ h.jsx("span", { className: "icon-bg", children: /* @__PURE__ */ h.jsx("i", { className: "fas fa-envelope" }) }),
      /* @__PURE__ */ h.jsx("a", { href: `mailto: ${f}`, children: f })
    ] }),
    g && /* @__PURE__ */ h.jsxs("div", { className: "author-contact", children: [
      /* @__PURE__ */ h.jsx("span", { className: "icon-bg", children: /* @__PURE__ */ h.jsx("i", { className: "fas fa-phone" }) }),
      /* @__PURE__ */ h.jsx("a", { href: `tel: ${g}`, children: g })
    ] })
  ] }) }), et = () => /* @__PURE__ */ h.jsxs(
    rw,
    {
      className: "row row-spaced mt-3 pt-6 pb-2 event-info",
      "data-testid": "event-info",
      children: [
        /* @__PURE__ */ h.jsxs("div", { className: "col col-lg-4 col-md-6 col-12", children: [
          /* @__PURE__ */ h.jsx("h4", { children: "For more information contact:" }),
          /* @__PURE__ */ h.jsx("div", { className: "event-author", children: m }),
          /* @__PURE__ */ h.jsx("div", { className: "event-author-title", children: y }),
          (f || g) && /* @__PURE__ */ h.jsxs("div", { className: "event-author-info", children: [
            f && /* @__PURE__ */ h.jsx("div", { children: /* @__PURE__ */ h.jsx("a", { href: `mailto: ${f}`, children: f }) }),
            g && /* @__PURE__ */ h.jsx("div", { children: /* @__PURE__ */ h.jsx("a", { href: `tel: ${g}`, children: g }) })
          ] })
        ] }),
        /* @__PURE__ */ h.jsxs("div", { className: "col col-lg-4 col-md-6 col-12", children: [
          /* @__PURE__ */ h.jsx("h4", { children: "Share this event:" }),
          /* @__PURE__ */ h.jsxs("div", { className: "article-social-media", children: [
            /* @__PURE__ */ h.jsx(
              Yf,
              {
                url: i,
                title: s,
                "aria-label": "Share via Facebook",
                children: /* @__PURE__ */ h.jsx(
                  qg,
                  {
                    size: 28,
                    borderRadius: 4,
                    bgStyle: { fill: "maroon" },
                    iconFillColor: "white"
                  }
                )
              }
            ),
            /* @__PURE__ */ h.jsx(
              qc,
              {
                url: i,
                title: s,
                "aria-label": "Share via X (formerly Twitter)",
                children: /* @__PURE__ */ h.jsx(
                  Yg,
                  {
                    size: 28,
                    borderRadius: 4,
                    bgStyle: { fill: "maroon" },
                    iconFillColor: "white"
                  }
                )
              }
            ),
            /* @__PURE__ */ h.jsx(
              Xy,
              {
                url: i,
                title: s,
                "aria-label": "Share via Email",
                subject: "Check out this article!",
                body: "I found this and thought you might find it interesting:",
                children: /* @__PURE__ */ h.jsx(
                  rT,
                  {
                    size: 28,
                    borderRadius: 4,
                    bgStyle: { fill: "maroon" },
                    iconFillColor: "white"
                  }
                )
              }
            ),
            /* @__PURE__ */ h.jsx(
              Gf,
              {
                url: i,
                title: s,
                "aria-label": "Share via LinkedIn",
                children: /* @__PURE__ */ h.jsx(
                  Vg,
                  {
                    size: 28,
                    borderRadius: 4,
                    bgStyle: { fill: "maroon" },
                    iconFillColor: "white"
                  }
                )
              }
            )
          ] })
        ] })
      ]
    }
  ), W = () => /* @__PURE__ */ h.jsxs("div", { className: "col col-12 col-lg-4 col-md-6", children: [
    /* @__PURE__ */ h.jsxs("h4", { children: [
      /* @__PURE__ */ h.jsx("i", { className: "fas fa-map-marker-alt" }),
      "Location:"
    ] }),
    A && /* @__PURE__ */ h.jsx(
      "div",
      {
        dangerouslySetInnerHTML: Xe(A)
      }
    ),
    D && R && /* @__PURE__ */ h.jsx("a", { href: R, children: "Attend on Zoom" })
  ] }), X = (B) => /* @__PURE__ */ h.jsx(
    "li",
    {
      className: "breadcrumb-item",
      "aria-current": B.active ? "page" : void 0,
      children: B.active ? /* @__PURE__ */ h.jsx("span", { children: B.title }) : /* @__PURE__ */ h.jsx("a", { href: B.url, children: B.title })
    },
    B.title
  );
  return i === "" && console.warn(
    "Warning: articleUrl prop is required for Article component for social media sharing to work properly."
  ), /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
    U && l !== "event" && /* @__PURE__ */ h.jsx(
      "div",
      {
        "data-testid": "uds-hero",
        className: "uds-hero uds-hero-md",
        style: {
          // @ts-ignore
          "--color1": "#19191900",
          "--color2": "#191919c9",
          // moved colors to variable because hex color in linear-gradient breaks react
          backgroundImage: `linear-gradient(180deg, var(--color1) 0%, var(--color2) 100%), url(${U})`
        }
      }
    ),
    /* @__PURE__ */ h.jsxs(iw, { className: `container ${l}-container wrapper-container`, children: [
      b && /* @__PURE__ */ h.jsx("div", { className: "row pt-4", "data-testid": "breadcrumbs", children: /* @__PURE__ */ h.jsx("div", { className: "col col-12", children: /* @__PURE__ */ h.jsx("nav", { "aria-label": "breadcrumb", children: /* @__PURE__ */ h.jsx("ol", { className: "breadcrumb", children: b.map((B) => X(B)) }) }) }) }),
      /* @__PURE__ */ h.jsxs("div", { className: "row pb-2 pt-3", children: [
        /* @__PURE__ */ h.jsx("div", { className: q, children: /* @__PURE__ */ h.jsx("h2", { "data-testid": "title", children: s }) }),
        l === "event" && /* @__PURE__ */ h.jsxs("div", { className: "col col-lg-4 col-xs-12", children: [
          (D || R) && Y(),
          T && /* @__PURE__ */ h.jsx("div", { className: "card-button uds-button", children: /* @__PURE__ */ h.jsx(
            al,
            {
              color: "gray",
              size: "small",
              href: T,
              label: "Add to calendar"
            }
          ) })
        ] })
      ] }),
      l === "event" ? /* @__PURE__ */ h.jsxs("div", { className: "row row-spaced pt-3 mb-2", children: [
        x && /* @__PURE__ */ h.jsxs("div", { className: "col col-lg-4 col-md-6 col-sm-12", children: [
          /* @__PURE__ */ h.jsxs("h4", { children: [
            /* @__PURE__ */ h.jsx("i", { className: "far fa-calendar" }),
            "Date and time:"
          ] }),
          /* @__PURE__ */ h.jsx(
            "div",
            {
              dangerouslySetInnerHTML: Xe(x)
            }
          )
        ] }),
        (D && R || A) && W()
      ] }) : /* @__PURE__ */ h.jsx("div", { className: "row row-spaced pt-2", children: /* @__PURE__ */ h.jsxs("div", { className: "col col-12", children: [
        /* @__PURE__ */ h.jsxs("div", { className: "article-social-media", children: [
          /* @__PURE__ */ h.jsx(Yf, { url: i, title: s, children: /* @__PURE__ */ h.jsx(
            qg,
            {
              size: 28,
              borderRadius: 4,
              bgStyle: { fill: "maroon" },
              iconFillColor: "white"
            }
          ) }),
          /* @__PURE__ */ h.jsx(qc, { url: i, title: s, children: /* @__PURE__ */ h.jsx(
            Yg,
            {
              size: 28,
              borderRadius: 4,
              bgStyle: { fill: "maroon" },
              iconFillColor: "white"
            }
          ) }),
          /* @__PURE__ */ h.jsx(Gf, { url: i, title: s, children: /* @__PURE__ */ h.jsx(
            Vg,
            {
              size: 28,
              borderRadius: 4,
              bgStyle: { fill: "maroon" },
              iconFillColor: "white"
            }
          ) })
        ] }),
        u && /* @__PURE__ */ h.jsx("i", { className: "news-date", children: u })
      ] }) }),
      /* @__PURE__ */ h.jsx("div", { className: "row", children: /* @__PURE__ */ h.jsx(
        "div",
        {
          className: "col col-12",
          dangerouslySetInnerHTML: Xe(o),
          "data-testid": "body"
        }
      ) }),
      l === "news" && L(),
      l === "event" && et()
    ] })
  ] });
};
Qy.propTypes = {
  /**
   * Type of article
   */
  type: p.oneOf(["event", "news"]),
  /**
   * This is the relative or absolute url to the full-page article
   */
  articleUrl: p.string.isRequired,
  /**
   * Date for the article
   */
  publicationDate: p.string.isRequired,
  /**
   * Title
   */
  title: p.string.isRequired,
  /**
   * Body content for the article
   */
  body: p.string.isRequired,
  /**
   * Article author email
   */
  authorEmail: p.string,
  /**
   * Article author full name
   */
  authorName: p.string.isRequired,
  /**
   * Article author phone number
   */
  authorPhone: p.string,
  /**
   * Article author title
   */
  authorTitle: p.string,
  /**
   * Breadcrumbs array
   */
  breadcrumbs: p.arrayOf(
    p.shape({
      title: p.string,
      url: p.string,
      active: p.bool
    })
  ),
  /**
   * URL for an "add to calendar" button
   */
  calendarUrl: p.string,
  /**
   * Article image
   */
  headerImageUrl: p.string,
  /**
   * Event location
   */
  eventLocation: p.string,
  /**
   * Event time
   */
  eventTime: p.string,
  /**
   * URL for a registation button
   */
  registrationUrl: p.string,
  /**
   * URL for a Zoom button
   */
  zoomUrl: p.string
};
const uw = {
  name: "onclick",
  event: "link",
  action: "click",
  type: "internal link",
  region: "main content"
}, id = ({
  color: l = "gray",
  icon: i = void 0,
  innerRef: u = void 0,
  onClick: s = void 0,
  size: o = "small",
  cardTitle: f = "",
  className: m,
  gaData: g,
  ...y
}) => {
  const b = () => {
    s == null || s();
  };
  return /* @__PURE__ */ h.jsx(
    be,
    {
      gaData: {
        ...uw,
        section: f,
        // @deprecated - remove at some point
        ...g,
        text: `${i == null ? void 0 : i[1]} icon`
      },
      children: /* @__PURE__ */ h.jsx(
        "button",
        {
          type: "button",
          className: `btn btn-circle btn-circle-alt-${l} ${o === "large" && "btn-circle-large"} ${m}`,
          ref: u,
          "aria-label": "Close",
          onClick: b,
          ...y,
          children: /* @__PURE__ */ h.jsx("i", { className: `${i == null ? void 0 : i[0]} fa-${i == null ? void 0 : i[1]}` })
        }
      )
    }
  );
};
id.propTypes = {
  /**
    Color the button based on the background color
  */
  color: p.oneOf(["white", "gray", "black"]),
  /**
    React Font Awesome icon prefix and name string to be rendered in button label. Ex: ['fab', 'drupal']
  */
  icon: p.arrayOf(p.string),
  /**
   * ref will only get you a reference to the Button component, use innerRef to
   * get a reference to the DOM element (for things like focus management).
   */
  innerRef: p.oneOfType([
    p.object,
    p.func,
    p.string
  ]),
  /**
    Event handler function for `<button>`
  */
  onClick: p.func,
  /**
   * @deprecated
   * Card title, use `gaData.section` instead
   */
  cardTitle: p.string,
  /**
   * Google Analytics event data
   */
  gaData: Pf,
  /**
    Button size
  */
  size: p.oneOf(["large", "small"]),
  className: p.string
};
const cw = {
  name: "onclick",
  event: "link",
  action: "click",
  type: "internal link",
  region: "main content"
}, rd = ({
  label: l = "",
  cardTitle: i = "",
  gaData: u,
  ariaLabel: s,
  color: o = "gray",
  disabled: f,
  element: m = "button",
  innerRef: g,
  href: y,
  onClick: b,
  ...T
}) => {
  const A = Rt("btn", "btn-tag", {
    "btn-tag-alt-white": o === "white",
    "btn-tag-alt-gray": o === "gray",
    "btn-tag-alt-dark": o === "dark",
    disabled: f
  });
  let x = m;
  return y && m === "button" && (x = "a"), /* @__PURE__ */ h.jsx(
    be,
    {
      gaData: {
        ...cw,
        section: i,
        // @deprecated - remove at some point
        ...u,
        text: l
      },
      children: /* @__PURE__ */ h.jsx(
        x,
        {
          type: x === "button" && b ? "button" : void 0,
          ...T,
          className: A,
          href: y,
          ref: g,
          onClick: b,
          "aria-label": s,
          children: l
        }
      )
    }
  );
};
rd.propTypes = {
  /**
    Button tag label
  */
  label: p.string,
  /**
   * @deprecated
   * Card title, use `gaData.section` instead
   */
  cardTitle: p.string,
  /**
   * Google Analytics event data
   */
  gaData: Pf,
  /**
    ARIA label for accessibility
  */
  ariaLabel: p.string,
  /**
    Button background color
  */
  color: p.oneOf(["white", "gray", "dark"]),
  /**
    Disable the button?
  */
  disabled: p.bool,
  /**
    Pass in a Component to override default button element.
    For example: react-router Link
  */
  element: p.oneOfType([
    p.func,
    p.string,
    p.shape({ $$typeof: p.symbol, render: p.func }),
    p.arrayOf(
      p.oneOfType([
        p.func,
        p.string,
        p.shape({ $$typeof: p.symbol, render: p.func })
      ])
    )
  ]),
  /**
    Link target url; will cause button to be rendered as `<a>` link
  */
  href: p.string,
  /**
   * ref will only get you a reference to the Button component, use innerRef to
   * get a reference to the DOM element (for things like focus management).
   */
  innerRef: p.oneOfType([
    p.object,
    p.func,
    p.string
  ]),
  /**
    Event handler function for `<button>`
  */
  onClick: p.func
};
const Ul = ({
  src: l,
  alt: i,
  cssClasses: u,
  loading: s = "lazy",
  decoding: o = "async",
  dataTestId: f,
  fetchPriority: m = "auto",
  width: g,
  height: y,
  cardLink: b,
  title: T,
  caption: A,
  captionTitle: x,
  border: U,
  dropShadow: D
}) => {
  const R = {
    src: l,
    alt: i,
    loading: s,
    decoding: o,
    fetchpriority: m,
    // React attribute bug workaround
    ...(u == null ? void 0 : u.length) > 0 && { className: _c(u) },
    ...f && { "data-testid": f },
    ...g && { width: g },
    ...y && { height: y }
  }, q = Rt("uds-img", {
    borderless: !U,
    "uds-img-drop-shadow": D
  }), Y = (et) => {
    const W = et ? `${R.className} ${et}` : R.className;
    return b ? /* @__PURE__ */ h.jsxs("a", { href: b, children: [
      /* @__PURE__ */ h.jsx("img", { ...R, className: W }),
      /* @__PURE__ */ h.jsx("span", { className: "visually-hidden", children: T })
    ] }) : /* @__PURE__ */ h.jsx("img", { ...R, className: W });
  }, L = () => /* @__PURE__ */ h.jsx("div", { className: q, children: /* @__PURE__ */ h.jsxs("figure", { className: "figure uds-figure", children: [
    Y(),
    A && /* @__PURE__ */ h.jsxs("figcaption", { className: "figure-caption uds-figure-caption", children: [
      x && /* @__PURE__ */ h.jsx("h3", { children: x }),
      /* @__PURE__ */ h.jsx(
        "span",
        {
          className: "uds-caption-text",
          dangerouslySetInnerHTML: Xe(A)
        }
      )
    ] })
  ] }) });
  return /* @__PURE__ */ h.jsx(h.Fragment, { children: A ? L() : Y(q) });
};
Ul.propTypes = {
  /**
   * Image source (We keep the same name as in the whole project)
   */
  src: p.string.isRequired,
  /**
   * Image alt text
   */
  alt: p.string.isRequired,
  /**
   * Array classes for the image
   */
  cssClasses: p.arrayOf(p.string),
  /**
   * Image loading mode
   */
  loading: p.oneOf(["lazy", "eager"]),
  /**
   * Image decoding mode
   */
  decoding: p.oneOf(["sync", "async", "auto"]),
  /**
   * Image fetch priority mode
   */
  fetchPriority: p.oneOf(["auto", "high", "low"]),
  /**
   * Width of the image
   */
  width: p.string,
  /**
   * Height of the image
   */
  height: p.string,
  dataTestId: p.string,
  cardLink: p.string,
  title: p.string,
  caption: p.string,
  captionTitle: p.string,
  border: p.bool,
  dropShadow: p.bool
};
const sw = Qn.div`
  &.cards-components a + &.cards-components a {
    margin-left: 5px;
  }
  .card-button {
    column-gap: 1rem;
  }
  .card-button .btn {
    margin: 0;
  }
`, ow = (l) => /^[A-Z0-9._+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(l), fw = (l) => !l.startsWith("https://") && !l.startsWith("http://") && ow(l) ? `mailto:${l}` : l, Gg = {
  name: "onclick",
  event: "link",
  action: "click",
  type: "internal link",
  region: "main content"
}, Zy = (l) => l === "event" || l === "news", ga = ({
  type: l = "default",
  width: i = "100%",
  horizontal: u = !1,
  image: s,
  imageAltText: o,
  title: f,
  icon: m,
  body: g,
  eventFormat: y = "stack",
  eventLocation: b,
  eventTime: T,
  buttons: A,
  linkLabel: x,
  linkUrl: U,
  tags: D,
  showBorders: R = !0,
  cardLink: q
}) => /* @__PURE__ */ h.jsx(
  Ky,
  {
    type: l,
    width: i,
    horizontal: u,
    image: s,
    imageAltText: o,
    title: f,
    icon: m,
    body: g,
    eventFormat: y,
    eventLocation: b,
    eventTime: T,
    buttons: A,
    linkLabel: x,
    linkUrl: U,
    tags: D,
    showBorders: R,
    cardLink: q
  }
);
ga.propTypes = {
  /**
   * Type of card
   */
  type: p.oneOf(["default", "degree", "event", "news", "story"]),
  /**
   * Width of card
   */
  width: p.oneOf(["25%", "50%", "75%", "100%"]),
  /**
   * Enable horizontal mode
   */
  horizontal: p.bool,
  /**
   * Card title
   */
  title: p.string.isRequired,
  /**
    React Font Awesome icon prefix and name string to be rendered in button label. Ex: ['fab', 'drupal']
  */
  icon: p.arrayOf(p.string),
  /**
   * Card body content
   */
  body: p.string,
  /**
   * Event info format
   */
  eventFormat: p.oneOf(["stack", "inline"]),
  /**
   * Location
   */
  eventLocation: p.string,
  /**
   * Event start time
   */
  eventTime: p.string,
  /**
   * Card header image
   */
  image: p.string,
  /**
   * Card header image alt text
   */
  imageAltText: p.string,
  /**
   * Buttons
   */
  buttons: p.arrayOf(
    p.shape({
      ariaLabel: p.string,
      color: p.oneOf(["gold", "maroon", "gray", "dark"]),
      icon: p.arrayOf(p.string),
      href: p.string,
      label: p.string,
      onClick: p.func,
      size: p.oneOf(["default", "small", "xsmall"]),
      target: p.oneOf(["_blank", "_self", "_top", "_parent"])
    })
  ),
  linkLabel: p.string,
  linkUrl: p.string,
  /**
   * Tags
   */
  tags: p.arrayOf(
    p.shape({
      ariaLabel: p.string,
      color: p.oneOf(["white", "gray", "dark"]),
      href: p.string,
      label: p.string,
      onClick: p.func
    })
  ),
  /**
   * Remove card borders
   */
  showBorders: p.bool,
  /**
   * Card link
   */
  cardLink: p.string
};
const Ky = ({
  type: l = "default",
  width: i = "100%",
  horizontal: u = !1,
  image: s = "",
  imageAltText: o = "",
  title: f,
  icon: m = void 0,
  body: g = "",
  eventFormat: y = "stack",
  eventLocation: b = "",
  eventTime: T = "",
  buttons: A = void 0,
  linkLabel: x = void 0,
  linkUrl: U = void 0,
  tags: D = void 0,
  showBorders: R = !0,
  cardLink: q
}) => {
  const Y = Rt("card", "cards-components", {
    "card-degree": l === "degree",
    "card-event": l === "event",
    "card-story": l === "story",
    "card-news": l === "news",
    [`w-${i.replace("%", "")}`]: i !== "100%",
    "card-horizontal": u,
    borderless: !R
  }), L = typeof s == "string" && s.length > 0, et = !Zy(l);
  return /* @__PURE__ */ h.jsxs(sw, { className: Y, "data-testid": "card-container", children: [
    L && /* @__PURE__ */ h.jsx(
      Ul,
      {
        src: s,
        alt: o,
        dataTestId: "card-image",
        cssClasses: ["card-img-top"],
        title: f,
        cardLink: et ? q : void 0
      }
    ),
    !s && m && /* @__PURE__ */ h.jsx(
      "i",
      {
        className: `${m == null ? void 0 : m[0]} fa-${m == null ? void 0 : m[1]} fa-2x card-icon-top`,
        "data-testid": "card-icon"
      }
    ),
    /* @__PURE__ */ h.jsx("div", { className: u ? "card-content-wrapper" : void 0, children: /* @__PURE__ */ h.jsx(
      $y,
      {
        type: l,
        body: g,
        eventFormat: y,
        eventLocation: b,
        eventTime: T,
        title: f,
        buttons: A,
        linkLabel: x,
        linkUrl: U,
        tags: D,
        cardLink: q
      }
    ) })
  ] });
};
Ky.propTypes = {
  type: p.oneOf(["default", "degree", "event", "news", "story"]),
  width: p.oneOf(["25%", "50%", "75%", "100%"]),
  horizontal: p.bool,
  title: p.string.isRequired,
  icon: p.arrayOf(p.string),
  // React Font Awesome icon prefix and name string to be rendered in button label. Ex: ['fab', 'drupal']
  body: p.string,
  eventFormat: p.oneOf(["stack", "inline"]),
  eventLocation: p.string,
  eventTime: p.string,
  image: p.string,
  imageAltText: p.string,
  buttons: p.arrayOf(
    p.shape({
      ariaLabel: p.string,
      color: p.oneOf(["gold", "maroon", "gray", "dark"]),
      icon: p.arrayOf(p.string),
      href: p.string,
      label: p.string,
      onClick: p.func,
      size: p.oneOf(["default", "small", "xsmall"]),
      target: p.oneOf(["_blank", "_self", "_top", "_parent"])
    })
  ),
  linkLabel: p.string,
  linkUrl: p.string,
  tags: p.arrayOf(
    p.shape({
      ariaLabel: p.string,
      color: p.oneOf(["white", "gray", "dark"]),
      href: p.string,
      label: p.string,
      onClick: p.func
    })
  ),
  showBorders: p.bool,
  cardLink: p.string
};
const $y = ({
  type: l = "default",
  body: i = "",
  eventFormat: u = "stack",
  eventLocation: s = "",
  eventTime: o = "",
  title: f,
  buttons: m = void 0,
  linkLabel: g = void 0,
  linkUrl: y = void 0,
  tags: b = void 0,
  cardLink: T
}) => {
  const A = Zy(l), x = T && !A, U = A && T, D = l === "event" && (o || s);
  return /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
    f && /* @__PURE__ */ h.jsx("div", { className: "card-header", "data-testid": "card-title", children: /* @__PURE__ */ h.jsx("h3", { className: "card-title", children: x ? /* @__PURE__ */ h.jsx("a", { href: T, children: f }) : f }) }),
    i && /* @__PURE__ */ h.jsx("div", { className: "card-body", "data-testid": "card-body", children: /* @__PURE__ */ h.jsx("div", { dangerouslySetInnerHTML: Xe(i) }) }),
    D && /* @__PURE__ */ h.jsx(
      Jy,
      {
        eventFormat: u,
        eventTime: o,
        eventLocation: s
      }
    ),
    U ? /* @__PURE__ */ h.jsx("div", { className: "card-link", "data-testid": "card-link", children: /* @__PURE__ */ h.jsx(
      be,
      {
        gaData: {
          ...Gg,
          text: f
        },
        children: /* @__PURE__ */ h.jsx("a", { href: T, className: "card-arrow-link", "aria-label": f, children: /* @__PURE__ */ h.jsx("i", { className: "fas fa-arrow-right", "aria-hidden": "true" }) })
      }
    ) }) : /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
      m && /* @__PURE__ */ h.jsx("div", { className: "card-buttons", children: m.map((R) => /* @__PURE__ */ h.jsx(
        "div",
        {
          className: "card-button",
          "data-testid": "card-button",
          children: /* @__PURE__ */ h.jsx(
            al,
            {
              ariaLabel: R.ariaLabel,
              color: R.color,
              icon: R.icon,
              href: R.href,
              label: R.label,
              onClick: R.onClick,
              size: R.size,
              target: R.target,
              cardTitle: f
            }
          )
        },
        `${R.label}-${R.href}`
      )) }),
      y && g && /* @__PURE__ */ h.jsx("div", { className: "card-link", "data-testid": "card-link", children: /* @__PURE__ */ h.jsx(
        be,
        {
          gaData: {
            ...Gg,
            section: f,
            text: g
          },
          children: /* @__PURE__ */ h.jsx("a", { href: fw(y), children: g })
        }
      ) })
    ] }),
    b && /* @__PURE__ */ h.jsx("div", { className: "card-tags", "data-testid": "card-tags", children: b.map((R) => (
      // @ts-ignore
      /* @__PURE__ */ h.jsx(
        rd,
        {
          ariaLabel: R.ariaLabel,
          color: R.color,
          href: R.href,
          label: R.label,
          onClick: R.onClick,
          cardTitle: f
        },
        `${R.label}-${R.href}`
      )
    )) })
  ] });
};
$y.propTypes = {
  type: p.oneOf(["default", "degree", "event", "news", "story"]),
  body: p.string,
  eventFormat: p.oneOf(["stack", "inline"]),
  eventLocation: p.string,
  eventTime: p.string,
  title: p.string.isRequired,
  buttons: p.arrayOf(
    p.shape({
      ariaLabel: p.string,
      color: p.oneOf(["gold", "maroon", "gray", "dark"]),
      icon: p.arrayOf(p.string),
      href: p.string,
      label: p.string,
      onClick: p.func,
      size: p.oneOf(["default", "small", "xsmall"]),
      target: p.oneOf(["_blank", "_self", "_top", "_parent"])
    })
  ),
  linkLabel: p.string,
  linkUrl: p.string,
  tags: p.arrayOf(
    p.shape({
      ariaLabel: p.string,
      color: p.oneOf(["white", "gray", "dark"]),
      href: p.string,
      label: p.string,
      onClick: p.func
    })
  ),
  cardLink: p.string
};
const Jy = ({
  eventFormat: l = "stack",
  eventLocation: i = "",
  eventTime: u = ""
}) => l === "inline" ? /* @__PURE__ */ h.jsxs("div", { className: "card-event-details", children: [
  u && /* @__PURE__ */ h.jsxs("div", { className: "card-event-icons", children: [
    /* @__PURE__ */ h.jsx("div", { children: /* @__PURE__ */ h.jsx("i", { className: "far fa-calendar" }) }),
    /* @__PURE__ */ h.jsx("div", { dangerouslySetInnerHTML: Xe(u) })
  ] }),
  i && /* @__PURE__ */ h.jsxs("div", { className: "card-event-icons", children: [
    /* @__PURE__ */ h.jsx("div", { children: /* @__PURE__ */ h.jsx("i", { className: "fas fa-map-marker-alt" }) }),
    /* @__PURE__ */ h.jsx(
      "div",
      {
        dangerouslySetInnerHTML: Xe(i)
      }
    )
  ] })
] }) : /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
  u && /* @__PURE__ */ h.jsx("div", { className: "card-event-details", children: /* @__PURE__ */ h.jsxs("div", { className: "card-event-icons", children: [
    /* @__PURE__ */ h.jsx("div", { children: /* @__PURE__ */ h.jsx("i", { className: "far fa-calendar" }) }),
    /* @__PURE__ */ h.jsx("div", { dangerouslySetInnerHTML: Xe(u) })
  ] }) }),
  i && /* @__PURE__ */ h.jsx("div", { className: "card-event-details", children: /* @__PURE__ */ h.jsxs("div", { className: "card-event-icons", children: [
    /* @__PURE__ */ h.jsx("div", { children: /* @__PURE__ */ h.jsx("i", { className: "fas fa-map-marker-alt" }) }),
    /* @__PURE__ */ h.jsx("span", { children: /* @__PURE__ */ h.jsx(
      "div",
      {
        dangerouslySetInnerHTML: Xe(i)
      }
    ) })
  ] }) })
] });
Jy.propTypes = {
  eventFormat: p.oneOf(["stack", "inline"]),
  eventLocation: p.string,
  eventTime: p.string
};
const Xg = {
  name: "onclick",
  event: "link",
  action: "click",
  type: "internal link",
  region: "main content"
}, Qg = {
  OPEN: "open",
  CLOSE: "close"
}, dw = {
  SMALL: "small"
}, Wy = (l) => l === dw.SMALL, Fy = ({ imageSize: l, body: i, heading: u, readMoreLink: s }) => {
  const [o, f] = ve(!1), m = Ir(), { isReact: g, isBootstrap: y } = ql(), b = `info-layer-${m}`, T = Wy(l), A = (x) => {
    (x.type === "click" || x.key === "Enter" || x.key === " ") && f(!o);
  };
  return /* @__PURE__ */ h.jsx(
    "div",
    {
      className: Rt("info-layer", { show: o }),
      "data-testid": "info-layer",
      id: b,
      children: /* @__PURE__ */ h.jsxs("div", { className: "content", children: [
        /* @__PURE__ */ h.jsxs(
          "div",
          {
            className: Rt("header", {
              closed: T && !o
            }),
            children: [
              T && /* @__PURE__ */ h.jsx("p", { dangerouslySetInnerHTML: Xe(i) }),
              /* @__PURE__ */ h.jsx(
                be,
                {
                  gaData: {
                    ...Xg,
                    text: "Expand ranking",
                    // TODO: for bootstrap can we use aria-expanded value of the button to populate the "action" field
                    action: o ? Qg.OPEN : Qg.CLOSE,
                    section: u
                  },
                  children: /* @__PURE__ */ h.jsxs(
                    "button",
                    {
                      "data-bs-toggle": y && "collapse",
                      "data-bs-target": y && `#${b}`,
                      onClick: g && A,
                      className: Rt("btn-expand", {
                        btn: T
                      }),
                      type: "button",
                      "aria-expanded": o,
                      "aria-controls": b,
                      children: [
                        T ? /* @__PURE__ */ h.jsx("span", { className: "visually-hidden", children: u }) : /* @__PURE__ */ h.jsx("h4", { children: u }),
                        /* @__PURE__ */ h.jsx("i", { className: "fas fa-chevron-up" })
                      ]
                    }
                  )
                }
              )
            ]
          }
        ),
        !T && /* @__PURE__ */ h.jsx("p", { dangerouslySetInnerHTML: Xe(i) }),
        s && /* @__PURE__ */ h.jsx(
          be,
          {
            gaData: {
              ...Xg,
              section: u,
              text: "read more"
            },
            children: /* @__PURE__ */ h.jsxs("a", { href: s, className: "read-more", children: [
              "Read more ",
              /* @__PURE__ */ h.jsx("span", { className: "visually-hidden", children: u }),
              /* @__PURE__ */ h.jsx(
                "span",
                {
                  className: "fas icon-small fa-arrow-right",
                  "aria-hidden": "true"
                }
              )
            ] })
          }
        )
      ] })
    }
  );
};
Fy.propTypes = {
  imageSize: p.oneOf(["small", "large"]),
  body: p.string.isRequired,
  heading: p.string.isRequired,
  readMoreLink: p.string
};
const ud = ({
  imageSize: l = "large",
  image: i,
  imageAlt: u,
  heading: s,
  body: o,
  readMoreLink: f = "",
  citation: m
}) => {
  const g = Wy(l);
  return /* @__PURE__ */ h.jsxs(
    "div",
    {
      className: Rt("card-ranking", {
        "large-image": !g,
        "small-image": g
      }),
      children: [
        g ? /* @__PURE__ */ h.jsx("div", { className: "image-wrapper", children: /* @__PURE__ */ h.jsx(Ul, { src: i, alt: u, fetchPriority: "high" }) }) : /* @__PURE__ */ h.jsx(Ul, { src: i, alt: u, fetchPriority: "high" }),
        g && /* @__PURE__ */ h.jsxs("div", { className: "citation", children: [
          /* @__PURE__ */ h.jsx("h4", { children: s }),
          /* @__PURE__ */ h.jsxs("p", { children: [
            "— ",
            m
          ] })
        ] }),
        /* @__PURE__ */ h.jsx(
          Fy,
          {
            imageSize: l,
            body: o,
            heading: s,
            readMoreLink: f
          }
        )
      ]
    }
  );
};
ud.propTypes = {
  /**
   * Size of ranking card
   */
  imageSize: p.oneOf(["small", "large"]).isRequired,
  /**
   * Ranking card image
   */
  image: p.string.isRequired,
  /**
   * Card header image alt text
   */
  imageAlt: p.string.isRequired,
  /**
   * Ranking card heading
   */
  heading: p.string.isRequired,
  /**
   * Ranking card body content
   */
  body: p.string.isRequired,
  /**
   * Link for read more
   */
  readMoreLink: p.string,
  /**
   * Ranking card citation content (Required for small size only)
   */
  citation: p.string
};
const hw = {
  1: "col-12",
  2: "col-12 col-md-6",
  3: "col-12 col-md-6 col-lg-4",
  4: "col-12 col-md-6 col-lg-4 col-xl-3"
}, Iy = ({ cards: l, cardType: i = "card", columns: u }) => {
  if (!l || l.length === 0)
    return null;
  let s;
  switch (i) {
    case "ranking":
      s = ud;
      break;
    case "image":
      s = Ul;
      break;
    default:
      s = ga;
      break;
  }
  const o = hw[u] || "col-12 col-md-auto";
  return /* @__PURE__ */ h.jsx("div", { className: "row", "data-testid": "card-arrangement", children: l.map((f, m) => /* @__PURE__ */ h.jsx(
    "div",
    {
      "data-testid": "uds-card-arrangement-content-container",
      className: `${f.horizontal ? "col-12 col-md-6" : o} mb-4`,
      children: /* @__PURE__ */ h.jsx(s, { ...f })
    },
    m
  )) });
};
Iy.propTypes = {
  /**
   * Array of card objects to render. Each object should contain props for the
   * Card or RankingCard component. Cards will wrap naturally based on their
   * intrinsic min/max widths.
   */
  cards: p.arrayOf(p.object).isRequired,
  /**
   * Type of card to render - either "card" (default), "ranking", or "image"
   */
  cardType: p.oneOf(["card", "ranking", "image"]),
  /**
   * Number of columns to display.
   */
  columns: p.oneOf([1, 2, 3, 4, "1", "2", "3", "4"])
};
const mw = {
  name: "onclick",
  event: "link",
  action: "click",
  type: "internal link",
  region: "main content"
}, Py = ({
  backgroundImage: l,
  icon: i,
  title: u,
  highlightText: s,
  description: o,
  button: f
}) => {
  const m = () => {
    if (!i) return null;
    let g = "";
    return Array.isArray(i) ? g = i.join(" ") : g = i.includes(" ") ? i : `fas fa-${i}`, /* @__PURE__ */ h.jsx("i", { className: g, "aria-hidden": "true" });
  };
  return /* @__PURE__ */ h.jsxs("div", { className: "content-spotlight", children: [
    /* @__PURE__ */ h.jsx("div", { className: "content-spotlight-image-container", children: /* @__PURE__ */ h.jsxs("div", { className: "content-spotlight-image-wrapper", children: [
      /* @__PURE__ */ h.jsx("div", { className: "content-spotlight-overlay" }),
      /* @__PURE__ */ h.jsx(
        "img",
        {
          src: l,
          alt: "",
          "aria-hidden": "true",
          className: "content-spotlight-image"
        }
      )
    ] }) }),
    /* @__PURE__ */ h.jsxs("div", { className: "content-spotlight-content", children: [
      i && /* @__PURE__ */ h.jsx("div", { className: "content-spotlight-icon", children: m() }),
      /* @__PURE__ */ h.jsxs("h2", { className: "content-spotlight-title", children: [
        u,
        s && /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
          u && s && /* @__PURE__ */ h.jsx("br", {}),
          /* @__PURE__ */ h.jsx("span", { className: "highlight", children: s })
        ] })
      ] }),
      o && /* @__PURE__ */ h.jsx(
        "p",
        {
          className: "content-spotlight-description",
          dangerouslySetInnerHTML: Xe(o)
        }
      ),
      f && /* @__PURE__ */ h.jsx(
        be,
        {
          gaData: {
            ...mw,
            text: f.label,
            component: "ContentSpotlight"
          },
          children: /* @__PURE__ */ h.jsx(
            "a",
            {
              href: f.href,
              className: `btn ${f.color ? `btn-${f.color}` : "btn-gold"}`,
              children: f.label
            }
          )
        }
      )
    ] })
  ] });
};
Py.propTypes = {
  backgroundImage: p.string.isRequired,
  icon: p.oneOfType([
    p.string,
    p.arrayOf(p.string)
  ]),
  title: p.node.isRequired,
  highlightText: p.string,
  description: p.string,
  button: p.shape({
    label: p.string.isRequired,
    href: p.string.isRequired,
    color: p.string
  })
};
var pw = /* @__PURE__ */ ((l) => (l.COPY = "copy", l))(pw || {});
const gw = ({ type: l }) => l == "copy" ? /* @__PURE__ */ h.jsx("hr", { className: "copy-divider" }) : /* @__PURE__ */ h.jsx("hr", {}), yw = Qn.div`
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
  div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 30px;
    height: 30px;
    margin: 3px;
    border: 3px solid #1b1b1b;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #1b1b1b transparent transparent transparent;
  }
  div:nth-child(1) {
    animation-delay: -0.45s;
  }
  div:nth-child(2) {
    animation-delay: -0.3s;
  }
  div:nth-child(3) {
    animation-delay: -0.15s;
  }
  @keyframes lds-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`, vw = () => /* @__PURE__ */ h.jsxs(yw, { children: [
  /* @__PURE__ */ h.jsx("div", {}),
  /* @__PURE__ */ h.jsx("div", {}),
  /* @__PURE__ */ h.jsx("div", {}),
  /* @__PURE__ */ h.jsx("div", {})
] }), bw = Qn.section``, Sw = _b(null), Tw = ({
  defaultProps: l,
  dataSource: i,
  noFeedText: u,
  renderHeader: s,
  renderBody: o,
  dataTransformer: f,
  dataFilter: m,
  maxItems: g
}) => {
  const [{ data: y, loading: b, error: T }, A] = zb(), [x, U] = ve([]), D = { ...l.dataSource, ...i };
  return Qe(() => {
    A(D == null ? void 0 : D.url);
  }, [D == null ? void 0 : D.url]), Qe(() => {
    const R = y == null ? void 0 : y.nodes.map(f), q = R == null ? void 0 : R.filter(
      (Y) => m(Y, i == null ? void 0 : i.filters)
    );
    U(g ? q == null ? void 0 : q.slice(0, g) : q);
  }, [y]), // Init the context to be used on its childrens
  /* @__PURE__ */ h.jsx(Sw.Provider, { value: { feeds: x }, children: /* @__PURE__ */ h.jsxs(bw, { children: [
    s,
    T ? /* @__PURE__ */ h.jsx("span", { children: "Error, try again!" }) : /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
      b && !(x != null && x.length) && /* @__PURE__ */ h.jsx("div", { className: "text-center mt-4", children: /* @__PURE__ */ h.jsx(vw, {}) }),
      x != null && x.length ? o : !b && /* @__PURE__ */ h.jsx("p", { className: "text-center", children: u })
    ] })
  ] }) });
};
Tw.propTypes = {
  renderHeader: p.element,
  renderBody: p.element,
  maxItems: p.number,
  dataTransformer: p.func,
  dataFilter: p.func,
  noFeedText: p.string
};
const tv = p.shape({
  color: p.oneOf(["white", "dark"]),
  text: p.string
}), ev = p.shape({
  color: p.oneOf(["gold", "maroon", "gray", "dark"]),
  text: p.string
}), uA = p.shape({
  color: p.oneOf(["gold", "maroon", "gray", "dark"]),
  text: p.string,
  size: p.string
}), ww = p.shape({
  url: p.string,
  filters: p.string
}), xw = p.shape({
  header: tv,
  ctaButton: ev,
  dataSource: ww,
  maxItems: p.number
}), Aw = Qn.div`
  @media screen and (min-width: 768px) {
    & {
      display: inline-flex;
      justify-content: flex-end;
    }
  }
`, _w = ({
  defaultProps: l,
  header: i,
  ctaButton: u
}) => {
  const s = { ...l.header, ...i }, o = { ...l.ctaButton, ...u }, f = s.tag || "h2", m = f !== "h2", g = `text-${s.color} ${m ? "h2" : ""}`.trim();
  return /* @__PURE__ */ h.jsxs(
    "div",
    {
      className: "row justify-content-between align-items-center pb-6",
      "data-testid": "feed-header",
      children: [
        /* @__PURE__ */ h.jsx("div", { className: "col-sm-12 col-md-9", children: /* @__PURE__ */ h.jsx(f, { className: g, children: s.text }) }),
        /* @__PURE__ */ h.jsx(Aw, { className: "col-sm-12 col-md-3", children: /* @__PURE__ */ h.jsx(
          be,
          {
            gaData: {
              event: "link",
              action: "click",
              name: "onclick",
              type: "internal link",
              region: "main content",
              section: s.text,
              text: o.text
            },
            children: /* @__PURE__ */ h.jsx("a", { className: `btn btn-${o.color}`, href: o.url, children: o.text })
          }
        ) })
      ]
    }
  );
};
_w.propTypes = {
  defaultProps: xw,
  header: tv,
  ctaButton: ev
};
const Ow = ({ children: l }) => /* @__PURE__ */ h.jsx("div", { className: "row", "data-testid": "feed-body", children: /* @__PURE__ */ h.jsx("div", { className: "col", children: l }) });
Ow.propTypes = {
  children: p.element
};
const Nw = Qn.img`
  width: 100%;
`;
function Ew({ image: l, title: i, contents: u }) {
  return console.log({ image: l, title: i, contents: u }), /* @__PURE__ */ h.jsx("div", { children: "TODO: to be implemented" });
}
function jw({
  image: l,
  subTitle: i,
  title: u,
  contents: s,
  contentsColor: o
}) {
  const f = {
    small: "uds-hero-sm",
    medium: "uds-hero-md",
    large: "uds-hero-lg",
    undefined: ""
  }, m = {
    gold: "highlight-gold",
    black: "highlight-black",
    white: "highlight-white",
    none: "text-white",
    undefined: ""
  }, g = {
    black: "text-dark",
    white: "text-white",
    undefined: ""
  };
  return /* @__PURE__ */ h.jsxs(
    "div",
    {
      className: Rt("uds-hero", {
        [f[l == null ? void 0 : l.size]]: l == null ? void 0 : l.size
      }),
      children: [
        /* @__PURE__ */ h.jsx("div", { className: "hero-overlay" }),
        /* @__PURE__ */ h.jsx(
          Nw,
          {
            className: "hero",
            src: l == null ? void 0 : l.url,
            alt: l == null ? void 0 : l.altText,
            "data-testid": "hero-image"
          }
        ),
        i && /* @__PURE__ */ h.jsx("div", { role: "doc-subtitle", "data-testid": "hero-subtitle", children: /* @__PURE__ */ h.jsx(
          "span",
          {
            className: Rt({
              [g[i.color]]: i.color,
              [m[i.highlightColor]]: i.highlightColor
            }),
            children: i.text
          }
        ) }),
        u && /* @__PURE__ */ h.jsx("h1", { style: { maxWidth: u.maxWidth || "" }, "data-testid": "hero-title", children: /* @__PURE__ */ h.jsx(
          "span",
          {
            className: Rt({
              [g[u.color]]: u.color,
              [m[u.highlightColor]]: u.highlightColor
            }),
            children: u.text
          }
        ) }),
        s && /* @__PURE__ */ h.jsx(
          "div",
          {
            "data-testid": "hero-content",
            className: Rt("content", {
              [g[o]]: o
            }),
            children: s.map((y, b) => /* @__PURE__ */ h.jsx("p", { children: y.text }, `content-${b}`))
          }
        )
      ]
    }
  );
}
const nv = (l) => {
  const i = l.type || "heading-hero";
  return {
    "heading-hero": () => jw(l),
    "story-hero": () => Ew(l),
    undefined: () => (console.error(
      `the type '${i}' is not supported by the 'Hero' component.`
    ), null)
  }[i]();
};
nv.propTypes = {
  type: p.oneOf(["heading-hero", "story-hero"]),
  image: T1,
  title: bf,
  subTitle: bf,
  contents: p.arrayOf(bf),
  contentsColor: p.string
};
const Rw = ({
  title: l = "Highly ranked",
  description: i = "",
  ctaText: u = "",
  ctaUrl: s = "",
  ctaButtonColor: o = "dark",
  rankings: f = []
}) => /* @__PURE__ */ h.jsx("section", { className: "highly-ranked-section", children: /* @__PURE__ */ h.jsxs("div", { className: "container", children: [
  /* @__PURE__ */ h.jsx("div", { className: "row", children: /* @__PURE__ */ h.jsxs("div", { className: "col-12 col-lg-8", children: [
    l && /* @__PURE__ */ h.jsx("h2", { className: "highly-ranked-title", children: /* @__PURE__ */ h.jsx("span", { className: "highlight-gold", children: l }) }),
    i && /* @__PURE__ */ h.jsx(
      "p",
      {
        className: "highly-ranked-description",
        dangerouslySetInnerHTML: Xe(i)
      }
    ),
    u && s && /* @__PURE__ */ h.jsx("div", { className: "highly-ranked-cta", children: /* @__PURE__ */ h.jsx(
      al,
      {
        label: u,
        href: s,
        color: o,
        size: "small",
        classes: []
      }
    ) })
  ] }) }),
  /* @__PURE__ */ h.jsx("div", { className: "row highly-ranked-grid", children: f.map((m, g) => /* @__PURE__ */ h.jsx("div", { className: "col-12 col-lg-6 mb-4", children: /* @__PURE__ */ h.jsxs("div", { className: "highly-ranked-card", children: [
    /* @__PURE__ */ h.jsx("div", { className: "ranking-value-container", children: /* @__PURE__ */ h.jsxs("h3", { className: "ranking-value", children: [
      /* @__PURE__ */ h.jsx(
        "span",
        {
          className: `ranking-value-main${m.headingLevel ? ` ${m.headingLevel}` : " h1"}`,
          children: m.value
        }
      ),
      m.title && /* @__PURE__ */ h.jsx("span", { className: "ranking-value-subsection", children: m.title })
    ] }) }),
    m.description && /* @__PURE__ */ h.jsx("div", { className: "ranking-content", children: /* @__PURE__ */ h.jsx(
      "p",
      {
        className: "ranking-description",
        dangerouslySetInnerHTML: Xe(
          m.description
        )
      }
    ) })
  ] }) }, g)) })
] }) }), En = ({
  dataId: l,
  isClickeable: i = !1,
  disabled: u = !1,
  pageLinkIcon: s = !1,
  selectedPage: o = !1,
  onClick: f = () => {
  },
  ellipses: m,
  ariaLabel: g,
  children: y,
  ariaDisabled: b
}) => /* @__PURE__ */ h.jsx(
  "li",
  {
    className: Rt("page-item", {
      disabled: u,
      active: o,
      elipses: m
    }),
    children: i ? /* @__PURE__ */ h.jsxs(
      "button",
      {
        type: "button",
        "aria-label": g,
        className: Rt("page-link", {
          "page-link-icon": s
        }),
        onClick: f,
        "data-testid": l ? `pagination-${l}` : "page-link",
        "data-id": l,
        "aria-current": o ? "page" : null,
        "aria-disabled": b,
        children: [
          y,
          o && /* @__PURE__ */ h.jsx("span", { className: "visually-hidden", children: "(current)" })
        ]
      }
    ) : /* @__PURE__ */ h.jsx("span", { className: "page-link", "data-testid": "page-link", children: y })
  }
);
En.propTypes = {
  isClickeable: p.bool,
  disabled: p.bool,
  pageLinkIcon: p.bool,
  selectedPage: p.bool,
  dataId: p.string,
  onClick: p.func,
  children: p.node,
  ellipses: p.bool,
  ariaLabel: p.string,
  ariaDisabled: p.bool
};
const Cw = {
  event: "select",
  action: "click",
  name: "onclick",
  type: "pagination",
  region: "main content"
}, av = ({
  type: l,
  background: i,
  currentPage: u = 1,
  totalPages: s = 10,
  onChange: o
}) => {
  const [f, m] = ve(null);
  Qe(() => {
    m(u);
  }, [u]);
  const g = (T) => {
    cy({ ...Cw, text: `page ${T}` });
  }, y = (T, A) => {
    const U = {
      first: 1,
      prev: f === 1 ? 1 : f - 1,
      next: f === s ? s : f + 1,
      last: s
    }[A] ?? A;
    m(U), g(U), o == null || o(T, U);
  }, b = () => {
    if (s < 5)
      return /* @__PURE__ */ h.jsx(h.Fragment, { children: Array.from({ length: s }, (q, Y) => {
        const L = Y + 1;
        return /* @__PURE__ */ h.jsx(
          En,
          {
            ariaLabel: `Page ${L} of ${s}`,
            isClickeable: !0,
            selectedPage: f === L,
            onClick: (et) => y(et, L),
            children: L
          },
          L
        );
      }) });
    const T = 2, A = Pp(
      f === s - 1,
      1,
      f === s ? 2 : 1
    ), x = Pp(
      f === 1,
      2,
      1
    ), U = pg(
      f - A,
      f,
      s
    ), D = pg(
      f,
      f + 1 + x,
      s
    ), R = [...U, ...D];
    return /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
      R[0] !== 1 && /* @__PURE__ */ h.jsx(
        En,
        {
          ariaLabel: `Page 1 of ${s}`,
          isClickeable: !0,
          selectedPage: f === 1,
          onClick: (q) => y(q, "first"),
          children: "1"
        }
      ),
      f > s - T && /* @__PURE__ */ h.jsx(
        En,
        {
          isClickeable: !0,
          ariaLabel: `Page 2 of ${s}`,
          selectedPage: f === 2,
          onClick: (q) => y(q, 2),
          children: "2"
        }
      ),
      R[0] > 2 && /* @__PURE__ */ h.jsx(En, { ellipses: !0, children: "..." }),
      R.map((q) => /* @__PURE__ */ h.jsx(
        En,
        {
          ariaLabel: `Page ${q} of ${s}`,
          isClickeable: !0,
          selectedPage: f === q,
          onClick: (Y) => y(Y, q),
          children: q
        },
        q
      )),
      R[R.length - 1] < s - 1 && /* @__PURE__ */ h.jsx(En, { ellipses: !0, children: "..." }),
      f < T + 1 && /* @__PURE__ */ h.jsx(
        En,
        {
          isClickeable: !0,
          ariaLabel: `Page ${s - 1} of ${s}`,
          selectedPage: f === s - 1,
          onClick: (q) => y(q, s - 1),
          children: s - 1
        }
      ),
      R[R.length - 1] !== s && /* @__PURE__ */ h.jsx(
        En,
        {
          isClickeable: !0,
          ariaLabel: `Page ${s} of ${s}`,
          selectedPage: f === s,
          onClick: (q) => y(q, "last"),
          children: s
        }
      )
    ] });
  };
  return /* @__PURE__ */ h.jsx("nav", { "aria-label": "Pagination", "data-testid": "pagination", children: /* @__PURE__ */ h.jsxs(
    "ul",
    {
      className: Rt(
        "pagination",
        "justify-content-center",
        "pt-2",
        "pb-2",
        {
          border: l === "bordered",
          "uds-bg-gray1": i === "gray1",
          "uds-bg-gray": i === "gray2",
          "uds-bg-dark": i === "gray7"
        }
      ),
      children: [
        /* @__PURE__ */ h.jsx(
          En,
          {
            dataId: "prev",
            isClickeable: !0,
            disabled: f === 1,
            pageLinkIcon: !0,
            onClick: (T) => y(T, "prev"),
            ariaDisabled: f === 1,
            ariaLabel: "Previous Page"
          }
        ),
        b(),
        /* @__PURE__ */ h.jsx(
          En,
          {
            dataId: "next",
            isClickeable: !0,
            ariaDisabled: f === s,
            disabled: f === s,
            pageLinkIcon: !0,
            onClick: (T) => y(T, "next"),
            ariaLabel: "Next Page"
          }
        )
      ]
    }
  ) });
};
av.propTypes = {
  /**
   * Type of pagination
   */
  type: p.oneOf(["default", "bordered"]).isRequired,
  /**
   * Background of pagination
   */
  background: p.oneOf(["white", "gray1", "gray2", "gray7"]).isRequired,
  /**
   * Current page
   */
  currentPage: p.number,
  /**
   * Total number of pages
   */
  totalPages: p.number,
  /**
   * Callback fired when the page is changed
   */
  onChange: p.func.isRequired
};
var Dw = /* @__PURE__ */ ((l) => (l.WARNING = "warning", l.INFO = "info", l.SUCCESS = "success", l.ERROR = "error", l))(Dw || {});
const zw = ({
  type: l,
  dismissable: i,
  children: u
}) => {
  var b, T, A;
  const { isBootstrap: s, isReact: o } = ql(), [f, m] = ve(!0), g = () => m(!1), y = {
    warning: {
      iconTitle: "Warning",
      iconName: "bell",
      alertClass: "warning"
    },
    info: {
      iconTitle: "Information",
      iconName: "info-circle",
      alertClass: "info"
    },
    success: {
      iconTitle: "Success",
      iconName: "check-circle",
      alertClass: "success"
    },
    error: {
      iconTitle: "Error",
      iconName: "exclamation-triangle",
      alertClass: "danger"
    }
  };
  return f && /* @__PURE__ */ h.jsxs(
    "div",
    {
      className: Rt("alert", {
        "alert-dismissable": i,
        [`alert-${(b = y[l]) == null ? void 0 : b.alertClass}`]: l
      }),
      role: "alert",
      children: [
        /* @__PURE__ */ h.jsx("div", { className: "alert-icon", children: /* @__PURE__ */ h.jsx(
          "span",
          {
            title: (T = y[l]) == null ? void 0 : T.iconTitle,
            className: `fa fa-icon fa-${(A = y[l]) == null ? void 0 : A.iconName}`
          }
        ) }),
        /* @__PURE__ */ h.jsx("div", { className: "alert-content", children: u }),
        i && /* @__PURE__ */ h.jsx("div", { className: "alert-close", children: /* @__PURE__ */ h.jsx(
          id,
          {
            icon: ["fas", "times"],
            onClick: o && g,
            "data-bs-dismiss": s && "alert"
          }
        ) })
      ]
    }
  );
}, Mw = Qn.div`
  button {
    padding: 16px 0;
    border: none;
    outline: none;
  }

  .scroll-control-prev,
  .scroll-control-next {
    outline: none;
    border: none;
    width: 80px;
    position: absolute;
    height: 100%;
    top: 0;
  }

  .scroll-control-prev {
    background: linear-gradient(
      90deg,
      rgba(25, 25, 25, 0.25) 0%,
      rgba(25, 25, 25, 0) 100%
    );
    left: 0;
  }

  .scroll-control-next {
    right: 0;
    background: linear-gradient(
      90deg,
      rgba(25, 25, 25, 0) 0%,
      rgba(25, 25, 25, 0.25) 100%
    );

    .carousel-control-next-icon {
      margin: 0 12px 0 42px;
    }
  }

  .scroll-control-prev .carousel-control-prev-icon,
  .scroll-control-next .carousel-control-next-icon {
    background-size: 60% 60%;
    display: block;
    opacity: 1;
    padding: 12px;
    position: relative;
    top: 50%;
    left: 0;
    transform: translate(0, -50%);
    background-color: #fafafa; // $asu-gray-7
    border: solid 1px #d0d0d0; // $asu-gray-5
    border-radius: 100%;
    color: #000;
  }

  .carousel-control-next-icon {
    background-image: url("data:image/svg+xml; utf8, <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512' data-fa-i2svg=''><path fill='currentColor' d='M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z'></path></svg>");
    background-position: 80% 50%;
  }

  .carousel-control-prev-icon {
    background-image: url("data:image/svg+xml; utf8, <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512' data-fa-i2svg=''><path fill='currentColor' d='M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z'></path></svg>");
    background-position: 60% 50%;
  }

  @media screen and (max-width: 768px) {
    // $uds-breakpoint-md
    .scroll-control-prev,
    .scroll-control-next {
      width: 48px;
    }

    .scroll-control-next .carousel-control-next-icon,
    .scroll-control-prev .carousel-control-prev-icon {
      margin: 0px 12px 0px 8px;
    }

    .scroll-control-prev .carousel-control-prev-icon {
      margin-left: 0px;
    }
  }
`, kw = ({ gaData: l, hidePrev: i, hideNext: u, slideNav: s }) => {
  const { isReact: o, isBootstrap: f } = ql();
  return /* @__PURE__ */ h.jsxs(Mw, { children: [
    (!i || f) && /* @__PURE__ */ h.jsx(be, { gaData: { ...l, text: "left chevron" }, children: /* @__PURE__ */ h.jsxs(
      "button",
      {
        className: "scroll-control-prev",
        type: "button",
        onClick: o && (() => s(-1)),
        tabIndex: -1,
        children: [
          /* @__PURE__ */ h.jsx("span", { className: "carousel-control-prev-icon", "aria-hidden": "true" }),
          /* @__PURE__ */ h.jsx("span", { className: "visually-hidden", children: "Previous" })
        ]
      }
    ) }),
    (!u || f) && /* @__PURE__ */ h.jsx(be, { gaData: { ...l, text: "right chevron" }, children: /* @__PURE__ */ h.jsxs(
      "button",
      {
        className: "scroll-control-next",
        type: "button",
        onClick: o && (() => s(1)),
        tabIndex: -1,
        children: [
          /* @__PURE__ */ h.jsx("span", { className: "carousel-control-next-icon", "aria-hidden": "true" }),
          /* @__PURE__ */ h.jsx("span", { className: "visually-hidden", children: "Next" })
        ]
      }
    ) })
  ] });
};
kw.propTypes = {
  gaData: p.object,
  hidePrev: p.bool,
  hideNext: p.bool,
  slideNav: p.func.isRequired
};
const Lw = ({ id: l, selected: i, isFocusEntry: u, title: s, selectTab: o, leftKeyPressed: f, rightKeyPressed: m, icon: g, gaData: y, ref: b }) => {
  const { isReact: T } = ql(), A = (x) => {
    x.key === "ArrowLeft" ? (x.preventDefault(), f()) : x.key === "ArrowRight" && (x.preventDefault(), m());
  };
  return /* @__PURE__ */ h.jsx(be, { gaData: { ...y, text: s }, children: /* @__PURE__ */ h.jsxs(
    "button",
    {
      ref: b,
      type: "button",
      className: `nav-item nav-link ${i ? "active" : ""}`,
      id: l,
      role: "tab",
      "aria-controls": `nav-${l}`,
      "aria-selected": i,
      onClick: (x) => o(x, l, s),
      onKeyDown: T ? A : void 0,
      tabIndex: u ?? i ? 0 : -1,
      children: [
        s,
        " ",
        g && /* @__PURE__ */ h.jsx("i", { "aria-hidden": "true", className: `${g[0]} fa-${g[1]} me-1` })
      ]
    }
  ) });
}, lv = ye.forwardRef(({
  overflowTabs: l,
  idToChild: i,
  activeTabID: u,
  selectTab: s,
  gaData: o,
  openRight: f = !1
}, m) => {
  const [g, y] = ve(!1), b = nn(null), T = nn(null), A = nn([]), x = Array.isArray(l) ? l : [], U = Ir(), D = x.includes(u ?? ""), R = x.map((B) => {
    const G = i == null ? void 0 : i[B];
    return G ? {
      id: B,
      title: G.props.title,
      icon: G.props.icon ?? null
    } : { id: B, title: B, icon: null };
  }), q = kl((B = !0) => {
    var G;
    y(!1), B && ((G = T.current) == null || G.focus());
  }, []), Y = (B) => {
    B.preventDefault(), y((G) => !G);
  };
  Qe(() => {
    function B(G) {
      var F;
      (F = b.current) != null && F.contains(G.target) || y(!1);
    }
    return document.addEventListener("mousedown", B), () => document.removeEventListener("mousedown", B);
  }, []);
  const L = kl(
    (B, G) => {
      var F, ut;
      switch (B.key) {
        case "ArrowDown": {
          B.preventDefault();
          const yt = A.current[G + 1] ?? A.current[0];
          yt == null || yt.focus();
          break;
        }
        case "ArrowUp": {
          B.preventDefault();
          const yt = A.current[G - 1] ?? A.current[R.length - 1];
          yt == null || yt.focus();
          break;
        }
        case "Home":
          B.preventDefault(), (F = A.current[0]) == null || F.focus();
          break;
        case "End":
          B.preventDefault(), (ut = A.current[R.length - 1]) == null || ut.focus();
          break;
        case "Escape":
          B.preventDefault(), q();
          break;
        case "Tab":
          y(!1);
          break;
      }
    },
    [R.length, q]
  ), et = (B, G, F) => {
    B.preventDefault(), q(!1), s == null || s(B, G, F);
  }, W = R.length === 0, X = (B) => {
    b.current = B, typeof m == "function" ? m(B) : m && (m.current = B);
  };
  return /* @__PURE__ */ h.jsxs(
    "div",
    {
      ref: X,
      className: `uds-more-dropdown${f ? " dropdown-open-right" : ""}${W ? " uds-more-dropdown-hidden" : ""}`,
      "aria-hidden": W || void 0,
      children: [
        /* @__PURE__ */ h.jsx(be, { gaData: o ?? {}, children: /* @__PURE__ */ h.jsxs(
          "button",
          {
            ref: T,
            type: "button",
            onClick: Y,
            onKeyDown: (B) => {
              var G, F;
              B.key === "Enter" || B.key === " " ? (B.preventDefault(), g ? q() : (y(!0), requestAnimationFrame(() => {
                var ut;
                return (ut = A.current[0]) == null ? void 0 : ut.focus();
              }))) : g && B.key === "ArrowDown" ? (B.preventDefault(), (G = A.current[0]) == null || G.focus()) : g && B.key === "ArrowUp" ? (B.preventDefault(), (F = A.current[R.length - 1]) == null || F.focus()) : g && B.key === "Escape" && (B.preventDefault(), q());
            },
            "aria-haspopup": "true",
            "aria-expanded": g,
            "aria-controls": U,
            "aria-label": `More, ${R.length} additional tab${R.length !== 1 ? "s" : ""}`,
            className: `uds-tab more-dropdown-button${D ? " active" : ""}`,
            children: [
              /* @__PURE__ */ h.jsxs("span", { className: "more-dropdown-button-inner", children: [
                /* @__PURE__ */ h.jsx("span", { "aria-hidden": "true", children: "More" }),
                /* @__PURE__ */ h.jsx(
                  "i",
                  {
                    "aria-hidden": "true",
                    className: "fas fa-chevron-down more-dropdown-icon"
                  }
                )
              ] }),
              /* @__PURE__ */ h.jsx("span", { className: "more-dropdown-button-indicator", "aria-hidden": "true" })
            ]
          }
        ) }),
        /* @__PURE__ */ h.jsx(
          "ul",
          {
            id: U,
            role: "menu",
            "aria-label": "More tabs",
            "aria-hidden": !g,
            className: `more-dropdown-menu uds-more-dropdown-list${g ? " open" : ""}`,
            children: R.map((B, G) => {
              const F = B.id === u;
              return /* @__PURE__ */ h.jsx("li", { role: "none", children: /* @__PURE__ */ h.jsxs(
                "button",
                {
                  ref: (ut) => {
                    ut && (A.current[G] = ut);
                  },
                  type: "button",
                  role: "menuitem",
                  tabIndex: -1,
                  onClick: (ut) => et(ut, B.id, B.title),
                  onKeyDown: (ut) => L(ut, G),
                  className: "more-dropdown-item",
                  "aria-current": F || void 0,
                  children: [
                    B.icon && /* @__PURE__ */ h.jsx(
                      "i",
                      {
                        "aria-hidden": "true",
                        className: `${B.icon[0]} fa-${B.icon[1]} me-1`
                      }
                    ),
                    B.title
                  ]
                }
              ) }, B.id);
            })
          }
        )
      ]
    }
  );
});
lv.displayName = "MoreDropdown";
function Bw() {
  const l = nn({}), i = kl(
    (u) => (s) => {
      l.current[u] = s;
    },
    []
  );
  return [l, i];
}
const cA = ({ id: l, bgColor: i, selected: u, children: s }) => /* @__PURE__ */ h.jsx(
  "div",
  {
    className: `tab-pane fade ${u ? "show active" : ""} ${i === "bg-dark" ? "text-white" : ""}`,
    id: `nav-${l}`,
    role: "tabpanel",
    "aria-labelledby": `nav-${l}-tab`,
    children: s
  }
);
function Hw(l) {
  const i = getComputedStyle(l);
  return parseFloat(i.getPropertyValue("column-gap") || i.getPropertyValue("gap")) || 8;
}
function jf(l, i) {
  if (l === i) return !0;
  if (l.length !== i.length) return !1;
  for (let u = 0; u < l.length; u++)
    if (l[u] !== i[u]) return !1;
  return !0;
}
const Uw = ({
  initialTab: l = "",
  children: i,
  bgColor: u = "",
  onTabChange: s = () => {
  }
}) => {
  var V, $;
  const o = Zp(
    () => ye.Children.toArray(i),
    [i]
  ), f = Zp(() => {
    const J = {};
    return o.forEach((tt) => {
      var lt;
      (lt = tt == null ? void 0 : tt.props) != null && lt.id && (J[tt.props.id] = tt);
    }), J;
  }, [o]), m = nn(!1), [g, y] = ve(
    l && l !== "null" ? l : (($ = (V = o[0]) == null ? void 0 : V.props) == null ? void 0 : $.id) ?? ""
  ), b = nn(null), T = nn(null), [A, x] = Bw(), U = nn({}), D = nn({}), R = kl(
    (J) => (tt) => {
      x(J)(tt), tt ? (U.current[J] = tt, D.current[J] = Math.round(
        tt.getBoundingClientRect().width
      )) : delete U.current[J];
    },
    [x]
  ), [q, Y] = ve([]), [L, et] = ve(
    o.map((J) => J.props.id)
  ), [W, X] = ve(!1), B = 282, G = kl(() => {
    const J = b.current;
    if (!J) {
      const bt = o.map((Ut) => Ut.props.id);
      et((Ut) => jf(Ut, bt) ? Ut : bt), Y((Ut) => Ut.length === 0 ? Ut : []);
      return;
    }
    const tt = o.map((bt) => bt.props.id), lt = tt.map((bt) => {
      var Kt;
      const Ut = U.current[bt] ?? ((Kt = A.current) == null ? void 0 : Kt[bt]);
      if (Ut && typeof Ut.getBoundingClientRect == "function") {
        const zt = Math.round(Ut.getBoundingClientRect().width);
        return D.current[bt] = zt, zt;
      }
      return typeof D.current[bt] == "number" ? D.current[bt] : 80;
    }), vt = J.clientWidth ?? 0, ct = T.current ? Math.round(T.current.getBoundingClientRect().width) : 83, at = Hw(J), ot = [], ue = [];
    let fe = 0;
    for (let bt = 0; bt < tt.length; bt++) {
      const Ut = lt[bt] ?? 0;
      if (fe + Ut + ct > vt) {
        for (let Kt = bt; Kt < tt.length; Kt++)
          ue.push(tt[Kt]);
        break;
      }
      ot.push(tt[bt]), fe += Ut + at;
    }
    if (et(
      (bt) => jf(bt, ot) ? bt : ot
    ), Y(
      (bt) => jf(bt, ue) ? bt : ue
    ), ue.length > 0 && J && T.current) {
      const bt = T.current.getBoundingClientRect(), Ut = J.getBoundingClientRect().width, Kt = bt.left + B <= window.innerWidth, zt = bt.left + B <= 1200, Zn = Ut < 1200;
      X(Zn && Kt && zt);
    } else
      X(!1);
  }, [o, A, B]);
  Kp(() => (G(), window.addEventListener("resize", G), () => window.removeEventListener("resize", G)), [G]);
  const F = nn(L);
  if (Kp(() => {
    F.current !== L && (F.current = L, G());
  }, [L, G]), Qe(() => {
    m.current && l && l !== "null" && g !== l && y(l);
  }, [l, g]), Qe(() => {
    m.current = !0;
  }, []), o.length === 0)
    return null;
  const ut = (J) => {
    s(J), y(J);
  }, yt = {
    event: "link",
    action: "click",
    name: "onclick",
    type: "internal link",
    text: ""
  }, Dt = o.map(
    (J) => ye.cloneElement(J, {
      bgColor: u,
      selected: g === J.props.id
    })
  ), Nt = (J, tt, lt) => {
    J.preventDefault(), ut(tt);
  }, pt = (J = !0) => {
    var ue;
    const tt = L, lt = tt.length;
    if (lt === 0) return;
    const vt = J ? 1 : -1, ct = tt.indexOf(g), at = ct === -1 ? J ? lt - 1 : 0 : ct, ot = tt[(lt + at + vt) % lt];
    ut(ot), (ue = A.current[ot]) == null || ue.focus();
  }, { isReact: Se } = ql();
  let Zt = "uds-tabbed-panels";
  u === "bg-dark" && (Zt += " uds-tabbed-panels-dark");
  const Q = q.includes(g);
  return /* @__PURE__ */ h.jsxs("div", { className: u, children: [
    /* @__PURE__ */ h.jsx("nav", { className: Zt, ...Se ? { "data-react": "true" } : {}, children: /* @__PURE__ */ h.jsxs("div", { className: "nav nav-tabs", role: "tablist", ref: b, children: [
      L.map((J, tt) => {
        const lt = f[J];
        if (!lt) return null;
        const vt = Q ? tt === 0 : g === J;
        return /* @__PURE__ */ h.jsx(
          Lw,
          {
            ref: R(J),
            id: lt.props.id,
            title: lt.props.title,
            selected: g === lt.props.id,
            isFocusEntry: vt,
            gaData: yt,
            selectTab: Nt,
            leftKeyPressed: () => pt(!1),
            rightKeyPressed: () => pt(),
            icon: lt.props.icon
          },
          lt.props.id
        );
      }),
      /* @__PURE__ */ h.jsx(
        lv,
        {
          ref: T,
          overflowTabs: q,
          idToChild: f,
          activeTabID: g,
          selectTab: Nt,
          gaData: yt,
          openRight: W
        }
      )
    ] }) }),
    /* @__PURE__ */ h.jsx(
      "div",
      {
        className: "tab-content",
        tabIndex: 0,
        role: "tabpanel",
        id: "nav-tabContent",
        children: Dt
      }
    )
  ] });
}, cd = ({ imageSource: l, imageAltText: i, quote: u, itemStyle: s = {} }) => {
  var o, f;
  return /* @__PURE__ */ h.jsxs(
    "div",
    {
      className: `uds-blockquote uds-testimonial ${l ? "with-image" : ""} ${_c(s.containerCssClass)}`,
      children: [
        l && /* @__PURE__ */ h.jsx(
          Ul,
          {
            src: l,
            alt: i,
            dataTestId: "testimonial-image",
            fetchPriority: "high"
          }
        ),
        /* @__PURE__ */ h.jsx("svg", { role: "presentation", viewBox: "0 0 302.87 245.82", children: /* @__PURE__ */ h.jsx("path", { d: "M113.61,245.82H0V164.56q0-49.34,8.69-77.83T40.84,35.58Q64.29,12.95,100.67,0l22.24,46.9q-34,11.33-48.72,31.54T58.63,132.21h55Zm180,0H180V164.56q0-49.74,8.7-78T221,35.58Q244.65,12.95,280.63,0l22.24,46.9q-34,11.33-48.72,31.54t-15.57,53.77h55Z" }) }),
        /* @__PURE__ */ h.jsxs("blockquote", { style: { paddingLeft: 0 }, children: [
          u.title && /* @__PURE__ */ h.jsx("h3", { className: "text-center", "data-testid": "testimonial-title", children: /* @__PURE__ */ h.jsx("span", { className: _c(s.titleCssClass), children: u.title }) }),
          u.content && /* @__PURE__ */ h.jsx(
            "p",
            {
              className: _c(s.contentCssClass),
              "data-testid": "testimonial-content",
              children: u.content
            }
          ),
          (!!((o = u.cite) != null && o.name) || !!((f = u.cite) != null && f.description)) && /* @__PURE__ */ h.jsxs("div", { className: "citation", "data-testid": "testimonial-citation", children: [
            /* @__PURE__ */ h.jsx("cite", { className: "name", children: u.cite.name }),
            u.cite && /* @__PURE__ */ h.jsx("cite", { className: "description", children: u.cite.description })
          ] })
        ] })
      ]
    }
  );
};
cd.propTypes = {
  quote: p.shape({
    title: p.string,
    content: p.string,
    cite: p.shape({
      name: p.string,
      description: p.string
    })
  }).isRequired,
  imageSource: p.string,
  imageAltText: p.string,
  itemStyle: p.shape({
    containerCssClass: p.arrayOf(p.string),
    titleCssClass: p.arrayOf(p.string),
    contentCssClass: p.arrayOf(p.string)
  })
};
const qw = (l) => /* @__PURE__ */ h.jsx("button", { className: "uds-tooltip uds-tooltip-gray", ...l, children: /* @__PURE__ */ h.jsxs("span", { className: "fa-stack", "aria-hidden": "true", children: [
  /* @__PURE__ */ h.jsx("i", { className: "fas fa-circle fa-stack-2x" }),
  /* @__PURE__ */ h.jsx("i", { className: "fas fa-info fa-stack-1x" })
] }) }), Vw = ({
  title: l,
  content: i,
  triggerElement: u,
  children: s,
  iconLabel: o
}) => {
  const f = "tooltip-" + Ir(), m = () => o || (l ? `Show tooltip: ${l}` : i && typeof i == "string" ? `Show tooltip: ${i.length > 50 ? i.substring(0, 47) + "..." : i}` : "Show more information");
  let g = s || u || /* @__PURE__ */ h.jsx(qw, { "aria-label": m() });
  return typeof g == "string" && (g = /* @__PURE__ */ h.jsx("button", { type: "button", children: g })), /* @__PURE__ */ h.jsxs("span", { className: "uds-tooltip-container", children: [
    ye.cloneElement(g, {
      "aria-describedby": f,
      tabIndex: 0
    }),
    /* @__PURE__ */ h.jsxs("div", { role: "tooltip", className: "uds-tooltip-description", id: f, children: [
      l && /* @__PURE__ */ h.jsx("span", { className: "uds-tooltip-heading", children: l }),
      i
    ] })
  ] });
}, Yw = {
  name: "onclick",
  event: "link",
  action: "click",
  type: "internal link",
  region: "main content",
  text: "play button"
}, Gw = ({
  url: l = "",
  vttUrl: i,
  caption: u,
  title: s = "",
  className: o,
  controls: f = !0
}) => {
  const m = nn(null);
  return /* @__PURE__ */ h.jsxs(
    "div",
    {
      className: Rt(`uds-video-container ${o}`, {
        "uds-video-with-caption": u
      }),
      children: [
        /* @__PURE__ */ h.jsx("div", { className: "uds-video-player", children: /* @__PURE__ */ h.jsx(be, { gaData: { ...Yw, section: s }, children: /* @__PURE__ */ h.jsxs(
          "video",
          {
            ref: m,
            title: s,
            playsInline: !0,
            controls: f || !0,
            children: [
              /* @__PURE__ */ h.jsx("source", { src: l }),
              /* @__PURE__ */ h.jsx(
                "track",
                {
                  src: i,
                  kind: "captions",
                  srcLang: "en",
                  label: "english_captions"
                }
              )
            ]
          }
        ) }) }),
        u && /* @__PURE__ */ h.jsx("figure", { "data-testid": "video-caption", children: /* @__PURE__ */ h.jsx("figcaption", { children: u }) })
      ]
    }
  );
}, Xw = ({ title: l = "", caption: i, url: u = "", className: s }) => /* @__PURE__ */ h.jsxs(
  "div",
  {
    className: Rt(`uds-video-container ${s}`, {
      "uds-video-with-caption": i
    }),
    children: [
      /* @__PURE__ */ h.jsx("div", { className: "uds-video-player youtube-video", children: /* @__PURE__ */ h.jsx("iframe", { title: l, src: u }) }),
      i && /* @__PURE__ */ h.jsx("figure", { "data-testid": "video-caption", children: /* @__PURE__ */ h.jsx("figcaption", { children: i }) })
    ]
  }
), iv = (l) => {
  const {
    type: i = "video",
    url: u = "",
    vttUrl: s,
    title: o = "",
    caption: f,
    className: m,
    controls: g = !0
  } = l;
  return i === "youtube" ? Xw({ url: u, title: o, caption: f, className: m }) : Gw({
    url: u,
    vttUrl: s,
    title: o,
    caption: f,
    className: m,
    controls: g
  });
};
iv.propTypes = {
  type: p.oneOf(["video", "youtube"]),
  url: p.string,
  vttUrl: p.string,
  title: p.string,
  className: p.string,
  caption: p.string,
  controls: p.bool
};
const Qw = {
  event: "select",
  action: "click",
  name: "onclick",
  region: "main content",
  type: "pagination",
  text: "owl dot"
}, sd = ({ children: l }) => /* @__PURE__ */ h.jsx(
  "div",
  {
    role: "group",
    className: "glide__bullets",
    "data-glide-el": "controls[nav]",
    "data-testid": "bullets-container",
    onClick: (i) => i.stopPropagation(),
    onKeyDown: (i) => i.stopPropagation(),
    children: l
  }
);
sd.propTypes = {
  children: p.oneOfType([
    p.element,
    p.arrayOf(p.element)
  ]).isRequired
};
const rv = ({ buttonCount: l }) => {
  const i = [];
  for (let u = 0; u < l; u += 1)
    i.push(
      /* @__PURE__ */ h.jsx(be, { gaData: Qw, children: /* @__PURE__ */ h.jsx(
        "button",
        {
          type: "button",
          className: "glide__bullet",
          "data-glide-dir": `=${u}`,
          "aria-label": `Slide view ${u + 1}`
        }
      ) }, `bullet-${u}`)
    );
  return /* @__PURE__ */ h.jsx(sd, { children: i });
};
rv.propTypes = {
  buttonCount: p.number.isRequired
};
const uv = ({ imageItems: l, onItemClick: i = () => null }) => {
  const u = (o, f) => {
    const { ariaSelected: m } = o.currentTarget.dataset;
    o.currentTarget.dataset.ariaSelected = String(!m), o.stopPropagation(), i(f);
  }, s = l.map((o, f) => /* @__PURE__ */ h.jsx(
    "button",
    {
      type: "button",
      role: "option",
      className: "bullet-image-container",
      "data-glide-dir": `=${f}`,
      "aria-label": `Slide view ${f + 1}`,
      "aria-selected": "false",
      onClick: (m) => u(m, f),
      onKeyDown: (m) => u(m, f),
      children: /* @__PURE__ */ h.jsx(
        "img",
        {
          src: o,
          alt: `Slide ${f + 1}`,
          className: "glide__bullet bullet-image",
          loading: "lazy",
          decoding: "async",
          fetchpriority: "low"
        }
      )
    },
    `bullet-${f}`
  ));
  return /* @__PURE__ */ h.jsx(sd, { children: s });
};
uv.propTypes = {
  imageItems: p.arrayOf(p.string).isRequired,
  onItemClick: p.func
};
const od = ({ onClick: l = () => null }) => /* @__PURE__ */ h.jsx(
  "button",
  {
    type: "button",
    className: "glide__arrow glide__arrow--next",
    "data-glide-dir": ">",
    "aria-label": "Next slide",
    onClick: l,
    children: /* @__PURE__ */ h.jsx("i", { className: "fas fa-chevron-right arrow-icon" })
  }
);
od.propTypes = {
  onClick: p.func
};
const fd = ({ onClick: l = () => null }) => /* @__PURE__ */ h.jsx(
  "button",
  {
    type: "button",
    className: "glide__arrow glide__arrow--prev",
    "data-glide-dir": "<",
    "aria-label": "Previous slide",
    onClick: l,
    children: /* @__PURE__ */ h.jsx("span", { className: "fas fa-chevron-left arrow-icon" })
  }
);
fd.propTypes = {
  onClick: p.func
};
const Zg = {
  event: "select",
  action: "click",
  name: "onclick",
  region: "main content",
  type: "carousel"
}, dd = ({ children: l = null }) => /* @__PURE__ */ h.jsx(
  "div",
  {
    className: "glide__arrows",
    "data-glide-el": "controls",
    "data-testid": "arrows-container",
    children: l
  }
);
dd.propTypes = {
  children: p.arrayOf(p.element)
};
const cv = ({ onClick: l = () => null, children: i = null }) => /* @__PURE__ */ h.jsxs(dd, { children: [
  /* @__PURE__ */ h.jsx(be, { gaData: { ...Zg, text: "left chevron" }, children: /* @__PURE__ */ h.jsx(fd, { onClick: l }) }),
  i,
  /* @__PURE__ */ h.jsx(be, { gaData: { ...Zg, text: "right chevron" }, children: /* @__PURE__ */ h.jsx(od, { onClick: l }) })
] });
cv.propTypes = {
  children: p.element,
  onClick: p.func
};
const sv = ({ carouselItems: l }) => {
  const i = l.map((u) => /* @__PURE__ */ h.jsx("li", { className: "glide__slide slider", children: u.item }, u.id.toString()));
  return /* @__PURE__ */ h.jsx("ul", { className: "glide__slides", children: i });
};
sv.propTypes = {
  carouselItems: p.arrayOf(p.object)
};
function Kg(l, i) {
  var u = Object.keys(l);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(l);
    i && (s = s.filter(function(o) {
      return Object.getOwnPropertyDescriptor(l, o).enumerable;
    })), u.push.apply(u, s);
  }
  return u;
}
function $g(l) {
  for (var i = 1; i < arguments.length; i++) {
    var u = arguments[i] != null ? arguments[i] : {};
    i % 2 ? Kg(Object(u), !0).forEach(function(s) {
      Kw(l, s, u[s]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(l, Object.getOwnPropertyDescriptors(u)) : Kg(Object(u)).forEach(function(s) {
      Object.defineProperty(l, s, Object.getOwnPropertyDescriptor(u, s));
    });
  }
  return l;
}
function zc(l) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? zc = function(i) {
    return typeof i;
  } : zc = function(i) {
    return i && typeof Symbol == "function" && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
  }, zc(l);
}
function Fc(l, i) {
  if (!(l instanceof i))
    throw new TypeError("Cannot call a class as a function");
}
function Zw(l, i) {
  for (var u = 0; u < i.length; u++) {
    var s = i[u];
    s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(l, s.key, s);
  }
}
function Ic(l, i, u) {
  return i && Zw(l.prototype, i), l;
}
function Kw(l, i, u) {
  return i in l ? Object.defineProperty(l, i, {
    value: u,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : l[i] = u, l;
}
function $w(l, i) {
  if (typeof i != "function" && i !== null)
    throw new TypeError("Super expression must either be null or a function");
  l.prototype = Object.create(i && i.prototype, {
    constructor: {
      value: l,
      writable: !0,
      configurable: !0
    }
  }), i && Xf(l, i);
}
function Bi(l) {
  return Bi = Object.setPrototypeOf ? Object.getPrototypeOf : function(u) {
    return u.__proto__ || Object.getPrototypeOf(u);
  }, Bi(l);
}
function Xf(l, i) {
  return Xf = Object.setPrototypeOf || function(s, o) {
    return s.__proto__ = o, s;
  }, Xf(l, i);
}
function Jw() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Ww(l) {
  if (l === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return l;
}
function Fw(l, i) {
  if (i && (typeof i == "object" || typeof i == "function"))
    return i;
  if (i !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Ww(l);
}
function Iw(l) {
  var i = Jw();
  return function() {
    var s = Bi(l), o;
    if (i) {
      var f = Bi(this).constructor;
      o = Reflect.construct(s, arguments, f);
    } else
      o = s.apply(this, arguments);
    return Fw(this, o);
  };
}
function Pw(l, i) {
  for (; !Object.prototype.hasOwnProperty.call(l, i) && (l = Bi(l), l !== null); )
    ;
  return l;
}
function Mc() {
  return typeof Reflect < "u" && Reflect.get ? Mc = Reflect.get : Mc = function(i, u, s) {
    var o = Pw(i, u);
    if (o) {
      var f = Object.getOwnPropertyDescriptor(o, u);
      return f.get ? f.get.call(arguments.length < 3 ? i : s) : f.value;
    }
  }, Mc.apply(this, arguments);
}
var tx = {
  /**
   * Type of the movement.
   *
   * Available types:
   * `slider` - Rewinds slider to the start/end when it reaches the first or last slide.
   * `carousel` - Changes slides without starting over when it reaches the first or last slide.
   *
   * @type {String}
   */
  type: "slider",
  /**
   * Start at specific slide number defined with zero-based index.
   *
   * @type {Number}
   */
  startAt: 0,
  /**
   * A number of slides visible on the single viewport.
   *
   * @type {Number}
   */
  perView: 1,
  /**
   * Focus currently active slide at a specified position in the track.
   *
   * Available inputs:
   * `center` - Current slide will be always focused at the center of a track.
   * `0,1,2,3...` - Current slide will be focused on the specified zero-based index.
   *
   * @type {String|Number}
   */
  focusAt: 0,
  /**
   * A size of the gap added between slides.
   *
   * @type {Number}
   */
  gap: 10,
  /**
   * Change slides after a specified interval. Use `false` for turning off autoplay.
   *
   * @type {Number|Boolean}
   */
  autoplay: !1,
  /**
   * Stop autoplay on mouseover event.
   *
   * @type {Boolean}
   */
  hoverpause: !0,
  /**
   * Allow for changing slides with left and right keyboard arrows.
   *
   * @type {Boolean}
   */
  keyboard: !0,
  /**
   * Stop running `perView` number of slides from the end. Use this
   * option if you don't want to have an empty space after
   * a slider. Works only with `slider` type and a
   * non-centered `focusAt` setting.
   *
   * @type {Boolean}
   */
  bound: !1,
  /**
   * Minimal swipe distance needed to change the slide. Use `false` for turning off a swiping.
   *
   * @type {Number|Boolean}
   */
  swipeThreshold: 80,
  /**
   * Minimal mouse drag distance needed to change the slide. Use `false` for turning off a dragging.
   *
   * @type {Number|Boolean}
   */
  dragThreshold: 120,
  /**
   * A number of slides moved on single swipe.
   *
   * Available types:
   * `` - Moves slider by one slide per swipe
   * `|` - Moves slider between views per swipe (number of slides defined in `perView` options)
   *
   * @type {String}
   */
  perSwipe: "",
  /**
   * Moving distance ratio of the slides on a swiping and dragging.
   *
   * @type {Number}
   */
  touchRatio: 0.5,
  /**
   * Angle required to activate slides moving on swiping or dragging.
   *
   * @type {Number}
   */
  touchAngle: 45,
  /**
   * Duration of the animation in milliseconds.
   *
   * @type {Number}
   */
  animationDuration: 400,
  /**
   * Allows looping the `slider` type. Slider will rewind to the first/last slide when it's at the start/end.
   *
   * @type {Boolean}
   */
  rewind: !0,
  /**
   * Duration of the rewinding animation of the `slider` type in milliseconds.
   *
   * @type {Number}
   */
  rewindDuration: 800,
  /**
   * Easing function for the animation.
   *
   * @type {String}
   */
  animationTimingFunc: "cubic-bezier(.165, .840, .440, 1)",
  /**
   * Wait for the animation to finish until the next user input can be processed
   *
   * @type {boolean}
   */
  waitForTransition: !0,
  /**
   * Throttle costly events at most once per every wait milliseconds.
   *
   * @type {Number}
   */
  throttle: 10,
  /**
   * Moving direction mode.
   *
   * Available inputs:
   * - 'ltr' - left to right movement,
   * - 'rtl' - right to left movement.
   *
   * @type {String}
   */
  direction: "ltr",
  /**
   * The distance value of the next and previous viewports which
   * have to peek in the current view. Accepts number and
   * pixels as a string. Left and right peeking can be
   * set up separately with a directions object.
   *
   * For example:
   * `100` - Peek 100px on the both sides.
   * { before: 100, after: 50 }` - Peek 100px on the left side and 50px on the right side.
   *
   * @type {Number|String|Object}
   */
  peek: 0,
  /**
   * Defines how many clones of current viewport will be generated.
   *
   * @type {Number}
   */
  cloningRatio: 1,
  /**
   * Collection of options applied at specified media breakpoints.
   * For example: display two slides per view under 800px.
   * `{
   *   '800px': {
   *     perView: 2
   *   }
   * }`
   */
  breakpoints: {},
  /**
   * Collection of internally used HTML classes.
   *
   * @todo Refactor `slider` and `carousel` properties to single `type: { slider: '', carousel: '' }` object
   * @type {Object}
   */
  classes: {
    swipeable: "glide--swipeable",
    dragging: "glide--dragging",
    direction: {
      ltr: "glide--ltr",
      rtl: "glide--rtl"
    },
    type: {
      slider: "glide--slider",
      carousel: "glide--carousel"
    },
    slide: {
      clone: "glide__slide--clone",
      active: "glide__slide--active"
    },
    arrow: {
      disabled: "glide__arrow--disabled"
    },
    nav: {
      active: "glide__bullet--active"
    }
  }
};
function ya(l) {
  console.error("[Glide warn]: ".concat(l));
}
function Be(l) {
  return parseInt(l);
}
function ex(l) {
  return parseFloat(l);
}
function Qf(l) {
  return typeof l == "string";
}
function Hi(l) {
  var i = zc(l);
  return i === "function" || i === "object" && !!l;
}
function Vc(l) {
  return typeof l == "function";
}
function ov(l) {
  return typeof l > "u";
}
function Zf(l) {
  return l.constructor === Array;
}
function nx(l, i, u) {
  var s = {};
  for (var o in i)
    Vc(i[o]) ? s[o] = i[o](l, s, u) : ya("Extension must be a function");
  for (var f in s)
    Vc(s[f].mount) && s[f].mount();
  return s;
}
function ie(l, i, u) {
  Object.defineProperty(l, i, u);
}
function ax(l) {
  return Object.keys(l).sort().reduce(function(i, u) {
    return i[u] = l[u], i[u], i;
  }, {});
}
function Kf(l, i) {
  var u = Object.assign({}, l, i);
  if (i.hasOwnProperty("classes")) {
    u.classes = Object.assign({}, l.classes, i.classes);
    var s = ["direction", "type", "slide", "arrow", "nav"];
    s.forEach(function(o) {
      i.classes.hasOwnProperty(o) && (u.classes[o] = $g($g({}, l.classes[o]), i.classes[o]));
    });
  }
  return i.hasOwnProperty("breakpoints") && (u.breakpoints = Object.assign({}, l.breakpoints, i.breakpoints)), u;
}
var lx = /* @__PURE__ */ (function() {
  function l() {
    var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Fc(this, l), this.events = i, this.hop = i.hasOwnProperty;
  }
  return Ic(l, [{
    key: "on",
    value: function(u, s) {
      if (Zf(u)) {
        for (var o = 0; o < u.length; o++)
          this.on(u[o], s);
        return;
      }
      this.hop.call(this.events, u) || (this.events[u] = []);
      var f = this.events[u].push(s) - 1;
      return {
        remove: function() {
          delete this.events[u][f];
        }
      };
    }
    /**
     * Runs registered handlers for specified event.
     *
     * @param {String|Array} event
     * @param {Object=} context
     */
  }, {
    key: "emit",
    value: function(u, s) {
      if (Zf(u)) {
        for (var o = 0; o < u.length; o++)
          this.emit(u[o], s);
        return;
      }
      this.hop.call(this.events, u) && this.events[u].forEach(function(f) {
        f(s || {});
      });
    }
  }]), l;
})(), ix = /* @__PURE__ */ (function() {
  function l(i) {
    var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    Fc(this, l), this._c = {}, this._t = [], this._e = new lx(), this.disabled = !1, this.selector = i, this.settings = Kf(tx, u), this.index = this.settings.startAt;
  }
  return Ic(l, [{
    key: "mount",
    value: function() {
      var u = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      return this._e.emit("mount.before"), Hi(u) ? this._c = nx(this, u, this._e) : ya("You need to provide a object on `mount()`"), this._e.emit("mount.after"), this;
    }
    /**
     * Collects an instance `translate` transformers.
     *
     * @param  {Array} transformers Collection of transformers.
     * @return {Void}
     */
  }, {
    key: "mutate",
    value: function() {
      var u = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
      return Zf(u) ? this._t = u : ya("You need to provide a array on `mutate()`"), this;
    }
    /**
     * Updates glide with specified settings.
     *
     * @param {Object} settings
     * @return {Glide}
     */
  }, {
    key: "update",
    value: function() {
      var u = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      return this.settings = Kf(this.settings, u), u.hasOwnProperty("startAt") && (this.index = u.startAt), this._e.emit("update"), this;
    }
    /**
     * Change slide with specified pattern. A pattern must be in the special format:
     * `>` - Move one forward
     * `<` - Move one backward
     * `={i}` - Go to {i} zero-based slide (eq. '=1', will go to second slide)
     * `>>` - Rewinds to end (last slide)
     * `<<` - Rewinds to start (first slide)
     * `|>` - Move one viewport forward
     * `|<` - Move one viewport backward
     *
     * @param {String} pattern
     * @return {Glide}
     */
  }, {
    key: "go",
    value: function(u) {
      return this._c.Run.make(u), this;
    }
    /**
     * Move track by specified distance.
     *
     * @param {String} distance
     * @return {Glide}
     */
  }, {
    key: "move",
    value: function(u) {
      return this._c.Transition.disable(), this._c.Move.make(u), this;
    }
    /**
     * Destroy instance and revert all changes done by this._c.
     *
     * @return {Glide}
     */
  }, {
    key: "destroy",
    value: function() {
      return this._e.emit("destroy"), this;
    }
    /**
     * Start instance autoplaying.
     *
     * @param {Boolean|Number} interval Run autoplaying with passed interval regardless of `autoplay` settings
     * @return {Glide}
     */
  }, {
    key: "play",
    value: function() {
      var u = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
      return u && (this.settings.autoplay = u), this._e.emit("play"), this;
    }
    /**
     * Stop instance autoplaying.
     *
     * @return {Glide}
     */
  }, {
    key: "pause",
    value: function() {
      return this._e.emit("pause"), this;
    }
    /**
     * Sets glide into a idle status.
     *
     * @return {Glide}
     */
  }, {
    key: "disable",
    value: function() {
      return this.disabled = !0, this;
    }
    /**
     * Sets glide into a active status.
     *
     * @return {Glide}
     */
  }, {
    key: "enable",
    value: function() {
      return this.disabled = !1, this;
    }
    /**
     * Adds cuutom event listener with handler.
     *
     * @param  {String|Array} event
     * @param  {Function} handler
     * @return {Glide}
     */
  }, {
    key: "on",
    value: function(u, s) {
      return this._e.on(u, s), this;
    }
    /**
     * Checks if glide is a precised type.
     *
     * @param  {String} name
     * @return {Boolean}
     */
  }, {
    key: "isType",
    value: function(u) {
      return this.settings.type === u;
    }
    /**
     * Gets value of the core options.
     *
     * @return {Object}
     */
  }, {
    key: "settings",
    get: function() {
      return this._o;
    },
    set: function(u) {
      Hi(u) ? this._o = u : ya("Options must be an `object` instance.");
    }
    /**
     * Gets current index of the slider.
     *
     * @return {Object}
     */
  }, {
    key: "index",
    get: function() {
      return this._i;
    },
    set: function(u) {
      this._i = Be(u);
    }
    /**
     * Gets type name of the slider.
     *
     * @return {String}
     */
  }, {
    key: "type",
    get: function() {
      return this.settings.type;
    }
    /**
     * Gets value of the idle status.
     *
     * @return {Boolean}
     */
  }, {
    key: "disabled",
    get: function() {
      return this._d;
    },
    set: function(u) {
      this._d = !!u;
    }
  }]), l;
})();
function rx(l, i, u) {
  var s = {
    /**
     * Initializes autorunning of the glide.
     *
     * @return {Void}
     */
    mount: function() {
      this._o = !1;
    },
    /**
     * Makes glides running based on the passed moving schema.
     *
     * @param {String} move
     */
    make: function(b) {
      var T = this;
      l.disabled || (!l.settings.waitForTransition || l.disable(), this.move = b, u.emit("run.before", this.move), this.calculate(), u.emit("run", this.move), i.Transition.after(function() {
        T.isStart() && u.emit("run.start", T.move), T.isEnd() && u.emit("run.end", T.move), T.isOffset() && (T._o = !1, u.emit("run.offset", T.move)), u.emit("run.after", T.move), l.enable();
      }));
    },
    /**
     * Calculates current index based on defined move.
     *
     * @return {Number|Undefined}
     */
    calculate: function() {
      var b = this.move, T = this.length, A = b.steps, x = b.direction, U = 1;
      if (x === "=") {
        if (l.settings.bound && Be(A) > T) {
          l.index = T;
          return;
        }
        l.index = A;
        return;
      }
      if (x === ">" && A === ">") {
        l.index = T;
        return;
      }
      if (x === "<" && A === "<") {
        l.index = 0;
        return;
      }
      if (x === "|" && (U = l.settings.perView || 1), x === ">" || x === "|" && A === ">") {
        var D = o(U);
        D > T && (this._o = !0), l.index = f(D, U);
        return;
      }
      if (x === "<" || x === "|" && A === "<") {
        var R = m(U);
        R < 0 && (this._o = !0), l.index = g(R, U);
        return;
      }
      ya("Invalid direction pattern [".concat(x).concat(A, "] has been used"));
    },
    /**
     * Checks if we are on the first slide.
     *
     * @return {Boolean}
     */
    isStart: function() {
      return l.index <= 0;
    },
    /**
     * Checks if we are on the last slide.
     *
     * @return {Boolean}
     */
    isEnd: function() {
      return l.index >= this.length;
    },
    /**
     * Checks if we are making a offset run.
     *
     * @param {String} direction
     * @return {Boolean}
     */
    isOffset: function() {
      var b = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : void 0;
      return b ? this._o ? b === "|>" ? this.move.direction === "|" && this.move.steps === ">" : b === "|<" ? this.move.direction === "|" && this.move.steps === "<" : this.move.direction === b : !1 : this._o;
    },
    /**
     * Checks if bound mode is active
     *
     * @return {Boolean}
     */
    isBound: function() {
      return l.isType("slider") && l.settings.focusAt !== "center" && l.settings.bound;
    }
  };
  function o(y) {
    var b = l.index;
    return l.isType("carousel") ? b + y : b + (y - b % y);
  }
  function f(y, b) {
    var T = s.length;
    return y <= T ? y : l.isType("carousel") ? y - (T + 1) : l.settings.rewind ? s.isBound() && !s.isEnd() ? T : 0 : s.isBound() ? T : Math.floor(T / b) * b;
  }
  function m(y) {
    var b = l.index;
    if (l.isType("carousel"))
      return b - y;
    var T = Math.ceil(b / y);
    return (T - 1) * y;
  }
  function g(y, b) {
    var T = s.length;
    return y >= 0 ? y : l.isType("carousel") ? y + (T + 1) : l.settings.rewind ? s.isBound() && s.isStart() ? T : Math.floor(T / b) * b : 0;
  }
  return ie(s, "move", {
    /**
     * Gets value of the move schema.
     *
     * @returns {Object}
     */
    get: function() {
      return this._m;
    },
    /**
     * Sets value of the move schema.
     *
     * @returns {Object}
     */
    set: function(b) {
      var T = b.substr(1);
      this._m = {
        direction: b.substr(0, 1),
        steps: T ? Be(T) ? Be(T) : T : 0
      };
    }
  }), ie(s, "length", {
    /**
     * Gets value of the running distance based
     * on zero-indexing number of slides.
     *
     * @return {Number}
     */
    get: function() {
      var b = l.settings, T = i.Html.slides.length;
      return this.isBound() ? T - 1 - (Be(b.perView) - 1) + Be(b.focusAt) : T - 1;
    }
  }), ie(s, "offset", {
    /**
     * Gets status of the offsetting flag.
     *
     * @return {Boolean}
     */
    get: function() {
      return this._o;
    }
  }), s;
}
function Jg() {
  return (/* @__PURE__ */ new Date()).getTime();
}
function Pc(l, i) {
  var u = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, s, o, f, m, g = 0, y = function() {
    g = u.leading === !1 ? 0 : Jg(), s = null, m = l.apply(o, f), s || (o = f = null);
  }, b = function() {
    var A = Jg();
    !g && u.leading === !1 && (g = A);
    var x = i - (A - g);
    return o = this, f = arguments, x <= 0 || x > i ? (s && (clearTimeout(s), s = null), g = A, m = l.apply(o, f), s || (o = f = null)) : !s && u.trailing !== !1 && (s = setTimeout(y, x)), m;
  };
  return b.cancel = function() {
    clearTimeout(s), g = 0, s = o = f = null;
  }, b;
}
var xc = {
  ltr: ["marginLeft", "marginRight"],
  rtl: ["marginRight", "marginLeft"]
};
function ux(l, i, u) {
  var s = {
    /**
     * Applies gaps between slides. First and last
     * slides do not receive it's edge margins.
     *
     * @param {HTMLCollection} slides
     * @return {Void}
     */
    apply: function(f) {
      for (var m = 0, g = f.length; m < g; m++) {
        var y = f[m].style, b = i.Direction.value;
        m !== 0 ? y[xc[b][0]] = "".concat(this.value / 2, "px") : y[xc[b][0]] = "", m !== f.length - 1 ? y[xc[b][1]] = "".concat(this.value / 2, "px") : y[xc[b][1]] = "";
      }
    },
    /**
     * Removes gaps from the slides.
     *
     * @param {HTMLCollection} slides
     * @returns {Void}
    */
    remove: function(f) {
      for (var m = 0, g = f.length; m < g; m++) {
        var y = f[m].style;
        y.marginLeft = "", y.marginRight = "";
      }
    }
  };
  return ie(s, "value", {
    /**
     * Gets value of the gap.
     *
     * @returns {Number}
     */
    get: function() {
      return Be(l.settings.gap);
    }
  }), ie(s, "grow", {
    /**
     * Gets additional dimensions value caused by gaps.
     * Used to increase width of the slides wrapper.
     *
     * @returns {Number}
     */
    get: function() {
      return s.value * i.Sizes.length;
    }
  }), ie(s, "reductor", {
    /**
     * Gets reduction value caused by gaps.
     * Used to subtract width of the slides.
     *
     * @returns {Number}
     */
    get: function() {
      var f = l.settings.perView;
      return s.value * (f - 1) / f;
    }
  }), u.on(["build.after", "update"], Pc(function() {
    s.apply(i.Html.wrapper.children);
  }, 30)), u.on("destroy", function() {
    s.remove(i.Html.wrapper.children);
  }), s;
}
function fv(l) {
  if (l && l.parentNode) {
    for (var i = l.parentNode.firstChild, u = []; i; i = i.nextSibling)
      i.nodeType === 1 && i !== l && u.push(i);
    return u;
  }
  return [];
}
function $f(l) {
  return Array.prototype.slice.call(l);
}
var cx = '[data-glide-el="track"]';
function sx(l, i, u) {
  var s = {
    /**
     * Setup slider HTML nodes.
     *
     * @param {Glide} glide
     */
    mount: function() {
      this.root = l.selector, this.track = this.root.querySelector(cx), this.collectSlides();
    },
    /**
     * Collect slides
     */
    collectSlides: function() {
      this.slides = $f(this.wrapper.children).filter(function(f) {
        return !f.classList.contains(l.settings.classes.slide.clone);
      });
    }
  };
  return ie(s, "root", {
    /**
     * Gets node of the glide main element.
     *
     * @return {Object}
     */
    get: function() {
      return s._r;
    },
    /**
     * Sets node of the glide main element.
     *
     * @return {Object}
     */
    set: function(f) {
      Qf(f) && (f = document.querySelector(f)), f !== null ? s._r = f : ya("Root element must be a existing Html node");
    }
  }), ie(s, "track", {
    /**
     * Gets node of the glide track with slides.
     *
     * @return {Object}
     */
    get: function() {
      return s._t;
    },
    /**
     * Sets node of the glide track with slides.
     *
     * @return {Object}
     */
    set: function(f) {
      s._t = f;
    }
  }), ie(s, "wrapper", {
    /**
     * Gets node of the slides wrapper.
     *
     * @return {Object}
     */
    get: function() {
      return s.track.children[0];
    }
  }), u.on("update", function() {
    s.collectSlides();
  }), s;
}
function ox(l, i, u) {
  var s = {
    /**
     * Setups how much to peek based on settings.
     *
     * @return {Void}
     */
    mount: function() {
      this.value = l.settings.peek;
    }
  };
  return ie(s, "value", {
    /**
     * Gets value of the peek.
     *
     * @returns {Number|Object}
     */
    get: function() {
      return s._v;
    },
    /**
     * Sets value of the peek.
     *
     * @param {Number|Object} value
     * @return {Void}
     */
    set: function(f) {
      Hi(f) ? (f.before = Be(f.before), f.after = Be(f.after)) : f = Be(f), s._v = f;
    }
  }), ie(s, "reductor", {
    /**
     * Gets reduction value caused by peek.
     *
     * @returns {Number}
     */
    get: function() {
      var f = s.value, m = l.settings.perView;
      return Hi(f) ? f.before / m + f.after / m : f * 2 / m;
    }
  }), u.on(["resize", "update"], function() {
    s.mount();
  }), s;
}
function fx(l, i, u) {
  var s = {
    /**
     * Constructs move component.
     *
     * @returns {Void}
     */
    mount: function() {
      this._o = 0;
    },
    /**
     * Calculates a movement value based on passed offset and currently active index.
     *
     * @param  {Number} offset
     * @return {Void}
     */
    make: function() {
      var f = this, m = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
      this.offset = m, u.emit("move", {
        movement: this.value
      }), i.Transition.after(function() {
        u.emit("move.after", {
          movement: f.value
        });
      });
    }
  };
  return ie(s, "offset", {
    /**
     * Gets an offset value used to modify current translate.
     *
     * @return {Object}
     */
    get: function() {
      return s._o;
    },
    /**
     * Sets an offset value used to modify current translate.
     *
     * @return {Object}
     */
    set: function(f) {
      s._o = ov(f) ? 0 : Be(f);
    }
  }), ie(s, "translate", {
    /**
     * Gets a raw movement value.
     *
     * @return {Number}
     */
    get: function() {
      return i.Sizes.slideWidth * l.index;
    }
  }), ie(s, "value", {
    /**
     * Gets an actual movement value corrected by offset.
     *
     * @return {Number}
     */
    get: function() {
      var f = this.offset, m = this.translate;
      return i.Direction.is("rtl") ? m + f : m - f;
    }
  }), u.on(["build.before", "run"], function() {
    s.make();
  }), s;
}
function dx(l, i, u) {
  var s = {
    /**
     * Setups dimensions of slides.
     *
     * @return {Void}
     */
    setupSlides: function() {
      for (var f = "".concat(this.slideWidth, "px"), m = i.Html.slides, g = 0; g < m.length; g++)
        m[g].style.width = f;
    },
    /**
     * Setups dimensions of slides wrapper.
     *
     * @return {Void}
     */
    setupWrapper: function() {
      i.Html.wrapper.style.width = "".concat(this.wrapperSize, "px");
    },
    /**
     * Removes applied styles from HTML elements.
     *
     * @returns {Void}
     */
    remove: function() {
      for (var f = i.Html.slides, m = 0; m < f.length; m++)
        f[m].style.width = "";
      i.Html.wrapper.style.width = "";
    }
  };
  return ie(s, "length", {
    /**
     * Gets count number of the slides.
     *
     * @return {Number}
     */
    get: function() {
      return i.Html.slides.length;
    }
  }), ie(s, "width", {
    /**
     * Gets width value of the slider (visible area).
     *
     * @return {Number}
     */
    get: function() {
      return i.Html.track.offsetWidth;
    }
  }), ie(s, "wrapperSize", {
    /**
     * Gets size of the slides wrapper.
     *
     * @return {Number}
     */
    get: function() {
      return s.slideWidth * s.length + i.Gaps.grow + i.Clones.grow;
    }
  }), ie(s, "slideWidth", {
    /**
     * Gets width value of a single slide.
     *
     * @return {Number}
     */
    get: function() {
      return s.width / l.settings.perView - i.Peek.reductor - i.Gaps.reductor;
    }
  }), u.on(["build.before", "resize", "update"], function() {
    s.setupSlides(), s.setupWrapper();
  }), u.on("destroy", function() {
    s.remove();
  }), s;
}
function hx(l, i, u) {
  var s = {
    /**
     * Init glide building. Adds classes, sets
     * dimensions and setups initial state.
     *
     * @return {Void}
     */
    mount: function() {
      u.emit("build.before"), this.typeClass(), this.activeClass(), u.emit("build.after");
    },
    /**
     * Adds `type` class to the glide element.
     *
     * @return {Void}
     */
    typeClass: function() {
      i.Html.root.classList.add(l.settings.classes.type[l.settings.type]);
    },
    /**
     * Sets active class to current slide.
     *
     * @return {Void}
     */
    activeClass: function() {
      var f = l.settings.classes, m = i.Html.slides[l.index];
      m && (m.classList.add(f.slide.active), fv(m).forEach(function(g) {
        g.classList.remove(f.slide.active);
      }));
    },
    /**
     * Removes HTML classes applied at building.
     *
     * @return {Void}
     */
    removeClasses: function() {
      var f = l.settings.classes, m = f.type, g = f.slide;
      i.Html.root.classList.remove(m[l.settings.type]), i.Html.slides.forEach(function(y) {
        y.classList.remove(g.active);
      });
    }
  };
  return u.on(["destroy", "update"], function() {
    s.removeClasses();
  }), u.on(["resize", "update"], function() {
    s.mount();
  }), u.on("move.after", function() {
    s.activeClass();
  }), s;
}
function mx(l, i, u) {
  var s = {
    /**
     * Create pattern map and collect slides to be cloned.
     */
    mount: function() {
      this.items = [], l.isType("carousel") && (this.items = this.collect());
    },
    /**
     * Collect clones with pattern.
     *
     * @return {[]}
     */
    collect: function() {
      var f = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], m = i.Html.slides, g = l.settings, y = g.perView, b = g.classes, T = g.cloningRatio;
      if (m.length > 0)
        for (var A = +!!l.settings.peek, x = y + A + Math.round(y / 2), U = m.slice(0, x).reverse(), D = m.slice(x * -1), R = 0; R < Math.max(T, Math.floor(y / m.length)); R++) {
          for (var q = 0; q < U.length; q++) {
            var Y = U[q].cloneNode(!0);
            Y.classList.add(b.slide.clone), f.push(Y);
          }
          for (var L = 0; L < D.length; L++) {
            var et = D[L].cloneNode(!0);
            et.classList.add(b.slide.clone), f.unshift(et);
          }
        }
      return f;
    },
    /**
     * Append cloned slides with generated pattern.
     *
     * @return {Void}
     */
    append: function() {
      for (var f = this.items, m = i.Html, g = m.wrapper, y = m.slides, b = Math.floor(f.length / 2), T = f.slice(0, b).reverse(), A = f.slice(b * -1).reverse(), x = "".concat(i.Sizes.slideWidth, "px"), U = 0; U < A.length; U++)
        g.appendChild(A[U]);
      for (var D = 0; D < T.length; D++)
        g.insertBefore(T[D], y[0]);
      for (var R = 0; R < f.length; R++)
        f[R].style.width = x;
    },
    /**
     * Remove all cloned slides.
     *
     * @return {Void}
     */
    remove: function() {
      for (var f = this.items, m = 0; m < f.length; m++)
        i.Html.wrapper.removeChild(f[m]);
    }
  };
  return ie(s, "grow", {
    /**
     * Gets additional dimensions value caused by clones.
     *
     * @return {Number}
     */
    get: function() {
      return (i.Sizes.slideWidth + i.Gaps.value) * s.items.length;
    }
  }), u.on("update", function() {
    s.remove(), s.mount(), s.append();
  }), u.on("build.before", function() {
    l.isType("carousel") && s.append();
  }), u.on("destroy", function() {
    s.remove();
  }), s;
}
var ll = /* @__PURE__ */ (function() {
  function l() {
    var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Fc(this, l), this.listeners = i;
  }
  return Ic(l, [{
    key: "on",
    value: function(u, s, o) {
      var f = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
      Qf(u) && (u = [u]);
      for (var m = 0; m < u.length; m++)
        this.listeners[u[m]] = o, s.addEventListener(u[m], this.listeners[u[m]], f);
    }
    /**
     * Removes event listeners from arrows HTML elements.
     *
     * @param  {String|Array} events
     * @param  {Element|Window|Document} el
     * @param  {Boolean|Object} capture
     * @return {Void}
     */
  }, {
    key: "off",
    value: function(u, s) {
      var o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
      Qf(u) && (u = [u]);
      for (var f = 0; f < u.length; f++)
        s.removeEventListener(u[f], this.listeners[u[f]], o);
    }
    /**
     * Destroy collected listeners.
     *
     * @returns {Void}
     */
  }, {
    key: "destroy",
    value: function() {
      delete this.listeners;
    }
  }]), l;
})();
function px(l, i, u) {
  var s = new ll(), o = {
    /**
     * Initializes window bindings.
     */
    mount: function() {
      this.bind();
    },
    /**
     * Binds `rezsize` listener to the window.
     * It's a costly event, so we are debouncing it.
     *
     * @return {Void}
     */
    bind: function() {
      s.on("resize", window, Pc(function() {
        u.emit("resize");
      }, l.settings.throttle));
    },
    /**
     * Unbinds listeners from the window.
     *
     * @return {Void}
     */
    unbind: function() {
      s.off("resize", window);
    }
  };
  return u.on("destroy", function() {
    o.unbind(), s.destroy();
  }), o;
}
var gx = ["ltr", "rtl"], yx = {
  ">": "<",
  "<": ">",
  "=": "="
};
function vx(l, i, u) {
  var s = {
    /**
     * Setups gap value based on settings.
     *
     * @return {Void}
     */
    mount: function() {
      this.value = l.settings.direction;
    },
    /**
     * Resolves pattern based on direction value
     *
     * @param {String} pattern
     * @returns {String}
     */
    resolve: function(f) {
      var m = f.slice(0, 1);
      return this.is("rtl") ? f.split(m).join(yx[m]) : f;
    },
    /**
     * Checks value of direction mode.
     *
     * @param {String} direction
     * @returns {Boolean}
     */
    is: function(f) {
      return this.value === f;
    },
    /**
     * Applies direction class to the root HTML element.
     *
     * @return {Void}
     */
    addClass: function() {
      i.Html.root.classList.add(l.settings.classes.direction[this.value]);
    },
    /**
     * Removes direction class from the root HTML element.
     *
     * @return {Void}
     */
    removeClass: function() {
      i.Html.root.classList.remove(l.settings.classes.direction[this.value]);
    }
  };
  return ie(s, "value", {
    /**
     * Gets value of the direction.
     *
     * @returns {Number}
     */
    get: function() {
      return s._v;
    },
    /**
     * Sets value of the direction.
     *
     * @param {String} value
     * @return {Void}
     */
    set: function(f) {
      gx.indexOf(f) > -1 ? s._v = f : ya("Direction value must be `ltr` or `rtl`");
    }
  }), u.on(["destroy", "update"], function() {
    s.removeClass();
  }), u.on("update", function() {
    s.mount();
  }), u.on(["build.before", "update"], function() {
    s.addClass();
  }), s;
}
function bx(l, i) {
  return {
    /**
     * Negates the passed translate if glide is in RTL option.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function(s) {
      return i.Direction.is("rtl") ? -s : s;
    }
  };
}
function Sx(l, i) {
  return {
    /**
     * Modifies passed translate value with number in the `gap` settings.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function(s) {
      var o = Math.floor(s / i.Sizes.slideWidth);
      return s + i.Gaps.value * o;
    }
  };
}
function Tx(l, i) {
  return {
    /**
     * Adds to the passed translate width of the half of clones.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function(s) {
      return s + i.Clones.grow / 2;
    }
  };
}
function wx(l, i) {
  return {
    /**
     * Modifies passed translate value with a `peek` setting.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function(s) {
      if (l.settings.focusAt >= 0) {
        var o = i.Peek.value;
        return Hi(o) ? s - o.before : s - o;
      }
      return s;
    }
  };
}
function xx(l, i) {
  return {
    /**
     * Modifies passed translate value with index in the `focusAt` setting.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function(s) {
      var o = i.Gaps.value, f = i.Sizes.width, m = l.settings.focusAt, g = i.Sizes.slideWidth;
      return m === "center" ? s - (f / 2 - g / 2) : s - g * m - o * m;
    }
  };
}
function Ax(l, i, u) {
  var s = [Sx, Tx, wx, xx].concat(l._t, [bx]);
  return {
    /**
     * Piplines translate value with registered transformers.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    mutate: function(f) {
      for (var m = 0; m < s.length; m++) {
        var g = s[m];
        Vc(g) && Vc(g().modify) ? f = g(l, i, u).modify(f) : ya("Transformer should be a function that returns an object with `modify()` method");
      }
      return f;
    }
  };
}
function _x(l, i, u) {
  var s = {
    /**
     * Sets value of translate on HTML element.
     *
     * @param {Number} value
     * @return {Void}
     */
    set: function(f) {
      var m = Ax(l, i).mutate(f), g = "translate3d(".concat(-1 * m, "px, 0px, 0px)");
      i.Html.wrapper.style.mozTransform = g, i.Html.wrapper.style.webkitTransform = g, i.Html.wrapper.style.transform = g;
    },
    /**
     * Removes value of translate from HTML element.
     *
     * @return {Void}
     */
    remove: function() {
      i.Html.wrapper.style.transform = "";
    },
    /**
     * @return {number}
     */
    getStartIndex: function() {
      var f = i.Sizes.length, m = l.index, g = l.settings.perView;
      return i.Run.isOffset(">") || i.Run.isOffset("|>") ? f + (m - g) : (m + g) % f;
    },
    /**
     * @return {number}
     */
    getTravelDistance: function() {
      var f = i.Sizes.slideWidth * l.settings.perView;
      return i.Run.isOffset(">") || i.Run.isOffset("|>") ? f * -1 : f;
    }
  };
  return u.on("move", function(o) {
    if (!l.isType("carousel") || !i.Run.isOffset())
      return s.set(o.movement);
    i.Transition.after(function() {
      u.emit("translate.jump"), s.set(i.Sizes.slideWidth * l.index);
    });
    var f = i.Sizes.slideWidth * i.Translate.getStartIndex();
    return s.set(f - i.Translate.getTravelDistance());
  }), u.on("destroy", function() {
    s.remove();
  }), s;
}
function Ox(l, i, u) {
  var s = !1, o = {
    /**
     * Composes string of the CSS transition.
     *
     * @param {String} property
     * @return {String}
     */
    compose: function(m) {
      var g = l.settings;
      return s ? "".concat(m, " 0ms ").concat(g.animationTimingFunc) : "".concat(m, " ").concat(this.duration, "ms ").concat(g.animationTimingFunc);
    },
    /**
     * Sets value of transition on HTML element.
     *
     * @param {String=} property
     * @return {Void}
     */
    set: function() {
      var m = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "transform";
      i.Html.wrapper.style.transition = this.compose(m);
    },
    /**
     * Removes value of transition from HTML element.
     *
     * @return {Void}
     */
    remove: function() {
      i.Html.wrapper.style.transition = "";
    },
    /**
     * Runs callback after animation.
     *
     * @param  {Function} callback
     * @return {Void}
     */
    after: function(m) {
      setTimeout(function() {
        m();
      }, this.duration);
    },
    /**
     * Enable transition.
     *
     * @return {Void}
     */
    enable: function() {
      s = !1, this.set();
    },
    /**
     * Disable transition.
     *
     * @return {Void}
     */
    disable: function() {
      s = !0, this.set();
    }
  };
  return ie(o, "duration", {
    /**
     * Gets duration of the transition based
     * on currently running animation type.
     *
     * @return {Number}
     */
    get: function() {
      var m = l.settings;
      return l.isType("slider") && i.Run.offset ? m.rewindDuration : m.animationDuration;
    }
  }), u.on("move", function() {
    o.set();
  }), u.on(["build.before", "resize", "translate.jump"], function() {
    o.disable();
  }), u.on("run", function() {
    o.enable();
  }), u.on("destroy", function() {
    o.remove();
  }), o;
}
var dv = !1;
try {
  var Wg = Object.defineProperty({}, "passive", {
    get: function() {
      dv = !0;
    }
  });
  window.addEventListener("testPassive", null, Wg), window.removeEventListener("testPassive", null, Wg);
} catch {
}
var Jf = dv, Ac = ["touchstart", "mousedown"], Fg = ["touchmove", "mousemove"], Ig = ["touchend", "touchcancel", "mouseup", "mouseleave"], Pg = ["mousedown", "mousemove", "mouseup", "mouseleave"];
function Nx(l, i, u) {
  var s = new ll(), o = 0, f = 0, m = 0, g = !1, y = Jf ? {
    passive: !0
  } : !1, b = {
    /**
     * Initializes swipe bindings.
     *
     * @return {Void}
     */
    mount: function() {
      this.bindSwipeStart();
    },
    /**
     * Handler for `swipestart` event. Calculates entry points of the user's tap.
     *
     * @param {Object} event
     * @return {Void}
     */
    start: function(A) {
      if (!g && !l.disabled) {
        this.disable();
        var x = this.touches(A);
        o = null, f = Be(x.pageX), m = Be(x.pageY), this.bindSwipeMove(), this.bindSwipeEnd(), u.emit("swipe.start");
      }
    },
    /**
     * Handler for `swipemove` event. Calculates user's tap angle and distance.
     *
     * @param {Object} event
     */
    move: function(A) {
      if (!l.disabled) {
        var x = l.settings, U = x.touchAngle, D = x.touchRatio, R = x.classes, q = this.touches(A), Y = Be(q.pageX) - f, L = Be(q.pageY) - m, et = Math.abs(Y << 2), W = Math.abs(L << 2), X = Math.sqrt(et + W), B = Math.sqrt(W);
        if (o = Math.asin(B / X), o * 180 / Math.PI < U)
          A.stopPropagation(), i.Move.make(Y * ex(D)), i.Html.root.classList.add(R.dragging), u.emit("swipe.move");
        else
          return !1;
      }
    },
    /**
     * Handler for `swipeend` event. Finitializes user's tap and decides about glide move.
     *
     * @param {Object} event
     * @return {Void}
     */
    end: function(A) {
      if (!l.disabled) {
        var x = l.settings, U = x.perSwipe, D = x.touchAngle, R = x.classes, q = this.touches(A), Y = this.threshold(A), L = q.pageX - f, et = o * 180 / Math.PI;
        this.enable(), L > Y && et < D ? i.Run.make(i.Direction.resolve("".concat(U, "<"))) : L < -Y && et < D ? i.Run.make(i.Direction.resolve("".concat(U, ">"))) : i.Move.make(), i.Html.root.classList.remove(R.dragging), this.unbindSwipeMove(), this.unbindSwipeEnd(), u.emit("swipe.end");
      }
    },
    /**
     * Binds swipe's starting event.
     *
     * @return {Void}
     */
    bindSwipeStart: function() {
      var A = this, x = l.settings, U = x.swipeThreshold, D = x.dragThreshold;
      U && s.on(Ac[0], i.Html.wrapper, function(R) {
        A.start(R);
      }, y), D && s.on(Ac[1], i.Html.wrapper, function(R) {
        A.start(R);
      }, y);
    },
    /**
     * Unbinds swipe's starting event.
     *
     * @return {Void}
     */
    unbindSwipeStart: function() {
      s.off(Ac[0], i.Html.wrapper, y), s.off(Ac[1], i.Html.wrapper, y);
    },
    /**
     * Binds swipe's moving event.
     *
     * @return {Void}
     */
    bindSwipeMove: function() {
      var A = this;
      s.on(Fg, i.Html.wrapper, Pc(function(x) {
        A.move(x);
      }, l.settings.throttle), y);
    },
    /**
     * Unbinds swipe's moving event.
     *
     * @return {Void}
     */
    unbindSwipeMove: function() {
      s.off(Fg, i.Html.wrapper, y);
    },
    /**
     * Binds swipe's ending event.
     *
     * @return {Void}
     */
    bindSwipeEnd: function() {
      var A = this;
      s.on(Ig, i.Html.wrapper, function(x) {
        A.end(x);
      });
    },
    /**
     * Unbinds swipe's ending event.
     *
     * @return {Void}
     */
    unbindSwipeEnd: function() {
      s.off(Ig, i.Html.wrapper);
    },
    /**
     * Normalizes event touches points accorting to different types.
     *
     * @param {Object} event
     */
    touches: function(A) {
      return Pg.indexOf(A.type) > -1 ? A : A.touches[0] || A.changedTouches[0];
    },
    /**
     * Gets value of minimum swipe distance settings based on event type.
     *
     * @return {Number}
     */
    threshold: function(A) {
      var x = l.settings;
      return Pg.indexOf(A.type) > -1 ? x.dragThreshold : x.swipeThreshold;
    },
    /**
     * Enables swipe event.
     *
     * @return {self}
     */
    enable: function() {
      return g = !1, i.Transition.enable(), this;
    },
    /**
     * Disables swipe event.
     *
     * @return {self}
     */
    disable: function() {
      return g = !0, i.Transition.disable(), this;
    }
  };
  return u.on("build.after", function() {
    i.Html.root.classList.add(l.settings.classes.swipeable);
  }), u.on("destroy", function() {
    b.unbindSwipeStart(), b.unbindSwipeMove(), b.unbindSwipeEnd(), s.destroy();
  }), b;
}
function Ex(l, i, u) {
  var s = new ll(), o = {
    /**
     * Binds listener to glide wrapper.
     *
     * @return {Void}
     */
    mount: function() {
      this.bind();
    },
    /**
     * Binds `dragstart` event on wrapper to prevent dragging images.
     *
     * @return {Void}
     */
    bind: function() {
      s.on("dragstart", i.Html.wrapper, this.dragstart);
    },
    /**
     * Unbinds `dragstart` event on wrapper.
     *
     * @return {Void}
     */
    unbind: function() {
      s.off("dragstart", i.Html.wrapper);
    },
    /**
     * Event handler. Prevents dragging.
     *
     * @return {Void}
     */
    dragstart: function(m) {
      m.preventDefault();
    }
  };
  return u.on("destroy", function() {
    o.unbind(), s.destroy();
  }), o;
}
function jx(l, i, u) {
  var s = new ll(), o = !1, f = !1, m = {
    /**
     * Setups a initial state of anchors component.
     *
     * @returns {Void}
     */
    mount: function() {
      this._a = i.Html.wrapper.querySelectorAll("a"), this.bind();
    },
    /**
     * Binds events to anchors inside a track.
     *
     * @return {Void}
     */
    bind: function() {
      s.on("click", i.Html.wrapper, this.click);
    },
    /**
     * Unbinds events attached to anchors inside a track.
     *
     * @return {Void}
     */
    unbind: function() {
      s.off("click", i.Html.wrapper);
    },
    /**
     * Handler for click event. Prevents clicks when glide is in `prevent` status.
     *
     * @param  {Object} event
     * @return {Void}
     */
    click: function(y) {
      f && (y.stopPropagation(), y.preventDefault());
    },
    /**
     * Detaches anchors click event inside glide.
     *
     * @return {self}
     */
    detach: function() {
      if (f = !0, !o) {
        for (var y = 0; y < this.items.length; y++)
          this.items[y].draggable = !1;
        o = !0;
      }
      return this;
    },
    /**
     * Attaches anchors click events inside glide.
     *
     * @return {self}
     */
    attach: function() {
      if (f = !1, o) {
        for (var y = 0; y < this.items.length; y++)
          this.items[y].draggable = !0;
        o = !1;
      }
      return this;
    }
  };
  return ie(m, "items", {
    /**
     * Gets collection of the arrows HTML elements.
     *
     * @return {HTMLElement[]}
     */
    get: function() {
      return m._a;
    }
  }), u.on("swipe.move", function() {
    m.detach();
  }), u.on("swipe.end", function() {
    i.Transition.after(function() {
      m.attach();
    });
  }), u.on("destroy", function() {
    m.attach(), m.unbind(), s.destroy();
  }), m;
}
var Rx = '[data-glide-el="controls[nav]"]', hd = '[data-glide-el^="controls"]', Cx = "".concat(hd, ' [data-glide-dir*="<"]'), Dx = "".concat(hd, ' [data-glide-dir*=">"]');
function zx(l, i, u) {
  var s = new ll(), o = Jf ? {
    passive: !0
  } : !1, f = {
    /**
     * Inits arrows. Binds events listeners
     * to the arrows HTML elements.
     *
     * @return {Void}
     */
    mount: function() {
      this._n = i.Html.root.querySelectorAll(Rx), this._c = i.Html.root.querySelectorAll(hd), this._arrowControls = {
        previous: i.Html.root.querySelectorAll(Cx),
        next: i.Html.root.querySelectorAll(Dx)
      }, this.addBindings();
    },
    /**
     * Sets active class to current slide.
     *
     * @return {Void}
     */
    setActive: function() {
      for (var g = 0; g < this._n.length; g++)
        this.addClass(this._n[g].children);
    },
    /**
     * Removes active class to current slide.
     *
     * @return {Void}
     */
    removeActive: function() {
      for (var g = 0; g < this._n.length; g++)
        this.removeClass(this._n[g].children);
    },
    /**
     * Toggles active class on items inside navigation.
     *
     * @param  {HTMLElement} controls
     * @return {Void}
     */
    addClass: function(g) {
      var y = l.settings, b = g[l.index];
      b && (b.classList.add(y.classes.nav.active), fv(b).forEach(function(T) {
        T.classList.remove(y.classes.nav.active);
      }));
    },
    /**
     * Removes active class from active control.
     *
     * @param  {HTMLElement} controls
     * @return {Void}
     */
    removeClass: function(g) {
      var y = g[l.index];
      y == null || y.classList.remove(l.settings.classes.nav.active);
    },
    /**
     * Calculates, removes or adds `Glide.settings.classes.disabledArrow` class on the control arrows
     */
    setArrowState: function() {
      if (!l.settings.rewind) {
        var g = f._arrowControls.next, y = f._arrowControls.previous;
        this.resetArrowState(g, y), l.index === 0 && this.disableArrow(y), l.index === i.Run.length && this.disableArrow(g);
      }
    },
    /**
     * Removes `Glide.settings.classes.disabledArrow` from given NodeList elements
     *
     * @param {NodeList[]} lists
     */
    resetArrowState: function() {
      for (var g = l.settings, y = arguments.length, b = new Array(y), T = 0; T < y; T++)
        b[T] = arguments[T];
      b.forEach(function(A) {
        $f(A).forEach(function(x) {
          x.classList.remove(g.classes.arrow.disabled);
        });
      });
    },
    /**
     * Adds `Glide.settings.classes.disabledArrow` to given NodeList elements
     *
     * @param {NodeList[]} lists
     */
    disableArrow: function() {
      for (var g = l.settings, y = arguments.length, b = new Array(y), T = 0; T < y; T++)
        b[T] = arguments[T];
      b.forEach(function(A) {
        $f(A).forEach(function(x) {
          x.classList.add(g.classes.arrow.disabled);
        });
      });
    },
    /**
     * Adds handles to the each group of controls.
     *
     * @return {Void}
     */
    addBindings: function() {
      for (var g = 0; g < this._c.length; g++)
        this.bind(this._c[g].children);
    },
    /**
     * Removes handles from the each group of controls.
     *
     * @return {Void}
     */
    removeBindings: function() {
      for (var g = 0; g < this._c.length; g++)
        this.unbind(this._c[g].children);
    },
    /**
     * Binds events to arrows HTML elements.
     *
     * @param {HTMLCollection} elements
     * @return {Void}
     */
    bind: function(g) {
      for (var y = 0; y < g.length; y++)
        s.on("click", g[y], this.click), s.on("touchstart", g[y], this.click, o);
    },
    /**
     * Unbinds events binded to the arrows HTML elements.
     *
     * @param {HTMLCollection} elements
     * @return {Void}
     */
    unbind: function(g) {
      for (var y = 0; y < g.length; y++)
        s.off(["click", "touchstart"], g[y]);
    },
    /**
     * Handles `click` event on the arrows HTML elements.
     * Moves slider in direction given via the
     * `data-glide-dir` attribute.
     *
     * @param {Object} event
     * @return {void}
     */
    click: function(g) {
      !Jf && g.type === "touchstart" && g.preventDefault();
      var y = g.currentTarget.getAttribute("data-glide-dir");
      i.Run.make(i.Direction.resolve(y));
    }
  };
  return ie(f, "items", {
    /**
     * Gets collection of the controls HTML elements.
     *
     * @return {HTMLElement[]}
     */
    get: function() {
      return f._c;
    }
  }), u.on(["mount.after", "move.after"], function() {
    f.setActive();
  }), u.on(["mount.after", "run"], function() {
    f.setArrowState();
  }), u.on("destroy", function() {
    f.removeBindings(), f.removeActive(), s.destroy();
  }), f;
}
function Mx(l, i, u) {
  var s = new ll(), o = {
    /**
     * Binds keyboard events on component mount.
     *
     * @return {Void}
     */
    mount: function() {
      l.settings.keyboard && this.bind();
    },
    /**
     * Adds keyboard press events.
     *
     * @return {Void}
     */
    bind: function() {
      s.on("keyup", document, this.press);
    },
    /**
     * Removes keyboard press events.
     *
     * @return {Void}
     */
    unbind: function() {
      s.off("keyup", document);
    },
    /**
     * Handles keyboard's arrows press and moving glide foward and backward.
     *
     * @param  {Object} event
     * @return {Void}
     */
    press: function(m) {
      var g = l.settings.perSwipe, y = {
        ArrowRight: ">",
        ArrowLeft: "<"
      };
      ["ArrowRight", "ArrowLeft"].includes(m.code) && i.Run.make(i.Direction.resolve("".concat(g).concat(y[m.code])));
    }
  };
  return u.on(["destroy", "update"], function() {
    o.unbind();
  }), u.on("update", function() {
    o.mount();
  }), u.on("destroy", function() {
    s.destroy();
  }), o;
}
function kx(l, i, u) {
  var s = new ll(), o = {
    /**
     * Initializes autoplaying and events.
     *
     * @return {Void}
     */
    mount: function() {
      this.enable(), this.start(), l.settings.hoverpause && this.bind();
    },
    /**
     * Enables autoplaying
     *
     * @returns {Void}
     */
    enable: function() {
      this._e = !0;
    },
    /**
     * Disables autoplaying.
     *
     * @returns {Void}
     */
    disable: function() {
      this._e = !1;
    },
    /**
     * Starts autoplaying in configured interval.
     *
     * @param {Boolean|Number} force Run autoplaying with passed interval regardless of `autoplay` settings
     * @return {Void}
     */
    start: function() {
      var m = this;
      this._e && (this.enable(), l.settings.autoplay && ov(this._i) && (this._i = setInterval(function() {
        m.stop(), i.Run.make(">"), m.start(), u.emit("autoplay");
      }, this.time)));
    },
    /**
     * Stops autorunning of the glide.
     *
     * @return {Void}
     */
    stop: function() {
      this._i = clearInterval(this._i);
    },
    /**
     * Stops autoplaying while mouse is over glide's area.
     *
     * @return {Void}
     */
    bind: function() {
      var m = this;
      s.on("mouseover", i.Html.root, function() {
        m._e && m.stop();
      }), s.on("mouseout", i.Html.root, function() {
        m._e && m.start();
      });
    },
    /**
     * Unbind mouseover events.
     *
     * @returns {Void}
     */
    unbind: function() {
      s.off(["mouseover", "mouseout"], i.Html.root);
    }
  };
  return ie(o, "time", {
    /**
     * Gets time period value for the autoplay interval. Prioritizes
     * times in `data-glide-autoplay` attrubutes over options.
     *
     * @return {Number}
     */
    get: function() {
      var m = i.Html.slides[l.index].getAttribute("data-glide-autoplay");
      return Be(m || l.settings.autoplay);
    }
  }), u.on(["destroy", "update"], function() {
    o.unbind();
  }), u.on(["run.before", "swipe.start", "update"], function() {
    o.stop();
  }), u.on(["pause", "destroy"], function() {
    o.disable(), o.stop();
  }), u.on(["run.after", "swipe.end"], function() {
    o.start();
  }), u.on(["play"], function() {
    o.enable(), o.start();
  }), u.on("update", function() {
    o.mount();
  }), u.on("destroy", function() {
    s.destroy();
  }), o;
}
function ty(l) {
  return Hi(l) ? ax(l) : (ya("Breakpoints option must be an object"), {});
}
function Lx(l, i, u) {
  var s = new ll(), o = l.settings, f = ty(o.breakpoints), m = Object.assign({}, o), g = {
    /**
     * Matches settings for currectly matching media breakpoint.
     *
     * @param {Object} points
     * @returns {Object}
     */
    match: function(b) {
      if (typeof window.matchMedia < "u") {
        for (var T in b)
          if (b.hasOwnProperty(T) && window.matchMedia("(max-width: ".concat(T, "px)")).matches)
            return b[T];
      }
      return m;
    }
  };
  return Object.assign(o, g.match(f)), s.on("resize", window, Pc(function() {
    l.settings = Kf(o, g.match(f));
  }, l.settings.throttle)), u.on("update", function() {
    f = ty(f), m = Object.assign({}, o);
  }), u.on("destroy", function() {
    s.off("resize", window);
  }), g;
}
var Bx = {
  // Required
  Html: sx,
  Translate: _x,
  Transition: Ox,
  Direction: vx,
  Peek: ox,
  Sizes: dx,
  Gaps: ux,
  Move: fx,
  Clones: mx,
  Resize: px,
  Build: hx,
  Run: rx,
  // Optional
  Swipe: Nx,
  Images: Ex,
  Anchors: jx,
  Controls: zx,
  Keyboard: Mx,
  Autoplay: kx,
  Breakpoints: Lx
}, Hx = /* @__PURE__ */ (function(l) {
  $w(u, l);
  var i = Iw(u);
  function u() {
    return Fc(this, u), i.apply(this, arguments);
  }
  return Ic(u, [{
    key: "mount",
    value: function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      return Mc(Bi(u.prototype), "mount", this).call(this, Object.assign({}, Bx, o));
    }
  }]), u;
})(ix);
function Ux(l) {
  let i, u, s;
  switch (l) {
    case 3:
      i = 1, u = 2, s = 3;
      break;
    case 2:
      i = 1, u = 2, s = 2;
      break;
    case 1:
    default:
      i = 1, u = 1, s = 1;
  }
  return {
    perViewSm: i,
    perViewMd: u,
    perViewLg: s
  };
}
function qx(l = 1, i, u = !0, s) {
  const { perViewSm: o, perViewMd: f, perViewLg: m } = Ux(l), g = u ? 24 : 0, y = u ? { before: 48, after: 48 } : 0, b = u ? { before: 124, after: 124 } : 0;
  return {
    type: "slider",
    // No wrap-around.
    focusAt: 0,
    bound: !0,
    // Only if type slider with focusAt 0
    rewind: !1,
    // Only if type slider
    gap: g,
    // Space between slides... may be impacted by viewport size.
    // `keyboard` Left/Right arrow key support for slides - true is default.
    // Is not fully Accessible, on keydown allcarousels move simultaneously
    // A custome keyboard handler is implemented
    keyboard: !1,
    startAt: 0,
    swipeThreshold: 80,
    // Distance required for swipe to change slide.
    dragThreshold: s ? 120 : !1,
    // Distance for mouse drag to change slide.
    perTouch: 1,
    // Number of slides that can be moved per each swipe/drag.
    perView: m,
    // Can be overwritten at breakpoints
    peek: b,
    // Can be overwritten at breakpoints
    // if isFullWidth = true, then we have only 1 image per view which takes the full width.
    // no need for breakpoints
    breakpoints: i ? null : {
      576: {
        // BS4 sm
        perView: o,
        peek: y
      },
      768: {
        // BS4 md
        perView: f,
        peek: y
      },
      992: {
        // BS4 lg
        perView: m,
        peek: y
      },
      1260: {
        // BS4 xl
        perView: m,
        peek: y
      },
      1400: {
        perView: m,
        peek: b
      },
      1920: {
        perView: m,
        peek: b
      }
    }
  };
}
function Vx(l, i, u) {
  const s = l.querySelector(".glide__arrow--prev"), o = l.querySelector(".glide__arrow--next"), f = l.querySelector(".glide__track"), m = l.querySelector(
    ".image-navigator-images"
  );
  if (!(s || o)) return;
  const g = ["slider-start", "slider-mid", "slider-end"], y = "glide__arrow--disabled";
  f == null || f.classList.remove(...g), m == null || m.classList.remove(...g), i === 0 ? (f == null || f.classList.add("slider-start"), m == null || m.classList.add("slider-start"), s == null || s.classList.add(y), s == null || s.setAttribute("aria-disabled", "true"), o == null || o.classList.remove(y), o == null || o.setAttribute("aria-disabled", "false")) : i >= u - 1 ? (f == null || f.classList.add("slider-end"), m == null || m.classList.add("slider-end"), s == null || s.classList.remove(y), s == null || s.setAttribute("aria-disabled", "false"), o == null || o.classList.add(y), o == null || o.setAttribute("aria-disabled", "true")) : (f == null || f.classList.add("slider-mid"), m == null || m.classList.add("slider-mid"), s == null || s.classList.remove(y), o == null || o.classList.remove(y), s == null || s.setAttribute("aria-disabled", "false"), o == null || o.setAttribute("aria-disabled", "false"));
}
function Yx(l, i, u) {
  const s = l.querySelectorAll(".glide__slide"), o = i, f = Math.min(
    s.length - 1,
    i + u - 1
  );
  s.forEach((m, g) => {
    g < o || g > f ? (m.setAttribute("aria-hidden", "true"), m.setAttribute("tabindex", "-1"), m.setAttribute("inert", "")) : (m.setAttribute("aria-hidden", "false"), m.removeAttribute("tabindex"), m.removeAttribute("inert"));
  });
}
function Gx({
  instanceName: l,
  perView: i,
  buttonCount: u,
  isFullWidth: s = !1,
  onItemClick: o,
  hasPeek: f = !0,
  isDraggable: m
}) {
  const g = qx(i, s, f, m), y = new Hx(`#${l}`, g);
  let b = document.querySelector(`#${l}`);
  return b.addEventListener("keyup", (T) => {
    const A = T;
    A.keyCode === 39 ? y.go(">") : A.keyCode === 37 ? y.go("<") : A.keyCode === 13 && y.go(document.activeElement.dataset.glideDir);
  }), y.on("build.before", () => {
    b = document.querySelector(`#${l}`), b && b.classList.add("slider-start");
  }), y.on("move", () => {
    if (b = document.querySelector(`#${l}`), !b) return;
    const T = y.index;
    Yx(b, T, i);
    const A = b.querySelector(".navigation-slider"), x = b.querySelector(".image-navigator-images");
    if (A && x) {
      const U = A.querySelectorAll(
        ".bullet-image-container"
      ), D = A.clientWidth, R = 82, q = U[T], Y = x.getBoundingClientRect().x, L = A.getBoundingClientRect().x - Y, et = q.getBoundingClientRect().x - Y, W = q.getBoundingClientRect().x + q.getBoundingClientRect().width - Y;
      if (T === 0 || et <= 0 + R)
        A.style.left = `${L - et + R}px`;
      else if (W >= D - R) {
        const X = W - D;
        A.style.left = `${L - X - R}px`;
      }
    }
    Vx(b, T, u), b.setAttribute("data-current-index", T), o && o(T);
  }), y.mount(), y;
}
function Xx(l, i) {
  let u;
  const s = Math.max(
    document.documentElement.clientWidth || 0,
    window.innerWidth || 0
  );
  return u = l, s >= 992 && (i >= 2 && (u = l - 1), i >= 3 && (u = l - 2)), u;
}
const eu = ({
  perView: l = 1,
  width: i,
  maxWidth: u,
  carouselItems: s,
  cssClass: o = "",
  CustomNavComponent: f,
  role: m,
  ariaLabelledBy: g,
  isFullWidth: y,
  removeSideBackground: b = !1,
  hasNavButtons: T = !0,
  hasPositionIndicators: A = !0,
  imageAutoSize: x = !0,
  onItemClick: U = () => null,
  hasPeek: D = !0,
  isDraggable: R = !0,
  hasShadow: q = !0
}) => {
  const Y = `glide-${Math.ceil(Math.random() * 1e4)}`, L = Xx(s.length, l);
  return Qe(() => {
    Gx({
      instanceName: Y,
      perView: l,
      buttonCount: L,
      isFullWidth: y,
      onItemClick: U,
      hasPeek: D,
      isDraggable: R
    });
  }, [
    Y,
    l,
    L,
    y,
    U,
    D,
    R
  ]), /* @__PURE__ */ h.jsxs(
    "div",
    {
      role: m,
      "aria-labelledby": g,
      className: `glide ${o}`,
      id: Y,
      style: { width: i, maxWidth: u },
      "data-remove-side-background": b,
      "data-image-auto-size": x,
      "data-has-shadow": q,
      children: [
        /* @__PURE__ */ h.jsx("div", { className: "glide__track", "data-glide-el": "track", children: /* @__PURE__ */ h.jsx(sv, { carouselItems: s }) }),
        f ? (
          // @ts-ignore
          /* @__PURE__ */ h.jsx(f, { instanceName: Y })
        ) : /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
          A && /* @__PURE__ */ h.jsx(rv, { buttonCount: L }),
          T && /* @__PURE__ */ h.jsx(cv, {})
        ] })
      ]
    }
  );
};
eu.propTypes = {
  perView: p.number,
  width: p.string,
  maxWidth: p.string,
  carouselItems: p.arrayOf(p.object).isRequired,
  cssClass: p.string,
  CustomNavComponent: p.func,
  role: p.string,
  ariaLabelledBy: p.string,
  onItemClick: p.func,
  isFullWidth: p.bool,
  removeSideBackground: p.bool,
  hasNavButtons: p.bool,
  hasPositionIndicators: p.bool,
  imageAutoSize: p.bool,
  hasPeek: p.bool,
  isDraggable: p.bool,
  hasShadow: p.bool
};
const Qx = ({
  id: l,
  imageSource: i,
  imageAltText: u,
  title: s,
  content: o,
  eventLocation: f,
  eventTime: m,
  buttons: g,
  linkLabel: y,
  linkUrl: b,
  tags: T
}, A, x, U) => {
  var D, R;
  return {
    // @ts-ignore
    id: l,
    item: /* @__PURE__ */ h.jsx(
      ga,
      {
        type: A,
        horizontal: x,
        image: i,
        imageAltText: u,
        title: s,
        body: o,
        eventFormat: U,
        eventLocation: f,
        eventTime: m,
        buttons: g,
        linkLabel: y,
        linkUrl: b || ((D = g == null ? void 0 : g[0]) == null ? void 0 : D.href),
        tags: T,
        cardLink: b || ((R = g == null ? void 0 : g[0]) == null ? void 0 : R.href)
      }
    )
  };
}, hv = ({
  perView: l = 0,
  cardItems: i = [],
  cardType: u = "default",
  cardEventFormat: s = "stack",
  cardHorizontal: o = !1,
  width: f = void 0,
  maxWidth: m = void 0,
  imageAutoSize: g = !0
}) => {
  const y = parseInt(`${l}`, 10), [b, T] = ve(y), A = 1024, x = 768;
  Qe(() => {
    const R = () => {
      const q = window.innerWidth;
      let Y;
      switch (y) {
        case 3:
          q > A ? Y = 3 : q > x ? Y = 2 : Y = 1;
          break;
        case 2:
          Y = q < x ? 1 : 2;
          break;
        default:
          Y = 1;
          break;
      }
      T(Y);
    };
    return R(), window.addEventListener("resize", R), () => window.removeEventListener("resize", R);
  }, [y]);
  const U = i.map(
    (R) => Qx(R, u, o, s)
  ), D = i.length > b;
  return /* @__PURE__ */ h.jsx(
    eu,
    {
      perView: +b,
      maxWidth: m,
      width: f,
      carouselItems: U,
      cssClass: "aligned-carousel",
      imageAutoSize: g,
      removeSideBackground: i.length <= b,
      hasPositionIndicators: D,
      hasNavButtons: D,
      isDraggable: D,
      hasShadow: !0
    }
  );
};
hv.propTypes = {
  perView: p.string.isRequired,
  cardItems: p.arrayOf(
    p.shape({
      title: p.string.isRequired,
      content: p.string,
      eventLocation: p.string,
      eventTime: p.string,
      image: p.string,
      imageAltText: p.string,
      buttons: ga.propTypes.buttons,
      linkLabel: p.string,
      linkUrl: p.string,
      tags: ga.propTypes.tags
    })
  ).isRequired,
  cardType: ga.propTypes.type,
  cardEventFormat: ga.propTypes.eventFormat,
  cardHorizontal: ga.propTypes.horizontal,
  width: p.string,
  maxWidth: p.string,
  imageAutoSize: p.bool
};
const Zx = ({ id: l, imageSource: i, imageAltText: u, title: s, content: o }) => ({
  // @ts-ignore
  id: l,
  item: /* @__PURE__ */ h.jsx("div", { className: "uds-img", children: /* @__PURE__ */ h.jsxs("figure", { className: "figure uds-figure", children: [
    /* @__PURE__ */ h.jsx(
      "img",
      {
        src: i,
        className: "uds-img figure-img img-fluid",
        alt: u,
        loading: "lazy",
        decoding: "async"
      }
    ),
    (s || o) && /* @__PURE__ */ h.jsx(
      "figcaption",
      {
        className: "figure-caption uds-figure-caption",
        "data-testid": "image-content-container",
        children: /* @__PURE__ */ h.jsx("div", { className: "uds-caption-text", children: s ? /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
          /* @__PURE__ */ h.jsx("h2", { children: s }),
          /* @__PURE__ */ h.jsx("div", { dangerouslySetInnerHTML: { __html: o } })
        ] }) : /* @__PURE__ */ h.jsx("div", { dangerouslySetInnerHTML: { __html: o } }) })
      }
    )
  ] }) })
}), mv = ({
  perView: l = 0,
  imageItems: i = [],
  width: u = void 0,
  maxWidth: s = void 0,
  imageAutoSize: o = !0
}) => {
  if (!i || i.length === 0)
    return null;
  const f = parseInt(`${l}`, 10), m = i.map(Zx) || [], g = i.length > f;
  return /* @__PURE__ */ h.jsx(
    eu,
    {
      perView: +f,
      maxWidth: s,
      width: u,
      cssClass: "image-carousel aligned-carousel",
      carouselItems: m,
      imageAutoSize: o,
      removeSideBackground: i.length <= f,
      hasPositionIndicators: g,
      hasNavButtons: g,
      isDraggable: g,
      hasShadow: !0
    }
  );
};
mv.propTypes = {
  perView: p.number.isRequired,
  imageItems: p.arrayOf(p.object).isRequired,
  width: p.string,
  maxWidth: p.string,
  imageAutoSize: p.bool
};
const Kx = (l, i) => {
  if (!l)
    return 0;
  const u = (l.match(/<br/g) || []).length, s = i / 6;
  return (parseInt(`${l.length / s}`, 10) + u) * 20;
}, Yc = {
  imageItems: p.arrayOf(
    p.shape({
      id: p.number,
      imageSource: p.string,
      thumbnailSource: p.string,
      imageAltText: p.string,
      content: p.oneOfType([p.string, p.element])
    })
  ),
  hasContent: p.bool
}, $x = ({ id: l, imageSource: i, imageAltText: u }) => ({
  // @ts-ignore
  id: l,
  item: /* @__PURE__ */ h.jsx("div", { className: "uds-img", children: /* @__PURE__ */ h.jsx(
    "img",
    {
      src: i,
      className: "uds-img figure-img img-fluid",
      alt: u,
      loading: "lazy",
      decoding: "async"
    }
  ) })
}), pv = ({ instanceName: l, imageItems: i, hasContent: u }) => {
  var T, A;
  const s = "data-current-index", [o, f] = ve(((T = i == null ? void 0 : i[0]) == null ? void 0 : T.title) || ""), [m, g] = ve(((A = i == null ? void 0 : i[0]) == null ? void 0 : A.content) || ""), y = kl(
    (x) => {
      const U = i == null ? void 0 : i[x];
      U && (f(U.title), g(U.content));
    },
    [i]
  );
  if (Qe(() => {
    if (!i || i.length === 0)
      return;
    const x = document.querySelector(
      ".image-gallery figcaption .uds-caption-text div"
    );
    if (x) {
      const q = parseInt(
        window.getComputedStyle(x, null).getPropertyValue("width").split("px")[0],
        10
      ), Y = i.reduce((L, et) => {
        const W = Kx(et.content, q);
        return W > L ? W : L;
      }, 0);
      x.style.height = `${Y}px`;
    }
    const U = document.querySelector(`#${l}`);
    if (!U)
      return;
    function D(q) {
      for (const Y of q)
        if (Y && Y.attributeName === s) {
          const L = U.getAttribute(s);
          L !== null && y(+L);
          return;
        }
    }
    const R = new MutationObserver(D);
    return R.observe(U, {
      attributes: !0
    }), () => {
      R.disconnect();
    };
  }, [l, i, y]), !i || i.length === 0)
    return null;
  const b = i.map((x) => x.imageSource);
  return /* @__PURE__ */ h.jsxs("div", { className: "image-gallery-action-area", "data-has-content": u, children: [
    /* @__PURE__ */ h.jsx("div", { className: "image-navigator", children: /* @__PURE__ */ h.jsxs(dd, { children: [
      /* @__PURE__ */ h.jsx(fd, {}),
      /* @__PURE__ */ h.jsx("div", { className: "image-navigator-images", children: /* @__PURE__ */ h.jsx("div", { className: "navigation-slider", children: /* @__PURE__ */ h.jsx(
        uv,
        {
          imageItems: b,
          onItemClick: (x) => y(x)
        }
      ) }) }),
      /* @__PURE__ */ h.jsx(od, {})
    ] }) }),
    u && (o || m) ? /* @__PURE__ */ h.jsx(
      "figcaption",
      {
        id: "caption",
        className: "figure-caption uds-figure-caption",
        "data-testid": "image-gallery-content-container",
        children: /* @__PURE__ */ h.jsxs("div", { className: "uds-caption-text", children: [
          o ? /* @__PURE__ */ h.jsx("h2", { children: o }) : null,
          /* @__PURE__ */ h.jsx("div", { dangerouslySetInnerHTML: { __html: m } })
        ] })
      }
    ) : null
  ] });
};
pv.propTypes = {
  instanceName: p.string,
  imageItems: Yc.imageItems,
  hasContent: Yc.hasContent
};
const gv = ({
  width: l,
  maxWidth: i,
  imageItems: u = [],
  hasContent: s = !1,
  imageAutoSize: o = !0
}) => {
  const f = u.map($x), m = u.length > 1;
  return /* @__PURE__ */ h.jsx(
    eu,
    {
      perView: 1,
      maxWidth: i,
      width: l,
      carouselItems: f,
      cssClass: "image-gallery",
      role: "figure",
      ariaLabelledBy: s ? "caption" : null,
      isFullWidth: !0,
      imageAutoSize: o,
      hasPeek: !1,
      CustomNavComponent: ({ instanceName: g }) => /* @__PURE__ */ h.jsx(
        pv,
        {
          instanceName: g,
          hasContent: s,
          imageItems: u
        }
      ),
      removeSideBackground: u.length <= 1,
      hasPositionIndicators: m,
      hasNavButtons: m,
      isDraggable: m,
      hasShadow: !0
    }
  );
};
gv.propTypes = {
  imageItems: Yc.imageItems.isRequired,
  hasContent: Yc.hasContent,
  width: p.string,
  maxWidth: p.string,
  imageAutoSize: p.bool
};
const Jx = ({ id: l, imageSource: i, imageAltText: u, quote: s }, o = {}) => ({
  // @ts-ignore
  id: l,
  item: /* @__PURE__ */ h.jsx(
    cd,
    {
      imageSource: i,
      imageAltText: u,
      quote: s,
      itemStyle: o
    }
  )
}), yv = ({
  width: l,
  maxWidth: i,
  testimonialItems: u = [],
  itemStyle: s = {},
  hasNavButtons: o = !1,
  hasPositionIndicators: f = !1,
  imageAutoSize: m = !0
}) => {
  const g = u.map(
    (y) => Jx(y, s)
  );
  return /* @__PURE__ */ h.jsx(
    eu,
    {
      perView: 1,
      maxWidth: i,
      width: l,
      carouselItems: g,
      isFullWidth: !0,
      removeSideBackground: !0,
      hasNavButtons: o,
      hasPositionIndicators: f,
      imageAutoSize: m,
      hasPeek: !1,
      hasShadow: !1
    }
  );
};
yv.propTypes = {
  testimonialItems: p.arrayOf(
    p.shape({
      title: p.string,
      content: p.string,
      cite: p.shape({
        name: p.string,
        description: p.string
      })
    })
  ).isRequired,
  itemStyle: p.shape({
    containerCssClass: p.arrayOf(p.string),
    titleCssClass: p.arrayOf(p.string),
    contentCssClass: p.arrayOf(p.string)
  }),
  width: p.string,
  maxWidth: p.string,
  imageAutoSize: p.bool,
  hasNavButtons: p.bool,
  hasPositionIndicators: p.bool
};
var Xn = /* @__PURE__ */ ((l) => (l.UNORDERED = "unordered", l.ORDERED = "ordered", l.ICON = "icon", l.STEP = "step", l.DISPLAY = "display", l))(Xn || {}), kc = /* @__PURE__ */ ((l) => (l.UL = "ul", l.OL = "ol", l))(kc || {}), Cl = /* @__PURE__ */ ((l) => (l.NONE = "none", l.LIGHT = "light", l.MEDIUM = "medium", l.DARK = "dark", l))(Cl || {}), Lc = /* @__PURE__ */ ((l) => (l.DEFAULT = "default", l.PRIMARY = "primary", l.SECONDARY = "secondary", l))(Lc || {});
const vv = (l) => {
  switch (l) {
    case kc.OL:
    case Xn.ORDERED:
    case Xn.STEP:
      return kc.OL;
    default:
      return kc.UL;
  }
}, bv = ({
  listType: l,
  content: i,
  icon: u,
  nestedType: s,
  nestedItems: o
}) => {
  const [f, ...m] = Array.isArray(i) ? i : [i];
  let g = null;
  if (o != null && o.length) {
    const y = s || l, b = vv(y);
    g = /* @__PURE__ */ h.jsx(b, { children: o.map((T, A) => /* @__PURE__ */ h.jsx(bv, { listType: y, ...T }, A)) });
  }
  return /* @__PURE__ */ h.jsxs("li", { children: [
    u && /* @__PURE__ */ h.jsx("span", { className: `fa-li ${u == null ? void 0 : u[0]} fa-${u == null ? void 0 : u[1]}` }),
    f,
    " ",
    m.map((y, b) => [/* @__PURE__ */ h.jsx("br", {}, `br-${b}`), /* @__PURE__ */ h.jsx("span", { children: y }, b)]),
    g
  ] });
}, Wx = ({
  listType: l = Xn.UNORDERED,
  backgroundColor: i = Cl.NONE,
  listItemStyleColor: u = Lc.DEFAULT,
  items: s
}) => {
  const o = vv(l);
  let f = "maroon", m = "maroon";
  i === Cl.DARK && (f = "gold", m = "gold"), l === Xn.STEP && (f = "uds-steplist-maroon", m = "uds-steplist-gold", i === Cl.DARK && (f = "uds-steplist-gold"));
  const g = Rt({
    "uds-list": l === Xn.UNORDERED || l === Xn.ORDERED,
    "uds-list fa-ul": l === Xn.ICON,
    "uds-list uds-steplist": l === Xn.STEP,
    "uds-list uds-display-list": l === Xn.DISPLAY,
    "light-smokemode": i === Cl.LIGHT,
    smokemode: i === Cl.MEDIUM,
    darkmode: i === Cl.DARK,
    [`${f}`]: u === Lc.PRIMARY,
    // Intentional space ` ${secondaryColor}` for when primary and secondary colors are the same
    [` ${m}`]: u === Lc.SECONDARY
  });
  return /* @__PURE__ */ h.jsx(o, { className: g || null, children: s.map((y, b) => /* @__PURE__ */ h.jsx(bv, { listType: l, ...y }, b)) });
}, Fx = {
  none: "",
  gold: "text-gold",
  white: "text-white"
}, Ix = {
  name: "onclick",
  event: "link",
  action: "click",
  type: "internal link",
  region: "main content"
}, Px = ({
  gridLinkItems: l,
  numColumns: i,
  textColor: u,
  children: s
}) => /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
  /* @__PURE__ */ h.jsx(
    "div",
    {
      className: [
        "uds-grid-links",
        i,
        Fx[u]
      ].join(" "),
      children: l && l.map((o) => /* @__PURE__ */ h.jsx(
        be,
        {
          gaData: {
            ...Ix,
            text: o.label,
            section: `grid links ${o.label}`
          },
          children: /* @__PURE__ */ h.jsxs("a", { href: o.href, children: [
            /* @__PURE__ */ h.jsx("span", { className: `fa fa-fw ${o.icon}` }),
            o.label
          ] })
        },
        o.label + o.href
      ))
    }
  ),
  /* @__PURE__ */ h.jsx("div", { children: s })
] });
var Rf = { exports: {} }, Qr = {}, Cf = { exports: {} }, Df = {};
var ey;
function tA() {
  return ey || (ey = 1, (function(l) {
    function i(Q, V) {
      var $ = Q.length;
      Q.push(V);
      t: for (; 0 < $; ) {
        var J = $ - 1 >>> 1, tt = Q[J];
        if (0 < o(tt, V))
          Q[J] = V, Q[$] = tt, $ = J;
        else break t;
      }
    }
    function u(Q) {
      return Q.length === 0 ? null : Q[0];
    }
    function s(Q) {
      if (Q.length === 0) return null;
      var V = Q[0], $ = Q.pop();
      if ($ !== V) {
        Q[0] = $;
        t: for (var J = 0, tt = Q.length, lt = tt >>> 1; J < lt; ) {
          var vt = 2 * (J + 1) - 1, ct = Q[vt], at = vt + 1, ot = Q[at];
          if (0 > o(ct, $))
            at < tt && 0 > o(ot, ct) ? (Q[J] = ot, Q[at] = $, J = at) : (Q[J] = ct, Q[vt] = $, J = vt);
          else if (at < tt && 0 > o(ot, $))
            Q[J] = ot, Q[at] = $, J = at;
          else break t;
        }
      }
      return V;
    }
    function o(Q, V) {
      var $ = Q.sortIndex - V.sortIndex;
      return $ !== 0 ? $ : Q.id - V.id;
    }
    if (l.unstable_now = void 0, typeof performance == "object" && typeof performance.now == "function") {
      var f = performance;
      l.unstable_now = function() {
        return f.now();
      };
    } else {
      var m = Date, g = m.now();
      l.unstable_now = function() {
        return m.now() - g;
      };
    }
    var y = [], b = [], T = 1, A = null, x = 3, U = !1, D = !1, R = !1, q = !1, Y = typeof setTimeout == "function" ? setTimeout : null, L = typeof clearTimeout == "function" ? clearTimeout : null, et = typeof setImmediate < "u" ? setImmediate : null;
    function W(Q) {
      for (var V = u(b); V !== null; ) {
        if (V.callback === null) s(b);
        else if (V.startTime <= Q)
          s(b), V.sortIndex = V.expirationTime, i(y, V);
        else break;
        V = u(b);
      }
    }
    function X(Q) {
      if (R = !1, W(Q), !D)
        if (u(y) !== null)
          D = !0, B || (B = !0, Nt());
        else {
          var V = u(b);
          V !== null && Zt(X, V.startTime - Q);
        }
    }
    var B = !1, G = -1, F = 5, ut = -1;
    function yt() {
      return q ? !0 : !(l.unstable_now() - ut < F);
    }
    function Dt() {
      if (q = !1, B) {
        var Q = l.unstable_now();
        ut = Q;
        var V = !0;
        try {
          t: {
            D = !1, R && (R = !1, L(G), G = -1), U = !0;
            var $ = x;
            try {
              e: {
                for (W(Q), A = u(y); A !== null && !(A.expirationTime > Q && yt()); ) {
                  var J = A.callback;
                  if (typeof J == "function") {
                    A.callback = null, x = A.priorityLevel;
                    var tt = J(
                      A.expirationTime <= Q
                    );
                    if (Q = l.unstable_now(), typeof tt == "function") {
                      A.callback = tt, W(Q), V = !0;
                      break e;
                    }
                    A === u(y) && s(y), W(Q);
                  } else s(y);
                  A = u(y);
                }
                if (A !== null) V = !0;
                else {
                  var lt = u(b);
                  lt !== null && Zt(
                    X,
                    lt.startTime - Q
                  ), V = !1;
                }
              }
              break t;
            } finally {
              A = null, x = $, U = !1;
            }
            V = void 0;
          }
        } finally {
          V ? Nt() : B = !1;
        }
      }
    }
    var Nt;
    if (typeof et == "function")
      Nt = function() {
        et(Dt);
      };
    else if (typeof MessageChannel < "u") {
      var pt = new MessageChannel(), Se = pt.port2;
      pt.port1.onmessage = Dt, Nt = function() {
        Se.postMessage(null);
      };
    } else
      Nt = function() {
        Y(Dt, 0);
      };
    function Zt(Q, V) {
      G = Y(function() {
        Q(l.unstable_now());
      }, V);
    }
    l.unstable_IdlePriority = 5, l.unstable_ImmediatePriority = 1, l.unstable_LowPriority = 4, l.unstable_NormalPriority = 3, l.unstable_Profiling = null, l.unstable_UserBlockingPriority = 2, l.unstable_cancelCallback = function(Q) {
      Q.callback = null;
    }, l.unstable_forceFrameRate = function(Q) {
      0 > Q || 125 < Q ? console.error(
        "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"
      ) : F = 0 < Q ? Math.floor(1e3 / Q) : 5;
    }, l.unstable_getCurrentPriorityLevel = function() {
      return x;
    }, l.unstable_next = function(Q) {
      switch (x) {
        case 1:
        case 2:
        case 3:
          var V = 3;
          break;
        default:
          V = x;
      }
      var $ = x;
      x = V;
      try {
        return Q();
      } finally {
        x = $;
      }
    }, l.unstable_requestPaint = function() {
      q = !0;
    }, l.unstable_runWithPriority = function(Q, V) {
      switch (Q) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          Q = 3;
      }
      var $ = x;
      x = Q;
      try {
        return V();
      } finally {
        x = $;
      }
    }, l.unstable_scheduleCallback = function(Q, V, $) {
      var J = l.unstable_now();
      switch (typeof $ == "object" && $ !== null ? ($ = $.delay, $ = typeof $ == "number" && 0 < $ ? J + $ : J) : $ = J, Q) {
        case 1:
          var tt = -1;
          break;
        case 2:
          tt = 250;
          break;
        case 5:
          tt = 1073741823;
          break;
        case 4:
          tt = 1e4;
          break;
        default:
          tt = 5e3;
      }
      return tt = $ + tt, Q = {
        id: T++,
        callback: V,
        priorityLevel: Q,
        startTime: $,
        expirationTime: tt,
        sortIndex: -1
      }, $ > J ? (Q.sortIndex = $, i(b, Q), u(y) === null && Q === u(b) && (R ? (L(G), G = -1) : R = !0, Zt(X, $ - J))) : (Q.sortIndex = tt, i(y, Q), D || U || (D = !0, B || (B = !0, Nt()))), Q;
    }, l.unstable_shouldYield = yt, l.unstable_wrapCallback = function(Q) {
      var V = x;
      return function() {
        var $ = x;
        x = V;
        try {
          return Q.apply(this, arguments);
        } finally {
          x = $;
        }
      };
    };
  })(Df)), Df;
}
var ny;
function eA() {
  return ny || (ny = 1, Cf.exports = tA()), Cf.exports;
}
var ay;
function nA() {
  if (ay) return Qr;
  ay = 1;
  var l = { env: { NODE_ENV: "production" } };
  var i = eA(), u = ye, s = Ob;
  function o(t) {
    var e = "https://react.dev/errors/" + t;
    if (1 < arguments.length) {
      e += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var n = 2; n < arguments.length; n++)
        e += "&args[]=" + encodeURIComponent(arguments[n]);
    }
    return "Minified React error #" + t + "; visit " + e + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  function f(t) {
    return !(!t || t.nodeType !== 1 && t.nodeType !== 9 && t.nodeType !== 11);
  }
  function m(t) {
    var e = t, n = t;
    if (t.alternate) for (; e.return; ) e = e.return;
    else {
      t = e;
      do
        e = t, (e.flags & 4098) !== 0 && (n = e.return), t = e.return;
      while (t);
    }
    return e.tag === 3 ? n : null;
  }
  function g(t) {
    if (t.tag === 13) {
      var e = t.memoizedState;
      if (e === null && (t = t.alternate, t !== null && (e = t.memoizedState)), e !== null) return e.dehydrated;
    }
    return null;
  }
  function y(t) {
    if (t.tag === 31) {
      var e = t.memoizedState;
      if (e === null && (t = t.alternate, t !== null && (e = t.memoizedState)), e !== null) return e.dehydrated;
    }
    return null;
  }
  function b(t) {
    if (m(t) !== t)
      throw Error(o(188));
  }
  function T(t) {
    var e = t.alternate;
    if (!e) {
      if (e = m(t), e === null) throw Error(o(188));
      return e !== t ? null : t;
    }
    for (var n = t, a = e; ; ) {
      var r = n.return;
      if (r === null) break;
      var c = r.alternate;
      if (c === null) {
        if (a = r.return, a !== null) {
          n = a;
          continue;
        }
        break;
      }
      if (r.child === c.child) {
        for (c = r.child; c; ) {
          if (c === n) return b(r), t;
          if (c === a) return b(r), e;
          c = c.sibling;
        }
        throw Error(o(188));
      }
      if (n.return !== a.return) n = r, a = c;
      else {
        for (var d = !1, v = r.child; v; ) {
          if (v === n) {
            d = !0, n = r, a = c;
            break;
          }
          if (v === a) {
            d = !0, a = r, n = c;
            break;
          }
          v = v.sibling;
        }
        if (!d) {
          for (v = c.child; v; ) {
            if (v === n) {
              d = !0, n = c, a = r;
              break;
            }
            if (v === a) {
              d = !0, a = c, n = r;
              break;
            }
            v = v.sibling;
          }
          if (!d) throw Error(o(189));
        }
      }
      if (n.alternate !== a) throw Error(o(190));
    }
    if (n.tag !== 3) throw Error(o(188));
    return n.stateNode.current === n ? t : e;
  }
  function A(t) {
    var e = t.tag;
    if (e === 5 || e === 26 || e === 27 || e === 6) return t;
    for (t = t.child; t !== null; ) {
      if (e = A(t), e !== null) return e;
      t = t.sibling;
    }
    return null;
  }
  var x = Object.assign, U = Symbol.for("react.element"), D = Symbol.for("react.transitional.element"), R = Symbol.for("react.portal"), q = Symbol.for("react.fragment"), Y = Symbol.for("react.strict_mode"), L = Symbol.for("react.profiler"), et = Symbol.for("react.consumer"), W = Symbol.for("react.context"), X = Symbol.for("react.forward_ref"), B = Symbol.for("react.suspense"), G = Symbol.for("react.suspense_list"), F = Symbol.for("react.memo"), ut = Symbol.for("react.lazy"), yt = Symbol.for("react.activity"), Dt = Symbol.for("react.memo_cache_sentinel"), Nt = Symbol.iterator;
  function pt(t) {
    return t === null || typeof t != "object" ? null : (t = Nt && t[Nt] || t["@@iterator"], typeof t == "function" ? t : null);
  }
  var Se = Symbol.for("react.client.reference");
  function Zt(t) {
    if (t == null) return null;
    if (typeof t == "function")
      return t.$$typeof === Se ? null : t.displayName || t.name || null;
    if (typeof t == "string") return t;
    switch (t) {
      case q:
        return "Fragment";
      case L:
        return "Profiler";
      case Y:
        return "StrictMode";
      case B:
        return "Suspense";
      case G:
        return "SuspenseList";
      case yt:
        return "Activity";
    }
    if (typeof t == "object")
      switch (t.$$typeof) {
        case R:
          return "Portal";
        case W:
          return t.displayName || "Context";
        case et:
          return (t._context.displayName || "Context") + ".Consumer";
        case X:
          var e = t.render;
          return t = t.displayName, t || (t = e.displayName || e.name || "", t = t !== "" ? "ForwardRef(" + t + ")" : "ForwardRef"), t;
        case F:
          return e = t.displayName || null, e !== null ? e : Zt(t.type) || "Memo";
        case ut:
          e = t._payload, t = t._init;
          try {
            return Zt(t(e));
          } catch {
          }
      }
    return null;
  }
  var Q = Array.isArray, V = u.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $ = s.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, J = {
    pending: !1,
    data: null,
    method: null,
    action: null
  }, tt = [], lt = -1;
  function vt(t) {
    return { current: t };
  }
  function ct(t) {
    0 > lt || (t.current = tt[lt], tt[lt] = null, lt--);
  }
  function at(t, e) {
    lt++, tt[lt] = t.current, t.current = e;
  }
  var ot = vt(null), ue = vt(null), fe = vt(null), bt = vt(null);
  function Ut(t, e) {
    switch (at(fe, e), at(ue, t), at(ot, null), e.nodeType) {
      case 9:
      case 11:
        t = (t = e.documentElement) && (t = t.namespaceURI) ? pp(t) : 0;
        break;
      default:
        if (t = e.tagName, e = e.namespaceURI)
          e = pp(e), t = gp(e, t);
        else
          switch (t) {
            case "svg":
              t = 1;
              break;
            case "math":
              t = 2;
              break;
            default:
              t = 0;
          }
    }
    ct(ot), at(ot, t);
  }
  function Kt() {
    ct(ot), ct(ue), ct(fe);
  }
  function zt(t) {
    t.memoizedState !== null && at(bt, t);
    var e = ot.current, n = gp(e, t.type);
    e !== n && (at(ue, t), at(ot, n));
  }
  function Zn(t) {
    ue.current === t && (ct(ot), ct(ue)), bt.current === t && (ct(bt), Lr._currentValue = J);
  }
  var Jt, qi;
  function Lt(t) {
    if (Jt === void 0)
      try {
        throw Error();
      } catch (n) {
        var e = n.stack.trim().match(/\n( *(at )?)/);
        Jt = e && e[1] || "", qi = -1 < n.stack.indexOf(`
    at`) ? " (<anonymous>)" : -1 < n.stack.indexOf("@") ? "@unknown:0:0" : "";
      }
    return `
` + Jt + t + qi;
  }
  var Kn = !1;
  function Gl(t, e) {
    if (!t || Kn) return "";
    Kn = !0;
    var n = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      var a = {
        DetermineComponentFrameRoot: function() {
          try {
            if (e) {
              var H = function() {
                throw Error();
              };
              if (Object.defineProperty(H.prototype, "props", {
                set: function() {
                  throw Error();
                }
              }), typeof Reflect == "object" && Reflect.construct) {
                try {
                  Reflect.construct(H, []);
                } catch (z) {
                  var C = z;
                }
                Reflect.construct(t, [], H);
              } else {
                try {
                  H.call();
                } catch (z) {
                  C = z;
                }
                t.call(H.prototype);
              }
            } else {
              try {
                throw Error();
              } catch (z) {
                C = z;
              }
              (H = t()) && typeof H.catch == "function" && H.catch(function() {
              });
            }
          } catch (z) {
            if (z && C && typeof z.stack == "string")
              return [z.stack, C.stack];
          }
          return [null, null];
        }
      };
      a.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
      var r = Object.getOwnPropertyDescriptor(
        a.DetermineComponentFrameRoot,
        "name"
      );
      r && r.configurable && Object.defineProperty(
        a.DetermineComponentFrameRoot,
        "name",
        { value: "DetermineComponentFrameRoot" }
      );
      var c = a.DetermineComponentFrameRoot(), d = c[0], v = c[1];
      if (d && v) {
        var w = d.split(`
`), E = v.split(`
`);
        for (r = a = 0; a < w.length && !w[a].includes("DetermineComponentFrameRoot"); )
          a++;
        for (; r < E.length && !E[r].includes(
          "DetermineComponentFrameRoot"
        ); )
          r++;
        if (a === w.length || r === E.length)
          for (a = w.length - 1, r = E.length - 1; 1 <= a && 0 <= r && w[a] !== E[r]; )
            r--;
        for (; 1 <= a && 0 <= r; a--, r--)
          if (w[a] !== E[r]) {
            if (a !== 1 || r !== 1)
              do
                if (a--, r--, 0 > r || w[a] !== E[r]) {
                  var M = `
` + w[a].replace(" at new ", " at ");
                  return t.displayName && M.includes("<anonymous>") && (M = M.replace("<anonymous>", t.displayName)), M;
                }
              while (1 <= a && 0 <= r);
            break;
          }
      }
    } finally {
      Kn = !1, Error.prepareStackTrace = n;
    }
    return (n = t ? t.displayName || t.name : "") ? Lt(n) : "";
  }
  function Cn(t, e) {
    switch (t.tag) {
      case 26:
      case 27:
      case 5:
        return Lt(t.type);
      case 16:
        return Lt("Lazy");
      case 13:
        return t.child !== e && e !== null ? Lt("Suspense Fallback") : Lt("Suspense");
      case 19:
        return Lt("SuspenseList");
      case 0:
      case 15:
        return Gl(t.type, !1);
      case 11:
        return Gl(t.type.render, !1);
      case 1:
        return Gl(t.type, !0);
      case 31:
        return Lt("Activity");
      default:
        return "";
    }
  }
  function Vi(t) {
    try {
      var e = "", n = null;
      do
        e += Cn(t, n), n = t, t = t.return;
      while (t);
      return e;
    } catch (a) {
      return `
Error generating stack: ` + a.message + `
` + a.stack;
    }
  }
  var il = Object.prototype.hasOwnProperty, Xl = i.unstable_scheduleCallback, Ql = i.unstable_cancelCallback, Dn = i.unstable_shouldYield, rl = i.unstable_requestPaint, de = i.unstable_now, Yi = i.unstable_getCurrentPriorityLevel, Zl = i.unstable_ImmediatePriority, Kl = i.unstable_UserBlockingPriority, va = i.unstable_NormalPriority, ba = i.unstable_LowPriority, ul = i.unstable_IdlePriority, $l = i.log, nu = i.unstable_setDisableYieldValue, Sa = null, qe = null;
  function dn(t) {
    if (typeof $l == "function" && nu(t), qe && typeof qe.setStrictMode == "function")
      try {
        qe.setStrictMode(Sa, t);
      } catch {
      }
  }
  var Ce = Math.clz32 ? Math.clz32 : Gi, Ta = Math.log, hn = Math.LN2;
  function Gi(t) {
    return t >>>= 0, t === 0 ? 32 : 31 - (Ta(t) / hn | 0) | 0;
  }
  var cl = 256, sl = 262144, wa = 4194304;
  function zn(t) {
    var e = t & 42;
    if (e !== 0) return e;
    switch (t & -t) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
        return 64;
      case 128:
        return 128;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
        return t & 261888;
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return t & 3932160;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return t & 62914560;
      case 67108864:
        return 67108864;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 0;
      default:
        return t;
    }
  }
  function $n(t, e, n) {
    var a = t.pendingLanes;
    if (a === 0) return 0;
    var r = 0, c = t.suspendedLanes, d = t.pingedLanes;
    t = t.warmLanes;
    var v = a & 134217727;
    return v !== 0 ? (a = v & ~c, a !== 0 ? r = zn(a) : (d &= v, d !== 0 ? r = zn(d) : n || (n = v & ~t, n !== 0 && (r = zn(n))))) : (v = a & ~c, v !== 0 ? r = zn(v) : d !== 0 ? r = zn(d) : n || (n = a & ~t, n !== 0 && (r = zn(n)))), r === 0 ? 0 : e !== 0 && e !== r && (e & c) === 0 && (c = r & -r, n = e & -e, c >= n || c === 32 && (n & 4194048) !== 0) ? e : r;
  }
  function Mn(t, e) {
    return (t.pendingLanes & ~(t.suspendedLanes & ~t.pingedLanes) & e) === 0;
  }
  function mn(t, e) {
    switch (t) {
      case 1:
      case 2:
      case 4:
      case 8:
      case 64:
        return e + 250;
      case 16:
      case 32:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return e + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return -1;
      case 67108864:
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function Jn() {
    var t = wa;
    return wa <<= 1, (wa & 62914560) === 0 && (wa = 4194304), t;
  }
  function ol(t) {
    for (var e = [], n = 0; 31 > n; n++) e.push(t);
    return e;
  }
  function Wn(t, e) {
    t.pendingLanes |= e, e !== 268435456 && (t.suspendedLanes = 0, t.pingedLanes = 0, t.warmLanes = 0);
  }
  function es(t, e, n, a, r, c) {
    var d = t.pendingLanes;
    t.pendingLanes = n, t.suspendedLanes = 0, t.pingedLanes = 0, t.warmLanes = 0, t.expiredLanes &= n, t.entangledLanes &= n, t.errorRecoveryDisabledLanes &= n, t.shellSuspendCounter = 0;
    var v = t.entanglements, w = t.expirationTimes, E = t.hiddenUpdates;
    for (n = d & ~n; 0 < n; ) {
      var M = 31 - Ce(n), H = 1 << M;
      v[M] = 0, w[M] = -1;
      var C = E[M];
      if (C !== null)
        for (E[M] = null, M = 0; M < C.length; M++) {
          var z = C[M];
          z !== null && (z.lane &= -536870913);
        }
      n &= ~H;
    }
    a !== 0 && Xi(t, a, 0), c !== 0 && r === 0 && t.tag !== 0 && (t.suspendedLanes |= c & ~(d & ~e));
  }
  function Xi(t, e, n) {
    t.pendingLanes |= e, t.suspendedLanes &= ~e;
    var a = 31 - Ce(e);
    t.entangledLanes |= e, t.entanglements[a] = t.entanglements[a] | 1073741824 | n & 261930;
  }
  function Jl(t, e) {
    var n = t.entangledLanes |= e;
    for (t = t.entanglements; n; ) {
      var a = 31 - Ce(n), r = 1 << a;
      r & e | t[a] & e && (t[a] |= e), n &= ~r;
    }
  }
  function Qi(t, e) {
    var n = e & -e;
    return n = (n & 42) !== 0 ? 1 : fl(n), (n & (t.suspendedLanes | e)) !== 0 ? 0 : n;
  }
  function fl(t) {
    switch (t) {
      case 2:
        t = 1;
        break;
      case 8:
        t = 4;
        break;
      case 32:
        t = 16;
        break;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        t = 128;
        break;
      case 268435456:
        t = 134217728;
        break;
      default:
        t = 0;
    }
    return t;
  }
  function Zi(t) {
    return t &= -t, 2 < t ? 8 < t ? (t & 134217727) !== 0 ? 32 : 268435456 : 8 : 2;
  }
  function xa() {
    var t = $.p;
    return t !== 0 ? t : (t = window.event, t === void 0 ? 32 : Up(t.type));
  }
  function au(t, e) {
    var n = $.p;
    try {
      return $.p = t, e();
    } finally {
      $.p = n;
    }
  }
  var kn = Math.random().toString(36).slice(2), ht = "__reactFiber$" + kn, he = "__reactProps$" + kn, Aa = "__reactContainer$" + kn, Wl = "__reactEvents$" + kn, Ki = "__reactListeners$" + kn, lu = "__reactHandles$" + kn, $i = "__reactResources$" + kn, dl = "__reactMarker$" + kn;
  function Ji(t) {
    delete t[ht], delete t[he], delete t[Wl], delete t[Ki], delete t[lu];
  }
  function _a(t) {
    var e = t[ht];
    if (e) return e;
    for (var n = t.parentNode; n; ) {
      if (e = n[Aa] || n[ht]) {
        if (n = e.alternate, e.child !== null || n !== null && n.child !== null)
          for (t = xp(t); t !== null; ) {
            if (n = t[ht]) return n;
            t = xp(t);
          }
        return e;
      }
      t = n, n = t.parentNode;
    }
    return null;
  }
  function Oa(t) {
    if (t = t[ht] || t[Aa]) {
      var e = t.tag;
      if (e === 5 || e === 6 || e === 13 || e === 31 || e === 26 || e === 27 || e === 3)
        return t;
    }
    return null;
  }
  function Ze(t) {
    var e = t.tag;
    if (e === 5 || e === 26 || e === 27 || e === 6) return t.stateNode;
    throw Error(o(33));
  }
  function Fn(t) {
    var e = t[$i];
    return e || (e = t[$i] = { hoistableStyles: /* @__PURE__ */ new Map(), hoistableScripts: /* @__PURE__ */ new Map() }), e;
  }
  function Wt(t) {
    t[dl] = !0;
  }
  var iu = /* @__PURE__ */ new Set(), ru = {};
  function Ln(t, e) {
    In(t, e), In(t + "Capture", e);
  }
  function In(t, e) {
    for (ru[t] = e, t = 0; t < e.length; t++)
      iu.add(e[t]);
  }
  var Fl = RegExp(
    "^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
  ), Il = {}, hl = {};
  function Na(t) {
    return il.call(hl, t) ? !0 : il.call(Il, t) ? !1 : Fl.test(t) ? hl[t] = !0 : (Il[t] = !0, !1);
  }
  function Bn(t, e, n) {
    if (Na(e))
      if (n === null) t.removeAttribute(e);
      else {
        switch (typeof n) {
          case "undefined":
          case "function":
          case "symbol":
            t.removeAttribute(e);
            return;
          case "boolean":
            var a = e.toLowerCase().slice(0, 5);
            if (a !== "data-" && a !== "aria-") {
              t.removeAttribute(e);
              return;
            }
        }
        t.setAttribute(e, "" + n);
      }
  }
  function Ke(t, e, n) {
    if (n === null) t.removeAttribute(e);
    else {
      switch (typeof n) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          t.removeAttribute(e);
          return;
      }
      t.setAttribute(e, "" + n);
    }
  }
  function An(t, e, n, a) {
    if (a === null) t.removeAttribute(n);
    else {
      switch (typeof a) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          t.removeAttribute(n);
          return;
      }
      t.setAttributeNS(e, n, "" + a);
    }
  }
  function $e(t) {
    switch (typeof t) {
      case "bigint":
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return t;
      case "object":
        return t;
      default:
        return "";
    }
  }
  function Wi(t) {
    var e = t.type;
    return (t = t.nodeName) && t.toLowerCase() === "input" && (e === "checkbox" || e === "radio");
  }
  function uu(t, e, n) {
    var a = Object.getOwnPropertyDescriptor(
      t.constructor.prototype,
      e
    );
    if (!t.hasOwnProperty(e) && typeof a < "u" && typeof a.get == "function" && typeof a.set == "function") {
      var r = a.get, c = a.set;
      return Object.defineProperty(t, e, {
        configurable: !0,
        get: function() {
          return r.call(this);
        },
        set: function(d) {
          n = "" + d, c.call(this, d);
        }
      }), Object.defineProperty(t, e, {
        enumerable: a.enumerable
      }), {
        getValue: function() {
          return n;
        },
        setValue: function(d) {
          n = "" + d;
        },
        stopTracking: function() {
          t._valueTracker = null, delete t[e];
        }
      };
    }
  }
  function Fi(t) {
    if (!t._valueTracker) {
      var e = Wi(t) ? "checked" : "value";
      t._valueTracker = uu(
        t,
        e,
        "" + t[e]
      );
    }
  }
  function Ii(t) {
    if (!t) return !1;
    var e = t._valueTracker;
    if (!e) return !0;
    var n = e.getValue(), a = "";
    return t && (a = Wi(t) ? t.checked ? "true" : "false" : t.value), t = a, t !== n ? (e.setValue(t), !0) : !1;
  }
  function Pl(t) {
    if (t = t || (typeof document < "u" ? document : void 0), typeof t > "u") return null;
    try {
      return t.activeElement || t.body;
    } catch {
      return t.body;
    }
  }
  var ns = /[\n"\\]/g;
  function Ve(t) {
    return t.replace(
      ns,
      function(e) {
        return "\\" + e.charCodeAt(0).toString(16) + " ";
      }
    );
  }
  function Ea(t, e, n, a, r, c, d, v) {
    t.name = "", d != null && typeof d != "function" && typeof d != "symbol" && typeof d != "boolean" ? t.type = d : t.removeAttribute("type"), e != null ? d === "number" ? (e === 0 && t.value === "" || t.value != e) && (t.value = "" + $e(e)) : t.value !== "" + $e(e) && (t.value = "" + $e(e)) : d !== "submit" && d !== "reset" || t.removeAttribute("value"), e != null ? Z(t, d, $e(e)) : n != null ? Z(t, d, $e(n)) : a != null && t.removeAttribute("value"), r == null && c != null && (t.defaultChecked = !!c), r != null && (t.checked = r && typeof r != "function" && typeof r != "symbol"), v != null && typeof v != "function" && typeof v != "symbol" && typeof v != "boolean" ? t.name = "" + $e(v) : t.removeAttribute("name");
  }
  function ti(t, e, n, a, r, c, d, v) {
    if (c != null && typeof c != "function" && typeof c != "symbol" && typeof c != "boolean" && (t.type = c), e != null || n != null) {
      if (!(c !== "submit" && c !== "reset" || e != null)) {
        Fi(t);
        return;
      }
      n = n != null ? "" + $e(n) : "", e = e != null ? "" + $e(e) : n, v || e === t.value || (t.value = e), t.defaultValue = e;
    }
    a = a ?? r, a = typeof a != "function" && typeof a != "symbol" && !!a, t.checked = v ? t.checked : !!a, t.defaultChecked = !!a, d != null && typeof d != "function" && typeof d != "symbol" && typeof d != "boolean" && (t.name = d), Fi(t);
  }
  function Z(t, e, n) {
    e === "number" && Pl(t.ownerDocument) === t || t.defaultValue === "" + n || (t.defaultValue = "" + n);
  }
  function S(t, e, n, a) {
    if (t = t.options, e) {
      e = {};
      for (var r = 0; r < n.length; r++)
        e["$" + n[r]] = !0;
      for (n = 0; n < t.length; n++)
        r = e.hasOwnProperty("$" + t[n].value), t[n].selected !== r && (t[n].selected = r), r && a && (t[n].defaultSelected = !0);
    } else {
      for (n = "" + $e(n), e = null, r = 0; r < t.length; r++) {
        if (t[r].value === n) {
          t[r].selected = !0, a && (t[r].defaultSelected = !0);
          return;
        }
        e !== null || t[r].disabled || (e = t[r]);
      }
      e !== null && (e.selected = !0);
    }
  }
  function j(t, e, n) {
    if (e != null && (e = "" + $e(e), e !== t.value && (t.value = e), n == null)) {
      t.defaultValue !== e && (t.defaultValue = e);
      return;
    }
    t.defaultValue = n != null ? "" + $e(n) : "";
  }
  function K(t, e, n, a) {
    if (e == null) {
      if (a != null) {
        if (n != null) throw Error(o(92));
        if (Q(a)) {
          if (1 < a.length) throw Error(o(93));
          a = a[0];
        }
        n = a;
      }
      n == null && (n = ""), e = n;
    }
    n = $e(e), t.defaultValue = n, a = t.textContent, a === n && a !== "" && a !== null && (t.value = a), Fi(t);
  }
  function I(t, e) {
    if (e) {
      var n = t.firstChild;
      if (n && n === t.lastChild && n.nodeType === 3) {
        n.nodeValue = e;
        return;
      }
    }
    t.textContent = e;
  }
  var ft = new Set(
    "animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(
      " "
    )
  );
  function wt(t, e, n) {
    var a = e.indexOf("--") === 0;
    n == null || typeof n == "boolean" || n === "" ? a ? t.setProperty(e, "") : e === "float" ? t.cssFloat = "" : t[e] = "" : a ? t.setProperty(e, n) : typeof n != "number" || n === 0 || ft.has(e) ? e === "float" ? t.cssFloat = n : t[e] = ("" + n).trim() : t[e] = n + "px";
  }
  function me(t, e, n) {
    if (e != null && typeof e != "object")
      throw Error(o(62));
    if (t = t.style, n != null) {
      for (var a in n)
        !n.hasOwnProperty(a) || e != null && e.hasOwnProperty(a) || (a.indexOf("--") === 0 ? t.setProperty(a, "") : a === "float" ? t.cssFloat = "" : t[a] = "");
      for (var r in e)
        a = e[r], e.hasOwnProperty(r) && n[r] !== a && wt(t, r, a);
    } else
      for (var c in e)
        e.hasOwnProperty(c) && wt(t, c, e[c]);
  }
  function ae(t) {
    if (t.indexOf("-") === -1) return !1;
    switch (t) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var Je = /* @__PURE__ */ new Map([
    ["acceptCharset", "accept-charset"],
    ["htmlFor", "for"],
    ["httpEquiv", "http-equiv"],
    ["crossOrigin", "crossorigin"],
    ["accentHeight", "accent-height"],
    ["alignmentBaseline", "alignment-baseline"],
    ["arabicForm", "arabic-form"],
    ["baselineShift", "baseline-shift"],
    ["capHeight", "cap-height"],
    ["clipPath", "clip-path"],
    ["clipRule", "clip-rule"],
    ["colorInterpolation", "color-interpolation"],
    ["colorInterpolationFilters", "color-interpolation-filters"],
    ["colorProfile", "color-profile"],
    ["colorRendering", "color-rendering"],
    ["dominantBaseline", "dominant-baseline"],
    ["enableBackground", "enable-background"],
    ["fillOpacity", "fill-opacity"],
    ["fillRule", "fill-rule"],
    ["floodColor", "flood-color"],
    ["floodOpacity", "flood-opacity"],
    ["fontFamily", "font-family"],
    ["fontSize", "font-size"],
    ["fontSizeAdjust", "font-size-adjust"],
    ["fontStretch", "font-stretch"],
    ["fontStyle", "font-style"],
    ["fontVariant", "font-variant"],
    ["fontWeight", "font-weight"],
    ["glyphName", "glyph-name"],
    ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
    ["glyphOrientationVertical", "glyph-orientation-vertical"],
    ["horizAdvX", "horiz-adv-x"],
    ["horizOriginX", "horiz-origin-x"],
    ["imageRendering", "image-rendering"],
    ["letterSpacing", "letter-spacing"],
    ["lightingColor", "lighting-color"],
    ["markerEnd", "marker-end"],
    ["markerMid", "marker-mid"],
    ["markerStart", "marker-start"],
    ["overlinePosition", "overline-position"],
    ["overlineThickness", "overline-thickness"],
    ["paintOrder", "paint-order"],
    ["panose-1", "panose-1"],
    ["pointerEvents", "pointer-events"],
    ["renderingIntent", "rendering-intent"],
    ["shapeRendering", "shape-rendering"],
    ["stopColor", "stop-color"],
    ["stopOpacity", "stop-opacity"],
    ["strikethroughPosition", "strikethrough-position"],
    ["strikethroughThickness", "strikethrough-thickness"],
    ["strokeDasharray", "stroke-dasharray"],
    ["strokeDashoffset", "stroke-dashoffset"],
    ["strokeLinecap", "stroke-linecap"],
    ["strokeLinejoin", "stroke-linejoin"],
    ["strokeMiterlimit", "stroke-miterlimit"],
    ["strokeOpacity", "stroke-opacity"],
    ["strokeWidth", "stroke-width"],
    ["textAnchor", "text-anchor"],
    ["textDecoration", "text-decoration"],
    ["textRendering", "text-rendering"],
    ["transformOrigin", "transform-origin"],
    ["underlinePosition", "underline-position"],
    ["underlineThickness", "underline-thickness"],
    ["unicodeBidi", "unicode-bidi"],
    ["unicodeRange", "unicode-range"],
    ["unitsPerEm", "units-per-em"],
    ["vAlphabetic", "v-alphabetic"],
    ["vHanging", "v-hanging"],
    ["vIdeographic", "v-ideographic"],
    ["vMathematical", "v-mathematical"],
    ["vectorEffect", "vector-effect"],
    ["vertAdvY", "vert-adv-y"],
    ["vertOriginX", "vert-origin-x"],
    ["vertOriginY", "vert-origin-y"],
    ["wordSpacing", "word-spacing"],
    ["writingMode", "writing-mode"],
    ["xmlnsXlink", "xmlns:xlink"],
    ["xHeight", "x-height"]
  ]), an = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
  function ja(t) {
    return an.test("" + t) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : t;
  }
  function Ft() {
  }
  var as = null;
  function ls(t) {
    return t = t.target || t.srcElement || window, t.correspondingUseElement && (t = t.correspondingUseElement), t.nodeType === 3 ? t.parentNode : t;
  }
  var ei = null, ni = null;
  function md(t) {
    var e = Oa(t);
    if (e && (t = e.stateNode)) {
      var n = t[he] || null;
      t: switch (t = e.stateNode, e.type) {
        case "input":
          if (Ea(
            t,
            n.value,
            n.defaultValue,
            n.defaultValue,
            n.checked,
            n.defaultChecked,
            n.type,
            n.name
          ), e = n.name, n.type === "radio" && e != null) {
            for (n = t; n.parentNode; ) n = n.parentNode;
            for (n = n.querySelectorAll(
              'input[name="' + Ve(
                "" + e
              ) + '"][type="radio"]'
            ), e = 0; e < n.length; e++) {
              var a = n[e];
              if (a !== t && a.form === t.form) {
                var r = a[he] || null;
                if (!r) throw Error(o(90));
                Ea(
                  a,
                  r.value,
                  r.defaultValue,
                  r.defaultValue,
                  r.checked,
                  r.defaultChecked,
                  r.type,
                  r.name
                );
              }
            }
            for (e = 0; e < n.length; e++)
              a = n[e], a.form === t.form && Ii(a);
          }
          break t;
        case "textarea":
          j(t, n.value, n.defaultValue);
          break t;
        case "select":
          e = n.value, e != null && S(t, !!n.multiple, e, !1);
      }
    }
  }
  var is = !1;
  function pd(t, e, n) {
    if (is) return t(e, n);
    is = !0;
    try {
      var a = t(e);
      return a;
    } finally {
      if (is = !1, (ei !== null || ni !== null) && ($u(), ei && (e = ei, t = ni, ni = ei = null, md(e), t)))
        for (e = 0; e < t.length; e++) md(t[e]);
    }
  }
  function Pi(t, e) {
    var n = t.stateNode;
    if (n === null) return null;
    var a = n[he] || null;
    if (a === null) return null;
    n = a[e];
    t: switch (e) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (a = !a.disabled) || (t = t.type, a = !(t === "button" || t === "input" || t === "select" || t === "textarea")), t = !a;
        break t;
      default:
        t = !1;
    }
    if (t) return null;
    if (n && typeof n != "function")
      throw Error(
        o(231, e, typeof n)
      );
    return n;
  }
  var Pn = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), rs = !1;
  if (Pn)
    try {
      var tr = {};
      Object.defineProperty(tr, "passive", {
        get: function() {
          rs = !0;
        }
      }), window.addEventListener("test", tr, tr), window.removeEventListener("test", tr, tr);
    } catch {
      rs = !1;
    }
  var Ra = null, us = null, cu = null;
  function gd() {
    if (cu) return cu;
    var t, e = us, n = e.length, a, r = "value" in Ra ? Ra.value : Ra.textContent, c = r.length;
    for (t = 0; t < n && e[t] === r[t]; t++) ;
    var d = n - t;
    for (a = 1; a <= d && e[n - a] === r[c - a]; a++) ;
    return cu = r.slice(t, 1 < a ? 1 - a : void 0);
  }
  function su(t) {
    var e = t.keyCode;
    return "charCode" in t ? (t = t.charCode, t === 0 && e === 13 && (t = 13)) : t = e, t === 10 && (t = 13), 32 <= t || t === 13 ? t : 0;
  }
  function ou() {
    return !0;
  }
  function yd() {
    return !1;
  }
  function We(t) {
    function e(n, a, r, c, d) {
      this._reactName = n, this._targetInst = r, this.type = a, this.nativeEvent = c, this.target = d, this.currentTarget = null;
      for (var v in t)
        t.hasOwnProperty(v) && (n = t[v], this[v] = n ? n(c) : c[v]);
      return this.isDefaultPrevented = (c.defaultPrevented != null ? c.defaultPrevented : c.returnValue === !1) ? ou : yd, this.isPropagationStopped = yd, this;
    }
    return x(e.prototype, {
      preventDefault: function() {
        this.defaultPrevented = !0;
        var n = this.nativeEvent;
        n && (n.preventDefault ? n.preventDefault() : typeof n.returnValue != "unknown" && (n.returnValue = !1), this.isDefaultPrevented = ou);
      },
      stopPropagation: function() {
        var n = this.nativeEvent;
        n && (n.stopPropagation ? n.stopPropagation() : typeof n.cancelBubble != "unknown" && (n.cancelBubble = !0), this.isPropagationStopped = ou);
      },
      persist: function() {
      },
      isPersistent: ou
    }), e;
  }
  var ml = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(t) {
      return t.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
  }, fu = We(ml), er = x({}, ml, { view: 0, detail: 0 }), Tv = We(er), cs, ss, nr, du = x({}, er, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: fs,
    button: 0,
    buttons: 0,
    relatedTarget: function(t) {
      return t.relatedTarget === void 0 ? t.fromElement === t.srcElement ? t.toElement : t.fromElement : t.relatedTarget;
    },
    movementX: function(t) {
      return "movementX" in t ? t.movementX : (t !== nr && (nr && t.type === "mousemove" ? (cs = t.screenX - nr.screenX, ss = t.screenY - nr.screenY) : ss = cs = 0, nr = t), cs);
    },
    movementY: function(t) {
      return "movementY" in t ? t.movementY : ss;
    }
  }), vd = We(du), wv = x({}, du, { dataTransfer: 0 }), xv = We(wv), Av = x({}, er, { relatedTarget: 0 }), os = We(Av), _v = x({}, ml, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }), Ov = We(_v), Nv = x({}, ml, {
    clipboardData: function(t) {
      return "clipboardData" in t ? t.clipboardData : window.clipboardData;
    }
  }), Ev = We(Nv), jv = x({}, ml, { data: 0 }), bd = We(jv), Rv = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, Cv = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, Dv = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
  };
  function zv(t) {
    var e = this.nativeEvent;
    return e.getModifierState ? e.getModifierState(t) : (t = Dv[t]) ? !!e[t] : !1;
  }
  function fs() {
    return zv;
  }
  var Mv = x({}, er, {
    key: function(t) {
      if (t.key) {
        var e = Rv[t.key] || t.key;
        if (e !== "Unidentified") return e;
      }
      return t.type === "keypress" ? (t = su(t), t === 13 ? "Enter" : String.fromCharCode(t)) : t.type === "keydown" || t.type === "keyup" ? Cv[t.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: fs,
    charCode: function(t) {
      return t.type === "keypress" ? su(t) : 0;
    },
    keyCode: function(t) {
      return t.type === "keydown" || t.type === "keyup" ? t.keyCode : 0;
    },
    which: function(t) {
      return t.type === "keypress" ? su(t) : t.type === "keydown" || t.type === "keyup" ? t.keyCode : 0;
    }
  }), kv = We(Mv), Lv = x({}, du, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
  }), Sd = We(Lv), Bv = x({}, er, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: fs
  }), Hv = We(Bv), Uv = x({}, ml, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }), qv = We(Uv), Vv = x({}, du, {
    deltaX: function(t) {
      return "deltaX" in t ? t.deltaX : "wheelDeltaX" in t ? -t.wheelDeltaX : 0;
    },
    deltaY: function(t) {
      return "deltaY" in t ? t.deltaY : "wheelDeltaY" in t ? -t.wheelDeltaY : "wheelDelta" in t ? -t.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), Yv = We(Vv), Gv = x({}, ml, {
    newState: 0,
    oldState: 0
  }), Xv = We(Gv), Qv = [9, 13, 27, 32], ds = Pn && "CompositionEvent" in window, ar = null;
  Pn && "documentMode" in document && (ar = document.documentMode);
  var Zv = Pn && "TextEvent" in window && !ar, Td = Pn && (!ds || ar && 8 < ar && 11 >= ar), wd = " ", xd = !1;
  function Ad(t, e) {
    switch (t) {
      case "keyup":
        return Qv.indexOf(e.keyCode) !== -1;
      case "keydown":
        return e.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function _d(t) {
    return t = t.detail, typeof t == "object" && "data" in t ? t.data : null;
  }
  var ai = !1;
  function Kv(t, e) {
    switch (t) {
      case "compositionend":
        return _d(e);
      case "keypress":
        return e.which !== 32 ? null : (xd = !0, wd);
      case "textInput":
        return t = e.data, t === wd && xd ? null : t;
      default:
        return null;
    }
  }
  function $v(t, e) {
    if (ai)
      return t === "compositionend" || !ds && Ad(t, e) ? (t = gd(), cu = us = Ra = null, ai = !1, t) : null;
    switch (t) {
      case "paste":
        return null;
      case "keypress":
        if (!(e.ctrlKey || e.altKey || e.metaKey) || e.ctrlKey && e.altKey) {
          if (e.char && 1 < e.char.length)
            return e.char;
          if (e.which) return String.fromCharCode(e.which);
        }
        return null;
      case "compositionend":
        return Td && e.locale !== "ko" ? null : e.data;
      default:
        return null;
    }
  }
  var Jv = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
  };
  function Od(t) {
    var e = t && t.nodeName && t.nodeName.toLowerCase();
    return e === "input" ? !!Jv[t.type] : e === "textarea";
  }
  function Nd(t, e, n, a) {
    ei ? ni ? ni.push(a) : ni = [a] : ei = a, e = ec(e, "onChange"), 0 < e.length && (n = new fu(
      "onChange",
      "change",
      null,
      n,
      a
    ), t.push({ event: n, listeners: e }));
  }
  var lr = null, ir = null;
  function Wv(t) {
    sp(t, 0);
  }
  function hu(t) {
    var e = Ze(t);
    if (Ii(e)) return t;
  }
  function Ed(t, e) {
    if (t === "change") return e;
  }
  var jd = !1;
  if (Pn) {
    var hs;
    if (Pn) {
      var ms = "oninput" in document;
      if (!ms) {
        var Rd = document.createElement("div");
        Rd.setAttribute("oninput", "return;"), ms = typeof Rd.oninput == "function";
      }
      hs = ms;
    } else hs = !1;
    jd = hs && (!document.documentMode || 9 < document.documentMode);
  }
  function Cd() {
    lr && (lr.detachEvent("onpropertychange", Dd), ir = lr = null);
  }
  function Dd(t) {
    if (t.propertyName === "value" && hu(ir)) {
      var e = [];
      Nd(
        e,
        ir,
        t,
        ls(t)
      ), pd(Wv, e);
    }
  }
  function Fv(t, e, n) {
    t === "focusin" ? (Cd(), lr = e, ir = n, lr.attachEvent("onpropertychange", Dd)) : t === "focusout" && Cd();
  }
  function Iv(t) {
    if (t === "selectionchange" || t === "keyup" || t === "keydown")
      return hu(ir);
  }
  function Pv(t, e) {
    if (t === "click") return hu(e);
  }
  function t0(t, e) {
    if (t === "input" || t === "change")
      return hu(e);
  }
  function e0(t, e) {
    return t === e && (t !== 0 || 1 / t === 1 / e) || t !== t && e !== e;
  }
  var ln = typeof Object.is == "function" ? Object.is : e0;
  function rr(t, e) {
    if (ln(t, e)) return !0;
    if (typeof t != "object" || t === null || typeof e != "object" || e === null)
      return !1;
    var n = Object.keys(t), a = Object.keys(e);
    if (n.length !== a.length) return !1;
    for (a = 0; a < n.length; a++) {
      var r = n[a];
      if (!il.call(e, r) || !ln(t[r], e[r]))
        return !1;
    }
    return !0;
  }
  function zd(t) {
    for (; t && t.firstChild; ) t = t.firstChild;
    return t;
  }
  function Md(t, e) {
    var n = zd(t);
    t = 0;
    for (var a; n; ) {
      if (n.nodeType === 3) {
        if (a = t + n.textContent.length, t <= e && a >= e)
          return { node: n, offset: e - t };
        t = a;
      }
      t: {
        for (; n; ) {
          if (n.nextSibling) {
            n = n.nextSibling;
            break t;
          }
          n = n.parentNode;
        }
        n = void 0;
      }
      n = zd(n);
    }
  }
  function kd(t, e) {
    return t && e ? t === e ? !0 : t && t.nodeType === 3 ? !1 : e && e.nodeType === 3 ? kd(t, e.parentNode) : "contains" in t ? t.contains(e) : t.compareDocumentPosition ? !!(t.compareDocumentPosition(e) & 16) : !1 : !1;
  }
  function Ld(t) {
    t = t != null && t.ownerDocument != null && t.ownerDocument.defaultView != null ? t.ownerDocument.defaultView : window;
    for (var e = Pl(t.document); e instanceof t.HTMLIFrameElement; ) {
      try {
        var n = typeof e.contentWindow.location.href == "string";
      } catch {
        n = !1;
      }
      if (n) t = e.contentWindow;
      else break;
      e = Pl(t.document);
    }
    return e;
  }
  function ps(t) {
    var e = t && t.nodeName && t.nodeName.toLowerCase();
    return e && (e === "input" && (t.type === "text" || t.type === "search" || t.type === "tel" || t.type === "url" || t.type === "password") || e === "textarea" || t.contentEditable === "true");
  }
  var n0 = Pn && "documentMode" in document && 11 >= document.documentMode, li = null, gs = null, ur = null, ys = !1;
  function Bd(t, e, n) {
    var a = n.window === n ? n.document : n.nodeType === 9 ? n : n.ownerDocument;
    ys || li == null || li !== Pl(a) || (a = li, "selectionStart" in a && ps(a) ? a = { start: a.selectionStart, end: a.selectionEnd } : (a = (a.ownerDocument && a.ownerDocument.defaultView || window).getSelection(), a = {
      anchorNode: a.anchorNode,
      anchorOffset: a.anchorOffset,
      focusNode: a.focusNode,
      focusOffset: a.focusOffset
    }), ur && rr(ur, a) || (ur = a, a = ec(gs, "onSelect"), 0 < a.length && (e = new fu(
      "onSelect",
      "select",
      null,
      e,
      n
    ), t.push({ event: e, listeners: a }), e.target = li)));
  }
  function pl(t, e) {
    var n = {};
    return n[t.toLowerCase()] = e.toLowerCase(), n["Webkit" + t] = "webkit" + e, n["Moz" + t] = "moz" + e, n;
  }
  var ii = {
    animationend: pl("Animation", "AnimationEnd"),
    animationiteration: pl("Animation", "AnimationIteration"),
    animationstart: pl("Animation", "AnimationStart"),
    transitionrun: pl("Transition", "TransitionRun"),
    transitionstart: pl("Transition", "TransitionStart"),
    transitioncancel: pl("Transition", "TransitionCancel"),
    transitionend: pl("Transition", "TransitionEnd")
  }, vs = {}, Hd = {};
  Pn && (Hd = document.createElement("div").style, "AnimationEvent" in window || (delete ii.animationend.animation, delete ii.animationiteration.animation, delete ii.animationstart.animation), "TransitionEvent" in window || delete ii.transitionend.transition);
  function gl(t) {
    if (vs[t]) return vs[t];
    if (!ii[t]) return t;
    var e = ii[t], n;
    for (n in e)
      if (e.hasOwnProperty(n) && n in Hd)
        return vs[t] = e[n];
    return t;
  }
  var Ud = gl("animationend"), qd = gl("animationiteration"), Vd = gl("animationstart"), a0 = gl("transitionrun"), l0 = gl("transitionstart"), i0 = gl("transitioncancel"), Yd = gl("transitionend"), Gd = /* @__PURE__ */ new Map(), bs = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(
    " "
  );
  bs.push("scrollEnd");
  function _n(t, e) {
    Gd.set(t, e), Ln(e, [t]);
  }
  var mu = typeof reportError == "function" ? reportError : function(t) {
    if (typeof window == "object" && typeof window.ErrorEvent == "function") {
      var e = new window.ErrorEvent("error", {
        bubbles: !0,
        cancelable: !0,
        message: typeof t == "object" && t !== null && typeof t.message == "string" ? String(t.message) : String(t),
        error: t
      });
      if (!window.dispatchEvent(e)) return;
    } else if (typeof l == "object" && typeof l.emit == "function") {
      l.emit("uncaughtException", t);
      return;
    }
    console.error(t);
  }, pn = [], ri = 0, Ss = 0;
  function pu() {
    for (var t = ri, e = Ss = ri = 0; e < t; ) {
      var n = pn[e];
      pn[e++] = null;
      var a = pn[e];
      pn[e++] = null;
      var r = pn[e];
      pn[e++] = null;
      var c = pn[e];
      if (pn[e++] = null, a !== null && r !== null) {
        var d = a.pending;
        d === null ? r.next = r : (r.next = d.next, d.next = r), a.pending = r;
      }
      c !== 0 && Xd(n, r, c);
    }
  }
  function gu(t, e, n, a) {
    pn[ri++] = t, pn[ri++] = e, pn[ri++] = n, pn[ri++] = a, Ss |= a, t.lanes |= a, t = t.alternate, t !== null && (t.lanes |= a);
  }
  function Ts(t, e, n, a) {
    return gu(t, e, n, a), yu(t);
  }
  function yl(t, e) {
    return gu(t, null, null, e), yu(t);
  }
  function Xd(t, e, n) {
    t.lanes |= n;
    var a = t.alternate;
    a !== null && (a.lanes |= n);
    for (var r = !1, c = t.return; c !== null; )
      c.childLanes |= n, a = c.alternate, a !== null && (a.childLanes |= n), c.tag === 22 && (t = c.stateNode, t === null || t._visibility & 1 || (r = !0)), t = c, c = c.return;
    return t.tag === 3 ? (c = t.stateNode, r && e !== null && (r = 31 - Ce(n), t = c.hiddenUpdates, a = t[r], a === null ? t[r] = [e] : a.push(e), e.lane = n | 536870912), c) : null;
  }
  function yu(t) {
    if (50 < jr)
      throw jr = 0, Co = null, Error(o(185));
    for (var e = t.return; e !== null; )
      t = e, e = t.return;
    return t.tag === 3 ? t.stateNode : null;
  }
  var ui = {};
  function r0(t, e, n, a) {
    this.tag = t, this.key = n, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.refCleanup = this.ref = null, this.pendingProps = e, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = a, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function rn(t, e, n, a) {
    return new r0(t, e, n, a);
  }
  function ws(t) {
    return t = t.prototype, !(!t || !t.isReactComponent);
  }
  function ta(t, e) {
    var n = t.alternate;
    return n === null ? (n = rn(
      t.tag,
      e,
      t.key,
      t.mode
    ), n.elementType = t.elementType, n.type = t.type, n.stateNode = t.stateNode, n.alternate = t, t.alternate = n) : (n.pendingProps = e, n.type = t.type, n.flags = 0, n.subtreeFlags = 0, n.deletions = null), n.flags = t.flags & 65011712, n.childLanes = t.childLanes, n.lanes = t.lanes, n.child = t.child, n.memoizedProps = t.memoizedProps, n.memoizedState = t.memoizedState, n.updateQueue = t.updateQueue, e = t.dependencies, n.dependencies = e === null ? null : { lanes: e.lanes, firstContext: e.firstContext }, n.sibling = t.sibling, n.index = t.index, n.ref = t.ref, n.refCleanup = t.refCleanup, n;
  }
  function Qd(t, e) {
    t.flags &= 65011714;
    var n = t.alternate;
    return n === null ? (t.childLanes = 0, t.lanes = e, t.child = null, t.subtreeFlags = 0, t.memoizedProps = null, t.memoizedState = null, t.updateQueue = null, t.dependencies = null, t.stateNode = null) : (t.childLanes = n.childLanes, t.lanes = n.lanes, t.child = n.child, t.subtreeFlags = 0, t.deletions = null, t.memoizedProps = n.memoizedProps, t.memoizedState = n.memoizedState, t.updateQueue = n.updateQueue, t.type = n.type, e = n.dependencies, t.dependencies = e === null ? null : {
      lanes: e.lanes,
      firstContext: e.firstContext
    }), t;
  }
  function vu(t, e, n, a, r, c) {
    var d = 0;
    if (a = t, typeof t == "function") ws(t) && (d = 1);
    else if (typeof t == "string")
      d = fb(
        t,
        n,
        ot.current
      ) ? 26 : t === "html" || t === "head" || t === "body" ? 27 : 5;
    else
      t: switch (t) {
        case yt:
          return t = rn(31, n, e, r), t.elementType = yt, t.lanes = c, t;
        case q:
          return vl(n.children, r, c, e);
        case Y:
          d = 8, r |= 24;
          break;
        case L:
          return t = rn(12, n, e, r | 2), t.elementType = L, t.lanes = c, t;
        case B:
          return t = rn(13, n, e, r), t.elementType = B, t.lanes = c, t;
        case G:
          return t = rn(19, n, e, r), t.elementType = G, t.lanes = c, t;
        default:
          if (typeof t == "object" && t !== null)
            switch (t.$$typeof) {
              case W:
                d = 10;
                break t;
              case et:
                d = 9;
                break t;
              case X:
                d = 11;
                break t;
              case F:
                d = 14;
                break t;
              case ut:
                d = 16, a = null;
                break t;
            }
          d = 29, n = Error(
            o(130, t === null ? "null" : typeof t, "")
          ), a = null;
      }
    return e = rn(d, n, e, r), e.elementType = t, e.type = a, e.lanes = c, e;
  }
  function vl(t, e, n, a) {
    return t = rn(7, t, a, e), t.lanes = n, t;
  }
  function xs(t, e, n) {
    return t = rn(6, t, null, e), t.lanes = n, t;
  }
  function Zd(t) {
    var e = rn(18, null, null, 0);
    return e.stateNode = t, e;
  }
  function As(t, e, n) {
    return e = rn(
      4,
      t.children !== null ? t.children : [],
      t.key,
      e
    ), e.lanes = n, e.stateNode = {
      containerInfo: t.containerInfo,
      pendingChildren: null,
      implementation: t.implementation
    }, e;
  }
  var Kd = /* @__PURE__ */ new WeakMap();
  function gn(t, e) {
    if (typeof t == "object" && t !== null) {
      var n = Kd.get(t);
      return n !== void 0 ? n : (e = {
        value: t,
        source: e,
        stack: Vi(e)
      }, Kd.set(t, e), e);
    }
    return {
      value: t,
      source: e,
      stack: Vi(e)
    };
  }
  var ci = [], si = 0, bu = null, cr = 0, yn = [], vn = 0, Ca = null, Hn = 1, Un = "";
  function ea(t, e) {
    ci[si++] = cr, ci[si++] = bu, bu = t, cr = e;
  }
  function $d(t, e, n) {
    yn[vn++] = Hn, yn[vn++] = Un, yn[vn++] = Ca, Ca = t;
    var a = Hn;
    t = Un;
    var r = 32 - Ce(a) - 1;
    a &= ~(1 << r), n += 1;
    var c = 32 - Ce(e) + r;
    if (30 < c) {
      var d = r - r % 5;
      c = (a & (1 << d) - 1).toString(32), a >>= d, r -= d, Hn = 1 << 32 - Ce(e) + r | n << r | a, Un = c + t;
    } else
      Hn = 1 << c | n << r | a, Un = t;
  }
  function _s(t) {
    t.return !== null && (ea(t, 1), $d(t, 1, 0));
  }
  function Os(t) {
    for (; t === bu; )
      bu = ci[--si], ci[si] = null, cr = ci[--si], ci[si] = null;
    for (; t === Ca; )
      Ca = yn[--vn], yn[vn] = null, Un = yn[--vn], yn[vn] = null, Hn = yn[--vn], yn[vn] = null;
  }
  function Jd(t, e) {
    yn[vn++] = Hn, yn[vn++] = Un, yn[vn++] = Ca, Hn = e.id, Un = e.overflow, Ca = t;
  }
  var De = null, It = null, _t = !1, Da = null, bn = !1, Ns = Error(o(519));
  function za(t) {
    var e = Error(
      o(
        418,
        1 < arguments.length && arguments[1] !== void 0 && arguments[1] ? "text" : "HTML",
        ""
      )
    );
    throw sr(gn(e, t)), Ns;
  }
  function Wd(t) {
    var e = t.stateNode, n = t.type, a = t.memoizedProps;
    switch (e[ht] = t, e[he] = a, n) {
      case "dialog":
        Tt("cancel", e), Tt("close", e);
        break;
      case "iframe":
      case "object":
      case "embed":
        Tt("load", e);
        break;
      case "video":
      case "audio":
        for (n = 0; n < Cr.length; n++)
          Tt(Cr[n], e);
        break;
      case "source":
        Tt("error", e);
        break;
      case "img":
      case "image":
      case "link":
        Tt("error", e), Tt("load", e);
        break;
      case "details":
        Tt("toggle", e);
        break;
      case "input":
        Tt("invalid", e), ti(
          e,
          a.value,
          a.defaultValue,
          a.checked,
          a.defaultChecked,
          a.type,
          a.name,
          !0
        );
        break;
      case "select":
        Tt("invalid", e);
        break;
      case "textarea":
        Tt("invalid", e), K(e, a.value, a.defaultValue, a.children);
    }
    n = a.children, typeof n != "string" && typeof n != "number" && typeof n != "bigint" || e.textContent === "" + n || a.suppressHydrationWarning === !0 || hp(e.textContent, n) ? (a.popover != null && (Tt("beforetoggle", e), Tt("toggle", e)), a.onScroll != null && Tt("scroll", e), a.onScrollEnd != null && Tt("scrollend", e), a.onClick != null && (e.onclick = Ft), e = !0) : e = !1, e || za(t, !0);
  }
  function Fd(t) {
    for (De = t.return; De; )
      switch (De.tag) {
        case 5:
        case 31:
        case 13:
          bn = !1;
          return;
        case 27:
        case 3:
          bn = !0;
          return;
        default:
          De = De.return;
      }
  }
  function oi(t) {
    if (t !== De) return !1;
    if (!_t) return Fd(t), _t = !0, !1;
    var e = t.tag, n;
    if ((n = e !== 3 && e !== 27) && ((n = e === 5) && (n = t.type, n = !(n !== "form" && n !== "button") || Zo(t.type, t.memoizedProps)), n = !n), n && It && za(t), Fd(t), e === 13) {
      if (t = t.memoizedState, t = t !== null ? t.dehydrated : null, !t) throw Error(o(317));
      It = wp(t);
    } else if (e === 31) {
      if (t = t.memoizedState, t = t !== null ? t.dehydrated : null, !t) throw Error(o(317));
      It = wp(t);
    } else
      e === 27 ? (e = It, Ka(t.type) ? (t = Fo, Fo = null, It = t) : It = e) : It = De ? Tn(t.stateNode.nextSibling) : null;
    return !0;
  }
  function bl() {
    It = De = null, _t = !1;
  }
  function Es() {
    var t = Da;
    return t !== null && (tn === null ? tn = t : tn.push.apply(
      tn,
      t
    ), Da = null), t;
  }
  function sr(t) {
    Da === null ? Da = [t] : Da.push(t);
  }
  var js = vt(null), Sl = null, na = null;
  function Ma(t, e, n) {
    at(js, e._currentValue), e._currentValue = n;
  }
  function aa(t) {
    t._currentValue = js.current, ct(js);
  }
  function Rs(t, e, n) {
    for (; t !== null; ) {
      var a = t.alternate;
      if ((t.childLanes & e) !== e ? (t.childLanes |= e, a !== null && (a.childLanes |= e)) : a !== null && (a.childLanes & e) !== e && (a.childLanes |= e), t === n) break;
      t = t.return;
    }
  }
  function Cs(t, e, n, a) {
    var r = t.child;
    for (r !== null && (r.return = t); r !== null; ) {
      var c = r.dependencies;
      if (c !== null) {
        var d = r.child;
        c = c.firstContext;
        t: for (; c !== null; ) {
          var v = c;
          c = r;
          for (var w = 0; w < e.length; w++)
            if (v.context === e[w]) {
              c.lanes |= n, v = c.alternate, v !== null && (v.lanes |= n), Rs(
                c.return,
                n,
                t
              ), a || (d = null);
              break t;
            }
          c = v.next;
        }
      } else if (r.tag === 18) {
        if (d = r.return, d === null) throw Error(o(341));
        d.lanes |= n, c = d.alternate, c !== null && (c.lanes |= n), Rs(d, n, t), d = null;
      } else d = r.child;
      if (d !== null) d.return = r;
      else
        for (d = r; d !== null; ) {
          if (d === t) {
            d = null;
            break;
          }
          if (r = d.sibling, r !== null) {
            r.return = d.return, d = r;
            break;
          }
          d = d.return;
        }
      r = d;
    }
  }
  function fi(t, e, n, a) {
    t = null;
    for (var r = e, c = !1; r !== null; ) {
      if (!c) {
        if ((r.flags & 524288) !== 0) c = !0;
        else if ((r.flags & 262144) !== 0) break;
      }
      if (r.tag === 10) {
        var d = r.alternate;
        if (d === null) throw Error(o(387));
        if (d = d.memoizedProps, d !== null) {
          var v = r.type;
          ln(r.pendingProps.value, d.value) || (t !== null ? t.push(v) : t = [v]);
        }
      } else if (r === bt.current) {
        if (d = r.alternate, d === null) throw Error(o(387));
        d.memoizedState.memoizedState !== r.memoizedState.memoizedState && (t !== null ? t.push(Lr) : t = [Lr]);
      }
      r = r.return;
    }
    t !== null && Cs(
      e,
      t,
      n,
      a
    ), e.flags |= 262144;
  }
  function Su(t) {
    for (t = t.firstContext; t !== null; ) {
      if (!ln(
        t.context._currentValue,
        t.memoizedValue
      ))
        return !0;
      t = t.next;
    }
    return !1;
  }
  function Tl(t) {
    Sl = t, na = null, t = t.dependencies, t !== null && (t.firstContext = null);
  }
  function ze(t) {
    return Id(Sl, t);
  }
  function Tu(t, e) {
    return Sl === null && Tl(t), Id(t, e);
  }
  function Id(t, e) {
    var n = e._currentValue;
    if (e = { context: e, memoizedValue: n, next: null }, na === null) {
      if (t === null) throw Error(o(308));
      na = e, t.dependencies = { lanes: 0, firstContext: e }, t.flags |= 524288;
    } else na = na.next = e;
    return n;
  }
  var u0 = typeof AbortController < "u" ? AbortController : function() {
    var t = [], e = this.signal = {
      aborted: !1,
      addEventListener: function(n, a) {
        t.push(a);
      }
    };
    this.abort = function() {
      e.aborted = !0, t.forEach(function(n) {
        return n();
      });
    };
  }, c0 = i.unstable_scheduleCallback, s0 = i.unstable_NormalPriority, Te = {
    $$typeof: W,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
  };
  function Ds() {
    return {
      controller: new u0(),
      data: /* @__PURE__ */ new Map(),
      refCount: 0
    };
  }
  function or(t) {
    t.refCount--, t.refCount === 0 && c0(s0, function() {
      t.controller.abort();
    });
  }
  var fr = null, zs = 0, di = 0, hi = null;
  function o0(t, e) {
    if (fr === null) {
      var n = fr = [];
      zs = 0, di = Bo(), hi = {
        status: "pending",
        value: void 0,
        then: function(a) {
          n.push(a);
        }
      };
    }
    return zs++, e.then(Pd, Pd), e;
  }
  function Pd() {
    if (--zs === 0 && fr !== null) {
      hi !== null && (hi.status = "fulfilled");
      var t = fr;
      fr = null, di = 0, hi = null;
      for (var e = 0; e < t.length; e++) (0, t[e])();
    }
  }
  function f0(t, e) {
    var n = [], a = {
      status: "pending",
      value: null,
      reason: null,
      then: function(r) {
        n.push(r);
      }
    };
    return t.then(
      function() {
        a.status = "fulfilled", a.value = e;
        for (var r = 0; r < n.length; r++) (0, n[r])(e);
      },
      function(r) {
        for (a.status = "rejected", a.reason = r, r = 0; r < n.length; r++)
          (0, n[r])(void 0);
      }
    ), a;
  }
  var th = V.S;
  V.S = function(t, e) {
    Bm = de(), typeof e == "object" && e !== null && typeof e.then == "function" && o0(t, e), th !== null && th(t, e);
  };
  var wl = vt(null);
  function Ms() {
    var t = wl.current;
    return t !== null ? t : $t.pooledCache;
  }
  function wu(t, e) {
    e === null ? at(wl, wl.current) : at(wl, e.pool);
  }
  function eh() {
    var t = Ms();
    return t === null ? null : { parent: Te._currentValue, pool: t };
  }
  var mi = Error(o(460)), ks = Error(o(474)), xu = Error(o(542)), Au = { then: function() {
  } };
  function nh(t) {
    return t = t.status, t === "fulfilled" || t === "rejected";
  }
  function ah(t, e, n) {
    switch (n = t[n], n === void 0 ? t.push(e) : n !== e && (e.then(Ft, Ft), e = n), e.status) {
      case "fulfilled":
        return e.value;
      case "rejected":
        throw t = e.reason, ih(t), t;
      default:
        if (typeof e.status == "string") e.then(Ft, Ft);
        else {
          if (t = $t, t !== null && 100 < t.shellSuspendCounter)
            throw Error(o(482));
          t = e, t.status = "pending", t.then(
            function(a) {
              if (e.status === "pending") {
                var r = e;
                r.status = "fulfilled", r.value = a;
              }
            },
            function(a) {
              if (e.status === "pending") {
                var r = e;
                r.status = "rejected", r.reason = a;
              }
            }
          );
        }
        switch (e.status) {
          case "fulfilled":
            return e.value;
          case "rejected":
            throw t = e.reason, ih(t), t;
        }
        throw Al = e, mi;
    }
  }
  function xl(t) {
    try {
      var e = t._init;
      return e(t._payload);
    } catch (n) {
      throw n !== null && typeof n == "object" && typeof n.then == "function" ? (Al = n, mi) : n;
    }
  }
  var Al = null;
  function lh() {
    if (Al === null) throw Error(o(459));
    var t = Al;
    return Al = null, t;
  }
  function ih(t) {
    if (t === mi || t === xu)
      throw Error(o(483));
  }
  var pi = null, dr = 0;
  function _u(t) {
    var e = dr;
    return dr += 1, pi === null && (pi = []), ah(pi, t, e);
  }
  function hr(t, e) {
    e = e.props.ref, t.ref = e !== void 0 ? e : null;
  }
  function Ou(t, e) {
    throw e.$$typeof === U ? Error(o(525)) : (t = Object.prototype.toString.call(e), Error(
      o(
        31,
        t === "[object Object]" ? "object with keys {" + Object.keys(e).join(", ") + "}" : t
      )
    ));
  }
  function rh(t) {
    function e(O, _) {
      if (t) {
        var N = O.deletions;
        N === null ? (O.deletions = [_], O.flags |= 16) : N.push(_);
      }
    }
    function n(O, _) {
      if (!t) return null;
      for (; _ !== null; )
        e(O, _), _ = _.sibling;
      return null;
    }
    function a(O) {
      for (var _ = /* @__PURE__ */ new Map(); O !== null; )
        O.key !== null ? _.set(O.key, O) : _.set(O.index, O), O = O.sibling;
      return _;
    }
    function r(O, _) {
      return O = ta(O, _), O.index = 0, O.sibling = null, O;
    }
    function c(O, _, N) {
      return O.index = N, t ? (N = O.alternate, N !== null ? (N = N.index, N < _ ? (O.flags |= 67108866, _) : N) : (O.flags |= 67108866, _)) : (O.flags |= 1048576, _);
    }
    function d(O) {
      return t && O.alternate === null && (O.flags |= 67108866), O;
    }
    function v(O, _, N, k) {
      return _ === null || _.tag !== 6 ? (_ = xs(N, O.mode, k), _.return = O, _) : (_ = r(_, N), _.return = O, _);
    }
    function w(O, _, N, k) {
      var it = N.type;
      return it === q ? M(
        O,
        _,
        N.props.children,
        k,
        N.key
      ) : _ !== null && (_.elementType === it || typeof it == "object" && it !== null && it.$$typeof === ut && xl(it) === _.type) ? (_ = r(_, N.props), hr(_, N), _.return = O, _) : (_ = vu(
        N.type,
        N.key,
        N.props,
        null,
        O.mode,
        k
      ), hr(_, N), _.return = O, _);
    }
    function E(O, _, N, k) {
      return _ === null || _.tag !== 4 || _.stateNode.containerInfo !== N.containerInfo || _.stateNode.implementation !== N.implementation ? (_ = As(N, O.mode, k), _.return = O, _) : (_ = r(_, N.children || []), _.return = O, _);
    }
    function M(O, _, N, k, it) {
      return _ === null || _.tag !== 7 ? (_ = vl(
        N,
        O.mode,
        k,
        it
      ), _.return = O, _) : (_ = r(_, N), _.return = O, _);
    }
    function H(O, _, N) {
      if (typeof _ == "string" && _ !== "" || typeof _ == "number" || typeof _ == "bigint")
        return _ = xs(
          "" + _,
          O.mode,
          N
        ), _.return = O, _;
      if (typeof _ == "object" && _ !== null) {
        switch (_.$$typeof) {
          case D:
            return N = vu(
              _.type,
              _.key,
              _.props,
              null,
              O.mode,
              N
            ), hr(N, _), N.return = O, N;
          case R:
            return _ = As(
              _,
              O.mode,
              N
            ), _.return = O, _;
          case ut:
            return _ = xl(_), H(O, _, N);
        }
        if (Q(_) || pt(_))
          return _ = vl(
            _,
            O.mode,
            N,
            null
          ), _.return = O, _;
        if (typeof _.then == "function")
          return H(O, _u(_), N);
        if (_.$$typeof === W)
          return H(
            O,
            Tu(O, _),
            N
          );
        Ou(O, _);
      }
      return null;
    }
    function C(O, _, N, k) {
      var it = _ !== null ? _.key : null;
      if (typeof N == "string" && N !== "" || typeof N == "number" || typeof N == "bigint")
        return it !== null ? null : v(O, _, "" + N, k);
      if (typeof N == "object" && N !== null) {
        switch (N.$$typeof) {
          case D:
            return N.key === it ? w(O, _, N, k) : null;
          case R:
            return N.key === it ? E(O, _, N, k) : null;
          case ut:
            return N = xl(N), C(O, _, N, k);
        }
        if (Q(N) || pt(N))
          return it !== null ? null : M(O, _, N, k, null);
        if (typeof N.then == "function")
          return C(
            O,
            _,
            _u(N),
            k
          );
        if (N.$$typeof === W)
          return C(
            O,
            _,
            Tu(O, N),
            k
          );
        Ou(O, N);
      }
      return null;
    }
    function z(O, _, N, k, it) {
      if (typeof k == "string" && k !== "" || typeof k == "number" || typeof k == "bigint")
        return O = O.get(N) || null, v(_, O, "" + k, it);
      if (typeof k == "object" && k !== null) {
        switch (k.$$typeof) {
          case D:
            return O = O.get(
              k.key === null ? N : k.key
            ) || null, w(_, O, k, it);
          case R:
            return O = O.get(
              k.key === null ? N : k.key
            ) || null, E(_, O, k, it);
          case ut:
            return k = xl(k), z(
              O,
              _,
              N,
              k,
              it
            );
        }
        if (Q(k) || pt(k))
          return O = O.get(N) || null, M(_, O, k, it, null);
        if (typeof k.then == "function")
          return z(
            O,
            _,
            N,
            _u(k),
            it
          );
        if (k.$$typeof === W)
          return z(
            O,
            _,
            N,
            Tu(_, k),
            it
          );
        Ou(_, k);
      }
      return null;
    }
    function P(O, _, N, k) {
      for (var it = null, Et = null, nt = _, dt = _ = 0, At = null; nt !== null && dt < N.length; dt++) {
        nt.index > dt ? (At = nt, nt = null) : At = nt.sibling;
        var jt = C(
          O,
          nt,
          N[dt],
          k
        );
        if (jt === null) {
          nt === null && (nt = At);
          break;
        }
        t && nt && jt.alternate === null && e(O, nt), _ = c(jt, _, dt), Et === null ? it = jt : Et.sibling = jt, Et = jt, nt = At;
      }
      if (dt === N.length)
        return n(O, nt), _t && ea(O, dt), it;
      if (nt === null) {
        for (; dt < N.length; dt++)
          nt = H(O, N[dt], k), nt !== null && (_ = c(
            nt,
            _,
            dt
          ), Et === null ? it = nt : Et.sibling = nt, Et = nt);
        return _t && ea(O, dt), it;
      }
      for (nt = a(nt); dt < N.length; dt++)
        At = z(
          nt,
          O,
          dt,
          N[dt],
          k
        ), At !== null && (t && At.alternate !== null && nt.delete(
          At.key === null ? dt : At.key
        ), _ = c(
          At,
          _,
          dt
        ), Et === null ? it = At : Et.sibling = At, Et = At);
      return t && nt.forEach(function(Ia) {
        return e(O, Ia);
      }), _t && ea(O, dt), it;
    }
    function rt(O, _, N, k) {
      if (N == null) throw Error(o(151));
      for (var it = null, Et = null, nt = _, dt = _ = 0, At = null, jt = N.next(); nt !== null && !jt.done; dt++, jt = N.next()) {
        nt.index > dt ? (At = nt, nt = null) : At = nt.sibling;
        var Ia = C(O, nt, jt.value, k);
        if (Ia === null) {
          nt === null && (nt = At);
          break;
        }
        t && nt && Ia.alternate === null && e(O, nt), _ = c(Ia, _, dt), Et === null ? it = Ia : Et.sibling = Ia, Et = Ia, nt = At;
      }
      if (jt.done)
        return n(O, nt), _t && ea(O, dt), it;
      if (nt === null) {
        for (; !jt.done; dt++, jt = N.next())
          jt = H(O, jt.value, k), jt !== null && (_ = c(jt, _, dt), Et === null ? it = jt : Et.sibling = jt, Et = jt);
        return _t && ea(O, dt), it;
      }
      for (nt = a(nt); !jt.done; dt++, jt = N.next())
        jt = z(nt, O, dt, jt.value, k), jt !== null && (t && jt.alternate !== null && nt.delete(jt.key === null ? dt : jt.key), _ = c(jt, _, dt), Et === null ? it = jt : Et.sibling = jt, Et = jt);
      return t && nt.forEach(function(wb) {
        return e(O, wb);
      }), _t && ea(O, dt), it;
    }
    function Yt(O, _, N, k) {
      if (typeof N == "object" && N !== null && N.type === q && N.key === null && (N = N.props.children), typeof N == "object" && N !== null) {
        switch (N.$$typeof) {
          case D:
            t: {
              for (var it = N.key; _ !== null; ) {
                if (_.key === it) {
                  if (it = N.type, it === q) {
                    if (_.tag === 7) {
                      n(
                        O,
                        _.sibling
                      ), k = r(
                        _,
                        N.props.children
                      ), k.return = O, O = k;
                      break t;
                    }
                  } else if (_.elementType === it || typeof it == "object" && it !== null && it.$$typeof === ut && xl(it) === _.type) {
                    n(
                      O,
                      _.sibling
                    ), k = r(_, N.props), hr(k, N), k.return = O, O = k;
                    break t;
                  }
                  n(O, _);
                  break;
                } else e(O, _);
                _ = _.sibling;
              }
              N.type === q ? (k = vl(
                N.props.children,
                O.mode,
                k,
                N.key
              ), k.return = O, O = k) : (k = vu(
                N.type,
                N.key,
                N.props,
                null,
                O.mode,
                k
              ), hr(k, N), k.return = O, O = k);
            }
            return d(O);
          case R:
            t: {
              for (it = N.key; _ !== null; ) {
                if (_.key === it)
                  if (_.tag === 4 && _.stateNode.containerInfo === N.containerInfo && _.stateNode.implementation === N.implementation) {
                    n(
                      O,
                      _.sibling
                    ), k = r(_, N.children || []), k.return = O, O = k;
                    break t;
                  } else {
                    n(O, _);
                    break;
                  }
                else e(O, _);
                _ = _.sibling;
              }
              k = As(N, O.mode, k), k.return = O, O = k;
            }
            return d(O);
          case ut:
            return N = xl(N), Yt(
              O,
              _,
              N,
              k
            );
        }
        if (Q(N))
          return P(
            O,
            _,
            N,
            k
          );
        if (pt(N)) {
          if (it = pt(N), typeof it != "function") throw Error(o(150));
          return N = it.call(N), rt(
            O,
            _,
            N,
            k
          );
        }
        if (typeof N.then == "function")
          return Yt(
            O,
            _,
            _u(N),
            k
          );
        if (N.$$typeof === W)
          return Yt(
            O,
            _,
            Tu(O, N),
            k
          );
        Ou(O, N);
      }
      return typeof N == "string" && N !== "" || typeof N == "number" || typeof N == "bigint" ? (N = "" + N, _ !== null && _.tag === 6 ? (n(O, _.sibling), k = r(_, N), k.return = O, O = k) : (n(O, _), k = xs(N, O.mode, k), k.return = O, O = k), d(O)) : n(O, _);
    }
    return function(O, _, N, k) {
      try {
        dr = 0;
        var it = Yt(
          O,
          _,
          N,
          k
        );
        return pi = null, it;
      } catch (nt) {
        if (nt === mi || nt === xu) throw nt;
        var Et = rn(29, nt, null, O.mode);
        return Et.lanes = k, Et.return = O, Et;
      } finally {
      }
    };
  }
  var _l = rh(!0), uh = rh(!1), ka = !1;
  function Ls(t) {
    t.updateQueue = {
      baseState: t.memoizedState,
      firstBaseUpdate: null,
      lastBaseUpdate: null,
      shared: { pending: null, lanes: 0, hiddenCallbacks: null },
      callbacks: null
    };
  }
  function Bs(t, e) {
    t = t.updateQueue, e.updateQueue === t && (e.updateQueue = {
      baseState: t.baseState,
      firstBaseUpdate: t.firstBaseUpdate,
      lastBaseUpdate: t.lastBaseUpdate,
      shared: t.shared,
      callbacks: null
    });
  }
  function La(t) {
    return { lane: t, tag: 0, payload: null, callback: null, next: null };
  }
  function Ba(t, e, n) {
    var a = t.updateQueue;
    if (a === null) return null;
    if (a = a.shared, (Mt & 2) !== 0) {
      var r = a.pending;
      return r === null ? e.next = e : (e.next = r.next, r.next = e), a.pending = e, e = yu(t), Xd(t, null, n), e;
    }
    return gu(t, a, e, n), yu(t);
  }
  function mr(t, e, n) {
    if (e = e.updateQueue, e !== null && (e = e.shared, (n & 4194048) !== 0)) {
      var a = e.lanes;
      a &= t.pendingLanes, n |= a, e.lanes = n, Jl(t, n);
    }
  }
  function Hs(t, e) {
    var n = t.updateQueue, a = t.alternate;
    if (a !== null && (a = a.updateQueue, n === a)) {
      var r = null, c = null;
      if (n = n.firstBaseUpdate, n !== null) {
        do {
          var d = {
            lane: n.lane,
            tag: n.tag,
            payload: n.payload,
            callback: null,
            next: null
          };
          c === null ? r = c = d : c = c.next = d, n = n.next;
        } while (n !== null);
        c === null ? r = c = e : c = c.next = e;
      } else r = c = e;
      n = {
        baseState: a.baseState,
        firstBaseUpdate: r,
        lastBaseUpdate: c,
        shared: a.shared,
        callbacks: a.callbacks
      }, t.updateQueue = n;
      return;
    }
    t = n.lastBaseUpdate, t === null ? n.firstBaseUpdate = e : t.next = e, n.lastBaseUpdate = e;
  }
  var Us = !1;
  function pr() {
    if (Us) {
      var t = hi;
      if (t !== null) throw t;
    }
  }
  function gr(t, e, n, a) {
    Us = !1;
    var r = t.updateQueue;
    ka = !1;
    var c = r.firstBaseUpdate, d = r.lastBaseUpdate, v = r.shared.pending;
    if (v !== null) {
      r.shared.pending = null;
      var w = v, E = w.next;
      w.next = null, d === null ? c = E : d.next = E, d = w;
      var M = t.alternate;
      M !== null && (M = M.updateQueue, v = M.lastBaseUpdate, v !== d && (v === null ? M.firstBaseUpdate = E : v.next = E, M.lastBaseUpdate = w));
    }
    if (c !== null) {
      var H = r.baseState;
      d = 0, M = E = w = null, v = c;
      do {
        var C = v.lane & -536870913, z = C !== v.lane;
        if (z ? (xt & C) === C : (a & C) === C) {
          C !== 0 && C === di && (Us = !0), M !== null && (M = M.next = {
            lane: 0,
            tag: v.tag,
            payload: v.payload,
            callback: null,
            next: null
          });
          t: {
            var P = t, rt = v;
            C = e;
            var Yt = n;
            switch (rt.tag) {
              case 1:
                if (P = rt.payload, typeof P == "function") {
                  H = P.call(Yt, H, C);
                  break t;
                }
                H = P;
                break t;
              case 3:
                P.flags = P.flags & -65537 | 128;
              case 0:
                if (P = rt.payload, C = typeof P == "function" ? P.call(Yt, H, C) : P, C == null) break t;
                H = x({}, H, C);
                break t;
              case 2:
                ka = !0;
            }
          }
          C = v.callback, C !== null && (t.flags |= 64, z && (t.flags |= 8192), z = r.callbacks, z === null ? r.callbacks = [C] : z.push(C));
        } else
          z = {
            lane: C,
            tag: v.tag,
            payload: v.payload,
            callback: v.callback,
            next: null
          }, M === null ? (E = M = z, w = H) : M = M.next = z, d |= C;
        if (v = v.next, v === null) {
          if (v = r.shared.pending, v === null)
            break;
          z = v, v = z.next, z.next = null, r.lastBaseUpdate = z, r.shared.pending = null;
        }
      } while (!0);
      M === null && (w = H), r.baseState = w, r.firstBaseUpdate = E, r.lastBaseUpdate = M, c === null && (r.shared.lanes = 0), Ya |= d, t.lanes = d, t.memoizedState = H;
    }
  }
  function ch(t, e) {
    if (typeof t != "function")
      throw Error(o(191, t));
    t.call(e);
  }
  function sh(t, e) {
    var n = t.callbacks;
    if (n !== null)
      for (t.callbacks = null, t = 0; t < n.length; t++)
        ch(n[t], e);
  }
  var gi = vt(null), Nu = vt(0);
  function oh(t, e) {
    t = da, at(Nu, t), at(gi, e), da = t | e.baseLanes;
  }
  function qs() {
    at(Nu, da), at(gi, gi.current);
  }
  function Vs() {
    da = Nu.current, ct(gi), ct(Nu);
  }
  var un = vt(null), Sn = null;
  function Ha(t) {
    var e = t.alternate;
    at(pe, pe.current & 1), at(un, t), Sn === null && (e === null || gi.current !== null || e.memoizedState !== null) && (Sn = t);
  }
  function Ys(t) {
    at(pe, pe.current), at(un, t), Sn === null && (Sn = t);
  }
  function fh(t) {
    t.tag === 22 ? (at(pe, pe.current), at(un, t), Sn === null && (Sn = t)) : Ua();
  }
  function Ua() {
    at(pe, pe.current), at(un, un.current);
  }
  function cn(t) {
    ct(un), Sn === t && (Sn = null), ct(pe);
  }
  var pe = vt(0);
  function Eu(t) {
    for (var e = t; e !== null; ) {
      if (e.tag === 13) {
        var n = e.memoizedState;
        if (n !== null && (n = n.dehydrated, n === null || Jo(n) || Wo(n)))
          return e;
      } else if (e.tag === 19 && (e.memoizedProps.revealOrder === "forwards" || e.memoizedProps.revealOrder === "backwards" || e.memoizedProps.revealOrder === "unstable_legacy-backwards" || e.memoizedProps.revealOrder === "together")) {
        if ((e.flags & 128) !== 0) return e;
      } else if (e.child !== null) {
        e.child.return = e, e = e.child;
        continue;
      }
      if (e === t) break;
      for (; e.sibling === null; ) {
        if (e.return === null || e.return === t) return null;
        e = e.return;
      }
      e.sibling.return = e.return, e = e.sibling;
    }
    return null;
  }
  var la = 0, st = null, qt = null, we = null, ju = !1, yi = !1, Ol = !1, Ru = 0, yr = 0, vi = null, d0 = 0;
  function ce() {
    throw Error(o(321));
  }
  function Gs(t, e) {
    if (e === null) return !1;
    for (var n = 0; n < e.length && n < t.length; n++)
      if (!ln(t[n], e[n])) return !1;
    return !0;
  }
  function Xs(t, e, n, a, r, c) {
    return la = c, st = e, e.memoizedState = null, e.updateQueue = null, e.lanes = 0, V.H = t === null || t.memoizedState === null ? $h : io, Ol = !1, c = n(a, r), Ol = !1, yi && (c = hh(
      e,
      n,
      a,
      r
    )), dh(t), c;
  }
  function dh(t) {
    V.H = Sr;
    var e = qt !== null && qt.next !== null;
    if (la = 0, we = qt = st = null, ju = !1, yr = 0, vi = null, e) throw Error(o(300));
    t === null || xe || (t = t.dependencies, t !== null && Su(t) && (xe = !0));
  }
  function hh(t, e, n, a) {
    st = t;
    var r = 0;
    do {
      if (yi && (vi = null), yr = 0, yi = !1, 25 <= r) throw Error(o(301));
      if (r += 1, we = qt = null, t.updateQueue != null) {
        var c = t.updateQueue;
        c.lastEffect = null, c.events = null, c.stores = null, c.memoCache != null && (c.memoCache.index = 0);
      }
      V.H = Jh, c = e(n, a);
    } while (yi);
    return c;
  }
  function h0() {
    var t = V.H, e = t.useState()[0];
    return e = typeof e.then == "function" ? vr(e) : e, t = t.useState()[0], (qt !== null ? qt.memoizedState : null) !== t && (st.flags |= 1024), e;
  }
  function Qs() {
    var t = Ru !== 0;
    return Ru = 0, t;
  }
  function Zs(t, e, n) {
    e.updateQueue = t.updateQueue, e.flags &= -2053, t.lanes &= ~n;
  }
  function Ks(t) {
    if (ju) {
      for (t = t.memoizedState; t !== null; ) {
        var e = t.queue;
        e !== null && (e.pending = null), t = t.next;
      }
      ju = !1;
    }
    la = 0, we = qt = st = null, yi = !1, yr = Ru = 0, vi = null;
  }
  function Ye() {
    var t = {
      memoizedState: null,
      baseState: null,
      baseQueue: null,
      queue: null,
      next: null
    };
    return we === null ? st.memoizedState = we = t : we = we.next = t, we;
  }
  function ge() {
    if (qt === null) {
      var t = st.alternate;
      t = t !== null ? t.memoizedState : null;
    } else t = qt.next;
    var e = we === null ? st.memoizedState : we.next;
    if (e !== null)
      we = e, qt = t;
    else {
      if (t === null)
        throw st.alternate === null ? Error(o(467)) : Error(o(310));
      qt = t, t = {
        memoizedState: qt.memoizedState,
        baseState: qt.baseState,
        baseQueue: qt.baseQueue,
        queue: qt.queue,
        next: null
      }, we === null ? st.memoizedState = we = t : we = we.next = t;
    }
    return we;
  }
  function Cu() {
    return { lastEffect: null, events: null, stores: null, memoCache: null };
  }
  function vr(t) {
    var e = yr;
    return yr += 1, vi === null && (vi = []), t = ah(vi, t, e), e = st, (we === null ? e.memoizedState : we.next) === null && (e = e.alternate, V.H = e === null || e.memoizedState === null ? $h : io), t;
  }
  function Du(t) {
    if (t !== null && typeof t == "object") {
      if (typeof t.then == "function") return vr(t);
      if (t.$$typeof === W) return ze(t);
    }
    throw Error(o(438, String(t)));
  }
  function $s(t) {
    var e = null, n = st.updateQueue;
    if (n !== null && (e = n.memoCache), e == null) {
      var a = st.alternate;
      a !== null && (a = a.updateQueue, a !== null && (a = a.memoCache, a != null && (e = {
        data: a.data.map(function(r) {
          return r.slice();
        }),
        index: 0
      })));
    }
    if (e == null && (e = { data: [], index: 0 }), n === null && (n = Cu(), st.updateQueue = n), n.memoCache = e, n = e.data[e.index], n === void 0)
      for (n = e.data[e.index] = Array(t), a = 0; a < t; a++)
        n[a] = Dt;
    return e.index++, n;
  }
  function ia(t, e) {
    return typeof e == "function" ? e(t) : e;
  }
  function zu(t) {
    var e = ge();
    return Js(e, qt, t);
  }
  function Js(t, e, n) {
    var a = t.queue;
    if (a === null) throw Error(o(311));
    a.lastRenderedReducer = n;
    var r = t.baseQueue, c = a.pending;
    if (c !== null) {
      if (r !== null) {
        var d = r.next;
        r.next = c.next, c.next = d;
      }
      e.baseQueue = r = c, a.pending = null;
    }
    if (c = t.baseState, r === null) t.memoizedState = c;
    else {
      e = r.next;
      var v = d = null, w = null, E = e, M = !1;
      do {
        var H = E.lane & -536870913;
        if (H !== E.lane ? (xt & H) === H : (la & H) === H) {
          var C = E.revertLane;
          if (C === 0)
            w !== null && (w = w.next = {
              lane: 0,
              revertLane: 0,
              gesture: null,
              action: E.action,
              hasEagerState: E.hasEagerState,
              eagerState: E.eagerState,
              next: null
            }), H === di && (M = !0);
          else if ((la & C) === C) {
            E = E.next, C === di && (M = !0);
            continue;
          } else
            H = {
              lane: 0,
              revertLane: E.revertLane,
              gesture: null,
              action: E.action,
              hasEagerState: E.hasEagerState,
              eagerState: E.eagerState,
              next: null
            }, w === null ? (v = w = H, d = c) : w = w.next = H, st.lanes |= C, Ya |= C;
          H = E.action, Ol && n(c, H), c = E.hasEagerState ? E.eagerState : n(c, H);
        } else
          C = {
            lane: H,
            revertLane: E.revertLane,
            gesture: E.gesture,
            action: E.action,
            hasEagerState: E.hasEagerState,
            eagerState: E.eagerState,
            next: null
          }, w === null ? (v = w = C, d = c) : w = w.next = C, st.lanes |= H, Ya |= H;
        E = E.next;
      } while (E !== null && E !== e);
      if (w === null ? d = c : w.next = v, !ln(c, t.memoizedState) && (xe = !0, M && (n = hi, n !== null)))
        throw n;
      t.memoizedState = c, t.baseState = d, t.baseQueue = w, a.lastRenderedState = c;
    }
    return r === null && (a.lanes = 0), [t.memoizedState, a.dispatch];
  }
  function Ws(t) {
    var e = ge(), n = e.queue;
    if (n === null) throw Error(o(311));
    n.lastRenderedReducer = t;
    var a = n.dispatch, r = n.pending, c = e.memoizedState;
    if (r !== null) {
      n.pending = null;
      var d = r = r.next;
      do
        c = t(c, d.action), d = d.next;
      while (d !== r);
      ln(c, e.memoizedState) || (xe = !0), e.memoizedState = c, e.baseQueue === null && (e.baseState = c), n.lastRenderedState = c;
    }
    return [c, a];
  }
  function mh(t, e, n) {
    var a = st, r = ge(), c = _t;
    if (c) {
      if (n === void 0) throw Error(o(407));
      n = n();
    } else n = e();
    var d = !ln(
      (qt || r).memoizedState,
      n
    );
    if (d && (r.memoizedState = n, xe = !0), r = r.queue, Ps(yh.bind(null, a, r, t), [
      t
    ]), r.getSnapshot !== e || d || we !== null && we.memoizedState.tag & 1) {
      if (a.flags |= 2048, bi(
        9,
        { destroy: void 0 },
        gh.bind(
          null,
          a,
          r,
          n,
          e
        ),
        null
      ), $t === null) throw Error(o(349));
      c || (la & 127) !== 0 || ph(a, e, n);
    }
    return n;
  }
  function ph(t, e, n) {
    t.flags |= 16384, t = { getSnapshot: e, value: n }, e = st.updateQueue, e === null ? (e = Cu(), st.updateQueue = e, e.stores = [t]) : (n = e.stores, n === null ? e.stores = [t] : n.push(t));
  }
  function gh(t, e, n, a) {
    e.value = n, e.getSnapshot = a, vh(e) && bh(t);
  }
  function yh(t, e, n) {
    return n(function() {
      vh(e) && bh(t);
    });
  }
  function vh(t) {
    var e = t.getSnapshot;
    t = t.value;
    try {
      var n = e();
      return !ln(t, n);
    } catch {
      return !0;
    }
  }
  function bh(t) {
    var e = yl(t, 2);
    e !== null && en(e, t, 2);
  }
  function Fs(t) {
    var e = Ye();
    if (typeof t == "function") {
      var n = t;
      if (t = n(), Ol) {
        dn(!0);
        try {
          n();
        } finally {
          dn(!1);
        }
      }
    }
    return e.memoizedState = e.baseState = t, e.queue = {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: ia,
      lastRenderedState: t
    }, e;
  }
  function Sh(t, e, n, a) {
    return t.baseState = n, Js(
      t,
      qt,
      typeof a == "function" ? a : ia
    );
  }
  function m0(t, e, n, a, r) {
    if (Lu(t)) throw Error(o(485));
    if (t = e.action, t !== null) {
      var c = {
        payload: r,
        action: t,
        next: null,
        isTransition: !0,
        status: "pending",
        value: null,
        reason: null,
        listeners: [],
        then: function(d) {
          c.listeners.push(d);
        }
      };
      V.T !== null ? n(!0) : c.isTransition = !1, a(c), n = e.pending, n === null ? (c.next = e.pending = c, Th(e, c)) : (c.next = n.next, e.pending = n.next = c);
    }
  }
  function Th(t, e) {
    var n = e.action, a = e.payload, r = t.state;
    if (e.isTransition) {
      var c = V.T, d = {};
      V.T = d;
      try {
        var v = n(r, a), w = V.S;
        w !== null && w(d, v), wh(t, e, v);
      } catch (E) {
        Is(t, e, E);
      } finally {
        c !== null && d.types !== null && (c.types = d.types), V.T = c;
      }
    } else
      try {
        c = n(r, a), wh(t, e, c);
      } catch (E) {
        Is(t, e, E);
      }
  }
  function wh(t, e, n) {
    n !== null && typeof n == "object" && typeof n.then == "function" ? n.then(
      function(a) {
        xh(t, e, a);
      },
      function(a) {
        return Is(t, e, a);
      }
    ) : xh(t, e, n);
  }
  function xh(t, e, n) {
    e.status = "fulfilled", e.value = n, Ah(e), t.state = n, e = t.pending, e !== null && (n = e.next, n === e ? t.pending = null : (n = n.next, e.next = n, Th(t, n)));
  }
  function Is(t, e, n) {
    var a = t.pending;
    if (t.pending = null, a !== null) {
      a = a.next;
      do
        e.status = "rejected", e.reason = n, Ah(e), e = e.next;
      while (e !== a);
    }
    t.action = null;
  }
  function Ah(t) {
    t = t.listeners;
    for (var e = 0; e < t.length; e++) (0, t[e])();
  }
  function _h(t, e) {
    return e;
  }
  function Oh(t, e) {
    if (_t) {
      var n = $t.formState;
      if (n !== null) {
        t: {
          var a = st;
          if (_t) {
            if (It) {
              e: {
                for (var r = It, c = bn; r.nodeType !== 8; ) {
                  if (!c) {
                    r = null;
                    break e;
                  }
                  if (r = Tn(
                    r.nextSibling
                  ), r === null) {
                    r = null;
                    break e;
                  }
                }
                c = r.data, r = c === "F!" || c === "F" ? r : null;
              }
              if (r) {
                It = Tn(
                  r.nextSibling
                ), a = r.data === "F!";
                break t;
              }
            }
            za(a);
          }
          a = !1;
        }
        a && (e = n[0]);
      }
    }
    return n = Ye(), n.memoizedState = n.baseState = e, a = {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: _h,
      lastRenderedState: e
    }, n.queue = a, n = Qh.bind(
      null,
      st,
      a
    ), a.dispatch = n, a = Fs(!1), c = lo.bind(
      null,
      st,
      !1,
      a.queue
    ), a = Ye(), r = {
      state: e,
      dispatch: null,
      action: t,
      pending: null
    }, a.queue = r, n = m0.bind(
      null,
      st,
      r,
      c,
      n
    ), r.dispatch = n, a.memoizedState = t, [e, n, !1];
  }
  function Nh(t) {
    var e = ge();
    return Eh(e, qt, t);
  }
  function Eh(t, e, n) {
    if (e = Js(
      t,
      e,
      _h
    )[0], t = zu(ia)[0], typeof e == "object" && e !== null && typeof e.then == "function")
      try {
        var a = vr(e);
      } catch (d) {
        throw d === mi ? xu : d;
      }
    else a = e;
    e = ge();
    var r = e.queue, c = r.dispatch;
    return n !== e.memoizedState && (st.flags |= 2048, bi(
      9,
      { destroy: void 0 },
      p0.bind(null, r, n),
      null
    )), [a, c, t];
  }
  function p0(t, e) {
    t.action = e;
  }
  function jh(t) {
    var e = ge(), n = qt;
    if (n !== null)
      return Eh(e, n, t);
    ge(), e = e.memoizedState, n = ge();
    var a = n.queue.dispatch;
    return n.memoizedState = t, [e, a, !1];
  }
  function bi(t, e, n, a) {
    return t = { tag: t, create: n, deps: a, inst: e, next: null }, e = st.updateQueue, e === null && (e = Cu(), st.updateQueue = e), n = e.lastEffect, n === null ? e.lastEffect = t.next = t : (a = n.next, n.next = t, t.next = a, e.lastEffect = t), t;
  }
  function Rh() {
    return ge().memoizedState;
  }
  function Mu(t, e, n, a) {
    var r = Ye();
    st.flags |= t, r.memoizedState = bi(
      1 | e,
      { destroy: void 0 },
      n,
      a === void 0 ? null : a
    );
  }
  function ku(t, e, n, a) {
    var r = ge();
    a = a === void 0 ? null : a;
    var c = r.memoizedState.inst;
    qt !== null && a !== null && Gs(a, qt.memoizedState.deps) ? r.memoizedState = bi(e, c, n, a) : (st.flags |= t, r.memoizedState = bi(
      1 | e,
      c,
      n,
      a
    ));
  }
  function Ch(t, e) {
    Mu(8390656, 8, t, e);
  }
  function Ps(t, e) {
    ku(2048, 8, t, e);
  }
  function g0(t) {
    st.flags |= 4;
    var e = st.updateQueue;
    if (e === null)
      e = Cu(), st.updateQueue = e, e.events = [t];
    else {
      var n = e.events;
      n === null ? e.events = [t] : n.push(t);
    }
  }
  function Dh(t) {
    var e = ge().memoizedState;
    return g0({ ref: e, nextImpl: t }), function() {
      if ((Mt & 2) !== 0) throw Error(o(440));
      return e.impl.apply(void 0, arguments);
    };
  }
  function zh(t, e) {
    return ku(4, 2, t, e);
  }
  function Mh(t, e) {
    return ku(4, 4, t, e);
  }
  function kh(t, e) {
    if (typeof e == "function") {
      t = t();
      var n = e(t);
      return function() {
        typeof n == "function" ? n() : e(null);
      };
    }
    if (e != null)
      return t = t(), e.current = t, function() {
        e.current = null;
      };
  }
  function Lh(t, e, n) {
    n = n != null ? n.concat([t]) : null, ku(4, 4, kh.bind(null, e, t), n);
  }
  function to() {
  }
  function Bh(t, e) {
    var n = ge();
    e = e === void 0 ? null : e;
    var a = n.memoizedState;
    return e !== null && Gs(e, a[1]) ? a[0] : (n.memoizedState = [t, e], t);
  }
  function Hh(t, e) {
    var n = ge();
    e = e === void 0 ? null : e;
    var a = n.memoizedState;
    if (e !== null && Gs(e, a[1]))
      return a[0];
    if (a = t(), Ol) {
      dn(!0);
      try {
        t();
      } finally {
        dn(!1);
      }
    }
    return n.memoizedState = [a, e], a;
  }
  function eo(t, e, n) {
    return n === void 0 || (la & 1073741824) !== 0 && (xt & 261930) === 0 ? t.memoizedState = e : (t.memoizedState = n, t = Um(), st.lanes |= t, Ya |= t, n);
  }
  function Uh(t, e, n, a) {
    return ln(n, e) ? n : gi.current !== null ? (t = eo(t, n, a), ln(t, e) || (xe = !0), t) : (la & 42) === 0 || (la & 1073741824) !== 0 && (xt & 261930) === 0 ? (xe = !0, t.memoizedState = n) : (t = Um(), st.lanes |= t, Ya |= t, e);
  }
  function qh(t, e, n, a, r) {
    var c = $.p;
    $.p = c !== 0 && 8 > c ? c : 8;
    var d = V.T, v = {};
    V.T = v, lo(t, !1, e, n);
    try {
      var w = r(), E = V.S;
      if (E !== null && E(v, w), w !== null && typeof w == "object" && typeof w.then == "function") {
        var M = f0(
          w,
          a
        );
        br(
          t,
          e,
          M,
          fn(t)
        );
      } else
        br(
          t,
          e,
          a,
          fn(t)
        );
    } catch (H) {
      br(
        t,
        e,
        { then: function() {
        }, status: "rejected", reason: H },
        fn()
      );
    } finally {
      $.p = c, d !== null && v.types !== null && (d.types = v.types), V.T = d;
    }
  }
  function y0() {
  }
  function no(t, e, n, a) {
    if (t.tag !== 5) throw Error(o(476));
    var r = Vh(t).queue;
    qh(
      t,
      r,
      e,
      J,
      n === null ? y0 : function() {
        return Yh(t), n(a);
      }
    );
  }
  function Vh(t) {
    var e = t.memoizedState;
    if (e !== null) return e;
    e = {
      memoizedState: J,
      baseState: J,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: ia,
        lastRenderedState: J
      },
      next: null
    };
    var n = {};
    return e.next = {
      memoizedState: n,
      baseState: n,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: ia,
        lastRenderedState: n
      },
      next: null
    }, t.memoizedState = e, t = t.alternate, t !== null && (t.memoizedState = e), e;
  }
  function Yh(t) {
    var e = Vh(t);
    e.next === null && (e = t.alternate.memoizedState), br(
      t,
      e.next.queue,
      {},
      fn()
    );
  }
  function ao() {
    return ze(Lr);
  }
  function Gh() {
    return ge().memoizedState;
  }
  function Xh() {
    return ge().memoizedState;
  }
  function v0(t) {
    for (var e = t.return; e !== null; ) {
      switch (e.tag) {
        case 24:
        case 3:
          var n = fn();
          t = La(n);
          var a = Ba(e, t, n);
          a !== null && (en(a, e, n), mr(a, e, n)), e = { cache: Ds() }, t.payload = e;
          return;
      }
      e = e.return;
    }
  }
  function b0(t, e, n) {
    var a = fn();
    n = {
      lane: a,
      revertLane: 0,
      gesture: null,
      action: n,
      hasEagerState: !1,
      eagerState: null,
      next: null
    }, Lu(t) ? Zh(e, n) : (n = Ts(t, e, n, a), n !== null && (en(n, t, a), Kh(n, e, a)));
  }
  function Qh(t, e, n) {
    var a = fn();
    br(t, e, n, a);
  }
  function br(t, e, n, a) {
    var r = {
      lane: a,
      revertLane: 0,
      gesture: null,
      action: n,
      hasEagerState: !1,
      eagerState: null,
      next: null
    };
    if (Lu(t)) Zh(e, r);
    else {
      var c = t.alternate;
      if (t.lanes === 0 && (c === null || c.lanes === 0) && (c = e.lastRenderedReducer, c !== null))
        try {
          var d = e.lastRenderedState, v = c(d, n);
          if (r.hasEagerState = !0, r.eagerState = v, ln(v, d))
            return gu(t, e, r, 0), $t === null && pu(), !1;
        } catch {
        } finally {
        }
      if (n = Ts(t, e, r, a), n !== null)
        return en(n, t, a), Kh(n, e, a), !0;
    }
    return !1;
  }
  function lo(t, e, n, a) {
    if (a = {
      lane: 2,
      revertLane: Bo(),
      gesture: null,
      action: a,
      hasEagerState: !1,
      eagerState: null,
      next: null
    }, Lu(t)) {
      if (e) throw Error(o(479));
    } else
      e = Ts(
        t,
        n,
        a,
        2
      ), e !== null && en(e, t, 2);
  }
  function Lu(t) {
    var e = t.alternate;
    return t === st || e !== null && e === st;
  }
  function Zh(t, e) {
    yi = ju = !0;
    var n = t.pending;
    n === null ? e.next = e : (e.next = n.next, n.next = e), t.pending = e;
  }
  function Kh(t, e, n) {
    if ((n & 4194048) !== 0) {
      var a = e.lanes;
      a &= t.pendingLanes, n |= a, e.lanes = n, Jl(t, n);
    }
  }
  var Sr = {
    readContext: ze,
    use: Du,
    useCallback: ce,
    useContext: ce,
    useEffect: ce,
    useImperativeHandle: ce,
    useLayoutEffect: ce,
    useInsertionEffect: ce,
    useMemo: ce,
    useReducer: ce,
    useRef: ce,
    useState: ce,
    useDebugValue: ce,
    useDeferredValue: ce,
    useTransition: ce,
    useSyncExternalStore: ce,
    useId: ce,
    useHostTransitionStatus: ce,
    useFormState: ce,
    useActionState: ce,
    useOptimistic: ce,
    useMemoCache: ce,
    useCacheRefresh: ce
  };
  Sr.useEffectEvent = ce;
  var $h = {
    readContext: ze,
    use: Du,
    useCallback: function(t, e) {
      return Ye().memoizedState = [
        t,
        e === void 0 ? null : e
      ], t;
    },
    useContext: ze,
    useEffect: Ch,
    useImperativeHandle: function(t, e, n) {
      n = n != null ? n.concat([t]) : null, Mu(
        4194308,
        4,
        kh.bind(null, e, t),
        n
      );
    },
    useLayoutEffect: function(t, e) {
      return Mu(4194308, 4, t, e);
    },
    useInsertionEffect: function(t, e) {
      Mu(4, 2, t, e);
    },
    useMemo: function(t, e) {
      var n = Ye();
      e = e === void 0 ? null : e;
      var a = t();
      if (Ol) {
        dn(!0);
        try {
          t();
        } finally {
          dn(!1);
        }
      }
      return n.memoizedState = [a, e], a;
    },
    useReducer: function(t, e, n) {
      var a = Ye();
      if (n !== void 0) {
        var r = n(e);
        if (Ol) {
          dn(!0);
          try {
            n(e);
          } finally {
            dn(!1);
          }
        }
      } else r = e;
      return a.memoizedState = a.baseState = r, t = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: t,
        lastRenderedState: r
      }, a.queue = t, t = t.dispatch = b0.bind(
        null,
        st,
        t
      ), [a.memoizedState, t];
    },
    useRef: function(t) {
      var e = Ye();
      return t = { current: t }, e.memoizedState = t;
    },
    useState: function(t) {
      t = Fs(t);
      var e = t.queue, n = Qh.bind(null, st, e);
      return e.dispatch = n, [t.memoizedState, n];
    },
    useDebugValue: to,
    useDeferredValue: function(t, e) {
      var n = Ye();
      return eo(n, t, e);
    },
    useTransition: function() {
      var t = Fs(!1);
      return t = qh.bind(
        null,
        st,
        t.queue,
        !0,
        !1
      ), Ye().memoizedState = t, [!1, t];
    },
    useSyncExternalStore: function(t, e, n) {
      var a = st, r = Ye();
      if (_t) {
        if (n === void 0)
          throw Error(o(407));
        n = n();
      } else {
        if (n = e(), $t === null)
          throw Error(o(349));
        (xt & 127) !== 0 || ph(a, e, n);
      }
      r.memoizedState = n;
      var c = { value: n, getSnapshot: e };
      return r.queue = c, Ch(yh.bind(null, a, c, t), [
        t
      ]), a.flags |= 2048, bi(
        9,
        { destroy: void 0 },
        gh.bind(
          null,
          a,
          c,
          n,
          e
        ),
        null
      ), n;
    },
    useId: function() {
      var t = Ye(), e = $t.identifierPrefix;
      if (_t) {
        var n = Un, a = Hn;
        n = (a & ~(1 << 32 - Ce(a) - 1)).toString(32) + n, e = "_" + e + "R_" + n, n = Ru++, 0 < n && (e += "H" + n.toString(32)), e += "_";
      } else
        n = d0++, e = "_" + e + "r_" + n.toString(32) + "_";
      return t.memoizedState = e;
    },
    useHostTransitionStatus: ao,
    useFormState: Oh,
    useActionState: Oh,
    useOptimistic: function(t) {
      var e = Ye();
      e.memoizedState = e.baseState = t;
      var n = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
      };
      return e.queue = n, e = lo.bind(
        null,
        st,
        !0,
        n
      ), n.dispatch = e, [t, e];
    },
    useMemoCache: $s,
    useCacheRefresh: function() {
      return Ye().memoizedState = v0.bind(
        null,
        st
      );
    },
    useEffectEvent: function(t) {
      var e = Ye(), n = { impl: t };
      return e.memoizedState = n, function() {
        if ((Mt & 2) !== 0)
          throw Error(o(440));
        return n.impl.apply(void 0, arguments);
      };
    }
  }, io = {
    readContext: ze,
    use: Du,
    useCallback: Bh,
    useContext: ze,
    useEffect: Ps,
    useImperativeHandle: Lh,
    useInsertionEffect: zh,
    useLayoutEffect: Mh,
    useMemo: Hh,
    useReducer: zu,
    useRef: Rh,
    useState: function() {
      return zu(ia);
    },
    useDebugValue: to,
    useDeferredValue: function(t, e) {
      var n = ge();
      return Uh(
        n,
        qt.memoizedState,
        t,
        e
      );
    },
    useTransition: function() {
      var t = zu(ia)[0], e = ge().memoizedState;
      return [
        typeof t == "boolean" ? t : vr(t),
        e
      ];
    },
    useSyncExternalStore: mh,
    useId: Gh,
    useHostTransitionStatus: ao,
    useFormState: Nh,
    useActionState: Nh,
    useOptimistic: function(t, e) {
      var n = ge();
      return Sh(n, qt, t, e);
    },
    useMemoCache: $s,
    useCacheRefresh: Xh
  };
  io.useEffectEvent = Dh;
  var Jh = {
    readContext: ze,
    use: Du,
    useCallback: Bh,
    useContext: ze,
    useEffect: Ps,
    useImperativeHandle: Lh,
    useInsertionEffect: zh,
    useLayoutEffect: Mh,
    useMemo: Hh,
    useReducer: Ws,
    useRef: Rh,
    useState: function() {
      return Ws(ia);
    },
    useDebugValue: to,
    useDeferredValue: function(t, e) {
      var n = ge();
      return qt === null ? eo(n, t, e) : Uh(
        n,
        qt.memoizedState,
        t,
        e
      );
    },
    useTransition: function() {
      var t = Ws(ia)[0], e = ge().memoizedState;
      return [
        typeof t == "boolean" ? t : vr(t),
        e
      ];
    },
    useSyncExternalStore: mh,
    useId: Gh,
    useHostTransitionStatus: ao,
    useFormState: jh,
    useActionState: jh,
    useOptimistic: function(t, e) {
      var n = ge();
      return qt !== null ? Sh(n, qt, t, e) : (n.baseState = t, [t, n.queue.dispatch]);
    },
    useMemoCache: $s,
    useCacheRefresh: Xh
  };
  Jh.useEffectEvent = Dh;
  function ro(t, e, n, a) {
    e = t.memoizedState, n = n(a, e), n = n == null ? e : x({}, e, n), t.memoizedState = n, t.lanes === 0 && (t.updateQueue.baseState = n);
  }
  var uo = {
    enqueueSetState: function(t, e, n) {
      t = t._reactInternals;
      var a = fn(), r = La(a);
      r.payload = e, n != null && (r.callback = n), e = Ba(t, r, a), e !== null && (en(e, t, a), mr(e, t, a));
    },
    enqueueReplaceState: function(t, e, n) {
      t = t._reactInternals;
      var a = fn(), r = La(a);
      r.tag = 1, r.payload = e, n != null && (r.callback = n), e = Ba(t, r, a), e !== null && (en(e, t, a), mr(e, t, a));
    },
    enqueueForceUpdate: function(t, e) {
      t = t._reactInternals;
      var n = fn(), a = La(n);
      a.tag = 2, e != null && (a.callback = e), e = Ba(t, a, n), e !== null && (en(e, t, n), mr(e, t, n));
    }
  };
  function Wh(t, e, n, a, r, c, d) {
    return t = t.stateNode, typeof t.shouldComponentUpdate == "function" ? t.shouldComponentUpdate(a, c, d) : e.prototype && e.prototype.isPureReactComponent ? !rr(n, a) || !rr(r, c) : !0;
  }
  function Fh(t, e, n, a) {
    t = e.state, typeof e.componentWillReceiveProps == "function" && e.componentWillReceiveProps(n, a), typeof e.UNSAFE_componentWillReceiveProps == "function" && e.UNSAFE_componentWillReceiveProps(n, a), e.state !== t && uo.enqueueReplaceState(e, e.state, null);
  }
  function Nl(t, e) {
    var n = e;
    if ("ref" in e) {
      n = {};
      for (var a in e)
        a !== "ref" && (n[a] = e[a]);
    }
    if (t = t.defaultProps) {
      n === e && (n = x({}, n));
      for (var r in t)
        n[r] === void 0 && (n[r] = t[r]);
    }
    return n;
  }
  function Ih(t) {
    mu(t);
  }
  function Ph(t) {
    console.error(t);
  }
  function tm(t) {
    mu(t);
  }
  function Bu(t, e) {
    try {
      var n = t.onUncaughtError;
      n(e.value, { componentStack: e.stack });
    } catch (a) {
      setTimeout(function() {
        throw a;
      });
    }
  }
  function em(t, e, n) {
    try {
      var a = t.onCaughtError;
      a(n.value, {
        componentStack: n.stack,
        errorBoundary: e.tag === 1 ? e.stateNode : null
      });
    } catch (r) {
      setTimeout(function() {
        throw r;
      });
    }
  }
  function co(t, e, n) {
    return n = La(n), n.tag = 3, n.payload = { element: null }, n.callback = function() {
      Bu(t, e);
    }, n;
  }
  function nm(t) {
    return t = La(t), t.tag = 3, t;
  }
  function am(t, e, n, a) {
    var r = n.type.getDerivedStateFromError;
    if (typeof r == "function") {
      var c = a.value;
      t.payload = function() {
        return r(c);
      }, t.callback = function() {
        em(e, n, a);
      };
    }
    var d = n.stateNode;
    d !== null && typeof d.componentDidCatch == "function" && (t.callback = function() {
      em(e, n, a), typeof r != "function" && (Ga === null ? Ga = /* @__PURE__ */ new Set([this]) : Ga.add(this));
      var v = a.stack;
      this.componentDidCatch(a.value, {
        componentStack: v !== null ? v : ""
      });
    });
  }
  function S0(t, e, n, a, r) {
    if (n.flags |= 32768, a !== null && typeof a == "object" && typeof a.then == "function") {
      if (e = n.alternate, e !== null && fi(
        e,
        n,
        r,
        !0
      ), n = un.current, n !== null) {
        switch (n.tag) {
          case 31:
          case 13:
            return Sn === null ? Ju() : n.alternate === null && se === 0 && (se = 3), n.flags &= -257, n.flags |= 65536, n.lanes = r, a === Au ? n.flags |= 16384 : (e = n.updateQueue, e === null ? n.updateQueue = /* @__PURE__ */ new Set([a]) : e.add(a), Mo(t, a, r)), !1;
          case 22:
            return n.flags |= 65536, a === Au ? n.flags |= 16384 : (e = n.updateQueue, e === null ? (e = {
              transitions: null,
              markerInstances: null,
              retryQueue: /* @__PURE__ */ new Set([a])
            }, n.updateQueue = e) : (n = e.retryQueue, n === null ? e.retryQueue = /* @__PURE__ */ new Set([a]) : n.add(a)), Mo(t, a, r)), !1;
        }
        throw Error(o(435, n.tag));
      }
      return Mo(t, a, r), Ju(), !1;
    }
    if (_t)
      return e = un.current, e !== null ? ((e.flags & 65536) === 0 && (e.flags |= 256), e.flags |= 65536, e.lanes = r, a !== Ns && (t = Error(o(422), { cause: a }), sr(gn(t, n)))) : (a !== Ns && (e = Error(o(423), {
        cause: a
      }), sr(
        gn(e, n)
      )), t = t.current.alternate, t.flags |= 65536, r &= -r, t.lanes |= r, a = gn(a, n), r = co(
        t.stateNode,
        a,
        r
      ), Hs(t, r), se !== 4 && (se = 2)), !1;
    var c = Error(o(520), { cause: a });
    if (c = gn(c, n), Er === null ? Er = [c] : Er.push(c), se !== 4 && (se = 2), e === null) return !0;
    a = gn(a, n), n = e;
    do {
      switch (n.tag) {
        case 3:
          return n.flags |= 65536, t = r & -r, n.lanes |= t, t = co(n.stateNode, a, t), Hs(n, t), !1;
        case 1:
          if (e = n.type, c = n.stateNode, (n.flags & 128) === 0 && (typeof e.getDerivedStateFromError == "function" || c !== null && typeof c.componentDidCatch == "function" && (Ga === null || !Ga.has(c))))
            return n.flags |= 65536, r &= -r, n.lanes |= r, r = nm(r), am(
              r,
              t,
              n,
              a
            ), Hs(n, r), !1;
      }
      n = n.return;
    } while (n !== null);
    return !1;
  }
  var so = Error(o(461)), xe = !1;
  function Me(t, e, n, a) {
    e.child = t === null ? uh(e, null, n, a) : _l(
      e,
      t.child,
      n,
      a
    );
  }
  function lm(t, e, n, a, r) {
    n = n.render;
    var c = e.ref;
    if ("ref" in a) {
      var d = {};
      for (var v in a)
        v !== "ref" && (d[v] = a[v]);
    } else d = a;
    return Tl(e), a = Xs(
      t,
      e,
      n,
      d,
      c,
      r
    ), v = Qs(), t !== null && !xe ? (Zs(t, e, r), ra(t, e, r)) : (_t && v && _s(e), e.flags |= 1, Me(t, e, a, r), e.child);
  }
  function im(t, e, n, a, r) {
    if (t === null) {
      var c = n.type;
      return typeof c == "function" && !ws(c) && c.defaultProps === void 0 && n.compare === null ? (e.tag = 15, e.type = c, rm(
        t,
        e,
        c,
        a,
        r
      )) : (t = vu(
        n.type,
        null,
        a,
        e,
        e.mode,
        r
      ), t.ref = e.ref, t.return = e, e.child = t);
    }
    if (c = t.child, !vo(t, r)) {
      var d = c.memoizedProps;
      if (n = n.compare, n = n !== null ? n : rr, n(d, a) && t.ref === e.ref)
        return ra(t, e, r);
    }
    return e.flags |= 1, t = ta(c, a), t.ref = e.ref, t.return = e, e.child = t;
  }
  function rm(t, e, n, a, r) {
    if (t !== null) {
      var c = t.memoizedProps;
      if (rr(c, a) && t.ref === e.ref)
        if (xe = !1, e.pendingProps = a = c, vo(t, r))
          (t.flags & 131072) !== 0 && (xe = !0);
        else
          return e.lanes = t.lanes, ra(t, e, r);
    }
    return oo(
      t,
      e,
      n,
      a,
      r
    );
  }
  function um(t, e, n, a) {
    var r = a.children, c = t !== null ? t.memoizedState : null;
    if (t === null && e.stateNode === null && (e.stateNode = {
      _visibility: 1,
      _pendingMarkers: null,
      _retryCache: null,
      _transitions: null
    }), a.mode === "hidden") {
      if ((e.flags & 128) !== 0) {
        if (c = c !== null ? c.baseLanes | n : n, t !== null) {
          for (a = e.child = t.child, r = 0; a !== null; )
            r = r | a.lanes | a.childLanes, a = a.sibling;
          a = r & ~c;
        } else a = 0, e.child = null;
        return cm(
          t,
          e,
          c,
          n,
          a
        );
      }
      if ((n & 536870912) !== 0)
        e.memoizedState = { baseLanes: 0, cachePool: null }, t !== null && wu(
          e,
          c !== null ? c.cachePool : null
        ), c !== null ? oh(e, c) : qs(), fh(e);
      else
        return a = e.lanes = 536870912, cm(
          t,
          e,
          c !== null ? c.baseLanes | n : n,
          n,
          a
        );
    } else
      c !== null ? (wu(e, c.cachePool), oh(e, c), Ua(), e.memoizedState = null) : (t !== null && wu(e, null), qs(), Ua());
    return Me(t, e, r, n), e.child;
  }
  function Tr(t, e) {
    return t !== null && t.tag === 22 || e.stateNode !== null || (e.stateNode = {
      _visibility: 1,
      _pendingMarkers: null,
      _retryCache: null,
      _transitions: null
    }), e.sibling;
  }
  function cm(t, e, n, a, r) {
    var c = Ms();
    return c = c === null ? null : { parent: Te._currentValue, pool: c }, e.memoizedState = {
      baseLanes: n,
      cachePool: c
    }, t !== null && wu(e, null), qs(), fh(e), t !== null && fi(t, e, a, !0), e.childLanes = r, null;
  }
  function Hu(t, e) {
    return e = qu(
      { mode: e.mode, children: e.children },
      t.mode
    ), e.ref = t.ref, t.child = e, e.return = t, e;
  }
  function sm(t, e, n) {
    return _l(e, t.child, null, n), t = Hu(e, e.pendingProps), t.flags |= 2, cn(e), e.memoizedState = null, t;
  }
  function T0(t, e, n) {
    var a = e.pendingProps, r = (e.flags & 128) !== 0;
    if (e.flags &= -129, t === null) {
      if (_t) {
        if (a.mode === "hidden")
          return t = Hu(e, a), e.lanes = 536870912, Tr(null, t);
        if (Ys(e), (t = It) ? (t = Tp(
          t,
          bn
        ), t = t !== null && t.data === "&" ? t : null, t !== null && (e.memoizedState = {
          dehydrated: t,
          treeContext: Ca !== null ? { id: Hn, overflow: Un } : null,
          retryLane: 536870912,
          hydrationErrors: null
        }, n = Zd(t), n.return = e, e.child = n, De = e, It = null)) : t = null, t === null) throw za(e);
        return e.lanes = 536870912, null;
      }
      return Hu(e, a);
    }
    var c = t.memoizedState;
    if (c !== null) {
      var d = c.dehydrated;
      if (Ys(e), r)
        if (e.flags & 256)
          e.flags &= -257, e = sm(
            t,
            e,
            n
          );
        else if (e.memoizedState !== null)
          e.child = t.child, e.flags |= 128, e = null;
        else throw Error(o(558));
      else if (xe || fi(t, e, n, !1), r = (n & t.childLanes) !== 0, xe || r) {
        if (a = $t, a !== null && (d = Qi(a, n), d !== 0 && d !== c.retryLane))
          throw c.retryLane = d, yl(t, d), en(a, t, d), so;
        Ju(), e = sm(
          t,
          e,
          n
        );
      } else
        t = c.treeContext, It = Tn(d.nextSibling), De = e, _t = !0, Da = null, bn = !1, t !== null && Jd(e, t), e = Hu(e, a), e.flags |= 4096;
      return e;
    }
    return t = ta(t.child, {
      mode: a.mode,
      children: a.children
    }), t.ref = e.ref, e.child = t, t.return = e, t;
  }
  function Uu(t, e) {
    var n = e.ref;
    if (n === null)
      t !== null && t.ref !== null && (e.flags |= 4194816);
    else {
      if (typeof n != "function" && typeof n != "object")
        throw Error(o(284));
      (t === null || t.ref !== n) && (e.flags |= 4194816);
    }
  }
  function oo(t, e, n, a, r) {
    return Tl(e), n = Xs(
      t,
      e,
      n,
      a,
      void 0,
      r
    ), a = Qs(), t !== null && !xe ? (Zs(t, e, r), ra(t, e, r)) : (_t && a && _s(e), e.flags |= 1, Me(t, e, n, r), e.child);
  }
  function om(t, e, n, a, r, c) {
    return Tl(e), e.updateQueue = null, n = hh(
      e,
      a,
      n,
      r
    ), dh(t), a = Qs(), t !== null && !xe ? (Zs(t, e, c), ra(t, e, c)) : (_t && a && _s(e), e.flags |= 1, Me(t, e, n, c), e.child);
  }
  function fm(t, e, n, a, r) {
    if (Tl(e), e.stateNode === null) {
      var c = ui, d = n.contextType;
      typeof d == "object" && d !== null && (c = ze(d)), c = new n(a, c), e.memoizedState = c.state !== null && c.state !== void 0 ? c.state : null, c.updater = uo, e.stateNode = c, c._reactInternals = e, c = e.stateNode, c.props = a, c.state = e.memoizedState, c.refs = {}, Ls(e), d = n.contextType, c.context = typeof d == "object" && d !== null ? ze(d) : ui, c.state = e.memoizedState, d = n.getDerivedStateFromProps, typeof d == "function" && (ro(
        e,
        n,
        d,
        a
      ), c.state = e.memoizedState), typeof n.getDerivedStateFromProps == "function" || typeof c.getSnapshotBeforeUpdate == "function" || typeof c.UNSAFE_componentWillMount != "function" && typeof c.componentWillMount != "function" || (d = c.state, typeof c.componentWillMount == "function" && c.componentWillMount(), typeof c.UNSAFE_componentWillMount == "function" && c.UNSAFE_componentWillMount(), d !== c.state && uo.enqueueReplaceState(c, c.state, null), gr(e, a, c, r), pr(), c.state = e.memoizedState), typeof c.componentDidMount == "function" && (e.flags |= 4194308), a = !0;
    } else if (t === null) {
      c = e.stateNode;
      var v = e.memoizedProps, w = Nl(n, v);
      c.props = w;
      var E = c.context, M = n.contextType;
      d = ui, typeof M == "object" && M !== null && (d = ze(M));
      var H = n.getDerivedStateFromProps;
      M = typeof H == "function" || typeof c.getSnapshotBeforeUpdate == "function", v = e.pendingProps !== v, M || typeof c.UNSAFE_componentWillReceiveProps != "function" && typeof c.componentWillReceiveProps != "function" || (v || E !== d) && Fh(
        e,
        c,
        a,
        d
      ), ka = !1;
      var C = e.memoizedState;
      c.state = C, gr(e, a, c, r), pr(), E = e.memoizedState, v || C !== E || ka ? (typeof H == "function" && (ro(
        e,
        n,
        H,
        a
      ), E = e.memoizedState), (w = ka || Wh(
        e,
        n,
        w,
        a,
        C,
        E,
        d
      )) ? (M || typeof c.UNSAFE_componentWillMount != "function" && typeof c.componentWillMount != "function" || (typeof c.componentWillMount == "function" && c.componentWillMount(), typeof c.UNSAFE_componentWillMount == "function" && c.UNSAFE_componentWillMount()), typeof c.componentDidMount == "function" && (e.flags |= 4194308)) : (typeof c.componentDidMount == "function" && (e.flags |= 4194308), e.memoizedProps = a, e.memoizedState = E), c.props = a, c.state = E, c.context = d, a = w) : (typeof c.componentDidMount == "function" && (e.flags |= 4194308), a = !1);
    } else {
      c = e.stateNode, Bs(t, e), d = e.memoizedProps, M = Nl(n, d), c.props = M, H = e.pendingProps, C = c.context, E = n.contextType, w = ui, typeof E == "object" && E !== null && (w = ze(E)), v = n.getDerivedStateFromProps, (E = typeof v == "function" || typeof c.getSnapshotBeforeUpdate == "function") || typeof c.UNSAFE_componentWillReceiveProps != "function" && typeof c.componentWillReceiveProps != "function" || (d !== H || C !== w) && Fh(
        e,
        c,
        a,
        w
      ), ka = !1, C = e.memoizedState, c.state = C, gr(e, a, c, r), pr();
      var z = e.memoizedState;
      d !== H || C !== z || ka || t !== null && t.dependencies !== null && Su(t.dependencies) ? (typeof v == "function" && (ro(
        e,
        n,
        v,
        a
      ), z = e.memoizedState), (M = ka || Wh(
        e,
        n,
        M,
        a,
        C,
        z,
        w
      ) || t !== null && t.dependencies !== null && Su(t.dependencies)) ? (E || typeof c.UNSAFE_componentWillUpdate != "function" && typeof c.componentWillUpdate != "function" || (typeof c.componentWillUpdate == "function" && c.componentWillUpdate(a, z, w), typeof c.UNSAFE_componentWillUpdate == "function" && c.UNSAFE_componentWillUpdate(
        a,
        z,
        w
      )), typeof c.componentDidUpdate == "function" && (e.flags |= 4), typeof c.getSnapshotBeforeUpdate == "function" && (e.flags |= 1024)) : (typeof c.componentDidUpdate != "function" || d === t.memoizedProps && C === t.memoizedState || (e.flags |= 4), typeof c.getSnapshotBeforeUpdate != "function" || d === t.memoizedProps && C === t.memoizedState || (e.flags |= 1024), e.memoizedProps = a, e.memoizedState = z), c.props = a, c.state = z, c.context = w, a = M) : (typeof c.componentDidUpdate != "function" || d === t.memoizedProps && C === t.memoizedState || (e.flags |= 4), typeof c.getSnapshotBeforeUpdate != "function" || d === t.memoizedProps && C === t.memoizedState || (e.flags |= 1024), a = !1);
    }
    return c = a, Uu(t, e), a = (e.flags & 128) !== 0, c || a ? (c = e.stateNode, n = a && typeof n.getDerivedStateFromError != "function" ? null : c.render(), e.flags |= 1, t !== null && a ? (e.child = _l(
      e,
      t.child,
      null,
      r
    ), e.child = _l(
      e,
      null,
      n,
      r
    )) : Me(t, e, n, r), e.memoizedState = c.state, t = e.child) : t = ra(
      t,
      e,
      r
    ), t;
  }
  function dm(t, e, n, a) {
    return bl(), e.flags |= 256, Me(t, e, n, a), e.child;
  }
  var fo = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
  };
  function ho(t) {
    return { baseLanes: t, cachePool: eh() };
  }
  function mo(t, e, n) {
    return t = t !== null ? t.childLanes & ~n : 0, e && (t |= on), t;
  }
  function hm(t, e, n) {
    var a = e.pendingProps, r = !1, c = (e.flags & 128) !== 0, d;
    if ((d = c) || (d = t !== null && t.memoizedState === null ? !1 : (pe.current & 2) !== 0), d && (r = !0, e.flags &= -129), d = (e.flags & 32) !== 0, e.flags &= -33, t === null) {
      if (_t) {
        if (r ? Ha(e) : Ua(), (t = It) ? (t = Tp(
          t,
          bn
        ), t = t !== null && t.data !== "&" ? t : null, t !== null && (e.memoizedState = {
          dehydrated: t,
          treeContext: Ca !== null ? { id: Hn, overflow: Un } : null,
          retryLane: 536870912,
          hydrationErrors: null
        }, n = Zd(t), n.return = e, e.child = n, De = e, It = null)) : t = null, t === null) throw za(e);
        return Wo(t) ? e.lanes = 32 : e.lanes = 536870912, null;
      }
      var v = a.children;
      return a = a.fallback, r ? (Ua(), r = e.mode, v = qu(
        { mode: "hidden", children: v },
        r
      ), a = vl(
        a,
        r,
        n,
        null
      ), v.return = e, a.return = e, v.sibling = a, e.child = v, a = e.child, a.memoizedState = ho(n), a.childLanes = mo(
        t,
        d,
        n
      ), e.memoizedState = fo, Tr(null, a)) : (Ha(e), po(e, v));
    }
    var w = t.memoizedState;
    if (w !== null && (v = w.dehydrated, v !== null)) {
      if (c)
        e.flags & 256 ? (Ha(e), e.flags &= -257, e = go(
          t,
          e,
          n
        )) : e.memoizedState !== null ? (Ua(), e.child = t.child, e.flags |= 128, e = null) : (Ua(), v = a.fallback, r = e.mode, a = qu(
          { mode: "visible", children: a.children },
          r
        ), v = vl(
          v,
          r,
          n,
          null
        ), v.flags |= 2, a.return = e, v.return = e, a.sibling = v, e.child = a, _l(
          e,
          t.child,
          null,
          n
        ), a = e.child, a.memoizedState = ho(n), a.childLanes = mo(
          t,
          d,
          n
        ), e.memoizedState = fo, e = Tr(null, a));
      else if (Ha(e), Wo(v)) {
        if (d = v.nextSibling && v.nextSibling.dataset, d) var E = d.dgst;
        d = E, a = Error(o(419)), a.stack = "", a.digest = d, sr({ value: a, source: null, stack: null }), e = go(
          t,
          e,
          n
        );
      } else if (xe || fi(t, e, n, !1), d = (n & t.childLanes) !== 0, xe || d) {
        if (d = $t, d !== null && (a = Qi(d, n), a !== 0 && a !== w.retryLane))
          throw w.retryLane = a, yl(t, a), en(d, t, a), so;
        Jo(v) || Ju(), e = go(
          t,
          e,
          n
        );
      } else
        Jo(v) ? (e.flags |= 192, e.child = t.child, e = null) : (t = w.treeContext, It = Tn(
          v.nextSibling
        ), De = e, _t = !0, Da = null, bn = !1, t !== null && Jd(e, t), e = po(
          e,
          a.children
        ), e.flags |= 4096);
      return e;
    }
    return r ? (Ua(), v = a.fallback, r = e.mode, w = t.child, E = w.sibling, a = ta(w, {
      mode: "hidden",
      children: a.children
    }), a.subtreeFlags = w.subtreeFlags & 65011712, E !== null ? v = ta(
      E,
      v
    ) : (v = vl(
      v,
      r,
      n,
      null
    ), v.flags |= 2), v.return = e, a.return = e, a.sibling = v, e.child = a, Tr(null, a), a = e.child, v = t.child.memoizedState, v === null ? v = ho(n) : (r = v.cachePool, r !== null ? (w = Te._currentValue, r = r.parent !== w ? { parent: w, pool: w } : r) : r = eh(), v = {
      baseLanes: v.baseLanes | n,
      cachePool: r
    }), a.memoizedState = v, a.childLanes = mo(
      t,
      d,
      n
    ), e.memoizedState = fo, Tr(t.child, a)) : (Ha(e), n = t.child, t = n.sibling, n = ta(n, {
      mode: "visible",
      children: a.children
    }), n.return = e, n.sibling = null, t !== null && (d = e.deletions, d === null ? (e.deletions = [t], e.flags |= 16) : d.push(t)), e.child = n, e.memoizedState = null, n);
  }
  function po(t, e) {
    return e = qu(
      { mode: "visible", children: e },
      t.mode
    ), e.return = t, t.child = e;
  }
  function qu(t, e) {
    return t = rn(22, t, null, e), t.lanes = 0, t;
  }
  function go(t, e, n) {
    return _l(e, t.child, null, n), t = po(
      e,
      e.pendingProps.children
    ), t.flags |= 2, e.memoizedState = null, t;
  }
  function mm(t, e, n) {
    t.lanes |= e;
    var a = t.alternate;
    a !== null && (a.lanes |= e), Rs(t.return, e, n);
  }
  function yo(t, e, n, a, r, c) {
    var d = t.memoizedState;
    d === null ? t.memoizedState = {
      isBackwards: e,
      rendering: null,
      renderingStartTime: 0,
      last: a,
      tail: n,
      tailMode: r,
      treeForkCount: c
    } : (d.isBackwards = e, d.rendering = null, d.renderingStartTime = 0, d.last = a, d.tail = n, d.tailMode = r, d.treeForkCount = c);
  }
  function pm(t, e, n) {
    var a = e.pendingProps, r = a.revealOrder, c = a.tail;
    a = a.children;
    var d = pe.current, v = (d & 2) !== 0;
    if (v ? (d = d & 1 | 2, e.flags |= 128) : d &= 1, at(pe, d), Me(t, e, a, n), a = _t ? cr : 0, !v && t !== null && (t.flags & 128) !== 0)
      t: for (t = e.child; t !== null; ) {
        if (t.tag === 13)
          t.memoizedState !== null && mm(t, n, e);
        else if (t.tag === 19)
          mm(t, n, e);
        else if (t.child !== null) {
          t.child.return = t, t = t.child;
          continue;
        }
        if (t === e) break t;
        for (; t.sibling === null; ) {
          if (t.return === null || t.return === e)
            break t;
          t = t.return;
        }
        t.sibling.return = t.return, t = t.sibling;
      }
    switch (r) {
      case "forwards":
        for (n = e.child, r = null; n !== null; )
          t = n.alternate, t !== null && Eu(t) === null && (r = n), n = n.sibling;
        n = r, n === null ? (r = e.child, e.child = null) : (r = n.sibling, n.sibling = null), yo(
          e,
          !1,
          r,
          n,
          c,
          a
        );
        break;
      case "backwards":
      case "unstable_legacy-backwards":
        for (n = null, r = e.child, e.child = null; r !== null; ) {
          if (t = r.alternate, t !== null && Eu(t) === null) {
            e.child = r;
            break;
          }
          t = r.sibling, r.sibling = n, n = r, r = t;
        }
        yo(
          e,
          !0,
          n,
          null,
          c,
          a
        );
        break;
      case "together":
        yo(
          e,
          !1,
          null,
          null,
          void 0,
          a
        );
        break;
      default:
        e.memoizedState = null;
    }
    return e.child;
  }
  function ra(t, e, n) {
    if (t !== null && (e.dependencies = t.dependencies), Ya |= e.lanes, (n & e.childLanes) === 0)
      if (t !== null) {
        if (fi(
          t,
          e,
          n,
          !1
        ), (n & e.childLanes) === 0)
          return null;
      } else return null;
    if (t !== null && e.child !== t.child)
      throw Error(o(153));
    if (e.child !== null) {
      for (t = e.child, n = ta(t, t.pendingProps), e.child = n, n.return = e; t.sibling !== null; )
        t = t.sibling, n = n.sibling = ta(t, t.pendingProps), n.return = e;
      n.sibling = null;
    }
    return e.child;
  }
  function vo(t, e) {
    return (t.lanes & e) !== 0 ? !0 : (t = t.dependencies, !!(t !== null && Su(t)));
  }
  function w0(t, e, n) {
    switch (e.tag) {
      case 3:
        Ut(e, e.stateNode.containerInfo), Ma(e, Te, t.memoizedState.cache), bl();
        break;
      case 27:
      case 5:
        zt(e);
        break;
      case 4:
        Ut(e, e.stateNode.containerInfo);
        break;
      case 10:
        Ma(
          e,
          e.type,
          e.memoizedProps.value
        );
        break;
      case 31:
        if (e.memoizedState !== null)
          return e.flags |= 128, Ys(e), null;
        break;
      case 13:
        var a = e.memoizedState;
        if (a !== null)
          return a.dehydrated !== null ? (Ha(e), e.flags |= 128, null) : (n & e.child.childLanes) !== 0 ? hm(t, e, n) : (Ha(e), t = ra(
            t,
            e,
            n
          ), t !== null ? t.sibling : null);
        Ha(e);
        break;
      case 19:
        var r = (t.flags & 128) !== 0;
        if (a = (n & e.childLanes) !== 0, a || (fi(
          t,
          e,
          n,
          !1
        ), a = (n & e.childLanes) !== 0), r) {
          if (a)
            return pm(
              t,
              e,
              n
            );
          e.flags |= 128;
        }
        if (r = e.memoizedState, r !== null && (r.rendering = null, r.tail = null, r.lastEffect = null), at(pe, pe.current), a) break;
        return null;
      case 22:
        return e.lanes = 0, um(
          t,
          e,
          n,
          e.pendingProps
        );
      case 24:
        Ma(e, Te, t.memoizedState.cache);
    }
    return ra(t, e, n);
  }
  function gm(t, e, n) {
    if (t !== null)
      if (t.memoizedProps !== e.pendingProps)
        xe = !0;
      else {
        if (!vo(t, n) && (e.flags & 128) === 0)
          return xe = !1, w0(
            t,
            e,
            n
          );
        xe = (t.flags & 131072) !== 0;
      }
    else
      xe = !1, _t && (e.flags & 1048576) !== 0 && $d(e, cr, e.index);
    switch (e.lanes = 0, e.tag) {
      case 16:
        t: {
          var a = e.pendingProps;
          if (t = xl(e.elementType), e.type = t, typeof t == "function")
            ws(t) ? (a = Nl(t, a), e.tag = 1, e = fm(
              null,
              e,
              t,
              a,
              n
            )) : (e.tag = 0, e = oo(
              null,
              e,
              t,
              a,
              n
            ));
          else {
            if (t != null) {
              var r = t.$$typeof;
              if (r === X) {
                e.tag = 11, e = lm(
                  null,
                  e,
                  t,
                  a,
                  n
                );
                break t;
              } else if (r === F) {
                e.tag = 14, e = im(
                  null,
                  e,
                  t,
                  a,
                  n
                );
                break t;
              }
            }
            throw e = Zt(t) || t, Error(o(306, e, ""));
          }
        }
        return e;
      case 0:
        return oo(
          t,
          e,
          e.type,
          e.pendingProps,
          n
        );
      case 1:
        return a = e.type, r = Nl(
          a,
          e.pendingProps
        ), fm(
          t,
          e,
          a,
          r,
          n
        );
      case 3:
        t: {
          if (Ut(
            e,
            e.stateNode.containerInfo
          ), t === null) throw Error(o(387));
          a = e.pendingProps;
          var c = e.memoizedState;
          r = c.element, Bs(t, e), gr(e, a, null, n);
          var d = e.memoizedState;
          if (a = d.cache, Ma(e, Te, a), a !== c.cache && Cs(
            e,
            [Te],
            n,
            !0
          ), pr(), a = d.element, c.isDehydrated)
            if (c = {
              element: a,
              isDehydrated: !1,
              cache: d.cache
            }, e.updateQueue.baseState = c, e.memoizedState = c, e.flags & 256) {
              e = dm(
                t,
                e,
                a,
                n
              );
              break t;
            } else if (a !== r) {
              r = gn(
                Error(o(424)),
                e
              ), sr(r), e = dm(
                t,
                e,
                a,
                n
              );
              break t;
            } else {
              switch (t = e.stateNode.containerInfo, t.nodeType) {
                case 9:
                  t = t.body;
                  break;
                default:
                  t = t.nodeName === "HTML" ? t.ownerDocument.body : t;
              }
              for (It = Tn(t.firstChild), De = e, _t = !0, Da = null, bn = !0, n = uh(
                e,
                null,
                a,
                n
              ), e.child = n; n; )
                n.flags = n.flags & -3 | 4096, n = n.sibling;
            }
          else {
            if (bl(), a === r) {
              e = ra(
                t,
                e,
                n
              );
              break t;
            }
            Me(t, e, a, n);
          }
          e = e.child;
        }
        return e;
      case 26:
        return Uu(t, e), t === null ? (n = Np(
          e.type,
          null,
          e.pendingProps,
          null
        )) ? e.memoizedState = n : _t || (n = e.type, t = e.pendingProps, a = nc(
          fe.current
        ).createElement(n), a[ht] = e, a[he] = t, ke(a, n, t), Wt(a), e.stateNode = a) : e.memoizedState = Np(
          e.type,
          t.memoizedProps,
          e.pendingProps,
          t.memoizedState
        ), null;
      case 27:
        return zt(e), t === null && _t && (a = e.stateNode = Ap(
          e.type,
          e.pendingProps,
          fe.current
        ), De = e, bn = !0, r = It, Ka(e.type) ? (Fo = r, It = Tn(a.firstChild)) : It = r), Me(
          t,
          e,
          e.pendingProps.children,
          n
        ), Uu(t, e), t === null && (e.flags |= 4194304), e.child;
      case 5:
        return t === null && _t && ((r = a = It) && (a = I0(
          a,
          e.type,
          e.pendingProps,
          bn
        ), a !== null ? (e.stateNode = a, De = e, It = Tn(a.firstChild), bn = !1, r = !0) : r = !1), r || za(e)), zt(e), r = e.type, c = e.pendingProps, d = t !== null ? t.memoizedProps : null, a = c.children, Zo(r, c) ? a = null : d !== null && Zo(r, d) && (e.flags |= 32), e.memoizedState !== null && (r = Xs(
          t,
          e,
          h0,
          null,
          null,
          n
        ), Lr._currentValue = r), Uu(t, e), Me(t, e, a, n), e.child;
      case 6:
        return t === null && _t && ((t = n = It) && (n = P0(
          n,
          e.pendingProps,
          bn
        ), n !== null ? (e.stateNode = n, De = e, It = null, t = !0) : t = !1), t || za(e)), null;
      case 13:
        return hm(t, e, n);
      case 4:
        return Ut(
          e,
          e.stateNode.containerInfo
        ), a = e.pendingProps, t === null ? e.child = _l(
          e,
          null,
          a,
          n
        ) : Me(t, e, a, n), e.child;
      case 11:
        return lm(
          t,
          e,
          e.type,
          e.pendingProps,
          n
        );
      case 7:
        return Me(
          t,
          e,
          e.pendingProps,
          n
        ), e.child;
      case 8:
        return Me(
          t,
          e,
          e.pendingProps.children,
          n
        ), e.child;
      case 12:
        return Me(
          t,
          e,
          e.pendingProps.children,
          n
        ), e.child;
      case 10:
        return a = e.pendingProps, Ma(e, e.type, a.value), Me(t, e, a.children, n), e.child;
      case 9:
        return r = e.type._context, a = e.pendingProps.children, Tl(e), r = ze(r), a = a(r), e.flags |= 1, Me(t, e, a, n), e.child;
      case 14:
        return im(
          t,
          e,
          e.type,
          e.pendingProps,
          n
        );
      case 15:
        return rm(
          t,
          e,
          e.type,
          e.pendingProps,
          n
        );
      case 19:
        return pm(t, e, n);
      case 31:
        return T0(t, e, n);
      case 22:
        return um(
          t,
          e,
          n,
          e.pendingProps
        );
      case 24:
        return Tl(e), a = ze(Te), t === null ? (r = Ms(), r === null && (r = $t, c = Ds(), r.pooledCache = c, c.refCount++, c !== null && (r.pooledCacheLanes |= n), r = c), e.memoizedState = { parent: a, cache: r }, Ls(e), Ma(e, Te, r)) : ((t.lanes & n) !== 0 && (Bs(t, e), gr(e, null, null, n), pr()), r = t.memoizedState, c = e.memoizedState, r.parent !== a ? (r = { parent: a, cache: a }, e.memoizedState = r, e.lanes === 0 && (e.memoizedState = e.updateQueue.baseState = r), Ma(e, Te, a)) : (a = c.cache, Ma(e, Te, a), a !== r.cache && Cs(
          e,
          [Te],
          n,
          !0
        ))), Me(
          t,
          e,
          e.pendingProps.children,
          n
        ), e.child;
      case 29:
        throw e.pendingProps;
    }
    throw Error(o(156, e.tag));
  }
  function ua(t) {
    t.flags |= 4;
  }
  function bo(t, e, n, a, r) {
    if ((e = (t.mode & 32) !== 0) && (e = !1), e) {
      if (t.flags |= 16777216, (r & 335544128) === r)
        if (t.stateNode.complete) t.flags |= 8192;
        else if (Gm()) t.flags |= 8192;
        else
          throw Al = Au, ks;
    } else t.flags &= -16777217;
  }
  function ym(t, e) {
    if (e.type !== "stylesheet" || (e.state.loading & 4) !== 0)
      t.flags &= -16777217;
    else if (t.flags |= 16777216, !Dp(e))
      if (Gm()) t.flags |= 8192;
      else
        throw Al = Au, ks;
  }
  function Vu(t, e) {
    e !== null && (t.flags |= 4), t.flags & 16384 && (e = t.tag !== 22 ? Jn() : 536870912, t.lanes |= e, xi |= e);
  }
  function wr(t, e) {
    if (!_t)
      switch (t.tailMode) {
        case "hidden":
          e = t.tail;
          for (var n = null; e !== null; )
            e.alternate !== null && (n = e), e = e.sibling;
          n === null ? t.tail = null : n.sibling = null;
          break;
        case "collapsed":
          n = t.tail;
          for (var a = null; n !== null; )
            n.alternate !== null && (a = n), n = n.sibling;
          a === null ? e || t.tail === null ? t.tail = null : t.tail.sibling = null : a.sibling = null;
      }
  }
  function Pt(t) {
    var e = t.alternate !== null && t.alternate.child === t.child, n = 0, a = 0;
    if (e)
      for (var r = t.child; r !== null; )
        n |= r.lanes | r.childLanes, a |= r.subtreeFlags & 65011712, a |= r.flags & 65011712, r.return = t, r = r.sibling;
    else
      for (r = t.child; r !== null; )
        n |= r.lanes | r.childLanes, a |= r.subtreeFlags, a |= r.flags, r.return = t, r = r.sibling;
    return t.subtreeFlags |= a, t.childLanes = n, e;
  }
  function x0(t, e, n) {
    var a = e.pendingProps;
    switch (Os(e), e.tag) {
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return Pt(e), null;
      case 1:
        return Pt(e), null;
      case 3:
        return n = e.stateNode, a = null, t !== null && (a = t.memoizedState.cache), e.memoizedState.cache !== a && (e.flags |= 2048), aa(Te), Kt(), n.pendingContext && (n.context = n.pendingContext, n.pendingContext = null), (t === null || t.child === null) && (oi(e) ? ua(e) : t === null || t.memoizedState.isDehydrated && (e.flags & 256) === 0 || (e.flags |= 1024, Es())), Pt(e), null;
      case 26:
        var r = e.type, c = e.memoizedState;
        return t === null ? (ua(e), c !== null ? (Pt(e), ym(e, c)) : (Pt(e), bo(
          e,
          r,
          null,
          a,
          n
        ))) : c ? c !== t.memoizedState ? (ua(e), Pt(e), ym(e, c)) : (Pt(e), e.flags &= -16777217) : (t = t.memoizedProps, t !== a && ua(e), Pt(e), bo(
          e,
          r,
          t,
          a,
          n
        )), null;
      case 27:
        if (Zn(e), n = fe.current, r = e.type, t !== null && e.stateNode != null)
          t.memoizedProps !== a && ua(e);
        else {
          if (!a) {
            if (e.stateNode === null)
              throw Error(o(166));
            return Pt(e), null;
          }
          t = ot.current, oi(e) ? Wd(e) : (t = Ap(r, a, n), e.stateNode = t, ua(e));
        }
        return Pt(e), null;
      case 5:
        if (Zn(e), r = e.type, t !== null && e.stateNode != null)
          t.memoizedProps !== a && ua(e);
        else {
          if (!a) {
            if (e.stateNode === null)
              throw Error(o(166));
            return Pt(e), null;
          }
          if (c = ot.current, oi(e))
            Wd(e);
          else {
            var d = nc(
              fe.current
            );
            switch (c) {
              case 1:
                c = d.createElementNS(
                  "http://www.w3.org/2000/svg",
                  r
                );
                break;
              case 2:
                c = d.createElementNS(
                  "http://www.w3.org/1998/Math/MathML",
                  r
                );
                break;
              default:
                switch (r) {
                  case "svg":
                    c = d.createElementNS(
                      "http://www.w3.org/2000/svg",
                      r
                    );
                    break;
                  case "math":
                    c = d.createElementNS(
                      "http://www.w3.org/1998/Math/MathML",
                      r
                    );
                    break;
                  case "script":
                    c = d.createElement("div"), c.innerHTML = "<script><\/script>", c = c.removeChild(
                      c.firstChild
                    );
                    break;
                  case "select":
                    c = typeof a.is == "string" ? d.createElement("select", {
                      is: a.is
                    }) : d.createElement("select"), a.multiple ? c.multiple = !0 : a.size && (c.size = a.size);
                    break;
                  default:
                    c = typeof a.is == "string" ? d.createElement(r, { is: a.is }) : d.createElement(r);
                }
            }
            c[ht] = e, c[he] = a;
            t: for (d = e.child; d !== null; ) {
              if (d.tag === 5 || d.tag === 6)
                c.appendChild(d.stateNode);
              else if (d.tag !== 4 && d.tag !== 27 && d.child !== null) {
                d.child.return = d, d = d.child;
                continue;
              }
              if (d === e) break t;
              for (; d.sibling === null; ) {
                if (d.return === null || d.return === e)
                  break t;
                d = d.return;
              }
              d.sibling.return = d.return, d = d.sibling;
            }
            e.stateNode = c;
            t: switch (ke(c, r, a), r) {
              case "button":
              case "input":
              case "select":
              case "textarea":
                a = !!a.autoFocus;
                break t;
              case "img":
                a = !0;
                break t;
              default:
                a = !1;
            }
            a && ua(e);
          }
        }
        return Pt(e), bo(
          e,
          e.type,
          t === null ? null : t.memoizedProps,
          e.pendingProps,
          n
        ), null;
      case 6:
        if (t && e.stateNode != null)
          t.memoizedProps !== a && ua(e);
        else {
          if (typeof a != "string" && e.stateNode === null)
            throw Error(o(166));
          if (t = fe.current, oi(e)) {
            if (t = e.stateNode, n = e.memoizedProps, a = null, r = De, r !== null)
              switch (r.tag) {
                case 27:
                case 5:
                  a = r.memoizedProps;
              }
            t[ht] = e, t = !!(t.nodeValue === n || a !== null && a.suppressHydrationWarning === !0 || hp(t.nodeValue, n)), t || za(e, !0);
          } else
            t = nc(t).createTextNode(
              a
            ), t[ht] = e, e.stateNode = t;
        }
        return Pt(e), null;
      case 31:
        if (n = e.memoizedState, t === null || t.memoizedState !== null) {
          if (a = oi(e), n !== null) {
            if (t === null) {
              if (!a) throw Error(o(318));
              if (t = e.memoizedState, t = t !== null ? t.dehydrated : null, !t) throw Error(o(557));
              t[ht] = e;
            } else
              bl(), (e.flags & 128) === 0 && (e.memoizedState = null), e.flags |= 4;
            Pt(e), t = !1;
          } else
            n = Es(), t !== null && t.memoizedState !== null && (t.memoizedState.hydrationErrors = n), t = !0;
          if (!t)
            return e.flags & 256 ? (cn(e), e) : (cn(e), null);
          if ((e.flags & 128) !== 0)
            throw Error(o(558));
        }
        return Pt(e), null;
      case 13:
        if (a = e.memoizedState, t === null || t.memoizedState !== null && t.memoizedState.dehydrated !== null) {
          if (r = oi(e), a !== null && a.dehydrated !== null) {
            if (t === null) {
              if (!r) throw Error(o(318));
              if (r = e.memoizedState, r = r !== null ? r.dehydrated : null, !r) throw Error(o(317));
              r[ht] = e;
            } else
              bl(), (e.flags & 128) === 0 && (e.memoizedState = null), e.flags |= 4;
            Pt(e), r = !1;
          } else
            r = Es(), t !== null && t.memoizedState !== null && (t.memoizedState.hydrationErrors = r), r = !0;
          if (!r)
            return e.flags & 256 ? (cn(e), e) : (cn(e), null);
        }
        return cn(e), (e.flags & 128) !== 0 ? (e.lanes = n, e) : (n = a !== null, t = t !== null && t.memoizedState !== null, n && (a = e.child, r = null, a.alternate !== null && a.alternate.memoizedState !== null && a.alternate.memoizedState.cachePool !== null && (r = a.alternate.memoizedState.cachePool.pool), c = null, a.memoizedState !== null && a.memoizedState.cachePool !== null && (c = a.memoizedState.cachePool.pool), c !== r && (a.flags |= 2048)), n !== t && n && (e.child.flags |= 8192), Vu(e, e.updateQueue), Pt(e), null);
      case 4:
        return Kt(), t === null && Vo(e.stateNode.containerInfo), Pt(e), null;
      case 10:
        return aa(e.type), Pt(e), null;
      case 19:
        if (ct(pe), a = e.memoizedState, a === null) return Pt(e), null;
        if (r = (e.flags & 128) !== 0, c = a.rendering, c === null)
          if (r) wr(a, !1);
          else {
            if (se !== 0 || t !== null && (t.flags & 128) !== 0)
              for (t = e.child; t !== null; ) {
                if (c = Eu(t), c !== null) {
                  for (e.flags |= 128, wr(a, !1), t = c.updateQueue, e.updateQueue = t, Vu(e, t), e.subtreeFlags = 0, t = n, n = e.child; n !== null; )
                    Qd(n, t), n = n.sibling;
                  return at(
                    pe,
                    pe.current & 1 | 2
                  ), _t && ea(e, a.treeForkCount), e.child;
                }
                t = t.sibling;
              }
            a.tail !== null && de() > Zu && (e.flags |= 128, r = !0, wr(a, !1), e.lanes = 4194304);
          }
        else {
          if (!r)
            if (t = Eu(c), t !== null) {
              if (e.flags |= 128, r = !0, t = t.updateQueue, e.updateQueue = t, Vu(e, t), wr(a, !0), a.tail === null && a.tailMode === "hidden" && !c.alternate && !_t)
                return Pt(e), null;
            } else
              2 * de() - a.renderingStartTime > Zu && n !== 536870912 && (e.flags |= 128, r = !0, wr(a, !1), e.lanes = 4194304);
          a.isBackwards ? (c.sibling = e.child, e.child = c) : (t = a.last, t !== null ? t.sibling = c : e.child = c, a.last = c);
        }
        return a.tail !== null ? (t = a.tail, a.rendering = t, a.tail = t.sibling, a.renderingStartTime = de(), t.sibling = null, n = pe.current, at(
          pe,
          r ? n & 1 | 2 : n & 1
        ), _t && ea(e, a.treeForkCount), t) : (Pt(e), null);
      case 22:
      case 23:
        return cn(e), Vs(), a = e.memoizedState !== null, t !== null ? t.memoizedState !== null !== a && (e.flags |= 8192) : a && (e.flags |= 8192), a ? (n & 536870912) !== 0 && (e.flags & 128) === 0 && (Pt(e), e.subtreeFlags & 6 && (e.flags |= 8192)) : Pt(e), n = e.updateQueue, n !== null && Vu(e, n.retryQueue), n = null, t !== null && t.memoizedState !== null && t.memoizedState.cachePool !== null && (n = t.memoizedState.cachePool.pool), a = null, e.memoizedState !== null && e.memoizedState.cachePool !== null && (a = e.memoizedState.cachePool.pool), a !== n && (e.flags |= 2048), t !== null && ct(wl), null;
      case 24:
        return n = null, t !== null && (n = t.memoizedState.cache), e.memoizedState.cache !== n && (e.flags |= 2048), aa(Te), Pt(e), null;
      case 25:
        return null;
      case 30:
        return null;
    }
    throw Error(o(156, e.tag));
  }
  function A0(t, e) {
    switch (Os(e), e.tag) {
      case 1:
        return t = e.flags, t & 65536 ? (e.flags = t & -65537 | 128, e) : null;
      case 3:
        return aa(Te), Kt(), t = e.flags, (t & 65536) !== 0 && (t & 128) === 0 ? (e.flags = t & -65537 | 128, e) : null;
      case 26:
      case 27:
      case 5:
        return Zn(e), null;
      case 31:
        if (e.memoizedState !== null) {
          if (cn(e), e.alternate === null)
            throw Error(o(340));
          bl();
        }
        return t = e.flags, t & 65536 ? (e.flags = t & -65537 | 128, e) : null;
      case 13:
        if (cn(e), t = e.memoizedState, t !== null && t.dehydrated !== null) {
          if (e.alternate === null)
            throw Error(o(340));
          bl();
        }
        return t = e.flags, t & 65536 ? (e.flags = t & -65537 | 128, e) : null;
      case 19:
        return ct(pe), null;
      case 4:
        return Kt(), null;
      case 10:
        return aa(e.type), null;
      case 22:
      case 23:
        return cn(e), Vs(), t !== null && ct(wl), t = e.flags, t & 65536 ? (e.flags = t & -65537 | 128, e) : null;
      case 24:
        return aa(Te), null;
      case 25:
        return null;
      default:
        return null;
    }
  }
  function vm(t, e) {
    switch (Os(e), e.tag) {
      case 3:
        aa(Te), Kt();
        break;
      case 26:
      case 27:
      case 5:
        Zn(e);
        break;
      case 4:
        Kt();
        break;
      case 31:
        e.memoizedState !== null && cn(e);
        break;
      case 13:
        cn(e);
        break;
      case 19:
        ct(pe);
        break;
      case 10:
        aa(e.type);
        break;
      case 22:
      case 23:
        cn(e), Vs(), t !== null && ct(wl);
        break;
      case 24:
        aa(Te);
    }
  }
  function xr(t, e) {
    try {
      var n = e.updateQueue, a = n !== null ? n.lastEffect : null;
      if (a !== null) {
        var r = a.next;
        n = r;
        do {
          if ((n.tag & t) === t) {
            a = void 0;
            var c = n.create, d = n.inst;
            a = c(), d.destroy = a;
          }
          n = n.next;
        } while (n !== r);
      }
    } catch (v) {
      Ht(e, e.return, v);
    }
  }
  function qa(t, e, n) {
    try {
      var a = e.updateQueue, r = a !== null ? a.lastEffect : null;
      if (r !== null) {
        var c = r.next;
        a = c;
        do {
          if ((a.tag & t) === t) {
            var d = a.inst, v = d.destroy;
            if (v !== void 0) {
              d.destroy = void 0, r = e;
              var w = n, E = v;
              try {
                E();
              } catch (M) {
                Ht(
                  r,
                  w,
                  M
                );
              }
            }
          }
          a = a.next;
        } while (a !== c);
      }
    } catch (M) {
      Ht(e, e.return, M);
    }
  }
  function bm(t) {
    var e = t.updateQueue;
    if (e !== null) {
      var n = t.stateNode;
      try {
        sh(e, n);
      } catch (a) {
        Ht(t, t.return, a);
      }
    }
  }
  function Sm(t, e, n) {
    n.props = Nl(
      t.type,
      t.memoizedProps
    ), n.state = t.memoizedState;
    try {
      n.componentWillUnmount();
    } catch (a) {
      Ht(t, e, a);
    }
  }
  function Ar(t, e) {
    try {
      var n = t.ref;
      if (n !== null) {
        switch (t.tag) {
          case 26:
          case 27:
          case 5:
            var a = t.stateNode;
            break;
          case 30:
            a = t.stateNode;
            break;
          default:
            a = t.stateNode;
        }
        typeof n == "function" ? t.refCleanup = n(a) : n.current = a;
      }
    } catch (r) {
      Ht(t, e, r);
    }
  }
  function qn(t, e) {
    var n = t.ref, a = t.refCleanup;
    if (n !== null)
      if (typeof a == "function")
        try {
          a();
        } catch (r) {
          Ht(t, e, r);
        } finally {
          t.refCleanup = null, t = t.alternate, t != null && (t.refCleanup = null);
        }
      else if (typeof n == "function")
        try {
          n(null);
        } catch (r) {
          Ht(t, e, r);
        }
      else n.current = null;
  }
  function Tm(t) {
    var e = t.type, n = t.memoizedProps, a = t.stateNode;
    try {
      t: switch (e) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          n.autoFocus && a.focus();
          break t;
        case "img":
          n.src ? a.src = n.src : n.srcSet && (a.srcset = n.srcSet);
      }
    } catch (r) {
      Ht(t, t.return, r);
    }
  }
  function So(t, e, n) {
    try {
      var a = t.stateNode;
      Z0(a, t.type, n, e), a[he] = e;
    } catch (r) {
      Ht(t, t.return, r);
    }
  }
  function wm(t) {
    return t.tag === 5 || t.tag === 3 || t.tag === 26 || t.tag === 27 && Ka(t.type) || t.tag === 4;
  }
  function To(t) {
    t: for (; ; ) {
      for (; t.sibling === null; ) {
        if (t.return === null || wm(t.return)) return null;
        t = t.return;
      }
      for (t.sibling.return = t.return, t = t.sibling; t.tag !== 5 && t.tag !== 6 && t.tag !== 18; ) {
        if (t.tag === 27 && Ka(t.type) || t.flags & 2 || t.child === null || t.tag === 4) continue t;
        t.child.return = t, t = t.child;
      }
      if (!(t.flags & 2)) return t.stateNode;
    }
  }
  function wo(t, e, n) {
    var a = t.tag;
    if (a === 5 || a === 6)
      t = t.stateNode, e ? (n.nodeType === 9 ? n.body : n.nodeName === "HTML" ? n.ownerDocument.body : n).insertBefore(t, e) : (e = n.nodeType === 9 ? n.body : n.nodeName === "HTML" ? n.ownerDocument.body : n, e.appendChild(t), n = n._reactRootContainer, n != null || e.onclick !== null || (e.onclick = Ft));
    else if (a !== 4 && (a === 27 && Ka(t.type) && (n = t.stateNode, e = null), t = t.child, t !== null))
      for (wo(t, e, n), t = t.sibling; t !== null; )
        wo(t, e, n), t = t.sibling;
  }
  function Yu(t, e, n) {
    var a = t.tag;
    if (a === 5 || a === 6)
      t = t.stateNode, e ? n.insertBefore(t, e) : n.appendChild(t);
    else if (a !== 4 && (a === 27 && Ka(t.type) && (n = t.stateNode), t = t.child, t !== null))
      for (Yu(t, e, n), t = t.sibling; t !== null; )
        Yu(t, e, n), t = t.sibling;
  }
  function xm(t) {
    var e = t.stateNode, n = t.memoizedProps;
    try {
      for (var a = t.type, r = e.attributes; r.length; )
        e.removeAttributeNode(r[0]);
      ke(e, a, n), e[ht] = t, e[he] = n;
    } catch (c) {
      Ht(t, t.return, c);
    }
  }
  var ca = !1, Ae = !1, xo = !1, Am = typeof WeakSet == "function" ? WeakSet : Set, je = null;
  function _0(t, e) {
    if (t = t.containerInfo, Xo = sc, t = Ld(t), ps(t)) {
      if ("selectionStart" in t)
        var n = {
          start: t.selectionStart,
          end: t.selectionEnd
        };
      else
        t: {
          n = (n = t.ownerDocument) && n.defaultView || window;
          var a = n.getSelection && n.getSelection();
          if (a && a.rangeCount !== 0) {
            n = a.anchorNode;
            var r = a.anchorOffset, c = a.focusNode;
            a = a.focusOffset;
            try {
              n.nodeType, c.nodeType;
            } catch {
              n = null;
              break t;
            }
            var d = 0, v = -1, w = -1, E = 0, M = 0, H = t, C = null;
            e: for (; ; ) {
              for (var z; H !== n || r !== 0 && H.nodeType !== 3 || (v = d + r), H !== c || a !== 0 && H.nodeType !== 3 || (w = d + a), H.nodeType === 3 && (d += H.nodeValue.length), (z = H.firstChild) !== null; )
                C = H, H = z;
              for (; ; ) {
                if (H === t) break e;
                if (C === n && ++E === r && (v = d), C === c && ++M === a && (w = d), (z = H.nextSibling) !== null) break;
                H = C, C = H.parentNode;
              }
              H = z;
            }
            n = v === -1 || w === -1 ? null : { start: v, end: w };
          } else n = null;
        }
      n = n || { start: 0, end: 0 };
    } else n = null;
    for (Qo = { focusedElem: t, selectionRange: n }, sc = !1, je = e; je !== null; )
      if (e = je, t = e.child, (e.subtreeFlags & 1028) !== 0 && t !== null)
        t.return = e, je = t;
      else
        for (; je !== null; ) {
          switch (e = je, c = e.alternate, t = e.flags, e.tag) {
            case 0:
              if ((t & 4) !== 0 && (t = e.updateQueue, t = t !== null ? t.events : null, t !== null))
                for (n = 0; n < t.length; n++)
                  r = t[n], r.ref.impl = r.nextImpl;
              break;
            case 11:
            case 15:
              break;
            case 1:
              if ((t & 1024) !== 0 && c !== null) {
                t = void 0, n = e, r = c.memoizedProps, c = c.memoizedState, a = n.stateNode;
                try {
                  var P = Nl(
                    n.type,
                    r
                  );
                  t = a.getSnapshotBeforeUpdate(
                    P,
                    c
                  ), a.__reactInternalSnapshotBeforeUpdate = t;
                } catch (rt) {
                  Ht(
                    n,
                    n.return,
                    rt
                  );
                }
              }
              break;
            case 3:
              if ((t & 1024) !== 0) {
                if (t = e.stateNode.containerInfo, n = t.nodeType, n === 9)
                  $o(t);
                else if (n === 1)
                  switch (t.nodeName) {
                    case "HEAD":
                    case "HTML":
                    case "BODY":
                      $o(t);
                      break;
                    default:
                      t.textContent = "";
                  }
              }
              break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
              break;
            default:
              if ((t & 1024) !== 0) throw Error(o(163));
          }
          if (t = e.sibling, t !== null) {
            t.return = e.return, je = t;
            break;
          }
          je = e.return;
        }
  }
  function _m(t, e, n) {
    var a = n.flags;
    switch (n.tag) {
      case 0:
      case 11:
      case 15:
        oa(t, n), a & 4 && xr(5, n);
        break;
      case 1:
        if (oa(t, n), a & 4)
          if (t = n.stateNode, e === null)
            try {
              t.componentDidMount();
            } catch (d) {
              Ht(n, n.return, d);
            }
          else {
            var r = Nl(
              n.type,
              e.memoizedProps
            );
            e = e.memoizedState;
            try {
              t.componentDidUpdate(
                r,
                e,
                t.__reactInternalSnapshotBeforeUpdate
              );
            } catch (d) {
              Ht(
                n,
                n.return,
                d
              );
            }
          }
        a & 64 && bm(n), a & 512 && Ar(n, n.return);
        break;
      case 3:
        if (oa(t, n), a & 64 && (t = n.updateQueue, t !== null)) {
          if (e = null, n.child !== null)
            switch (n.child.tag) {
              case 27:
              case 5:
                e = n.child.stateNode;
                break;
              case 1:
                e = n.child.stateNode;
            }
          try {
            sh(t, e);
          } catch (d) {
            Ht(n, n.return, d);
          }
        }
        break;
      case 27:
        e === null && a & 4 && xm(n);
      case 26:
      case 5:
        oa(t, n), e === null && a & 4 && Tm(n), a & 512 && Ar(n, n.return);
        break;
      case 12:
        oa(t, n);
        break;
      case 31:
        oa(t, n), a & 4 && Em(t, n);
        break;
      case 13:
        oa(t, n), a & 4 && jm(t, n), a & 64 && (t = n.memoizedState, t !== null && (t = t.dehydrated, t !== null && (n = M0.bind(
          null,
          n
        ), tb(t, n))));
        break;
      case 22:
        if (a = n.memoizedState !== null || ca, !a) {
          e = e !== null && e.memoizedState !== null || Ae, r = ca;
          var c = Ae;
          ca = a, (Ae = e) && !c ? fa(
            t,
            n,
            (n.subtreeFlags & 8772) !== 0
          ) : oa(t, n), ca = r, Ae = c;
        }
        break;
      case 30:
        break;
      default:
        oa(t, n);
    }
  }
  function Om(t) {
    var e = t.alternate;
    e !== null && (t.alternate = null, Om(e)), t.child = null, t.deletions = null, t.sibling = null, t.tag === 5 && (e = t.stateNode, e !== null && Ji(e)), t.stateNode = null, t.return = null, t.dependencies = null, t.memoizedProps = null, t.memoizedState = null, t.pendingProps = null, t.stateNode = null, t.updateQueue = null;
  }
  var le = null, Fe = !1;
  function sa(t, e, n) {
    for (n = n.child; n !== null; )
      Nm(t, e, n), n = n.sibling;
  }
  function Nm(t, e, n) {
    if (qe && typeof qe.onCommitFiberUnmount == "function")
      try {
        qe.onCommitFiberUnmount(Sa, n);
      } catch {
      }
    switch (n.tag) {
      case 26:
        Ae || qn(n, e), sa(
          t,
          e,
          n
        ), n.memoizedState ? n.memoizedState.count-- : n.stateNode && (n = n.stateNode, n.parentNode.removeChild(n));
        break;
      case 27:
        Ae || qn(n, e);
        var a = le, r = Fe;
        Ka(n.type) && (le = n.stateNode, Fe = !1), sa(
          t,
          e,
          n
        ), zr(n.stateNode), le = a, Fe = r;
        break;
      case 5:
        Ae || qn(n, e);
      case 6:
        if (a = le, r = Fe, le = null, sa(
          t,
          e,
          n
        ), le = a, Fe = r, le !== null)
          if (Fe)
            try {
              (le.nodeType === 9 ? le.body : le.nodeName === "HTML" ? le.ownerDocument.body : le).removeChild(n.stateNode);
            } catch (c) {
              Ht(
                n,
                e,
                c
              );
            }
          else
            try {
              le.removeChild(n.stateNode);
            } catch (c) {
              Ht(
                n,
                e,
                c
              );
            }
        break;
      case 18:
        le !== null && (Fe ? (t = le, bp(
          t.nodeType === 9 ? t.body : t.nodeName === "HTML" ? t.ownerDocument.body : t,
          n.stateNode
        ), Ci(t)) : bp(le, n.stateNode));
        break;
      case 4:
        a = le, r = Fe, le = n.stateNode.containerInfo, Fe = !0, sa(
          t,
          e,
          n
        ), le = a, Fe = r;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        qa(2, n, e), Ae || qa(4, n, e), sa(
          t,
          e,
          n
        );
        break;
      case 1:
        Ae || (qn(n, e), a = n.stateNode, typeof a.componentWillUnmount == "function" && Sm(
          n,
          e,
          a
        )), sa(
          t,
          e,
          n
        );
        break;
      case 21:
        sa(
          t,
          e,
          n
        );
        break;
      case 22:
        Ae = (a = Ae) || n.memoizedState !== null, sa(
          t,
          e,
          n
        ), Ae = a;
        break;
      default:
        sa(
          t,
          e,
          n
        );
    }
  }
  function Em(t, e) {
    if (e.memoizedState === null && (t = e.alternate, t !== null && (t = t.memoizedState, t !== null))) {
      t = t.dehydrated;
      try {
        Ci(t);
      } catch (n) {
        Ht(e, e.return, n);
      }
    }
  }
  function jm(t, e) {
    if (e.memoizedState === null && (t = e.alternate, t !== null && (t = t.memoizedState, t !== null && (t = t.dehydrated, t !== null))))
      try {
        Ci(t);
      } catch (n) {
        Ht(e, e.return, n);
      }
  }
  function O0(t) {
    switch (t.tag) {
      case 31:
      case 13:
      case 19:
        var e = t.stateNode;
        return e === null && (e = t.stateNode = new Am()), e;
      case 22:
        return t = t.stateNode, e = t._retryCache, e === null && (e = t._retryCache = new Am()), e;
      default:
        throw Error(o(435, t.tag));
    }
  }
  function Gu(t, e) {
    var n = O0(t);
    e.forEach(function(a) {
      if (!n.has(a)) {
        n.add(a);
        var r = k0.bind(null, t, a);
        a.then(r, r);
      }
    });
  }
  function Ie(t, e) {
    var n = e.deletions;
    if (n !== null)
      for (var a = 0; a < n.length; a++) {
        var r = n[a], c = t, d = e, v = d;
        t: for (; v !== null; ) {
          switch (v.tag) {
            case 27:
              if (Ka(v.type)) {
                le = v.stateNode, Fe = !1;
                break t;
              }
              break;
            case 5:
              le = v.stateNode, Fe = !1;
              break t;
            case 3:
            case 4:
              le = v.stateNode.containerInfo, Fe = !0;
              break t;
          }
          v = v.return;
        }
        if (le === null) throw Error(o(160));
        Nm(c, d, r), le = null, Fe = !1, c = r.alternate, c !== null && (c.return = null), r.return = null;
      }
    if (e.subtreeFlags & 13886)
      for (e = e.child; e !== null; )
        Rm(e, t), e = e.sibling;
  }
  var On = null;
  function Rm(t, e) {
    var n = t.alternate, a = t.flags;
    switch (t.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        Ie(e, t), Pe(t), a & 4 && (qa(3, t, t.return), xr(3, t), qa(5, t, t.return));
        break;
      case 1:
        Ie(e, t), Pe(t), a & 512 && (Ae || n === null || qn(n, n.return)), a & 64 && ca && (t = t.updateQueue, t !== null && (a = t.callbacks, a !== null && (n = t.shared.hiddenCallbacks, t.shared.hiddenCallbacks = n === null ? a : n.concat(a))));
        break;
      case 26:
        var r = On;
        if (Ie(e, t), Pe(t), a & 512 && (Ae || n === null || qn(n, n.return)), a & 4) {
          var c = n !== null ? n.memoizedState : null;
          if (a = t.memoizedState, n === null)
            if (a === null)
              if (t.stateNode === null) {
                t: {
                  a = t.type, n = t.memoizedProps, r = r.ownerDocument || r;
                  e: switch (a) {
                    case "title":
                      c = r.getElementsByTagName("title")[0], (!c || c[dl] || c[ht] || c.namespaceURI === "http://www.w3.org/2000/svg" || c.hasAttribute("itemprop")) && (c = r.createElement(a), r.head.insertBefore(
                        c,
                        r.querySelector("head > title")
                      )), ke(c, a, n), c[ht] = t, Wt(c), a = c;
                      break t;
                    case "link":
                      var d = Rp(
                        "link",
                        "href",
                        r
                      ).get(a + (n.href || ""));
                      if (d) {
                        for (var v = 0; v < d.length; v++)
                          if (c = d[v], c.getAttribute("href") === (n.href == null || n.href === "" ? null : n.href) && c.getAttribute("rel") === (n.rel == null ? null : n.rel) && c.getAttribute("title") === (n.title == null ? null : n.title) && c.getAttribute("crossorigin") === (n.crossOrigin == null ? null : n.crossOrigin)) {
                            d.splice(v, 1);
                            break e;
                          }
                      }
                      c = r.createElement(a), ke(c, a, n), r.head.appendChild(c);
                      break;
                    case "meta":
                      if (d = Rp(
                        "meta",
                        "content",
                        r
                      ).get(a + (n.content || ""))) {
                        for (v = 0; v < d.length; v++)
                          if (c = d[v], c.getAttribute("content") === (n.content == null ? null : "" + n.content) && c.getAttribute("name") === (n.name == null ? null : n.name) && c.getAttribute("property") === (n.property == null ? null : n.property) && c.getAttribute("http-equiv") === (n.httpEquiv == null ? null : n.httpEquiv) && c.getAttribute("charset") === (n.charSet == null ? null : n.charSet)) {
                            d.splice(v, 1);
                            break e;
                          }
                      }
                      c = r.createElement(a), ke(c, a, n), r.head.appendChild(c);
                      break;
                    default:
                      throw Error(o(468, a));
                  }
                  c[ht] = t, Wt(c), a = c;
                }
                t.stateNode = a;
              } else
                Cp(
                  r,
                  t.type,
                  t.stateNode
                );
            else
              t.stateNode = jp(
                r,
                a,
                t.memoizedProps
              );
          else
            c !== a ? (c === null ? n.stateNode !== null && (n = n.stateNode, n.parentNode.removeChild(n)) : c.count--, a === null ? Cp(
              r,
              t.type,
              t.stateNode
            ) : jp(
              r,
              a,
              t.memoizedProps
            )) : a === null && t.stateNode !== null && So(
              t,
              t.memoizedProps,
              n.memoizedProps
            );
        }
        break;
      case 27:
        Ie(e, t), Pe(t), a & 512 && (Ae || n === null || qn(n, n.return)), n !== null && a & 4 && So(
          t,
          t.memoizedProps,
          n.memoizedProps
        );
        break;
      case 5:
        if (Ie(e, t), Pe(t), a & 512 && (Ae || n === null || qn(n, n.return)), t.flags & 32) {
          r = t.stateNode;
          try {
            I(r, "");
          } catch (P) {
            Ht(t, t.return, P);
          }
        }
        a & 4 && t.stateNode != null && (r = t.memoizedProps, So(
          t,
          r,
          n !== null ? n.memoizedProps : r
        )), a & 1024 && (xo = !0);
        break;
      case 6:
        if (Ie(e, t), Pe(t), a & 4) {
          if (t.stateNode === null)
            throw Error(o(162));
          a = t.memoizedProps, n = t.stateNode;
          try {
            n.nodeValue = a;
          } catch (P) {
            Ht(t, t.return, P);
          }
        }
        break;
      case 3:
        if (ic = null, r = On, On = ac(e.containerInfo), Ie(e, t), On = r, Pe(t), a & 4 && n !== null && n.memoizedState.isDehydrated)
          try {
            Ci(e.containerInfo);
          } catch (P) {
            Ht(t, t.return, P);
          }
        xo && (xo = !1, Cm(t));
        break;
      case 4:
        a = On, On = ac(
          t.stateNode.containerInfo
        ), Ie(e, t), Pe(t), On = a;
        break;
      case 12:
        Ie(e, t), Pe(t);
        break;
      case 31:
        Ie(e, t), Pe(t), a & 4 && (a = t.updateQueue, a !== null && (t.updateQueue = null, Gu(t, a)));
        break;
      case 13:
        Ie(e, t), Pe(t), t.child.flags & 8192 && t.memoizedState !== null != (n !== null && n.memoizedState !== null) && (Qu = de()), a & 4 && (a = t.updateQueue, a !== null && (t.updateQueue = null, Gu(t, a)));
        break;
      case 22:
        r = t.memoizedState !== null;
        var w = n !== null && n.memoizedState !== null, E = ca, M = Ae;
        if (ca = E || r, Ae = M || w, Ie(e, t), Ae = M, ca = E, Pe(t), a & 8192)
          t: for (e = t.stateNode, e._visibility = r ? e._visibility & -2 : e._visibility | 1, r && (n === null || w || ca || Ae || El(t)), n = null, e = t; ; ) {
            if (e.tag === 5 || e.tag === 26) {
              if (n === null) {
                w = n = e;
                try {
                  if (c = w.stateNode, r)
                    d = c.style, typeof d.setProperty == "function" ? d.setProperty("display", "none", "important") : d.display = "none";
                  else {
                    v = w.stateNode;
                    var H = w.memoizedProps.style, C = H != null && H.hasOwnProperty("display") ? H.display : null;
                    v.style.display = C == null || typeof C == "boolean" ? "" : ("" + C).trim();
                  }
                } catch (P) {
                  Ht(w, w.return, P);
                }
              }
            } else if (e.tag === 6) {
              if (n === null) {
                w = e;
                try {
                  w.stateNode.nodeValue = r ? "" : w.memoizedProps;
                } catch (P) {
                  Ht(w, w.return, P);
                }
              }
            } else if (e.tag === 18) {
              if (n === null) {
                w = e;
                try {
                  var z = w.stateNode;
                  r ? Sp(z, !0) : Sp(w.stateNode, !1);
                } catch (P) {
                  Ht(w, w.return, P);
                }
              }
            } else if ((e.tag !== 22 && e.tag !== 23 || e.memoizedState === null || e === t) && e.child !== null) {
              e.child.return = e, e = e.child;
              continue;
            }
            if (e === t) break t;
            for (; e.sibling === null; ) {
              if (e.return === null || e.return === t) break t;
              n === e && (n = null), e = e.return;
            }
            n === e && (n = null), e.sibling.return = e.return, e = e.sibling;
          }
        a & 4 && (a = t.updateQueue, a !== null && (n = a.retryQueue, n !== null && (a.retryQueue = null, Gu(t, n))));
        break;
      case 19:
        Ie(e, t), Pe(t), a & 4 && (a = t.updateQueue, a !== null && (t.updateQueue = null, Gu(t, a)));
        break;
      case 30:
        break;
      case 21:
        break;
      default:
        Ie(e, t), Pe(t);
    }
  }
  function Pe(t) {
    var e = t.flags;
    if (e & 2) {
      try {
        for (var n, a = t.return; a !== null; ) {
          if (wm(a)) {
            n = a;
            break;
          }
          a = a.return;
        }
        if (n == null) throw Error(o(160));
        switch (n.tag) {
          case 27:
            var r = n.stateNode, c = To(t);
            Yu(t, c, r);
            break;
          case 5:
            var d = n.stateNode;
            n.flags & 32 && (I(d, ""), n.flags &= -33);
            var v = To(t);
            Yu(t, v, d);
            break;
          case 3:
          case 4:
            var w = n.stateNode.containerInfo, E = To(t);
            wo(
              t,
              E,
              w
            );
            break;
          default:
            throw Error(o(161));
        }
      } catch (M) {
        Ht(t, t.return, M);
      }
      t.flags &= -3;
    }
    e & 4096 && (t.flags &= -4097);
  }
  function Cm(t) {
    if (t.subtreeFlags & 1024)
      for (t = t.child; t !== null; ) {
        var e = t;
        Cm(e), e.tag === 5 && e.flags & 1024 && e.stateNode.reset(), t = t.sibling;
      }
  }
  function oa(t, e) {
    if (e.subtreeFlags & 8772)
      for (e = e.child; e !== null; )
        _m(t, e.alternate, e), e = e.sibling;
  }
  function El(t) {
    for (t = t.child; t !== null; ) {
      var e = t;
      switch (e.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          qa(4, e, e.return), El(e);
          break;
        case 1:
          qn(e, e.return);
          var n = e.stateNode;
          typeof n.componentWillUnmount == "function" && Sm(
            e,
            e.return,
            n
          ), El(e);
          break;
        case 27:
          zr(e.stateNode);
        case 26:
        case 5:
          qn(e, e.return), El(e);
          break;
        case 22:
          e.memoizedState === null && El(e);
          break;
        case 30:
          El(e);
          break;
        default:
          El(e);
      }
      t = t.sibling;
    }
  }
  function fa(t, e, n) {
    for (n = n && (e.subtreeFlags & 8772) !== 0, e = e.child; e !== null; ) {
      var a = e.alternate, r = t, c = e, d = c.flags;
      switch (c.tag) {
        case 0:
        case 11:
        case 15:
          fa(
            r,
            c,
            n
          ), xr(4, c);
          break;
        case 1:
          if (fa(
            r,
            c,
            n
          ), a = c, r = a.stateNode, typeof r.componentDidMount == "function")
            try {
              r.componentDidMount();
            } catch (E) {
              Ht(a, a.return, E);
            }
          if (a = c, r = a.updateQueue, r !== null) {
            var v = a.stateNode;
            try {
              var w = r.shared.hiddenCallbacks;
              if (w !== null)
                for (r.shared.hiddenCallbacks = null, r = 0; r < w.length; r++)
                  ch(w[r], v);
            } catch (E) {
              Ht(a, a.return, E);
            }
          }
          n && d & 64 && bm(c), Ar(c, c.return);
          break;
        case 27:
          xm(c);
        case 26:
        case 5:
          fa(
            r,
            c,
            n
          ), n && a === null && d & 4 && Tm(c), Ar(c, c.return);
          break;
        case 12:
          fa(
            r,
            c,
            n
          );
          break;
        case 31:
          fa(
            r,
            c,
            n
          ), n && d & 4 && Em(r, c);
          break;
        case 13:
          fa(
            r,
            c,
            n
          ), n && d & 4 && jm(r, c);
          break;
        case 22:
          c.memoizedState === null && fa(
            r,
            c,
            n
          ), Ar(c, c.return);
          break;
        case 30:
          break;
        default:
          fa(
            r,
            c,
            n
          );
      }
      e = e.sibling;
    }
  }
  function Ao(t, e) {
    var n = null;
    t !== null && t.memoizedState !== null && t.memoizedState.cachePool !== null && (n = t.memoizedState.cachePool.pool), t = null, e.memoizedState !== null && e.memoizedState.cachePool !== null && (t = e.memoizedState.cachePool.pool), t !== n && (t != null && t.refCount++, n != null && or(n));
  }
  function _o(t, e) {
    t = null, e.alternate !== null && (t = e.alternate.memoizedState.cache), e = e.memoizedState.cache, e !== t && (e.refCount++, t != null && or(t));
  }
  function Nn(t, e, n, a) {
    if (e.subtreeFlags & 10256)
      for (e = e.child; e !== null; )
        Dm(
          t,
          e,
          n,
          a
        ), e = e.sibling;
  }
  function Dm(t, e, n, a) {
    var r = e.flags;
    switch (e.tag) {
      case 0:
      case 11:
      case 15:
        Nn(
          t,
          e,
          n,
          a
        ), r & 2048 && xr(9, e);
        break;
      case 1:
        Nn(
          t,
          e,
          n,
          a
        );
        break;
      case 3:
        Nn(
          t,
          e,
          n,
          a
        ), r & 2048 && (t = null, e.alternate !== null && (t = e.alternate.memoizedState.cache), e = e.memoizedState.cache, e !== t && (e.refCount++, t != null && or(t)));
        break;
      case 12:
        if (r & 2048) {
          Nn(
            t,
            e,
            n,
            a
          ), t = e.stateNode;
          try {
            var c = e.memoizedProps, d = c.id, v = c.onPostCommit;
            typeof v == "function" && v(
              d,
              e.alternate === null ? "mount" : "update",
              t.passiveEffectDuration,
              -0
            );
          } catch (w) {
            Ht(e, e.return, w);
          }
        } else
          Nn(
            t,
            e,
            n,
            a
          );
        break;
      case 31:
        Nn(
          t,
          e,
          n,
          a
        );
        break;
      case 13:
        Nn(
          t,
          e,
          n,
          a
        );
        break;
      case 23:
        break;
      case 22:
        c = e.stateNode, d = e.alternate, e.memoizedState !== null ? c._visibility & 2 ? Nn(
          t,
          e,
          n,
          a
        ) : _r(t, e) : c._visibility & 2 ? Nn(
          t,
          e,
          n,
          a
        ) : (c._visibility |= 2, Si(
          t,
          e,
          n,
          a,
          (e.subtreeFlags & 10256) !== 0 || !1
        )), r & 2048 && Ao(d, e);
        break;
      case 24:
        Nn(
          t,
          e,
          n,
          a
        ), r & 2048 && _o(e.alternate, e);
        break;
      default:
        Nn(
          t,
          e,
          n,
          a
        );
    }
  }
  function Si(t, e, n, a, r) {
    for (r = r && ((e.subtreeFlags & 10256) !== 0 || !1), e = e.child; e !== null; ) {
      var c = t, d = e, v = n, w = a, E = d.flags;
      switch (d.tag) {
        case 0:
        case 11:
        case 15:
          Si(
            c,
            d,
            v,
            w,
            r
          ), xr(8, d);
          break;
        case 23:
          break;
        case 22:
          var M = d.stateNode;
          d.memoizedState !== null ? M._visibility & 2 ? Si(
            c,
            d,
            v,
            w,
            r
          ) : _r(
            c,
            d
          ) : (M._visibility |= 2, Si(
            c,
            d,
            v,
            w,
            r
          )), r && E & 2048 && Ao(
            d.alternate,
            d
          );
          break;
        case 24:
          Si(
            c,
            d,
            v,
            w,
            r
          ), r && E & 2048 && _o(d.alternate, d);
          break;
        default:
          Si(
            c,
            d,
            v,
            w,
            r
          );
      }
      e = e.sibling;
    }
  }
  function _r(t, e) {
    if (e.subtreeFlags & 10256)
      for (e = e.child; e !== null; ) {
        var n = t, a = e, r = a.flags;
        switch (a.tag) {
          case 22:
            _r(n, a), r & 2048 && Ao(
              a.alternate,
              a
            );
            break;
          case 24:
            _r(n, a), r & 2048 && _o(a.alternate, a);
            break;
          default:
            _r(n, a);
        }
        e = e.sibling;
      }
  }
  var Or = 8192;
  function Ti(t, e, n) {
    if (t.subtreeFlags & Or)
      for (t = t.child; t !== null; )
        zm(
          t,
          e,
          n
        ), t = t.sibling;
  }
  function zm(t, e, n) {
    switch (t.tag) {
      case 26:
        Ti(
          t,
          e,
          n
        ), t.flags & Or && t.memoizedState !== null && db(
          n,
          On,
          t.memoizedState,
          t.memoizedProps
        );
        break;
      case 5:
        Ti(
          t,
          e,
          n
        );
        break;
      case 3:
      case 4:
        var a = On;
        On = ac(t.stateNode.containerInfo), Ti(
          t,
          e,
          n
        ), On = a;
        break;
      case 22:
        t.memoizedState === null && (a = t.alternate, a !== null && a.memoizedState !== null ? (a = Or, Or = 16777216, Ti(
          t,
          e,
          n
        ), Or = a) : Ti(
          t,
          e,
          n
        ));
        break;
      default:
        Ti(
          t,
          e,
          n
        );
    }
  }
  function Mm(t) {
    var e = t.alternate;
    if (e !== null && (t = e.child, t !== null)) {
      e.child = null;
      do
        e = t.sibling, t.sibling = null, t = e;
      while (t !== null);
    }
  }
  function Nr(t) {
    var e = t.deletions;
    if ((t.flags & 16) !== 0) {
      if (e !== null)
        for (var n = 0; n < e.length; n++) {
          var a = e[n];
          je = a, Lm(
            a,
            t
          );
        }
      Mm(t);
    }
    if (t.subtreeFlags & 10256)
      for (t = t.child; t !== null; )
        km(t), t = t.sibling;
  }
  function km(t) {
    switch (t.tag) {
      case 0:
      case 11:
      case 15:
        Nr(t), t.flags & 2048 && qa(9, t, t.return);
        break;
      case 3:
        Nr(t);
        break;
      case 12:
        Nr(t);
        break;
      case 22:
        var e = t.stateNode;
        t.memoizedState !== null && e._visibility & 2 && (t.return === null || t.return.tag !== 13) ? (e._visibility &= -3, Xu(t)) : Nr(t);
        break;
      default:
        Nr(t);
    }
  }
  function Xu(t) {
    var e = t.deletions;
    if ((t.flags & 16) !== 0) {
      if (e !== null)
        for (var n = 0; n < e.length; n++) {
          var a = e[n];
          je = a, Lm(
            a,
            t
          );
        }
      Mm(t);
    }
    for (t = t.child; t !== null; ) {
      switch (e = t, e.tag) {
        case 0:
        case 11:
        case 15:
          qa(8, e, e.return), Xu(e);
          break;
        case 22:
          n = e.stateNode, n._visibility & 2 && (n._visibility &= -3, Xu(e));
          break;
        default:
          Xu(e);
      }
      t = t.sibling;
    }
  }
  function Lm(t, e) {
    for (; je !== null; ) {
      var n = je;
      switch (n.tag) {
        case 0:
        case 11:
        case 15:
          qa(8, n, e);
          break;
        case 23:
        case 22:
          if (n.memoizedState !== null && n.memoizedState.cachePool !== null) {
            var a = n.memoizedState.cachePool.pool;
            a != null && a.refCount++;
          }
          break;
        case 24:
          or(n.memoizedState.cache);
      }
      if (a = n.child, a !== null) a.return = n, je = a;
      else
        t: for (n = t; je !== null; ) {
          a = je;
          var r = a.sibling, c = a.return;
          if (Om(a), a === n) {
            je = null;
            break t;
          }
          if (r !== null) {
            r.return = c, je = r;
            break t;
          }
          je = c;
        }
    }
  }
  var N0 = {
    getCacheForType: function(t) {
      var e = ze(Te), n = e.data.get(t);
      return n === void 0 && (n = t(), e.data.set(t, n)), n;
    },
    cacheSignal: function() {
      return ze(Te).controller.signal;
    }
  }, E0 = typeof WeakMap == "function" ? WeakMap : Map, Mt = 0, $t = null, St = null, xt = 0, Bt = 0, sn = null, Va = !1, wi = !1, Oo = !1, da = 0, se = 0, Ya = 0, jl = 0, No = 0, on = 0, xi = 0, Er = null, tn = null, Eo = !1, Qu = 0, Bm = 0, Zu = 1 / 0, Ku = null, Ga = null, Ne = 0, Xa = null, Ai = null, ha = 0, jo = 0, Ro = null, Hm = null, jr = 0, Co = null;
  function fn() {
    return (Mt & 2) !== 0 && xt !== 0 ? xt & -xt : V.T !== null ? Bo() : xa();
  }
  function Um() {
    if (on === 0)
      if ((xt & 536870912) === 0 || _t) {
        var t = sl;
        sl <<= 1, (sl & 3932160) === 0 && (sl = 262144), on = t;
      } else on = 536870912;
    return t = un.current, t !== null && (t.flags |= 32), on;
  }
  function en(t, e, n) {
    (t === $t && (Bt === 2 || Bt === 9) || t.cancelPendingCommit !== null) && (_i(t, 0), Qa(
      t,
      xt,
      on,
      !1
    )), Wn(t, n), ((Mt & 2) === 0 || t !== $t) && (t === $t && ((Mt & 2) === 0 && (jl |= n), se === 4 && Qa(
      t,
      xt,
      on,
      !1
    )), Vn(t));
  }
  function qm(t, e, n) {
    if ((Mt & 6) !== 0) throw Error(o(327));
    var a = !n && (e & 127) === 0 && (e & t.expiredLanes) === 0 || Mn(t, e), r = a ? C0(t, e) : zo(t, e, !0), c = a;
    do {
      if (r === 0) {
        wi && !a && Qa(t, e, 0, !1);
        break;
      } else {
        if (n = t.current.alternate, c && !j0(n)) {
          r = zo(t, e, !1), c = !1;
          continue;
        }
        if (r === 2) {
          if (c = e, t.errorRecoveryDisabledLanes & c)
            var d = 0;
          else
            d = t.pendingLanes & -536870913, d = d !== 0 ? d : d & 536870912 ? 536870912 : 0;
          if (d !== 0) {
            e = d;
            t: {
              var v = t;
              r = Er;
              var w = v.current.memoizedState.isDehydrated;
              if (w && (_i(v, d).flags |= 256), d = zo(
                v,
                d,
                !1
              ), d !== 2) {
                if (Oo && !w) {
                  v.errorRecoveryDisabledLanes |= c, jl |= c, r = 4;
                  break t;
                }
                c = tn, tn = r, c !== null && (tn === null ? tn = c : tn.push.apply(
                  tn,
                  c
                ));
              }
              r = d;
            }
            if (c = !1, r !== 2) continue;
          }
        }
        if (r === 1) {
          _i(t, 0), Qa(t, e, 0, !0);
          break;
        }
        t: {
          switch (a = t, c = r, c) {
            case 0:
            case 1:
              throw Error(o(345));
            case 4:
              if ((e & 4194048) !== e) break;
            case 6:
              Qa(
                a,
                e,
                on,
                !Va
              );
              break t;
            case 2:
              tn = null;
              break;
            case 3:
            case 5:
              break;
            default:
              throw Error(o(329));
          }
          if ((e & 62914560) === e && (r = Qu + 300 - de(), 10 < r)) {
            if (Qa(
              a,
              e,
              on,
              !Va
            ), $n(a, 0, !0) !== 0) break t;
            ha = e, a.timeoutHandle = yp(
              Vm.bind(
                null,
                a,
                n,
                tn,
                Ku,
                Eo,
                e,
                on,
                jl,
                xi,
                Va,
                c,
                "Throttled",
                -0,
                0
              ),
              r
            );
            break t;
          }
          Vm(
            a,
            n,
            tn,
            Ku,
            Eo,
            e,
            on,
            jl,
            xi,
            Va,
            c,
            null,
            -0,
            0
          );
        }
      }
      break;
    } while (!0);
    Vn(t);
  }
  function Vm(t, e, n, a, r, c, d, v, w, E, M, H, C, z) {
    if (t.timeoutHandle = -1, H = e.subtreeFlags, H & 8192 || (H & 16785408) === 16785408) {
      H = {
        stylesheets: null,
        count: 0,
        imgCount: 0,
        imgBytes: 0,
        suspenseyImages: [],
        waitingForImages: !0,
        waitingForViewTransition: !1,
        unsuspend: Ft
      }, zm(
        e,
        c,
        H
      );
      var P = (c & 62914560) === c ? Qu - de() : (c & 4194048) === c ? Bm - de() : 0;
      if (P = hb(
        H,
        P
      ), P !== null) {
        ha = c, t.cancelPendingCommit = P(
          Jm.bind(
            null,
            t,
            e,
            c,
            n,
            a,
            r,
            d,
            v,
            w,
            M,
            H,
            null,
            C,
            z
          )
        ), Qa(t, c, d, !E);
        return;
      }
    }
    Jm(
      t,
      e,
      c,
      n,
      a,
      r,
      d,
      v,
      w
    );
  }
  function j0(t) {
    for (var e = t; ; ) {
      var n = e.tag;
      if ((n === 0 || n === 11 || n === 15) && e.flags & 16384 && (n = e.updateQueue, n !== null && (n = n.stores, n !== null)))
        for (var a = 0; a < n.length; a++) {
          var r = n[a], c = r.getSnapshot;
          r = r.value;
          try {
            if (!ln(c(), r)) return !1;
          } catch {
            return !1;
          }
        }
      if (n = e.child, e.subtreeFlags & 16384 && n !== null)
        n.return = e, e = n;
      else {
        if (e === t) break;
        for (; e.sibling === null; ) {
          if (e.return === null || e.return === t) return !0;
          e = e.return;
        }
        e.sibling.return = e.return, e = e.sibling;
      }
    }
    return !0;
  }
  function Qa(t, e, n, a) {
    e &= ~No, e &= ~jl, t.suspendedLanes |= e, t.pingedLanes &= ~e, a && (t.warmLanes |= e), a = t.expirationTimes;
    for (var r = e; 0 < r; ) {
      var c = 31 - Ce(r), d = 1 << c;
      a[c] = -1, r &= ~d;
    }
    n !== 0 && Xi(t, n, e);
  }
  function $u() {
    return (Mt & 6) === 0 ? (Rr(0), !1) : !0;
  }
  function Do() {
    if (St !== null) {
      if (Bt === 0)
        var t = St.return;
      else
        t = St, na = Sl = null, Ks(t), pi = null, dr = 0, t = St;
      for (; t !== null; )
        vm(t.alternate, t), t = t.return;
      St = null;
    }
  }
  function _i(t, e) {
    var n = t.timeoutHandle;
    n !== -1 && (t.timeoutHandle = -1, J0(n)), n = t.cancelPendingCommit, n !== null && (t.cancelPendingCommit = null, n()), ha = 0, Do(), $t = t, St = n = ta(t.current, null), xt = e, Bt = 0, sn = null, Va = !1, wi = Mn(t, e), Oo = !1, xi = on = No = jl = Ya = se = 0, tn = Er = null, Eo = !1, (e & 8) !== 0 && (e |= e & 32);
    var a = t.entangledLanes;
    if (a !== 0)
      for (t = t.entanglements, a &= e; 0 < a; ) {
        var r = 31 - Ce(a), c = 1 << r;
        e |= t[r], a &= ~c;
      }
    return da = e, pu(), n;
  }
  function Ym(t, e) {
    st = null, V.H = Sr, e === mi || e === xu ? (e = lh(), Bt = 3) : e === ks ? (e = lh(), Bt = 4) : Bt = e === so ? 8 : e !== null && typeof e == "object" && typeof e.then == "function" ? 6 : 1, sn = e, St === null && (se = 1, Bu(
      t,
      gn(e, t.current)
    ));
  }
  function Gm() {
    var t = un.current;
    return t === null ? !0 : (xt & 4194048) === xt ? Sn === null : (xt & 62914560) === xt || (xt & 536870912) !== 0 ? t === Sn : !1;
  }
  function Xm() {
    var t = V.H;
    return V.H = Sr, t === null ? Sr : t;
  }
  function Qm() {
    var t = V.A;
    return V.A = N0, t;
  }
  function Ju() {
    se = 4, Va || (xt & 4194048) !== xt && un.current !== null || (wi = !0), (Ya & 134217727) === 0 && (jl & 134217727) === 0 || $t === null || Qa(
      $t,
      xt,
      on,
      !1
    );
  }
  function zo(t, e, n) {
    var a = Mt;
    Mt |= 2;
    var r = Xm(), c = Qm();
    ($t !== t || xt !== e) && (Ku = null, _i(t, e)), e = !1;
    var d = se;
    t: do
      try {
        if (Bt !== 0 && St !== null) {
          var v = St, w = sn;
          switch (Bt) {
            case 8:
              Do(), d = 6;
              break t;
            case 3:
            case 2:
            case 9:
            case 6:
              un.current === null && (e = !0);
              var E = Bt;
              if (Bt = 0, sn = null, Oi(t, v, w, E), n && wi) {
                d = 0;
                break t;
              }
              break;
            default:
              E = Bt, Bt = 0, sn = null, Oi(t, v, w, E);
          }
        }
        R0(), d = se;
        break;
      } catch (M) {
        Ym(t, M);
      }
    while (!0);
    return e && t.shellSuspendCounter++, na = Sl = null, Mt = a, V.H = r, V.A = c, St === null && ($t = null, xt = 0, pu()), d;
  }
  function R0() {
    for (; St !== null; ) Zm(St);
  }
  function C0(t, e) {
    var n = Mt;
    Mt |= 2;
    var a = Xm(), r = Qm();
    $t !== t || xt !== e ? (Ku = null, Zu = de() + 500, _i(t, e)) : wi = Mn(
      t,
      e
    );
    t: do
      try {
        if (Bt !== 0 && St !== null) {
          e = St;
          var c = sn;
          e: switch (Bt) {
            case 1:
              Bt = 0, sn = null, Oi(t, e, c, 1);
              break;
            case 2:
            case 9:
              if (nh(c)) {
                Bt = 0, sn = null, Km(e);
                break;
              }
              e = function() {
                Bt !== 2 && Bt !== 9 || $t !== t || (Bt = 7), Vn(t);
              }, c.then(e, e);
              break t;
            case 3:
              Bt = 7;
              break t;
            case 4:
              Bt = 5;
              break t;
            case 7:
              nh(c) ? (Bt = 0, sn = null, Km(e)) : (Bt = 0, sn = null, Oi(t, e, c, 7));
              break;
            case 5:
              var d = null;
              switch (St.tag) {
                case 26:
                  d = St.memoizedState;
                case 5:
                case 27:
                  var v = St;
                  if (d ? Dp(d) : v.stateNode.complete) {
                    Bt = 0, sn = null;
                    var w = v.sibling;
                    if (w !== null) St = w;
                    else {
                      var E = v.return;
                      E !== null ? (St = E, Wu(E)) : St = null;
                    }
                    break e;
                  }
              }
              Bt = 0, sn = null, Oi(t, e, c, 5);
              break;
            case 6:
              Bt = 0, sn = null, Oi(t, e, c, 6);
              break;
            case 8:
              Do(), se = 6;
              break t;
            default:
              throw Error(o(462));
          }
        }
        D0();
        break;
      } catch (M) {
        Ym(t, M);
      }
    while (!0);
    return na = Sl = null, V.H = a, V.A = r, Mt = n, St !== null ? 0 : ($t = null, xt = 0, pu(), se);
  }
  function D0() {
    for (; St !== null && !Dn(); )
      Zm(St);
  }
  function Zm(t) {
    var e = gm(t.alternate, t, da);
    t.memoizedProps = t.pendingProps, e === null ? Wu(t) : St = e;
  }
  function Km(t) {
    var e = t, n = e.alternate;
    switch (e.tag) {
      case 15:
      case 0:
        e = om(
          n,
          e,
          e.pendingProps,
          e.type,
          void 0,
          xt
        );
        break;
      case 11:
        e = om(
          n,
          e,
          e.pendingProps,
          e.type.render,
          e.ref,
          xt
        );
        break;
      case 5:
        Ks(e);
      default:
        vm(n, e), e = St = Qd(e, da), e = gm(n, e, da);
    }
    t.memoizedProps = t.pendingProps, e === null ? Wu(t) : St = e;
  }
  function Oi(t, e, n, a) {
    na = Sl = null, Ks(e), pi = null, dr = 0;
    var r = e.return;
    try {
      if (S0(
        t,
        r,
        e,
        n,
        xt
      )) {
        se = 1, Bu(
          t,
          gn(n, t.current)
        ), St = null;
        return;
      }
    } catch (c) {
      if (r !== null) throw St = r, c;
      se = 1, Bu(
        t,
        gn(n, t.current)
      ), St = null;
      return;
    }
    e.flags & 32768 ? (_t || a === 1 ? t = !0 : wi || (xt & 536870912) !== 0 ? t = !1 : (Va = t = !0, (a === 2 || a === 9 || a === 3 || a === 6) && (a = un.current, a !== null && a.tag === 13 && (a.flags |= 16384))), $m(e, t)) : Wu(e);
  }
  function Wu(t) {
    var e = t;
    do {
      if ((e.flags & 32768) !== 0) {
        $m(
          e,
          Va
        );
        return;
      }
      t = e.return;
      var n = x0(
        e.alternate,
        e,
        da
      );
      if (n !== null) {
        St = n;
        return;
      }
      if (e = e.sibling, e !== null) {
        St = e;
        return;
      }
      St = e = t;
    } while (e !== null);
    se === 0 && (se = 5);
  }
  function $m(t, e) {
    do {
      var n = A0(t.alternate, t);
      if (n !== null) {
        n.flags &= 32767, St = n;
        return;
      }
      if (n = t.return, n !== null && (n.flags |= 32768, n.subtreeFlags = 0, n.deletions = null), !e && (t = t.sibling, t !== null)) {
        St = t;
        return;
      }
      St = t = n;
    } while (t !== null);
    se = 6, St = null;
  }
  function Jm(t, e, n, a, r, c, d, v, w) {
    t.cancelPendingCommit = null;
    do
      Fu();
    while (Ne !== 0);
    if ((Mt & 6) !== 0) throw Error(o(327));
    if (e !== null) {
      if (e === t.current) throw Error(o(177));
      if (c = e.lanes | e.childLanes, c |= Ss, es(
        t,
        n,
        c,
        d,
        v,
        w
      ), t === $t && (St = $t = null, xt = 0), Ai = e, Xa = t, ha = n, jo = c, Ro = r, Hm = a, (e.subtreeFlags & 10256) !== 0 || (e.flags & 10256) !== 0 ? (t.callbackNode = null, t.callbackPriority = 0, L0(va, function() {
        return tp(), null;
      })) : (t.callbackNode = null, t.callbackPriority = 0), a = (e.flags & 13878) !== 0, (e.subtreeFlags & 13878) !== 0 || a) {
        a = V.T, V.T = null, r = $.p, $.p = 2, d = Mt, Mt |= 4;
        try {
          _0(t, e, n);
        } finally {
          Mt = d, $.p = r, V.T = a;
        }
      }
      Ne = 1, Wm(), Fm(), Im();
    }
  }
  function Wm() {
    if (Ne === 1) {
      Ne = 0;
      var t = Xa, e = Ai, n = (e.flags & 13878) !== 0;
      if ((e.subtreeFlags & 13878) !== 0 || n) {
        n = V.T, V.T = null;
        var a = $.p;
        $.p = 2;
        var r = Mt;
        Mt |= 4;
        try {
          Rm(e, t);
          var c = Qo, d = Ld(t.containerInfo), v = c.focusedElem, w = c.selectionRange;
          if (d !== v && v && v.ownerDocument && kd(
            v.ownerDocument.documentElement,
            v
          )) {
            if (w !== null && ps(v)) {
              var E = w.start, M = w.end;
              if (M === void 0 && (M = E), "selectionStart" in v)
                v.selectionStart = E, v.selectionEnd = Math.min(
                  M,
                  v.value.length
                );
              else {
                var H = v.ownerDocument || document, C = H && H.defaultView || window;
                if (C.getSelection) {
                  var z = C.getSelection(), P = v.textContent.length, rt = Math.min(w.start, P), Yt = w.end === void 0 ? rt : Math.min(w.end, P);
                  !z.extend && rt > Yt && (d = Yt, Yt = rt, rt = d);
                  var O = Md(
                    v,
                    rt
                  ), _ = Md(
                    v,
                    Yt
                  );
                  if (O && _ && (z.rangeCount !== 1 || z.anchorNode !== O.node || z.anchorOffset !== O.offset || z.focusNode !== _.node || z.focusOffset !== _.offset)) {
                    var N = H.createRange();
                    N.setStart(O.node, O.offset), z.removeAllRanges(), rt > Yt ? (z.addRange(N), z.extend(_.node, _.offset)) : (N.setEnd(_.node, _.offset), z.addRange(N));
                  }
                }
              }
            }
            for (H = [], z = v; z = z.parentNode; )
              z.nodeType === 1 && H.push({
                element: z,
                left: z.scrollLeft,
                top: z.scrollTop
              });
            for (typeof v.focus == "function" && v.focus(), v = 0; v < H.length; v++) {
              var k = H[v];
              k.element.scrollLeft = k.left, k.element.scrollTop = k.top;
            }
          }
          sc = !!Xo, Qo = Xo = null;
        } finally {
          Mt = r, $.p = a, V.T = n;
        }
      }
      t.current = e, Ne = 2;
    }
  }
  function Fm() {
    if (Ne === 2) {
      Ne = 0;
      var t = Xa, e = Ai, n = (e.flags & 8772) !== 0;
      if ((e.subtreeFlags & 8772) !== 0 || n) {
        n = V.T, V.T = null;
        var a = $.p;
        $.p = 2;
        var r = Mt;
        Mt |= 4;
        try {
          _m(t, e.alternate, e);
        } finally {
          Mt = r, $.p = a, V.T = n;
        }
      }
      Ne = 3;
    }
  }
  function Im() {
    if (Ne === 4 || Ne === 3) {
      Ne = 0, rl();
      var t = Xa, e = Ai, n = ha, a = Hm;
      (e.subtreeFlags & 10256) !== 0 || (e.flags & 10256) !== 0 ? Ne = 5 : (Ne = 0, Ai = Xa = null, Pm(t, t.pendingLanes));
      var r = t.pendingLanes;
      if (r === 0 && (Ga = null), Zi(n), e = e.stateNode, qe && typeof qe.onCommitFiberRoot == "function")
        try {
          qe.onCommitFiberRoot(
            Sa,
            e,
            void 0,
            (e.current.flags & 128) === 128
          );
        } catch {
        }
      if (a !== null) {
        e = V.T, r = $.p, $.p = 2, V.T = null;
        try {
          for (var c = t.onRecoverableError, d = 0; d < a.length; d++) {
            var v = a[d];
            c(v.value, {
              componentStack: v.stack
            });
          }
        } finally {
          V.T = e, $.p = r;
        }
      }
      (ha & 3) !== 0 && Fu(), Vn(t), r = t.pendingLanes, (n & 261930) !== 0 && (r & 42) !== 0 ? t === Co ? jr++ : (jr = 0, Co = t) : jr = 0, Rr(0);
    }
  }
  function Pm(t, e) {
    (t.pooledCacheLanes &= e) === 0 && (e = t.pooledCache, e != null && (t.pooledCache = null, or(e)));
  }
  function Fu() {
    return Wm(), Fm(), Im(), tp();
  }
  function tp() {
    if (Ne !== 5) return !1;
    var t = Xa, e = jo;
    jo = 0;
    var n = Zi(ha), a = V.T, r = $.p;
    try {
      $.p = 32 > n ? 32 : n, V.T = null, n = Ro, Ro = null;
      var c = Xa, d = ha;
      if (Ne = 0, Ai = Xa = null, ha = 0, (Mt & 6) !== 0) throw Error(o(331));
      var v = Mt;
      if (Mt |= 4, km(c.current), Dm(
        c,
        c.current,
        d,
        n
      ), Mt = v, Rr(0, !1), qe && typeof qe.onPostCommitFiberRoot == "function")
        try {
          qe.onPostCommitFiberRoot(Sa, c);
        } catch {
        }
      return !0;
    } finally {
      $.p = r, V.T = a, Pm(t, e);
    }
  }
  function ep(t, e, n) {
    e = gn(n, e), e = co(t.stateNode, e, 2), t = Ba(t, e, 2), t !== null && (Wn(t, 2), Vn(t));
  }
  function Ht(t, e, n) {
    if (t.tag === 3)
      ep(t, t, n);
    else
      for (; e !== null; ) {
        if (e.tag === 3) {
          ep(
            e,
            t,
            n
          );
          break;
        } else if (e.tag === 1) {
          var a = e.stateNode;
          if (typeof e.type.getDerivedStateFromError == "function" || typeof a.componentDidCatch == "function" && (Ga === null || !Ga.has(a))) {
            t = gn(n, t), n = nm(2), a = Ba(e, n, 2), a !== null && (am(
              n,
              a,
              e,
              t
            ), Wn(a, 2), Vn(a));
            break;
          }
        }
        e = e.return;
      }
  }
  function Mo(t, e, n) {
    var a = t.pingCache;
    if (a === null) {
      a = t.pingCache = new E0();
      var r = /* @__PURE__ */ new Set();
      a.set(e, r);
    } else
      r = a.get(e), r === void 0 && (r = /* @__PURE__ */ new Set(), a.set(e, r));
    r.has(n) || (Oo = !0, r.add(n), t = z0.bind(null, t, e, n), e.then(t, t));
  }
  function z0(t, e, n) {
    var a = t.pingCache;
    a !== null && a.delete(e), t.pingedLanes |= t.suspendedLanes & n, t.warmLanes &= ~n, $t === t && (xt & n) === n && (se === 4 || se === 3 && (xt & 62914560) === xt && 300 > de() - Qu ? (Mt & 2) === 0 && _i(t, 0) : No |= n, xi === xt && (xi = 0)), Vn(t);
  }
  function np(t, e) {
    e === 0 && (e = Jn()), t = yl(t, e), t !== null && (Wn(t, e), Vn(t));
  }
  function M0(t) {
    var e = t.memoizedState, n = 0;
    e !== null && (n = e.retryLane), np(t, n);
  }
  function k0(t, e) {
    var n = 0;
    switch (t.tag) {
      case 31:
      case 13:
        var a = t.stateNode, r = t.memoizedState;
        r !== null && (n = r.retryLane);
        break;
      case 19:
        a = t.stateNode;
        break;
      case 22:
        a = t.stateNode._retryCache;
        break;
      default:
        throw Error(o(314));
    }
    a !== null && a.delete(e), np(t, n);
  }
  function L0(t, e) {
    return Xl(t, e);
  }
  var Iu = null, Ni = null, ko = !1, Pu = !1, Lo = !1, Za = 0;
  function Vn(t) {
    t !== Ni && t.next === null && (Ni === null ? Iu = Ni = t : Ni = Ni.next = t), Pu = !0, ko || (ko = !0, H0());
  }
  function Rr(t, e) {
    if (!Lo && Pu) {
      Lo = !0;
      do
        for (var n = !1, a = Iu; a !== null; ) {
          if (t !== 0) {
            var r = a.pendingLanes;
            if (r === 0) var c = 0;
            else {
              var d = a.suspendedLanes, v = a.pingedLanes;
              c = (1 << 31 - Ce(42 | t) + 1) - 1, c &= r & ~(d & ~v), c = c & 201326741 ? c & 201326741 | 1 : c ? c | 2 : 0;
            }
            c !== 0 && (n = !0, rp(a, c));
          } else
            c = xt, c = $n(
              a,
              a === $t ? c : 0,
              a.cancelPendingCommit !== null || a.timeoutHandle !== -1
            ), (c & 3) === 0 || Mn(a, c) || (n = !0, rp(a, c));
          a = a.next;
        }
      while (n);
      Lo = !1;
    }
  }
  function B0() {
    ap();
  }
  function ap() {
    Pu = ko = !1;
    var t = 0;
    Za !== 0 && $0() && (t = Za);
    for (var e = de(), n = null, a = Iu; a !== null; ) {
      var r = a.next, c = lp(a, e);
      c === 0 ? (a.next = null, n === null ? Iu = r : n.next = r, r === null && (Ni = n)) : (n = a, (t !== 0 || (c & 3) !== 0) && (Pu = !0)), a = r;
    }
    Ne !== 0 && Ne !== 5 || Rr(t), Za !== 0 && (Za = 0);
  }
  function lp(t, e) {
    for (var n = t.suspendedLanes, a = t.pingedLanes, r = t.expirationTimes, c = t.pendingLanes & -62914561; 0 < c; ) {
      var d = 31 - Ce(c), v = 1 << d, w = r[d];
      w === -1 ? ((v & n) === 0 || (v & a) !== 0) && (r[d] = mn(v, e)) : w <= e && (t.expiredLanes |= v), c &= ~v;
    }
    if (e = $t, n = xt, n = $n(
      t,
      t === e ? n : 0,
      t.cancelPendingCommit !== null || t.timeoutHandle !== -1
    ), a = t.callbackNode, n === 0 || t === e && (Bt === 2 || Bt === 9) || t.cancelPendingCommit !== null)
      return a !== null && a !== null && Ql(a), t.callbackNode = null, t.callbackPriority = 0;
    if ((n & 3) === 0 || Mn(t, n)) {
      if (e = n & -n, e === t.callbackPriority) return e;
      switch (a !== null && Ql(a), Zi(n)) {
        case 2:
        case 8:
          n = Kl;
          break;
        case 32:
          n = va;
          break;
        case 268435456:
          n = ul;
          break;
        default:
          n = va;
      }
      return a = ip.bind(null, t), n = Xl(n, a), t.callbackPriority = e, t.callbackNode = n, e;
    }
    return a !== null && a !== null && Ql(a), t.callbackPriority = 2, t.callbackNode = null, 2;
  }
  function ip(t, e) {
    if (Ne !== 0 && Ne !== 5)
      return t.callbackNode = null, t.callbackPriority = 0, null;
    var n = t.callbackNode;
    if (Fu() && t.callbackNode !== n)
      return null;
    var a = xt;
    return a = $n(
      t,
      t === $t ? a : 0,
      t.cancelPendingCommit !== null || t.timeoutHandle !== -1
    ), a === 0 ? null : (qm(t, a, e), lp(t, de()), t.callbackNode != null && t.callbackNode === n ? ip.bind(null, t) : null);
  }
  function rp(t, e) {
    if (Fu()) return null;
    qm(t, e, !0);
  }
  function H0() {
    W0(function() {
      (Mt & 6) !== 0 ? Xl(
        Zl,
        B0
      ) : ap();
    });
  }
  function Bo() {
    if (Za === 0) {
      var t = di;
      t === 0 && (t = cl, cl <<= 1, (cl & 261888) === 0 && (cl = 256)), Za = t;
    }
    return Za;
  }
  function up(t) {
    return t == null || typeof t == "symbol" || typeof t == "boolean" ? null : typeof t == "function" ? t : ja("" + t);
  }
  function cp(t, e) {
    var n = e.ownerDocument.createElement("input");
    return n.name = e.name, n.value = e.value, t.id && n.setAttribute("form", t.id), e.parentNode.insertBefore(n, e), t = new FormData(t), n.parentNode.removeChild(n), t;
  }
  function U0(t, e, n, a, r) {
    if (e === "submit" && n && n.stateNode === r) {
      var c = up(
        (r[he] || null).action
      ), d = a.submitter;
      d && (e = (e = d[he] || null) ? up(e.formAction) : d.getAttribute("formAction"), e !== null && (c = e, d = null));
      var v = new fu(
        "action",
        "action",
        null,
        a,
        r
      );
      t.push({
        event: v,
        listeners: [
          {
            instance: null,
            listener: function() {
              if (a.defaultPrevented) {
                if (Za !== 0) {
                  var w = d ? cp(r, d) : new FormData(r);
                  no(
                    n,
                    {
                      pending: !0,
                      data: w,
                      method: r.method,
                      action: c
                    },
                    null,
                    w
                  );
                }
              } else
                typeof c == "function" && (v.preventDefault(), w = d ? cp(r, d) : new FormData(r), no(
                  n,
                  {
                    pending: !0,
                    data: w,
                    method: r.method,
                    action: c
                  },
                  c,
                  w
                ));
            },
            currentTarget: r
          }
        ]
      });
    }
  }
  for (var Ho = 0; Ho < bs.length; Ho++) {
    var Uo = bs[Ho], q0 = Uo.toLowerCase(), V0 = Uo[0].toUpperCase() + Uo.slice(1);
    _n(
      q0,
      "on" + V0
    );
  }
  _n(Ud, "onAnimationEnd"), _n(qd, "onAnimationIteration"), _n(Vd, "onAnimationStart"), _n("dblclick", "onDoubleClick"), _n("focusin", "onFocus"), _n("focusout", "onBlur"), _n(a0, "onTransitionRun"), _n(l0, "onTransitionStart"), _n(i0, "onTransitionCancel"), _n(Yd, "onTransitionEnd"), In("onMouseEnter", ["mouseout", "mouseover"]), In("onMouseLeave", ["mouseout", "mouseover"]), In("onPointerEnter", ["pointerout", "pointerover"]), In("onPointerLeave", ["pointerout", "pointerover"]), Ln(
    "onChange",
    "change click focusin focusout input keydown keyup selectionchange".split(" ")
  ), Ln(
    "onSelect",
    "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(
      " "
    )
  ), Ln("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
  ]), Ln(
    "onCompositionEnd",
    "compositionend focusout keydown keypress keyup mousedown".split(" ")
  ), Ln(
    "onCompositionStart",
    "compositionstart focusout keydown keypress keyup mousedown".split(" ")
  ), Ln(
    "onCompositionUpdate",
    "compositionupdate focusout keydown keypress keyup mousedown".split(" ")
  );
  var Cr = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(
    " "
  ), Y0 = new Set(
    "beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(Cr)
  );
  function sp(t, e) {
    e = (e & 4) !== 0;
    for (var n = 0; n < t.length; n++) {
      var a = t[n], r = a.event;
      a = a.listeners;
      t: {
        var c = void 0;
        if (e)
          for (var d = a.length - 1; 0 <= d; d--) {
            var v = a[d], w = v.instance, E = v.currentTarget;
            if (v = v.listener, w !== c && r.isPropagationStopped())
              break t;
            c = v, r.currentTarget = E;
            try {
              c(r);
            } catch (M) {
              mu(M);
            }
            r.currentTarget = null, c = w;
          }
        else
          for (d = 0; d < a.length; d++) {
            if (v = a[d], w = v.instance, E = v.currentTarget, v = v.listener, w !== c && r.isPropagationStopped())
              break t;
            c = v, r.currentTarget = E;
            try {
              c(r);
            } catch (M) {
              mu(M);
            }
            r.currentTarget = null, c = w;
          }
      }
    }
  }
  function Tt(t, e) {
    var n = e[Wl];
    n === void 0 && (n = e[Wl] = /* @__PURE__ */ new Set());
    var a = t + "__bubble";
    n.has(a) || (op(e, t, 2, !1), n.add(a));
  }
  function qo(t, e, n) {
    var a = 0;
    e && (a |= 4), op(
      n,
      t,
      a,
      e
    );
  }
  var tc = "_reactListening" + Math.random().toString(36).slice(2);
  function Vo(t) {
    if (!t[tc]) {
      t[tc] = !0, iu.forEach(function(n) {
        n !== "selectionchange" && (Y0.has(n) || qo(n, !1, t), qo(n, !0, t));
      });
      var e = t.nodeType === 9 ? t : t.ownerDocument;
      e === null || e[tc] || (e[tc] = !0, qo("selectionchange", !1, e));
    }
  }
  function op(t, e, n, a) {
    switch (Up(e)) {
      case 2:
        var r = gb;
        break;
      case 8:
        r = yb;
        break;
      default:
        r = nf;
    }
    n = r.bind(
      null,
      e,
      n,
      t
    ), r = void 0, !rs || e !== "touchstart" && e !== "touchmove" && e !== "wheel" || (r = !0), a ? r !== void 0 ? t.addEventListener(e, n, {
      capture: !0,
      passive: r
    }) : t.addEventListener(e, n, !0) : r !== void 0 ? t.addEventListener(e, n, {
      passive: r
    }) : t.addEventListener(e, n, !1);
  }
  function Yo(t, e, n, a, r) {
    var c = a;
    if ((e & 1) === 0 && (e & 2) === 0 && a !== null)
      t: for (; ; ) {
        if (a === null) return;
        var d = a.tag;
        if (d === 3 || d === 4) {
          var v = a.stateNode.containerInfo;
          if (v === r) break;
          if (d === 4)
            for (d = a.return; d !== null; ) {
              var w = d.tag;
              if ((w === 3 || w === 4) && d.stateNode.containerInfo === r)
                return;
              d = d.return;
            }
          for (; v !== null; ) {
            if (d = _a(v), d === null) return;
            if (w = d.tag, w === 5 || w === 6 || w === 26 || w === 27) {
              a = c = d;
              continue t;
            }
            v = v.parentNode;
          }
        }
        a = a.return;
      }
    pd(function() {
      var E = c, M = ls(n), H = [];
      t: {
        var C = Gd.get(t);
        if (C !== void 0) {
          var z = fu, P = t;
          switch (t) {
            case "keypress":
              if (su(n) === 0) break t;
            case "keydown":
            case "keyup":
              z = kv;
              break;
            case "focusin":
              P = "focus", z = os;
              break;
            case "focusout":
              P = "blur", z = os;
              break;
            case "beforeblur":
            case "afterblur":
              z = os;
              break;
            case "click":
              if (n.button === 2) break t;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              z = vd;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              z = xv;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              z = Hv;
              break;
            case Ud:
            case qd:
            case Vd:
              z = Ov;
              break;
            case Yd:
              z = qv;
              break;
            case "scroll":
            case "scrollend":
              z = Tv;
              break;
            case "wheel":
              z = Yv;
              break;
            case "copy":
            case "cut":
            case "paste":
              z = Ev;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              z = Sd;
              break;
            case "toggle":
            case "beforetoggle":
              z = Xv;
          }
          var rt = (e & 4) !== 0, Yt = !rt && (t === "scroll" || t === "scrollend"), O = rt ? C !== null ? C + "Capture" : null : C;
          rt = [];
          for (var _ = E, N; _ !== null; ) {
            var k = _;
            if (N = k.stateNode, k = k.tag, k !== 5 && k !== 26 && k !== 27 || N === null || O === null || (k = Pi(_, O), k != null && rt.push(
              Dr(_, k, N)
            )), Yt) break;
            _ = _.return;
          }
          0 < rt.length && (C = new z(
            C,
            P,
            null,
            n,
            M
          ), H.push({ event: C, listeners: rt }));
        }
      }
      if ((e & 7) === 0) {
        t: {
          if (C = t === "mouseover" || t === "pointerover", z = t === "mouseout" || t === "pointerout", C && n !== as && (P = n.relatedTarget || n.fromElement) && (_a(P) || P[Aa]))
            break t;
          if ((z || C) && (C = M.window === M ? M : (C = M.ownerDocument) ? C.defaultView || C.parentWindow : window, z ? (P = n.relatedTarget || n.toElement, z = E, P = P ? _a(P) : null, P !== null && (Yt = m(P), rt = P.tag, P !== Yt || rt !== 5 && rt !== 27 && rt !== 6) && (P = null)) : (z = null, P = E), z !== P)) {
            if (rt = vd, k = "onMouseLeave", O = "onMouseEnter", _ = "mouse", (t === "pointerout" || t === "pointerover") && (rt = Sd, k = "onPointerLeave", O = "onPointerEnter", _ = "pointer"), Yt = z == null ? C : Ze(z), N = P == null ? C : Ze(P), C = new rt(
              k,
              _ + "leave",
              z,
              n,
              M
            ), C.target = Yt, C.relatedTarget = N, k = null, _a(M) === E && (rt = new rt(
              O,
              _ + "enter",
              P,
              n,
              M
            ), rt.target = N, rt.relatedTarget = Yt, k = rt), Yt = k, z && P)
              e: {
                for (rt = G0, O = z, _ = P, N = 0, k = O; k; k = rt(k))
                  N++;
                k = 0;
                for (var it = _; it; it = rt(it))
                  k++;
                for (; 0 < N - k; )
                  O = rt(O), N--;
                for (; 0 < k - N; )
                  _ = rt(_), k--;
                for (; N--; ) {
                  if (O === _ || _ !== null && O === _.alternate) {
                    rt = O;
                    break e;
                  }
                  O = rt(O), _ = rt(_);
                }
                rt = null;
              }
            else rt = null;
            z !== null && fp(
              H,
              C,
              z,
              rt,
              !1
            ), P !== null && Yt !== null && fp(
              H,
              Yt,
              P,
              rt,
              !0
            );
          }
        }
        t: {
          if (C = E ? Ze(E) : window, z = C.nodeName && C.nodeName.toLowerCase(), z === "select" || z === "input" && C.type === "file")
            var Et = Ed;
          else if (Od(C))
            if (jd)
              Et = t0;
            else {
              Et = Iv;
              var nt = Fv;
            }
          else
            z = C.nodeName, !z || z.toLowerCase() !== "input" || C.type !== "checkbox" && C.type !== "radio" ? E && ae(E.elementType) && (Et = Ed) : Et = Pv;
          if (Et && (Et = Et(t, E))) {
            Nd(
              H,
              Et,
              n,
              M
            );
            break t;
          }
          nt && nt(t, C, E), t === "focusout" && E && C.type === "number" && E.memoizedProps.value != null && Z(C, "number", C.value);
        }
        switch (nt = E ? Ze(E) : window, t) {
          case "focusin":
            (Od(nt) || nt.contentEditable === "true") && (li = nt, gs = E, ur = null);
            break;
          case "focusout":
            ur = gs = li = null;
            break;
          case "mousedown":
            ys = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            ys = !1, Bd(H, n, M);
            break;
          case "selectionchange":
            if (n0) break;
          case "keydown":
          case "keyup":
            Bd(H, n, M);
        }
        var dt;
        if (ds)
          t: {
            switch (t) {
              case "compositionstart":
                var At = "onCompositionStart";
                break t;
              case "compositionend":
                At = "onCompositionEnd";
                break t;
              case "compositionupdate":
                At = "onCompositionUpdate";
                break t;
            }
            At = void 0;
          }
        else
          ai ? Ad(t, n) && (At = "onCompositionEnd") : t === "keydown" && n.keyCode === 229 && (At = "onCompositionStart");
        At && (Td && n.locale !== "ko" && (ai || At !== "onCompositionStart" ? At === "onCompositionEnd" && ai && (dt = gd()) : (Ra = M, us = "value" in Ra ? Ra.value : Ra.textContent, ai = !0)), nt = ec(E, At), 0 < nt.length && (At = new bd(
          At,
          t,
          null,
          n,
          M
        ), H.push({ event: At, listeners: nt }), dt ? At.data = dt : (dt = _d(n), dt !== null && (At.data = dt)))), (dt = Zv ? Kv(t, n) : $v(t, n)) && (At = ec(E, "onBeforeInput"), 0 < At.length && (nt = new bd(
          "onBeforeInput",
          "beforeinput",
          null,
          n,
          M
        ), H.push({
          event: nt,
          listeners: At
        }), nt.data = dt)), U0(
          H,
          t,
          E,
          n,
          M
        );
      }
      sp(H, e);
    });
  }
  function Dr(t, e, n) {
    return {
      instance: t,
      listener: e,
      currentTarget: n
    };
  }
  function ec(t, e) {
    for (var n = e + "Capture", a = []; t !== null; ) {
      var r = t, c = r.stateNode;
      if (r = r.tag, r !== 5 && r !== 26 && r !== 27 || c === null || (r = Pi(t, n), r != null && a.unshift(
        Dr(t, r, c)
      ), r = Pi(t, e), r != null && a.push(
        Dr(t, r, c)
      )), t.tag === 3) return a;
      t = t.return;
    }
    return [];
  }
  function G0(t) {
    if (t === null) return null;
    do
      t = t.return;
    while (t && t.tag !== 5 && t.tag !== 27);
    return t || null;
  }
  function fp(t, e, n, a, r) {
    for (var c = e._reactName, d = []; n !== null && n !== a; ) {
      var v = n, w = v.alternate, E = v.stateNode;
      if (v = v.tag, w !== null && w === a) break;
      v !== 5 && v !== 26 && v !== 27 || E === null || (w = E, r ? (E = Pi(n, c), E != null && d.unshift(
        Dr(n, E, w)
      )) : r || (E = Pi(n, c), E != null && d.push(
        Dr(n, E, w)
      ))), n = n.return;
    }
    d.length !== 0 && t.push({ event: e, listeners: d });
  }
  var X0 = /\r\n?/g, Q0 = /\u0000|\uFFFD/g;
  function dp(t) {
    return (typeof t == "string" ? t : "" + t).replace(X0, `
`).replace(Q0, "");
  }
  function hp(t, e) {
    return e = dp(e), dp(t) === e;
  }
  function Vt(t, e, n, a, r, c) {
    switch (n) {
      case "children":
        typeof a == "string" ? e === "body" || e === "textarea" && a === "" || I(t, a) : (typeof a == "number" || typeof a == "bigint") && e !== "body" && I(t, "" + a);
        break;
      case "className":
        Ke(t, "class", a);
        break;
      case "tabIndex":
        Ke(t, "tabindex", a);
        break;
      case "dir":
      case "role":
      case "viewBox":
      case "width":
      case "height":
        Ke(t, n, a);
        break;
      case "style":
        me(t, a, c);
        break;
      case "data":
        if (e !== "object") {
          Ke(t, "data", a);
          break;
        }
      case "src":
      case "href":
        if (a === "" && (e !== "a" || n !== "href")) {
          t.removeAttribute(n);
          break;
        }
        if (a == null || typeof a == "function" || typeof a == "symbol" || typeof a == "boolean") {
          t.removeAttribute(n);
          break;
        }
        a = ja("" + a), t.setAttribute(n, a);
        break;
      case "action":
      case "formAction":
        if (typeof a == "function") {
          t.setAttribute(
            n,
            "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')"
          );
          break;
        } else
          typeof c == "function" && (n === "formAction" ? (e !== "input" && Vt(t, e, "name", r.name, r, null), Vt(
            t,
            e,
            "formEncType",
            r.formEncType,
            r,
            null
          ), Vt(
            t,
            e,
            "formMethod",
            r.formMethod,
            r,
            null
          ), Vt(
            t,
            e,
            "formTarget",
            r.formTarget,
            r,
            null
          )) : (Vt(t, e, "encType", r.encType, r, null), Vt(t, e, "method", r.method, r, null), Vt(t, e, "target", r.target, r, null)));
        if (a == null || typeof a == "symbol" || typeof a == "boolean") {
          t.removeAttribute(n);
          break;
        }
        a = ja("" + a), t.setAttribute(n, a);
        break;
      case "onClick":
        a != null && (t.onclick = Ft);
        break;
      case "onScroll":
        a != null && Tt("scroll", t);
        break;
      case "onScrollEnd":
        a != null && Tt("scrollend", t);
        break;
      case "dangerouslySetInnerHTML":
        if (a != null) {
          if (typeof a != "object" || !("__html" in a))
            throw Error(o(61));
          if (n = a.__html, n != null) {
            if (r.children != null) throw Error(o(60));
            t.innerHTML = n;
          }
        }
        break;
      case "multiple":
        t.multiple = a && typeof a != "function" && typeof a != "symbol";
        break;
      case "muted":
        t.muted = a && typeof a != "function" && typeof a != "symbol";
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "ref":
        break;
      case "autoFocus":
        break;
      case "xlinkHref":
        if (a == null || typeof a == "function" || typeof a == "boolean" || typeof a == "symbol") {
          t.removeAttribute("xlink:href");
          break;
        }
        n = ja("" + a), t.setAttributeNS(
          "http://www.w3.org/1999/xlink",
          "xlink:href",
          n
        );
        break;
      case "contentEditable":
      case "spellCheck":
      case "draggable":
      case "value":
      case "autoReverse":
      case "externalResourcesRequired":
      case "focusable":
      case "preserveAlpha":
        a != null && typeof a != "function" && typeof a != "symbol" ? t.setAttribute(n, "" + a) : t.removeAttribute(n);
        break;
      case "inert":
      case "allowFullScreen":
      case "async":
      case "autoPlay":
      case "controls":
      case "default":
      case "defer":
      case "disabled":
      case "disablePictureInPicture":
      case "disableRemotePlayback":
      case "formNoValidate":
      case "hidden":
      case "loop":
      case "noModule":
      case "noValidate":
      case "open":
      case "playsInline":
      case "readOnly":
      case "required":
      case "reversed":
      case "scoped":
      case "seamless":
      case "itemScope":
        a && typeof a != "function" && typeof a != "symbol" ? t.setAttribute(n, "") : t.removeAttribute(n);
        break;
      case "capture":
      case "download":
        a === !0 ? t.setAttribute(n, "") : a !== !1 && a != null && typeof a != "function" && typeof a != "symbol" ? t.setAttribute(n, a) : t.removeAttribute(n);
        break;
      case "cols":
      case "rows":
      case "size":
      case "span":
        a != null && typeof a != "function" && typeof a != "symbol" && !isNaN(a) && 1 <= a ? t.setAttribute(n, a) : t.removeAttribute(n);
        break;
      case "rowSpan":
      case "start":
        a == null || typeof a == "function" || typeof a == "symbol" || isNaN(a) ? t.removeAttribute(n) : t.setAttribute(n, a);
        break;
      case "popover":
        Tt("beforetoggle", t), Tt("toggle", t), Bn(t, "popover", a);
        break;
      case "xlinkActuate":
        An(
          t,
          "http://www.w3.org/1999/xlink",
          "xlink:actuate",
          a
        );
        break;
      case "xlinkArcrole":
        An(
          t,
          "http://www.w3.org/1999/xlink",
          "xlink:arcrole",
          a
        );
        break;
      case "xlinkRole":
        An(
          t,
          "http://www.w3.org/1999/xlink",
          "xlink:role",
          a
        );
        break;
      case "xlinkShow":
        An(
          t,
          "http://www.w3.org/1999/xlink",
          "xlink:show",
          a
        );
        break;
      case "xlinkTitle":
        An(
          t,
          "http://www.w3.org/1999/xlink",
          "xlink:title",
          a
        );
        break;
      case "xlinkType":
        An(
          t,
          "http://www.w3.org/1999/xlink",
          "xlink:type",
          a
        );
        break;
      case "xmlBase":
        An(
          t,
          "http://www.w3.org/XML/1998/namespace",
          "xml:base",
          a
        );
        break;
      case "xmlLang":
        An(
          t,
          "http://www.w3.org/XML/1998/namespace",
          "xml:lang",
          a
        );
        break;
      case "xmlSpace":
        An(
          t,
          "http://www.w3.org/XML/1998/namespace",
          "xml:space",
          a
        );
        break;
      case "is":
        Bn(t, "is", a);
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        (!(2 < n.length) || n[0] !== "o" && n[0] !== "O" || n[1] !== "n" && n[1] !== "N") && (n = Je.get(n) || n, Bn(t, n, a));
    }
  }
  function Go(t, e, n, a, r, c) {
    switch (n) {
      case "style":
        me(t, a, c);
        break;
      case "dangerouslySetInnerHTML":
        if (a != null) {
          if (typeof a != "object" || !("__html" in a))
            throw Error(o(61));
          if (n = a.__html, n != null) {
            if (r.children != null) throw Error(o(60));
            t.innerHTML = n;
          }
        }
        break;
      case "children":
        typeof a == "string" ? I(t, a) : (typeof a == "number" || typeof a == "bigint") && I(t, "" + a);
        break;
      case "onScroll":
        a != null && Tt("scroll", t);
        break;
      case "onScrollEnd":
        a != null && Tt("scrollend", t);
        break;
      case "onClick":
        a != null && (t.onclick = Ft);
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "innerHTML":
      case "ref":
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        if (!ru.hasOwnProperty(n))
          t: {
            if (n[0] === "o" && n[1] === "n" && (r = n.endsWith("Capture"), e = n.slice(2, r ? n.length - 7 : void 0), c = t[he] || null, c = c != null ? c[n] : null, typeof c == "function" && t.removeEventListener(e, c, r), typeof a == "function")) {
              typeof c != "function" && c !== null && (n in t ? t[n] = null : t.hasAttribute(n) && t.removeAttribute(n)), t.addEventListener(e, a, r);
              break t;
            }
            n in t ? t[n] = a : a === !0 ? t.setAttribute(n, "") : Bn(t, n, a);
          }
    }
  }
  function ke(t, e, n) {
    switch (e) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "img":
        Tt("error", t), Tt("load", t);
        var a = !1, r = !1, c;
        for (c in n)
          if (n.hasOwnProperty(c)) {
            var d = n[c];
            if (d != null)
              switch (c) {
                case "src":
                  a = !0;
                  break;
                case "srcSet":
                  r = !0;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(o(137, e));
                default:
                  Vt(t, e, c, d, n, null);
              }
          }
        r && Vt(t, e, "srcSet", n.srcSet, n, null), a && Vt(t, e, "src", n.src, n, null);
        return;
      case "input":
        Tt("invalid", t);
        var v = c = d = r = null, w = null, E = null;
        for (a in n)
          if (n.hasOwnProperty(a)) {
            var M = n[a];
            if (M != null)
              switch (a) {
                case "name":
                  r = M;
                  break;
                case "type":
                  d = M;
                  break;
                case "checked":
                  w = M;
                  break;
                case "defaultChecked":
                  E = M;
                  break;
                case "value":
                  c = M;
                  break;
                case "defaultValue":
                  v = M;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  if (M != null)
                    throw Error(o(137, e));
                  break;
                default:
                  Vt(t, e, a, M, n, null);
              }
          }
        ti(
          t,
          c,
          v,
          w,
          E,
          d,
          r,
          !1
        );
        return;
      case "select":
        Tt("invalid", t), a = d = c = null;
        for (r in n)
          if (n.hasOwnProperty(r) && (v = n[r], v != null))
            switch (r) {
              case "value":
                c = v;
                break;
              case "defaultValue":
                d = v;
                break;
              case "multiple":
                a = v;
              default:
                Vt(t, e, r, v, n, null);
            }
        e = c, n = d, t.multiple = !!a, e != null ? S(t, !!a, e, !1) : n != null && S(t, !!a, n, !0);
        return;
      case "textarea":
        Tt("invalid", t), c = r = a = null;
        for (d in n)
          if (n.hasOwnProperty(d) && (v = n[d], v != null))
            switch (d) {
              case "value":
                a = v;
                break;
              case "defaultValue":
                r = v;
                break;
              case "children":
                c = v;
                break;
              case "dangerouslySetInnerHTML":
                if (v != null) throw Error(o(91));
                break;
              default:
                Vt(t, e, d, v, n, null);
            }
        K(t, a, r, c);
        return;
      case "option":
        for (w in n)
          if (n.hasOwnProperty(w) && (a = n[w], a != null))
            switch (w) {
              case "selected":
                t.selected = a && typeof a != "function" && typeof a != "symbol";
                break;
              default:
                Vt(t, e, w, a, n, null);
            }
        return;
      case "dialog":
        Tt("beforetoggle", t), Tt("toggle", t), Tt("cancel", t), Tt("close", t);
        break;
      case "iframe":
      case "object":
        Tt("load", t);
        break;
      case "video":
      case "audio":
        for (a = 0; a < Cr.length; a++)
          Tt(Cr[a], t);
        break;
      case "image":
        Tt("error", t), Tt("load", t);
        break;
      case "details":
        Tt("toggle", t);
        break;
      case "embed":
      case "source":
      case "link":
        Tt("error", t), Tt("load", t);
      case "area":
      case "base":
      case "br":
      case "col":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "track":
      case "wbr":
      case "menuitem":
        for (E in n)
          if (n.hasOwnProperty(E) && (a = n[E], a != null))
            switch (E) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(o(137, e));
              default:
                Vt(t, e, E, a, n, null);
            }
        return;
      default:
        if (ae(e)) {
          for (M in n)
            n.hasOwnProperty(M) && (a = n[M], a !== void 0 && Go(
              t,
              e,
              M,
              a,
              n,
              void 0
            ));
          return;
        }
    }
    for (v in n)
      n.hasOwnProperty(v) && (a = n[v], a != null && Vt(t, e, v, a, n, null));
  }
  function Z0(t, e, n, a) {
    switch (e) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "input":
        var r = null, c = null, d = null, v = null, w = null, E = null, M = null;
        for (z in n) {
          var H = n[z];
          if (n.hasOwnProperty(z) && H != null)
            switch (z) {
              case "checked":
                break;
              case "value":
                break;
              case "defaultValue":
                w = H;
              default:
                a.hasOwnProperty(z) || Vt(t, e, z, null, a, H);
            }
        }
        for (var C in a) {
          var z = a[C];
          if (H = n[C], a.hasOwnProperty(C) && (z != null || H != null))
            switch (C) {
              case "type":
                c = z;
                break;
              case "name":
                r = z;
                break;
              case "checked":
                E = z;
                break;
              case "defaultChecked":
                M = z;
                break;
              case "value":
                d = z;
                break;
              case "defaultValue":
                v = z;
                break;
              case "children":
              case "dangerouslySetInnerHTML":
                if (z != null)
                  throw Error(o(137, e));
                break;
              default:
                z !== H && Vt(
                  t,
                  e,
                  C,
                  z,
                  a,
                  H
                );
            }
        }
        Ea(
          t,
          d,
          v,
          w,
          E,
          M,
          c,
          r
        );
        return;
      case "select":
        z = d = v = C = null;
        for (c in n)
          if (w = n[c], n.hasOwnProperty(c) && w != null)
            switch (c) {
              case "value":
                break;
              case "multiple":
                z = w;
              default:
                a.hasOwnProperty(c) || Vt(
                  t,
                  e,
                  c,
                  null,
                  a,
                  w
                );
            }
        for (r in a)
          if (c = a[r], w = n[r], a.hasOwnProperty(r) && (c != null || w != null))
            switch (r) {
              case "value":
                C = c;
                break;
              case "defaultValue":
                v = c;
                break;
              case "multiple":
                d = c;
              default:
                c !== w && Vt(
                  t,
                  e,
                  r,
                  c,
                  a,
                  w
                );
            }
        e = v, n = d, a = z, C != null ? S(t, !!n, C, !1) : !!a != !!n && (e != null ? S(t, !!n, e, !0) : S(t, !!n, n ? [] : "", !1));
        return;
      case "textarea":
        z = C = null;
        for (v in n)
          if (r = n[v], n.hasOwnProperty(v) && r != null && !a.hasOwnProperty(v))
            switch (v) {
              case "value":
                break;
              case "children":
                break;
              default:
                Vt(t, e, v, null, a, r);
            }
        for (d in a)
          if (r = a[d], c = n[d], a.hasOwnProperty(d) && (r != null || c != null))
            switch (d) {
              case "value":
                C = r;
                break;
              case "defaultValue":
                z = r;
                break;
              case "children":
                break;
              case "dangerouslySetInnerHTML":
                if (r != null) throw Error(o(91));
                break;
              default:
                r !== c && Vt(t, e, d, r, a, c);
            }
        j(t, C, z);
        return;
      case "option":
        for (var P in n)
          if (C = n[P], n.hasOwnProperty(P) && C != null && !a.hasOwnProperty(P))
            switch (P) {
              case "selected":
                t.selected = !1;
                break;
              default:
                Vt(
                  t,
                  e,
                  P,
                  null,
                  a,
                  C
                );
            }
        for (w in a)
          if (C = a[w], z = n[w], a.hasOwnProperty(w) && C !== z && (C != null || z != null))
            switch (w) {
              case "selected":
                t.selected = C && typeof C != "function" && typeof C != "symbol";
                break;
              default:
                Vt(
                  t,
                  e,
                  w,
                  C,
                  a,
                  z
                );
            }
        return;
      case "img":
      case "link":
      case "area":
      case "base":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "source":
      case "track":
      case "wbr":
      case "menuitem":
        for (var rt in n)
          C = n[rt], n.hasOwnProperty(rt) && C != null && !a.hasOwnProperty(rt) && Vt(t, e, rt, null, a, C);
        for (E in a)
          if (C = a[E], z = n[E], a.hasOwnProperty(E) && C !== z && (C != null || z != null))
            switch (E) {
              case "children":
              case "dangerouslySetInnerHTML":
                if (C != null)
                  throw Error(o(137, e));
                break;
              default:
                Vt(
                  t,
                  e,
                  E,
                  C,
                  a,
                  z
                );
            }
        return;
      default:
        if (ae(e)) {
          for (var Yt in n)
            C = n[Yt], n.hasOwnProperty(Yt) && C !== void 0 && !a.hasOwnProperty(Yt) && Go(
              t,
              e,
              Yt,
              void 0,
              a,
              C
            );
          for (M in a)
            C = a[M], z = n[M], !a.hasOwnProperty(M) || C === z || C === void 0 && z === void 0 || Go(
              t,
              e,
              M,
              C,
              a,
              z
            );
          return;
        }
    }
    for (var O in n)
      C = n[O], n.hasOwnProperty(O) && C != null && !a.hasOwnProperty(O) && Vt(t, e, O, null, a, C);
    for (H in a)
      C = a[H], z = n[H], !a.hasOwnProperty(H) || C === z || C == null && z == null || Vt(t, e, H, C, a, z);
  }
  function mp(t) {
    switch (t) {
      case "css":
      case "script":
      case "font":
      case "img":
      case "image":
      case "input":
      case "link":
        return !0;
      default:
        return !1;
    }
  }
  function K0() {
    if (typeof performance.getEntriesByType == "function") {
      for (var t = 0, e = 0, n = performance.getEntriesByType("resource"), a = 0; a < n.length; a++) {
        var r = n[a], c = r.transferSize, d = r.initiatorType, v = r.duration;
        if (c && v && mp(d)) {
          for (d = 0, v = r.responseEnd, a += 1; a < n.length; a++) {
            var w = n[a], E = w.startTime;
            if (E > v) break;
            var M = w.transferSize, H = w.initiatorType;
            M && mp(H) && (w = w.responseEnd, d += M * (w < v ? 1 : (v - E) / (w - E)));
          }
          if (--a, e += 8 * (c + d) / (r.duration / 1e3), t++, 10 < t) break;
        }
      }
      if (0 < t) return e / t / 1e6;
    }
    return navigator.connection && (t = navigator.connection.downlink, typeof t == "number") ? t : 5;
  }
  var Xo = null, Qo = null;
  function nc(t) {
    return t.nodeType === 9 ? t : t.ownerDocument;
  }
  function pp(t) {
    switch (t) {
      case "http://www.w3.org/2000/svg":
        return 1;
      case "http://www.w3.org/1998/Math/MathML":
        return 2;
      default:
        return 0;
    }
  }
  function gp(t, e) {
    if (t === 0)
      switch (e) {
        case "svg":
          return 1;
        case "math":
          return 2;
        default:
          return 0;
      }
    return t === 1 && e === "foreignObject" ? 0 : t;
  }
  function Zo(t, e) {
    return t === "textarea" || t === "noscript" || typeof e.children == "string" || typeof e.children == "number" || typeof e.children == "bigint" || typeof e.dangerouslySetInnerHTML == "object" && e.dangerouslySetInnerHTML !== null && e.dangerouslySetInnerHTML.__html != null;
  }
  var Ko = null;
  function $0() {
    var t = window.event;
    return t && t.type === "popstate" ? t === Ko ? !1 : (Ko = t, !0) : (Ko = null, !1);
  }
  var yp = typeof setTimeout == "function" ? setTimeout : void 0, J0 = typeof clearTimeout == "function" ? clearTimeout : void 0, vp = typeof Promise == "function" ? Promise : void 0, W0 = typeof queueMicrotask == "function" ? queueMicrotask : typeof vp < "u" ? function(t) {
    return vp.resolve(null).then(t).catch(F0);
  } : yp;
  function F0(t) {
    setTimeout(function() {
      throw t;
    });
  }
  function Ka(t) {
    return t === "head";
  }
  function bp(t, e) {
    var n = e, a = 0;
    do {
      var r = n.nextSibling;
      if (t.removeChild(n), r && r.nodeType === 8)
        if (n = r.data, n === "/$" || n === "/&") {
          if (a === 0) {
            t.removeChild(r), Ci(e);
            return;
          }
          a--;
        } else if (n === "$" || n === "$?" || n === "$~" || n === "$!" || n === "&")
          a++;
        else if (n === "html")
          zr(t.ownerDocument.documentElement);
        else if (n === "head") {
          n = t.ownerDocument.head, zr(n);
          for (var c = n.firstChild; c; ) {
            var d = c.nextSibling, v = c.nodeName;
            c[dl] || v === "SCRIPT" || v === "STYLE" || v === "LINK" && c.rel.toLowerCase() === "stylesheet" || n.removeChild(c), c = d;
          }
        } else
          n === "body" && zr(t.ownerDocument.body);
      n = r;
    } while (n);
    Ci(e);
  }
  function Sp(t, e) {
    var n = t;
    t = 0;
    do {
      var a = n.nextSibling;
      if (n.nodeType === 1 ? e ? (n._stashedDisplay = n.style.display, n.style.display = "none") : (n.style.display = n._stashedDisplay || "", n.getAttribute("style") === "" && n.removeAttribute("style")) : n.nodeType === 3 && (e ? (n._stashedText = n.nodeValue, n.nodeValue = "") : n.nodeValue = n._stashedText || ""), a && a.nodeType === 8)
        if (n = a.data, n === "/$") {
          if (t === 0) break;
          t--;
        } else
          n !== "$" && n !== "$?" && n !== "$~" && n !== "$!" || t++;
      n = a;
    } while (n);
  }
  function $o(t) {
    var e = t.firstChild;
    for (e && e.nodeType === 10 && (e = e.nextSibling); e; ) {
      var n = e;
      switch (e = e.nextSibling, n.nodeName) {
        case "HTML":
        case "HEAD":
        case "BODY":
          $o(n), Ji(n);
          continue;
        case "SCRIPT":
        case "STYLE":
          continue;
        case "LINK":
          if (n.rel.toLowerCase() === "stylesheet") continue;
      }
      t.removeChild(n);
    }
  }
  function I0(t, e, n, a) {
    for (; t.nodeType === 1; ) {
      var r = n;
      if (t.nodeName.toLowerCase() !== e.toLowerCase()) {
        if (!a && (t.nodeName !== "INPUT" || t.type !== "hidden"))
          break;
      } else if (a) {
        if (!t[dl])
          switch (e) {
            case "meta":
              if (!t.hasAttribute("itemprop")) break;
              return t;
            case "link":
              if (c = t.getAttribute("rel"), c === "stylesheet" && t.hasAttribute("data-precedence"))
                break;
              if (c !== r.rel || t.getAttribute("href") !== (r.href == null || r.href === "" ? null : r.href) || t.getAttribute("crossorigin") !== (r.crossOrigin == null ? null : r.crossOrigin) || t.getAttribute("title") !== (r.title == null ? null : r.title))
                break;
              return t;
            case "style":
              if (t.hasAttribute("data-precedence")) break;
              return t;
            case "script":
              if (c = t.getAttribute("src"), (c !== (r.src == null ? null : r.src) || t.getAttribute("type") !== (r.type == null ? null : r.type) || t.getAttribute("crossorigin") !== (r.crossOrigin == null ? null : r.crossOrigin)) && c && t.hasAttribute("async") && !t.hasAttribute("itemprop"))
                break;
              return t;
            default:
              return t;
          }
      } else if (e === "input" && t.type === "hidden") {
        var c = r.name == null ? null : "" + r.name;
        if (r.type === "hidden" && t.getAttribute("name") === c)
          return t;
      } else return t;
      if (t = Tn(t.nextSibling), t === null) break;
    }
    return null;
  }
  function P0(t, e, n) {
    if (e === "") return null;
    for (; t.nodeType !== 3; )
      if ((t.nodeType !== 1 || t.nodeName !== "INPUT" || t.type !== "hidden") && !n || (t = Tn(t.nextSibling), t === null)) return null;
    return t;
  }
  function Tp(t, e) {
    for (; t.nodeType !== 8; )
      if ((t.nodeType !== 1 || t.nodeName !== "INPUT" || t.type !== "hidden") && !e || (t = Tn(t.nextSibling), t === null)) return null;
    return t;
  }
  function Jo(t) {
    return t.data === "$?" || t.data === "$~";
  }
  function Wo(t) {
    return t.data === "$!" || t.data === "$?" && t.ownerDocument.readyState !== "loading";
  }
  function tb(t, e) {
    var n = t.ownerDocument;
    if (t.data === "$~") t._reactRetry = e;
    else if (t.data !== "$?" || n.readyState !== "loading")
      e();
    else {
      var a = function() {
        e(), n.removeEventListener("DOMContentLoaded", a);
      };
      n.addEventListener("DOMContentLoaded", a), t._reactRetry = a;
    }
  }
  function Tn(t) {
    for (; t != null; t = t.nextSibling) {
      var e = t.nodeType;
      if (e === 1 || e === 3) break;
      if (e === 8) {
        if (e = t.data, e === "$" || e === "$!" || e === "$?" || e === "$~" || e === "&" || e === "F!" || e === "F")
          break;
        if (e === "/$" || e === "/&") return null;
      }
    }
    return t;
  }
  var Fo = null;
  function wp(t) {
    t = t.nextSibling;
    for (var e = 0; t; ) {
      if (t.nodeType === 8) {
        var n = t.data;
        if (n === "/$" || n === "/&") {
          if (e === 0)
            return Tn(t.nextSibling);
          e--;
        } else
          n !== "$" && n !== "$!" && n !== "$?" && n !== "$~" && n !== "&" || e++;
      }
      t = t.nextSibling;
    }
    return null;
  }
  function xp(t) {
    t = t.previousSibling;
    for (var e = 0; t; ) {
      if (t.nodeType === 8) {
        var n = t.data;
        if (n === "$" || n === "$!" || n === "$?" || n === "$~" || n === "&") {
          if (e === 0) return t;
          e--;
        } else n !== "/$" && n !== "/&" || e++;
      }
      t = t.previousSibling;
    }
    return null;
  }
  function Ap(t, e, n) {
    switch (e = nc(n), t) {
      case "html":
        if (t = e.documentElement, !t) throw Error(o(452));
        return t;
      case "head":
        if (t = e.head, !t) throw Error(o(453));
        return t;
      case "body":
        if (t = e.body, !t) throw Error(o(454));
        return t;
      default:
        throw Error(o(451));
    }
  }
  function zr(t) {
    for (var e = t.attributes; e.length; )
      t.removeAttributeNode(e[0]);
    Ji(t);
  }
  var wn = /* @__PURE__ */ new Map(), _p = /* @__PURE__ */ new Set();
  function ac(t) {
    return typeof t.getRootNode == "function" ? t.getRootNode() : t.nodeType === 9 ? t : t.ownerDocument;
  }
  var ma = $.d;
  $.d = {
    f: eb,
    r: nb,
    D: ab,
    C: lb,
    L: ib,
    m: rb,
    X: cb,
    S: ub,
    M: sb
  };
  function eb() {
    var t = ma.f(), e = $u();
    return t || e;
  }
  function nb(t) {
    var e = Oa(t);
    e !== null && e.tag === 5 && e.type === "form" ? Yh(e) : ma.r(t);
  }
  var Ei = typeof document > "u" ? null : document;
  function Op(t, e, n) {
    var a = Ei;
    if (a && typeof e == "string" && e) {
      var r = Ve(e);
      r = 'link[rel="' + t + '"][href="' + r + '"]', typeof n == "string" && (r += '[crossorigin="' + n + '"]'), _p.has(r) || (_p.add(r), t = { rel: t, crossOrigin: n, href: e }, a.querySelector(r) === null && (e = a.createElement("link"), ke(e, "link", t), Wt(e), a.head.appendChild(e)));
    }
  }
  function ab(t) {
    ma.D(t), Op("dns-prefetch", t, null);
  }
  function lb(t, e) {
    ma.C(t, e), Op("preconnect", t, e);
  }
  function ib(t, e, n) {
    ma.L(t, e, n);
    var a = Ei;
    if (a && t && e) {
      var r = 'link[rel="preload"][as="' + Ve(e) + '"]';
      e === "image" && n && n.imageSrcSet ? (r += '[imagesrcset="' + Ve(
        n.imageSrcSet
      ) + '"]', typeof n.imageSizes == "string" && (r += '[imagesizes="' + Ve(
        n.imageSizes
      ) + '"]')) : r += '[href="' + Ve(t) + '"]';
      var c = r;
      switch (e) {
        case "style":
          c = ji(t);
          break;
        case "script":
          c = Ri(t);
      }
      wn.has(c) || (t = x(
        {
          rel: "preload",
          href: e === "image" && n && n.imageSrcSet ? void 0 : t,
          as: e
        },
        n
      ), wn.set(c, t), a.querySelector(r) !== null || e === "style" && a.querySelector(Mr(c)) || e === "script" && a.querySelector(kr(c)) || (e = a.createElement("link"), ke(e, "link", t), Wt(e), a.head.appendChild(e)));
    }
  }
  function rb(t, e) {
    ma.m(t, e);
    var n = Ei;
    if (n && t) {
      var a = e && typeof e.as == "string" ? e.as : "script", r = 'link[rel="modulepreload"][as="' + Ve(a) + '"][href="' + Ve(t) + '"]', c = r;
      switch (a) {
        case "audioworklet":
        case "paintworklet":
        case "serviceworker":
        case "sharedworker":
        case "worker":
        case "script":
          c = Ri(t);
      }
      if (!wn.has(c) && (t = x({ rel: "modulepreload", href: t }, e), wn.set(c, t), n.querySelector(r) === null)) {
        switch (a) {
          case "audioworklet":
          case "paintworklet":
          case "serviceworker":
          case "sharedworker":
          case "worker":
          case "script":
            if (n.querySelector(kr(c)))
              return;
        }
        a = n.createElement("link"), ke(a, "link", t), Wt(a), n.head.appendChild(a);
      }
    }
  }
  function ub(t, e, n) {
    ma.S(t, e, n);
    var a = Ei;
    if (a && t) {
      var r = Fn(a).hoistableStyles, c = ji(t);
      e = e || "default";
      var d = r.get(c);
      if (!d) {
        var v = { loading: 0, preload: null };
        if (d = a.querySelector(
          Mr(c)
        ))
          v.loading = 5;
        else {
          t = x(
            { rel: "stylesheet", href: t, "data-precedence": e },
            n
          ), (n = wn.get(c)) && Io(t, n);
          var w = d = a.createElement("link");
          Wt(w), ke(w, "link", t), w._p = new Promise(function(E, M) {
            w.onload = E, w.onerror = M;
          }), w.addEventListener("load", function() {
            v.loading |= 1;
          }), w.addEventListener("error", function() {
            v.loading |= 2;
          }), v.loading |= 4, lc(d, e, a);
        }
        d = {
          type: "stylesheet",
          instance: d,
          count: 1,
          state: v
        }, r.set(c, d);
      }
    }
  }
  function cb(t, e) {
    ma.X(t, e);
    var n = Ei;
    if (n && t) {
      var a = Fn(n).hoistableScripts, r = Ri(t), c = a.get(r);
      c || (c = n.querySelector(kr(r)), c || (t = x({ src: t, async: !0 }, e), (e = wn.get(r)) && Po(t, e), c = n.createElement("script"), Wt(c), ke(c, "link", t), n.head.appendChild(c)), c = {
        type: "script",
        instance: c,
        count: 1,
        state: null
      }, a.set(r, c));
    }
  }
  function sb(t, e) {
    ma.M(t, e);
    var n = Ei;
    if (n && t) {
      var a = Fn(n).hoistableScripts, r = Ri(t), c = a.get(r);
      c || (c = n.querySelector(kr(r)), c || (t = x({ src: t, async: !0, type: "module" }, e), (e = wn.get(r)) && Po(t, e), c = n.createElement("script"), Wt(c), ke(c, "link", t), n.head.appendChild(c)), c = {
        type: "script",
        instance: c,
        count: 1,
        state: null
      }, a.set(r, c));
    }
  }
  function Np(t, e, n, a) {
    var r = (r = fe.current) ? ac(r) : null;
    if (!r) throw Error(o(446));
    switch (t) {
      case "meta":
      case "title":
        return null;
      case "style":
        return typeof n.precedence == "string" && typeof n.href == "string" ? (e = ji(n.href), n = Fn(
          r
        ).hoistableStyles, a = n.get(e), a || (a = {
          type: "style",
          instance: null,
          count: 0,
          state: null
        }, n.set(e, a)), a) : { type: "void", instance: null, count: 0, state: null };
      case "link":
        if (n.rel === "stylesheet" && typeof n.href == "string" && typeof n.precedence == "string") {
          t = ji(n.href);
          var c = Fn(
            r
          ).hoistableStyles, d = c.get(t);
          if (d || (r = r.ownerDocument || r, d = {
            type: "stylesheet",
            instance: null,
            count: 0,
            state: { loading: 0, preload: null }
          }, c.set(t, d), (c = r.querySelector(
            Mr(t)
          )) && !c._p && (d.instance = c, d.state.loading = 5), wn.has(t) || (n = {
            rel: "preload",
            as: "style",
            href: n.href,
            crossOrigin: n.crossOrigin,
            integrity: n.integrity,
            media: n.media,
            hrefLang: n.hrefLang,
            referrerPolicy: n.referrerPolicy
          }, wn.set(t, n), c || ob(
            r,
            t,
            n,
            d.state
          ))), e && a === null)
            throw Error(o(528, ""));
          return d;
        }
        if (e && a !== null)
          throw Error(o(529, ""));
        return null;
      case "script":
        return e = n.async, n = n.src, typeof n == "string" && e && typeof e != "function" && typeof e != "symbol" ? (e = Ri(n), n = Fn(
          r
        ).hoistableScripts, a = n.get(e), a || (a = {
          type: "script",
          instance: null,
          count: 0,
          state: null
        }, n.set(e, a)), a) : { type: "void", instance: null, count: 0, state: null };
      default:
        throw Error(o(444, t));
    }
  }
  function ji(t) {
    return 'href="' + Ve(t) + '"';
  }
  function Mr(t) {
    return 'link[rel="stylesheet"][' + t + "]";
  }
  function Ep(t) {
    return x({}, t, {
      "data-precedence": t.precedence,
      precedence: null
    });
  }
  function ob(t, e, n, a) {
    t.querySelector('link[rel="preload"][as="style"][' + e + "]") ? a.loading = 1 : (e = t.createElement("link"), a.preload = e, e.addEventListener("load", function() {
      return a.loading |= 1;
    }), e.addEventListener("error", function() {
      return a.loading |= 2;
    }), ke(e, "link", n), Wt(e), t.head.appendChild(e));
  }
  function Ri(t) {
    return '[src="' + Ve(t) + '"]';
  }
  function kr(t) {
    return "script[async]" + t;
  }
  function jp(t, e, n) {
    if (e.count++, e.instance === null)
      switch (e.type) {
        case "style":
          var a = t.querySelector(
            'style[data-href~="' + Ve(n.href) + '"]'
          );
          if (a)
            return e.instance = a, Wt(a), a;
          var r = x({}, n, {
            "data-href": n.href,
            "data-precedence": n.precedence,
            href: null,
            precedence: null
          });
          return a = (t.ownerDocument || t).createElement(
            "style"
          ), Wt(a), ke(a, "style", r), lc(a, n.precedence, t), e.instance = a;
        case "stylesheet":
          r = ji(n.href);
          var c = t.querySelector(
            Mr(r)
          );
          if (c)
            return e.state.loading |= 4, e.instance = c, Wt(c), c;
          a = Ep(n), (r = wn.get(r)) && Io(a, r), c = (t.ownerDocument || t).createElement("link"), Wt(c);
          var d = c;
          return d._p = new Promise(function(v, w) {
            d.onload = v, d.onerror = w;
          }), ke(c, "link", a), e.state.loading |= 4, lc(c, n.precedence, t), e.instance = c;
        case "script":
          return c = Ri(n.src), (r = t.querySelector(
            kr(c)
          )) ? (e.instance = r, Wt(r), r) : (a = n, (r = wn.get(c)) && (a = x({}, n), Po(a, r)), t = t.ownerDocument || t, r = t.createElement("script"), Wt(r), ke(r, "link", a), t.head.appendChild(r), e.instance = r);
        case "void":
          return null;
        default:
          throw Error(o(443, e.type));
      }
    else
      e.type === "stylesheet" && (e.state.loading & 4) === 0 && (a = e.instance, e.state.loading |= 4, lc(a, n.precedence, t));
    return e.instance;
  }
  function lc(t, e, n) {
    for (var a = n.querySelectorAll(
      'link[rel="stylesheet"][data-precedence],style[data-precedence]'
    ), r = a.length ? a[a.length - 1] : null, c = r, d = 0; d < a.length; d++) {
      var v = a[d];
      if (v.dataset.precedence === e) c = v;
      else if (c !== r) break;
    }
    c ? c.parentNode.insertBefore(t, c.nextSibling) : (e = n.nodeType === 9 ? n.head : n, e.insertBefore(t, e.firstChild));
  }
  function Io(t, e) {
    t.crossOrigin == null && (t.crossOrigin = e.crossOrigin), t.referrerPolicy == null && (t.referrerPolicy = e.referrerPolicy), t.title == null && (t.title = e.title);
  }
  function Po(t, e) {
    t.crossOrigin == null && (t.crossOrigin = e.crossOrigin), t.referrerPolicy == null && (t.referrerPolicy = e.referrerPolicy), t.integrity == null && (t.integrity = e.integrity);
  }
  var ic = null;
  function Rp(t, e, n) {
    if (ic === null) {
      var a = /* @__PURE__ */ new Map(), r = ic = /* @__PURE__ */ new Map();
      r.set(n, a);
    } else
      r = ic, a = r.get(n), a || (a = /* @__PURE__ */ new Map(), r.set(n, a));
    if (a.has(t)) return a;
    for (a.set(t, null), n = n.getElementsByTagName(t), r = 0; r < n.length; r++) {
      var c = n[r];
      if (!(c[dl] || c[ht] || t === "link" && c.getAttribute("rel") === "stylesheet") && c.namespaceURI !== "http://www.w3.org/2000/svg") {
        var d = c.getAttribute(e) || "";
        d = t + d;
        var v = a.get(d);
        v ? v.push(c) : a.set(d, [c]);
      }
    }
    return a;
  }
  function Cp(t, e, n) {
    t = t.ownerDocument || t, t.head.insertBefore(
      n,
      e === "title" ? t.querySelector("head > title") : null
    );
  }
  function fb(t, e, n) {
    if (n === 1 || e.itemProp != null) return !1;
    switch (t) {
      case "meta":
      case "title":
        return !0;
      case "style":
        if (typeof e.precedence != "string" || typeof e.href != "string" || e.href === "")
          break;
        return !0;
      case "link":
        if (typeof e.rel != "string" || typeof e.href != "string" || e.href === "" || e.onLoad || e.onError)
          break;
        switch (e.rel) {
          case "stylesheet":
            return t = e.disabled, typeof e.precedence == "string" && t == null;
          default:
            return !0;
        }
      case "script":
        if (e.async && typeof e.async != "function" && typeof e.async != "symbol" && !e.onLoad && !e.onError && e.src && typeof e.src == "string")
          return !0;
    }
    return !1;
  }
  function Dp(t) {
    return !(t.type === "stylesheet" && (t.state.loading & 3) === 0);
  }
  function db(t, e, n, a) {
    if (n.type === "stylesheet" && (typeof a.media != "string" || matchMedia(a.media).matches !== !1) && (n.state.loading & 4) === 0) {
      if (n.instance === null) {
        var r = ji(a.href), c = e.querySelector(
          Mr(r)
        );
        if (c) {
          e = c._p, e !== null && typeof e == "object" && typeof e.then == "function" && (t.count++, t = rc.bind(t), e.then(t, t)), n.state.loading |= 4, n.instance = c, Wt(c);
          return;
        }
        c = e.ownerDocument || e, a = Ep(a), (r = wn.get(r)) && Io(a, r), c = c.createElement("link"), Wt(c);
        var d = c;
        d._p = new Promise(function(v, w) {
          d.onload = v, d.onerror = w;
        }), ke(c, "link", a), n.instance = c;
      }
      t.stylesheets === null && (t.stylesheets = /* @__PURE__ */ new Map()), t.stylesheets.set(n, e), (e = n.state.preload) && (n.state.loading & 3) === 0 && (t.count++, n = rc.bind(t), e.addEventListener("load", n), e.addEventListener("error", n));
    }
  }
  var tf = 0;
  function hb(t, e) {
    return t.stylesheets && t.count === 0 && cc(t, t.stylesheets), 0 < t.count || 0 < t.imgCount ? function(n) {
      var a = setTimeout(function() {
        if (t.stylesheets && cc(t, t.stylesheets), t.unsuspend) {
          var c = t.unsuspend;
          t.unsuspend = null, c();
        }
      }, 6e4 + e);
      0 < t.imgBytes && tf === 0 && (tf = 62500 * K0());
      var r = setTimeout(
        function() {
          if (t.waitingForImages = !1, t.count === 0 && (t.stylesheets && cc(t, t.stylesheets), t.unsuspend)) {
            var c = t.unsuspend;
            t.unsuspend = null, c();
          }
        },
        (t.imgBytes > tf ? 50 : 800) + e
      );
      return t.unsuspend = n, function() {
        t.unsuspend = null, clearTimeout(a), clearTimeout(r);
      };
    } : null;
  }
  function rc() {
    if (this.count--, this.count === 0 && (this.imgCount === 0 || !this.waitingForImages)) {
      if (this.stylesheets) cc(this, this.stylesheets);
      else if (this.unsuspend) {
        var t = this.unsuspend;
        this.unsuspend = null, t();
      }
    }
  }
  var uc = null;
  function cc(t, e) {
    t.stylesheets = null, t.unsuspend !== null && (t.count++, uc = /* @__PURE__ */ new Map(), e.forEach(mb, t), uc = null, rc.call(t));
  }
  function mb(t, e) {
    if (!(e.state.loading & 4)) {
      var n = uc.get(t);
      if (n) var a = n.get(null);
      else {
        n = /* @__PURE__ */ new Map(), uc.set(t, n);
        for (var r = t.querySelectorAll(
          "link[data-precedence],style[data-precedence]"
        ), c = 0; c < r.length; c++) {
          var d = r[c];
          (d.nodeName === "LINK" || d.getAttribute("media") !== "not all") && (n.set(d.dataset.precedence, d), a = d);
        }
        a && n.set(null, a);
      }
      r = e.instance, d = r.getAttribute("data-precedence"), c = n.get(d) || a, c === a && n.set(null, r), n.set(d, r), this.count++, a = rc.bind(this), r.addEventListener("load", a), r.addEventListener("error", a), c ? c.parentNode.insertBefore(r, c.nextSibling) : (t = t.nodeType === 9 ? t.head : t, t.insertBefore(r, t.firstChild)), e.state.loading |= 4;
    }
  }
  var Lr = {
    $$typeof: W,
    Provider: null,
    Consumer: null,
    _currentValue: J,
    _currentValue2: J,
    _threadCount: 0
  };
  function pb(t, e, n, a, r, c, d, v, w) {
    this.tag = 1, this.containerInfo = t, this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null, this.callbackPriority = 0, this.expirationTimes = ol(-1), this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = ol(0), this.hiddenUpdates = ol(null), this.identifierPrefix = a, this.onUncaughtError = r, this.onCaughtError = c, this.onRecoverableError = d, this.pooledCache = null, this.pooledCacheLanes = 0, this.formState = w, this.incompleteTransitions = /* @__PURE__ */ new Map();
  }
  function zp(t, e, n, a, r, c, d, v, w, E, M, H) {
    return t = new pb(
      t,
      e,
      n,
      d,
      w,
      E,
      M,
      H,
      v
    ), e = 1, c === !0 && (e |= 24), c = rn(3, null, null, e), t.current = c, c.stateNode = t, e = Ds(), e.refCount++, t.pooledCache = e, e.refCount++, c.memoizedState = {
      element: a,
      isDehydrated: n,
      cache: e
    }, Ls(c), t;
  }
  function Mp(t) {
    return t ? (t = ui, t) : ui;
  }
  function kp(t, e, n, a, r, c) {
    r = Mp(r), a.context === null ? a.context = r : a.pendingContext = r, a = La(e), a.payload = { element: n }, c = c === void 0 ? null : c, c !== null && (a.callback = c), n = Ba(t, a, e), n !== null && (en(n, t, e), mr(n, t, e));
  }
  function Lp(t, e) {
    if (t = t.memoizedState, t !== null && t.dehydrated !== null) {
      var n = t.retryLane;
      t.retryLane = n !== 0 && n < e ? n : e;
    }
  }
  function ef(t, e) {
    Lp(t, e), (t = t.alternate) && Lp(t, e);
  }
  function Bp(t) {
    if (t.tag === 13 || t.tag === 31) {
      var e = yl(t, 67108864);
      e !== null && en(e, t, 67108864), ef(t, 67108864);
    }
  }
  function Hp(t) {
    if (t.tag === 13 || t.tag === 31) {
      var e = fn();
      e = fl(e);
      var n = yl(t, e);
      n !== null && en(n, t, e), ef(t, e);
    }
  }
  var sc = !0;
  function gb(t, e, n, a) {
    var r = V.T;
    V.T = null;
    var c = $.p;
    try {
      $.p = 2, nf(t, e, n, a);
    } finally {
      $.p = c, V.T = r;
    }
  }
  function yb(t, e, n, a) {
    var r = V.T;
    V.T = null;
    var c = $.p;
    try {
      $.p = 8, nf(t, e, n, a);
    } finally {
      $.p = c, V.T = r;
    }
  }
  function nf(t, e, n, a) {
    if (sc) {
      var r = af(a);
      if (r === null)
        Yo(
          t,
          e,
          a,
          oc,
          n
        ), qp(t, a);
      else if (bb(
        r,
        t,
        e,
        n,
        a
      ))
        a.stopPropagation();
      else if (qp(t, a), e & 4 && -1 < vb.indexOf(t)) {
        for (; r !== null; ) {
          var c = Oa(r);
          if (c !== null)
            switch (c.tag) {
              case 3:
                if (c = c.stateNode, c.current.memoizedState.isDehydrated) {
                  var d = zn(c.pendingLanes);
                  if (d !== 0) {
                    var v = c;
                    for (v.pendingLanes |= 2, v.entangledLanes |= 2; d; ) {
                      var w = 1 << 31 - Ce(d);
                      v.entanglements[1] |= w, d &= ~w;
                    }
                    Vn(c), (Mt & 6) === 0 && (Zu = de() + 500, Rr(0));
                  }
                }
                break;
              case 31:
              case 13:
                v = yl(c, 2), v !== null && en(v, c, 2), $u(), ef(c, 2);
            }
          if (c = af(a), c === null && Yo(
            t,
            e,
            a,
            oc,
            n
          ), c === r) break;
          r = c;
        }
        r !== null && a.stopPropagation();
      } else
        Yo(
          t,
          e,
          a,
          null,
          n
        );
    }
  }
  function af(t) {
    return t = ls(t), lf(t);
  }
  var oc = null;
  function lf(t) {
    if (oc = null, t = _a(t), t !== null) {
      var e = m(t);
      if (e === null) t = null;
      else {
        var n = e.tag;
        if (n === 13) {
          if (t = g(e), t !== null) return t;
          t = null;
        } else if (n === 31) {
          if (t = y(e), t !== null) return t;
          t = null;
        } else if (n === 3) {
          if (e.stateNode.current.memoizedState.isDehydrated)
            return e.tag === 3 ? e.stateNode.containerInfo : null;
          t = null;
        } else e !== t && (t = null);
      }
    }
    return oc = t, null;
  }
  function Up(t) {
    switch (t) {
      case "beforetoggle":
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "toggle":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 2;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 8;
      case "message":
        switch (Yi()) {
          case Zl:
            return 2;
          case Kl:
            return 8;
          case va:
          case ba:
            return 32;
          case ul:
            return 268435456;
          default:
            return 32;
        }
      default:
        return 32;
    }
  }
  var rf = !1, $a = null, Ja = null, Wa = null, Br = /* @__PURE__ */ new Map(), Hr = /* @__PURE__ */ new Map(), Fa = [], vb = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(
    " "
  );
  function qp(t, e) {
    switch (t) {
      case "focusin":
      case "focusout":
        $a = null;
        break;
      case "dragenter":
      case "dragleave":
        Ja = null;
        break;
      case "mouseover":
      case "mouseout":
        Wa = null;
        break;
      case "pointerover":
      case "pointerout":
        Br.delete(e.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        Hr.delete(e.pointerId);
    }
  }
  function Ur(t, e, n, a, r, c) {
    return t === null || t.nativeEvent !== c ? (t = {
      blockedOn: e,
      domEventName: n,
      eventSystemFlags: a,
      nativeEvent: c,
      targetContainers: [r]
    }, e !== null && (e = Oa(e), e !== null && Bp(e)), t) : (t.eventSystemFlags |= a, e = t.targetContainers, r !== null && e.indexOf(r) === -1 && e.push(r), t);
  }
  function bb(t, e, n, a, r) {
    switch (e) {
      case "focusin":
        return $a = Ur(
          $a,
          t,
          e,
          n,
          a,
          r
        ), !0;
      case "dragenter":
        return Ja = Ur(
          Ja,
          t,
          e,
          n,
          a,
          r
        ), !0;
      case "mouseover":
        return Wa = Ur(
          Wa,
          t,
          e,
          n,
          a,
          r
        ), !0;
      case "pointerover":
        var c = r.pointerId;
        return Br.set(
          c,
          Ur(
            Br.get(c) || null,
            t,
            e,
            n,
            a,
            r
          )
        ), !0;
      case "gotpointercapture":
        return c = r.pointerId, Hr.set(
          c,
          Ur(
            Hr.get(c) || null,
            t,
            e,
            n,
            a,
            r
          )
        ), !0;
    }
    return !1;
  }
  function Vp(t) {
    var e = _a(t.target);
    if (e !== null) {
      var n = m(e);
      if (n !== null) {
        if (e = n.tag, e === 13) {
          if (e = g(n), e !== null) {
            t.blockedOn = e, au(t.priority, function() {
              Hp(n);
            });
            return;
          }
        } else if (e === 31) {
          if (e = y(n), e !== null) {
            t.blockedOn = e, au(t.priority, function() {
              Hp(n);
            });
            return;
          }
        } else if (e === 3 && n.stateNode.current.memoizedState.isDehydrated) {
          t.blockedOn = n.tag === 3 ? n.stateNode.containerInfo : null;
          return;
        }
      }
    }
    t.blockedOn = null;
  }
  function fc(t) {
    if (t.blockedOn !== null) return !1;
    for (var e = t.targetContainers; 0 < e.length; ) {
      var n = af(t.nativeEvent);
      if (n === null) {
        n = t.nativeEvent;
        var a = new n.constructor(
          n.type,
          n
        );
        as = a, n.target.dispatchEvent(a), as = null;
      } else
        return e = Oa(n), e !== null && Bp(e), t.blockedOn = n, !1;
      e.shift();
    }
    return !0;
  }
  function Yp(t, e, n) {
    fc(t) && n.delete(e);
  }
  function Sb() {
    rf = !1, $a !== null && fc($a) && ($a = null), Ja !== null && fc(Ja) && (Ja = null), Wa !== null && fc(Wa) && (Wa = null), Br.forEach(Yp), Hr.forEach(Yp);
  }
  function dc(t, e) {
    t.blockedOn === e && (t.blockedOn = null, rf || (rf = !0, i.unstable_scheduleCallback(
      i.unstable_NormalPriority,
      Sb
    )));
  }
  var hc = null;
  function Gp(t) {
    hc !== t && (hc = t, i.unstable_scheduleCallback(
      i.unstable_NormalPriority,
      function() {
        hc === t && (hc = null);
        for (var e = 0; e < t.length; e += 3) {
          var n = t[e], a = t[e + 1], r = t[e + 2];
          if (typeof a != "function") {
            if (lf(a || n) === null)
              continue;
            break;
          }
          var c = Oa(n);
          c !== null && (t.splice(e, 3), e -= 3, no(
            c,
            {
              pending: !0,
              data: r,
              method: n.method,
              action: a
            },
            a,
            r
          ));
        }
      }
    ));
  }
  function Ci(t) {
    function e(w) {
      return dc(w, t);
    }
    $a !== null && dc($a, t), Ja !== null && dc(Ja, t), Wa !== null && dc(Wa, t), Br.forEach(e), Hr.forEach(e);
    for (var n = 0; n < Fa.length; n++) {
      var a = Fa[n];
      a.blockedOn === t && (a.blockedOn = null);
    }
    for (; 0 < Fa.length && (n = Fa[0], n.blockedOn === null); )
      Vp(n), n.blockedOn === null && Fa.shift();
    if (n = (t.ownerDocument || t).$$reactFormReplay, n != null)
      for (a = 0; a < n.length; a += 3) {
        var r = n[a], c = n[a + 1], d = r[he] || null;
        if (typeof c == "function")
          d || Gp(n);
        else if (d) {
          var v = null;
          if (c && c.hasAttribute("formAction")) {
            if (r = c, d = c[he] || null)
              v = d.formAction;
            else if (lf(r) !== null) continue;
          } else v = d.action;
          typeof v == "function" ? n[a + 1] = v : (n.splice(a, 3), a -= 3), Gp(n);
        }
      }
  }
  function Xp() {
    function t(c) {
      c.canIntercept && c.info === "react-transition" && c.intercept({
        handler: function() {
          return new Promise(function(d) {
            return r = d;
          });
        },
        focusReset: "manual",
        scroll: "manual"
      });
    }
    function e() {
      r !== null && (r(), r = null), a || setTimeout(n, 20);
    }
    function n() {
      if (!a && !navigation.transition) {
        var c = navigation.currentEntry;
        c && c.url != null && navigation.navigate(c.url, {
          state: c.getState(),
          info: "react-transition",
          history: "replace"
        });
      }
    }
    if (typeof navigation == "object") {
      var a = !1, r = null;
      return navigation.addEventListener("navigate", t), navigation.addEventListener("navigatesuccess", e), navigation.addEventListener("navigateerror", e), setTimeout(n, 100), function() {
        a = !0, navigation.removeEventListener("navigate", t), navigation.removeEventListener("navigatesuccess", e), navigation.removeEventListener("navigateerror", e), r !== null && (r(), r = null);
      };
    }
  }
  function uf(t) {
    this._internalRoot = t;
  }
  mc.prototype.render = uf.prototype.render = function(t) {
    var e = this._internalRoot;
    if (e === null) throw Error(o(409));
    var n = e.current, a = fn();
    kp(n, a, t, e, null, null);
  }, mc.prototype.unmount = uf.prototype.unmount = function() {
    var t = this._internalRoot;
    if (t !== null) {
      this._internalRoot = null;
      var e = t.containerInfo;
      kp(t.current, 2, null, t, null, null), $u(), e[Aa] = null;
    }
  };
  function mc(t) {
    this._internalRoot = t;
  }
  mc.prototype.unstable_scheduleHydration = function(t) {
    if (t) {
      var e = xa();
      t = { blockedOn: null, target: t, priority: e };
      for (var n = 0; n < Fa.length && e !== 0 && e < Fa[n].priority; n++) ;
      Fa.splice(n, 0, t), n === 0 && Vp(t);
    }
  };
  var Qp = u.version;
  if (Qp !== "19.2.6")
    throw Error(
      o(
        527,
        Qp,
        "19.2.6"
      )
    );
  $.findDOMNode = function(t) {
    var e = t._reactInternals;
    if (e === void 0)
      throw typeof t.render == "function" ? Error(o(188)) : (t = Object.keys(t).join(","), Error(o(268, t)));
    return t = T(e), t = t !== null ? A(t) : null, t = t === null ? null : t.stateNode, t;
  };
  var Tb = {
    bundleType: 0,
    version: "19.2.6",
    rendererPackageName: "react-dom",
    currentDispatcherRef: V,
    reconcilerVersion: "19.2.6"
  };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var pc = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!pc.isDisabled && pc.supportsFiber)
      try {
        Sa = pc.inject(
          Tb
        ), qe = pc;
      } catch {
      }
  }
  return Qr.createRoot = function(t, e) {
    if (!f(t)) throw Error(o(299));
    var n = !1, a = "", r = Ih, c = Ph, d = tm;
    return e != null && (e.unstable_strictMode === !0 && (n = !0), e.identifierPrefix !== void 0 && (a = e.identifierPrefix), e.onUncaughtError !== void 0 && (r = e.onUncaughtError), e.onCaughtError !== void 0 && (c = e.onCaughtError), e.onRecoverableError !== void 0 && (d = e.onRecoverableError)), e = zp(
      t,
      1,
      !1,
      null,
      null,
      n,
      a,
      null,
      r,
      c,
      d,
      Xp
    ), t[Aa] = e.current, Vo(t), new uf(e);
  }, Qr.hydrateRoot = function(t, e, n) {
    if (!f(t)) throw Error(o(299));
    var a = !1, r = "", c = Ih, d = Ph, v = tm, w = null;
    return n != null && (n.unstable_strictMode === !0 && (a = !0), n.identifierPrefix !== void 0 && (r = n.identifierPrefix), n.onUncaughtError !== void 0 && (c = n.onUncaughtError), n.onCaughtError !== void 0 && (d = n.onCaughtError), n.onRecoverableError !== void 0 && (v = n.onRecoverableError), n.formState !== void 0 && (w = n.formState)), e = zp(
      t,
      1,
      !0,
      e,
      n ?? null,
      a,
      r,
      w,
      c,
      d,
      v,
      Xp
    ), e.context = Mp(null), n = e.current, a = fn(), a = fl(a), r = La(a), r.callback = null, Ba(n, r, a), n = a, e.current.lanes = n, Wn(e, n), Vn(e), t[Aa] = e.current, Vo(t), new mc(e);
  }, Qr.version = "19.2.6", Qr;
}
var ly;
function aA() {
  if (ly) return Rf.exports;
  ly = 1;
  function l() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function"))
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(l);
      } catch (i) {
        console.error(i);
      }
  }
  return l(), Rf.exports = nA(), Rf.exports;
}
var Sv = aA();
const lA = (l, i, u) => {
  Sv.createRoot(u).render(ye.createElement(l, i));
}, ts = ({ typeCarousel: l, targetSelector: i, props: u }) => {
  const o = {
    card: hv,
    testimonial: yv,
    image: mv,
    "image-gallery": gv
  }[l];
  o && lA(o, u, document.querySelector(i));
}, sA = ({ targetSelector: l, props: i }) => ts({
  typeCarousel: "card",
  targetSelector: l,
  props: i
}), oA = ({ targetSelector: l, props: i }) => {
  ts({
    typeCarousel: "testimonial",
    targetSelector: l,
    props: i
  });
}, fA = ({ targetSelector: l, props: i }) => {
  ts({ typeCarousel: "image", targetSelector: l, props: i });
}, dA = ({ targetSelector: l, props: i }) => {
  ts({
    typeCarousel: "image-gallery",
    targetSelector: l,
    props: i
  });
}, oe = (l, i, u) => {
  Sv.createRoot(u).render(ye.createElement(l, i));
}, hA = ({ targetSelector: l, props: i }) => oe(dy, i, document.querySelector(l)), mA = ({ targetSelector: l, props: i }) => oe(qy, i, document.querySelector(l)), pA = ({ targetSelector: l, props: i }) => oe(Qy, i, document.querySelector(l)), gA = ({ targetSelector: l, props: i }) => oe(al, i, document.querySelector(l)), yA = ({ targetSelector: l, props: i }) => oe(id, i, document.querySelector(l)), vA = ({ targetSelector: l, props: i }) => oe(rd, i, document.querySelector(l)), bA = ({ targetSelector: l, props: i }) => oe(ga, i, document.querySelector(l)), SA = ({ targetSelector: l, props: i }) => oe(Iy, i, document.querySelector(l)), TA = ({ targetSelector: l, props: i }) => oe(Py, i, document.querySelector(l)), wA = ({ targetSelector: l, props: i }) => oe(Px, i, document.querySelector(l)), xA = ({ targetSelector: l, props: i }) => oe(nv, i, document.querySelector(l)), AA = ({ targetSelector: l, props: i }) => oe(Ul, i, document.querySelector(l)), _A = ({ targetSelector: l, props: i }) => oe(av, i, document.querySelector(l)), OA = ({ targetSelector: l, props: i }) => oe(ud, i, document.querySelector(l)), NA = ({ targetSelector: l, props: i }) => oe(Uw, i, document.querySelector(l)), EA = ({ targetSelector: l, props: i }) => oe(cd, i, document.querySelector(l)), jA = ({ targetSelector: l, props: i }) => oe(iv, i, document.querySelector(l)), RA = ({ targetSelector: l, props: i }) => oe(zw, i, document.querySelector(l)), CA = ({ targetSelector: l, props: i }) => oe(gw, i, document.querySelector(l)), DA = ({ targetSelector: l, props: i }) => oe(Vw, i, document.querySelector(l)), zA = ({ targetSelector: l, props: i }) => oe(Wx, i, document.querySelector(l)), MA = ({ targetSelector: l, props: i }) => oe(Rw, i, document.querySelector(l));
export {
  dy as Accordion,
  qy as AnchorMenu,
  Qy as Article,
  al as Button,
  id as ButtonIconOnly,
  rd as ButtonTag,
  ga as Card,
  Iy as CardArrangement,
  hv as CardCarousel,
  Py as ContentSpotlight,
  gw as Divider,
  pw as DividerType,
  Ow as FeedBody,
  Tw as FeedContainerProvider,
  Sw as FeedContext,
  _w as FeedHeader,
  Px as GridLinks,
  nv as Hero,
  Rw as HighlyRanked,
  Ul as Image,
  mv as ImageCarousel,
  gv as ImageGalleryCarousel,
  Wx as List,
  kw as NavControls,
  av as Pagination,
  ud as RankingCard,
  zw as SystemAlert,
  Dw as SystemAlertType,
  cA as Tab,
  Lw as TabHeader,
  Uw as TabbedPanels,
  cd as Testimonial,
  yv as TestimonialCarousel,
  Vw as Tooltip,
  iv as Video,
  uA as feedCardButtonShape,
  xw as feedComponentShape,
  ev as feedCtaButtonShape,
  ww as feedDataSourceShape,
  tv as feedHeaderShape,
  hA as initAccordion,
  mA as initAnchorMenu,
  pA as initArticle,
  gA as initButton,
  yA as initButtonIconOnly,
  vA as initButtonTag,
  bA as initCard,
  SA as initCardArrangement,
  sA as initCardCarousel,
  TA as initContentSpotlight,
  CA as initDivider,
  wA as initGridLinks,
  xA as initHero,
  MA as initHighlyRanked,
  AA as initImage,
  fA as initImageCarousel,
  dA as initImageGalleryCarousel,
  zA as initList,
  _A as initPagination,
  OA as initRankingCard,
  RA as initSystemAlert,
  NA as initTabbedPanels,
  EA as initTestimonial,
  oA as initTestimonialCarousel,
  DA as initTooltip,
  jA as initVideo
};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/*! @license DOMPurify 3.4.11 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.4.11/LICENSE */
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/*!
 * Glide.js v3.7.1
 * (c) 2013-2024 Jędrzej Chałubek (https://github.com/jedrzejchalubek/)
 * Released under the MIT License.
 */
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

(function() {
                var css = `@charset "UTF-8";.glide{position:relative;width:100%;box-sizing:border-box}.glide *{box-sizing:inherit}.glide__track{overflow:hidden}.glide__slides{position:relative;width:100%;list-style:none;backface-visibility:hidden;transform-style:preserve-3d;touch-action:pan-Y;overflow:hidden;margin:0;padding:0;white-space:nowrap;display:flex;flex-wrap:nowrap;will-change:transform}.glide__slides--dragging{-webkit-user-select:none;user-select:none}.glide__slide{width:100%;height:100%;flex-shrink:0;white-space:normal;-webkit-user-select:none;user-select:none;-webkit-touch-callout:none;-webkit-tap-highlight-color:transparent}.glide__slide a{-webkit-user-select:none;user-select:none;-webkit-user-drag:none;-moz-user-select:none;-ms-user-select:none}.glide__arrows,.glide__bullets{-webkit-touch-callout:none;-webkit-user-select:none;user-select:none}.glide--rtl{direction:rtl}@media only screen and (min-width:1260px){.container .aligned-carousel{margin-left:-124px!important}}.glide{display:flex;flex-direction:column;gap:32px;position:relative}[data-image-auto-size=true] .glide__slides .glide__slide{height:auto;position:relative;display:inline-flex;justify-content:center}[data-image-auto-size=true] .glide__slides .glide__slide>div.uds-img{display:flex;width:100%;max-width:100%}[data-image-auto-size=true] .glide__slides .glide__slide>div.uds-img img{flex-grow:1;object-fit:cover}[data-image-auto-size=true] .glide__slides .glide__slide>div.uds-img img.uds-img{max-width:100%}[data-image-auto-size=true] .glide__slides .glide__slide>div.uds-img figure.uds-figure{display:flex;justify-content:space-between;flex-direction:column}.glide .glide__track{position:relative}.glide .glide__track .glide__slides{margin-bottom:0;touch-action:auto}.glide .glide__track .glide__slides .glide__slide .card{width:100%}@media only screen and (min-width:576px){.glide[data-has-shadow=true] .glide__track.slider-start:after{background:linear-gradient(to left,#19191933,48px,#fff0 96px);content:" ";height:100%;position:absolute;pointer-events:none;width:100%;top:0}.glide[data-has-shadow=true] .glide__track.slider-mid:after{background:linear-gradient(to right,#19191933,48px,#fff0 96px),linear-gradient(to left,#19191933,48px,#fff0 96px);content:" ";height:100%;position:absolute;pointer-events:none;width:100%;top:0}.glide[data-has-shadow=true] .glide__track.slider-end:after{background:linear-gradient(to right,#19191933,48px,#fff0 96px);content:" ";height:100%;position:absolute;pointer-events:none;width:100%;top:0}}.glide__arrows{z-index:2;align-self:center}.glide__arrows .glide__arrow{color:#191919;width:4rem;height:4rem;margin:0 .5rem;background-color:#e8e8e8;border:1px solid #d0d0d0;border-radius:50%;font-size:1.3rem;text-shadow:0 .25em .5em rgba(0,0,0,.1);opacity:1;cursor:pointer;transition:opacity .15s ease,border .3s ease-in-out;line-height:1}.glide__arrows .glide__arrow.glide__arrow--disabled{color:#e8e8e8;background-color:#fafafa;border:1px solid #e8e8e8;opacity:1}.glide__arrows .glide__arrow:focus{outline:none}.glide__arrows .glide__arrow:hover{border-color:#fff}.glide__arrows .glide__arrow--left{left:2em}.glide__arrows .glide__arrow--right{right:2em}.glide__arrows .glide__arrow--disabled{opacity:.33}.glide__bullets{z-index:2;list-style:none;max-width:100%;display:flex;justify-content:center}.glide__bullet{transition:all .3s ease-in-out;background-color:#d0d0d0;width:1rem;height:1rem;padding:0;border-radius:50%;border:2px solid transparent;cursor:pointer;line-height:0;margin:.375rem}.glide__bullet:focus{outline:none}.glide__bullet:hover,.glide__bullet:focus{border:1px solid #d0d0d0;background-color:#191919}.glide__bullet--active{background-color:#191919}.glide.aligned-carousel{width:1448px;margin:auto}.glide.image-gallery{gap:0;overflow:hidden}.glide.image-gallery .glide__track{border:1px solid #d0d0d0}.glide.image-gallery .glide__track:after{content:none}.glide.image-gallery .glide__track .glide__slides li.glide__slide{display:list-item}.glide.image-gallery .glide__track .glide__slides{margin-bottom:0;height:100%}.glide.image-gallery .glide__track .glide__slides .glide__slide>div.uds-img{height:100%}.glide.image-gallery .glide__track .glide__slides .glide__slide>div.uds-img img{object-fit:cover;border:none}.glide.image-gallery .image-gallery-action-area{border:1px solid #d0d0d0;border-top:0}.glide.image-gallery .image-gallery-action-area[data-has-content=true] .image-navigator{border-bottom:1px solid #d0d0d0}.glide.image-gallery .image-gallery-action-area[data-has-content=true] .uds-caption-text{padding:1rem 0;display:inline-block}.glide.image-gallery .image-gallery-action-area[data-has-content=true] .uds-caption-text>div{height:auto!important}.glide.image-gallery figcaption{padding:0 .75rem;font-size:.75rem}.glide.image-gallery figcaption h2{font-size:1.5rem;line-height:1.75rem;letter-spacing:-.0525rem}.glide.image-gallery .image-navigator{position:relative}.glide.image-gallery .image-navigator .image-navigator-images{min-height:64px;padding-top:1rem;padding-bottom:1rem;width:100%;margin:auto;overflow:hidden}.glide.image-gallery .image-navigator .image-navigator-images.slider-start:after{background:linear-gradient(to left,#19191933,48px,#fff0 96px);content:" ";height:100%;position:absolute;pointer-events:none;width:100%;top:0}.glide.image-gallery .image-navigator .image-navigator-images.slider-mid:after{background:linear-gradient(to right,#19191933,48px,#fff0 96px),linear-gradient(to left,#19191933,48px,#fff0 96px);content:" ";height:100%;position:absolute;pointer-events:none;width:100%;top:0}.glide.image-gallery .image-navigator .image-navigator-images.slider-end:after{background:linear-gradient(to right,#19191933,48px,#fff0 96px);content:" ";height:100%;position:absolute;pointer-events:none;width:100%;top:0}.glide.image-gallery .image-navigator .image-navigator-images .navigation-slider{position:relative;left:0}.glide.image-gallery .image-navigator .image-navigator-images .navigation-slider .glide__bullets{position:relative}.glide.image-gallery .image-navigator .image-navigator-images .navigation-slider .glide__bullets .bullet-image-container{position:relative;margin:0 .5rem;height:48px;border:0;padding:0}.glide.image-gallery .image-navigator .image-navigator-images .navigation-slider .glide__bullets .bullet-image-container:first-child{margin-left:16rem}.glide.image-gallery .image-navigator .image-navigator-images .navigation-slider .glide__bullets .bullet-image-container .bullet-image{flex-basis:auto;width:88px;height:100%;border-radius:0;border:0;z-index:2;object-fit:cover;margin:0}.glide.image-gallery .image-navigator .image-navigator-images .navigation-slider .glide__bullets .bullet-image-container:focus{box-shadow:0 0 0 2px #fff,0 0 0 4px #191919!important}.glide.image-gallery .image-navigator .image-navigator-images .navigation-slider .glide__bullets .glide__bullet--active{background-color:transparent;border:5px solid #ffc627}.glide.image-gallery .image-navigator .glide__arrows{width:100%;display:flex;justify-content:space-between;align-items:center}.glide.image-gallery .image-navigator .glide__arrows .glide__arrow{width:2.5rem;height:2.5rem;display:flex;align-items:center;justify-content:center;z-index:3;position:absolute;background-color:#fff}.glide.image-gallery .image-navigator .glide__arrows .glide__arrow:hover{border-color:#d0d0d0}.glide.image-gallery .image-navigator .glide__arrows .glide__arrow .arrow-icon{font-size:1rem}.glide.image-gallery .image-navigator .glide__arrows .glide__arrow.glide__arrow--prev{left:0}.glide.image-gallery .image-navigator .glide__arrows .glide__arrow.glide__arrow--next{right:0}@media only screen and (max-width:576px){.glide{gap:21px}.glide:not(.glide.image-gallery) .glide__bullets{display:none}.glide.image-gallery{width:100%;margin:auto!important}.glide.image-gallery .image-navigator .image-navigator-images .glide__arrows .glide__arrow{display:none}}@media only screen and (max-width:1260px){.glide.aligned-carousel{width:100%}}.glide--swipeable{cursor:grab;cursor:-moz-grab;cursor:-webkit-grab}.glide--dragging{cursor:grabbing;cursor:-moz-grabbing;cursor:-webkit-grabbing}.glide[data-remove-side-background=true]:after,.glide[data-remove-side-background=true]:before{content:none}.glide button:focus,.glide a:focus,.glide input:focus,.glide textarea:focus,.glide select:focus{outline:none!important;box-shadow:0 0 0 2px #fff,0 0 0 4px #191919!important}.glide.image-gallery,.glide.image-carousel{margin:auto}.glide.image-gallery[role=figure],.glide.image-gallery figure.uds-figure,.glide.image-carousel[role=figure],.glide.image-carousel figure.uds-figure{margin:0}.glide.image-gallery[role=figure] figcaption *,.glide.image-gallery[role=figure] .uds-caption-text,.glide.image-gallery figure.uds-figure figcaption *,.glide.image-gallery figure.uds-figure .uds-caption-text,.glide.image-carousel[role=figure] figcaption *,.glide.image-carousel[role=figure] .uds-caption-text,.glide.image-carousel figure.uds-figure figcaption *,.glide.image-carousel figure.uds-figure .uds-caption-text{color:#191919;max-width:100%}
`;
                var style = document.createElement('style');
                style.type = 'text/css';
                if (style.styleSheet) {
                  style.styleSheet.cssText = css;
                } else {
                  style.appendChild(document.createTextNode(css));
                }
                document.head.appendChild(style);
              })();